import * as C from "react";
import m, { useState as Me, useRef as E1, useEffect as te, useCallback as ue, useMemo as Ye, Suspense as J2 } from "react";
import { h as b, k as ie, l as e0, m as Bi, n as ot, o as t0, p as r0, q as n0, _ as mt, r as F, s as Ui, t as a0, v as i0, C as o0, S as s0, w as qr, x as Hi, y as Ze, z as Ft, N as c0, V as l0, A as Ee, B as u0, D as d0, T as p0, E as f0, G as m0, I as v0, J as g0, K as dr, L as st, O as h0 } from "./index-BWGbEk2X.mjs";
import { u as U, c as je, P as de, s as C0, d as _0 } from "./contexts-CJJEYLdF.mjs";
import { f as Q, a as De } from "./variables-C1JOj6Xh.mjs";
import { t as kt } from "./breakpoints-Cn2bjDpi.mjs";
import { u as Bt } from "./hooks-Bh-C8W1t.mjs";
import jr from "axios";
import J, { getRequest as E0, createOperationDescriptor as y0 } from "relay-runtime";
import { b as b0 } from "./tracking-impression-event-BSYv6VZE.mjs";
import { v as fe, w as Ve, x as w0, y as T0, z as Mi, A as S0, B as A0, t as Vi, n as R0, f as I0, k as y1, u as Dn } from "./index-CnymUPx7.mjs";
import { useWindowSize as P0, useMountEffect as vt, useUpdateEffect as L0, useMap as O0, useAsync as Xt, useDeepCompareEffect as Di, useToggle as N0, useIntersectionObserver as x0, useSyncedRef as Fi } from "@react-hookz/web";
import { s as k0, t as Xi } from "./transient-options-CnVow8zz.mjs";
import { CacheProvider as B0, Global as U0, ThemeContext as H0, css as Lt, keyframes as M0 } from "@emotion/react";
import { ThemeProvider as V0, Badge as D0, badgeClasses as F0, Popover as X0, CircularProgress as $0, IconButton as Kr, Drawer as q0, Popper as j0, Tooltip as K0, tooltipClasses as Fn, ClickAwayListener as z0, Fade as G0 } from "@mui/material";
import { M as Y0, _ as zr, h as $i, j as qi, k as ji, l as Ki, m as Gr, n as b1, o as $t, p as Yr, q as W0, r as Z0, s as Wr, t as zi, u as Gi, v as gt, w as Q0, x as Yi, y as J0, z as Zr, B as w1, C as e4, D as t4, E as r4, G as n4 } from "./component-FEUSyOLI.mjs";
import { u as Oe } from "./fallback-storage-value-DraZAU_d.mjs";
import { g as T1, b as Qe } from "./environment-nVMLUumw.mjs";
import { readInlineData as l1, useRelayEnvironment as Wi, fetchQuery as Zi } from "react-relay";
import { Z as S1 } from "./z-index-CEuzp1gH.mjs";
import a4 from "@emotion/styled";
import { Memo as i4, ForwardRef as o4 } from "react-is";
import s4, { bindTrigger as c4, bindPopover as l4 } from "material-ui-popup-state";
import { WhatsappShareButton as u4, TwitterShareButton as d4, TelegramShareButton as p4, FacebookMessengerShareButton as f4, LineShareButton as m4, FacebookShareButton as v4, EmailShareButton as g4 } from "react-share";
import { useCopyToClipboard as h4 } from "react-use";
import * as C4 from "react-dom";
import "@mui/lab";
let _4 = {};
function A1() {
  return _4;
}
function Ut(e, t) {
  var s, c, l, u;
  const r = A1(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((u = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = fe(e), i = a.getDay(), o = (i < n ? 7 : 0) + i - n;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function u1(e) {
  return Ut(e, { weekStartsOn: 1 });
}
function Qi(e) {
  const t = fe(e), r = t.getFullYear(), n = Ve(e, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = u1(n), i = Ve(e, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const o = u1(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function d1(e) {
  const t = fe(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Xn(e) {
  const t = fe(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function E4(e, t) {
  const r = d1(e), n = d1(t), a = +r - Xn(r), i = +n - Xn(n);
  return Math.round((a - i) / w0);
}
function y4(e) {
  const t = Qi(e), r = Ve(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), u1(r);
}
function Ji(e) {
  return Ve(e, Date.now());
}
function eo(e, t) {
  const r = d1(e), n = d1(t);
  return +r == +n;
}
function b4(e) {
  return (t) => {
    const n = (e ? Math[e] : Math.trunc)(t);
    return n === 0 ? 0 : n;
  };
}
function w4(e, t) {
  return +fe(e) - +fe(t);
}
function T4(e, t, r) {
  const n = w4(e, t) / T0;
  return b4(r == null ? void 0 : r.roundingMethod)(n);
}
function S4(e) {
  const t = fe(e), r = Ve(e, 0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
const A4 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, R4 = (e, t, r) => {
  let n;
  const a = A4[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function q1(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const I4 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, P4 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, L4 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, O4 = {
  date: q1({
    formats: I4,
    defaultWidth: "full"
  }),
  time: q1({
    formats: P4,
    defaultWidth: "full"
  }),
  dateTime: q1({
    formats: L4,
    defaultWidth: "full"
  })
}, N4 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, x4 = (e, t, r, n) => N4[e];
function wt(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const k4 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, B4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, U4 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, H4 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, M4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, V4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, D4 = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, F4 = {
  ordinalNumber: D4,
  era: wt({
    values: k4,
    defaultWidth: "wide"
  }),
  quarter: wt({
    values: B4,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: wt({
    values: U4,
    defaultWidth: "wide"
  }),
  day: wt({
    values: H4,
    defaultWidth: "wide"
  }),
  dayPeriod: wt({
    values: M4,
    defaultWidth: "wide",
    formattingValues: V4,
    defaultFormattingWidth: "wide"
  })
};
function Tt(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? $4(s, (d) => d.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      X4(s, (d) => d.test(o))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(l)
    ) : l;
    const u = t.slice(o.length);
    return { value: l, rest: u };
  };
}
function X4(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function $4(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function q4(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const a = n[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
const j4 = /^(\d+)(th|st|nd|rd)?/i, K4 = /\d+/i, z4 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, G4 = {
  any: [/^b/i, /^(a|c)/i]
}, Y4 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, W4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Z4 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Q4 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, J4 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ec = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, tc = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, rc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, nc = {
  ordinalNumber: q4({
    matchPattern: j4,
    parsePattern: K4,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Tt({
    matchPatterns: z4,
    defaultMatchWidth: "wide",
    parsePatterns: G4,
    defaultParseWidth: "any"
  }),
  quarter: Tt({
    matchPatterns: Y4,
    defaultMatchWidth: "wide",
    parsePatterns: W4,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Tt({
    matchPatterns: Z4,
    defaultMatchWidth: "wide",
    parsePatterns: Q4,
    defaultParseWidth: "any"
  }),
  day: Tt({
    matchPatterns: J4,
    defaultMatchWidth: "wide",
    parsePatterns: ec,
    defaultParseWidth: "any"
  }),
  dayPeriod: Tt({
    matchPatterns: tc,
    defaultMatchWidth: "any",
    parsePatterns: rc,
    defaultParseWidth: "any"
  })
}, ac = {
  code: "en-US",
  formatDistance: R4,
  formatLong: O4,
  formatRelative: x4,
  localize: F4,
  match: nc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ic(e) {
  const t = fe(e);
  return E4(t, S4(t)) + 1;
}
function oc(e) {
  const t = fe(e), r = +u1(t) - +y4(t);
  return Math.round(r / Mi) + 1;
}
function to(e, t) {
  var u, d, f, h;
  const r = fe(e), n = r.getFullYear(), a = A1(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((h = (f = a.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = Ve(e, 0);
  o.setFullYear(n + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = Ut(o, t), c = Ve(e, 0);
  c.setFullYear(n, 0, i), c.setHours(0, 0, 0, 0);
  const l = Ut(c, t);
  return r.getTime() >= s.getTime() ? n + 1 : r.getTime() >= l.getTime() ? n : n - 1;
}
function sc(e, t) {
  var s, c, l, u;
  const r = A1(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((u = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = to(e, t), i = Ve(e, 0);
  return i.setFullYear(a, 0, n), i.setHours(0, 0, 0, 0), Ut(i, t);
}
function cc(e, t) {
  const r = fe(e), n = +Ut(r, t) - +sc(r, t);
  return Math.round(n / Mi) + 1;
}
function D(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const Ue = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return D(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : D(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return D(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return D(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return D(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return D(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return D(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return D(a, t.length);
  }
}, rt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, $n = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return Ue.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = to(e, n), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return D(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(i, { unit: "year" }) : D(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = Qi(e);
    return D(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return D(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return D(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return D(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ue.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return D(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = cc(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : D(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = oc(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : D(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : Ue.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = ic(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : D(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return D(i, 2);
      case "eo":
        return r.ordinalNumber(i, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return D(i, t.length);
      case "co":
        return r.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return D(a, t.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = rt.noon : n === 0 ? a = rt.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = rt.evening : n >= 12 ? a = rt.afternoon : n >= 4 ? a = rt.morning : a = rt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return Ue.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : Ue.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : D(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : D(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Ue.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : Ue.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Ue.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return jn(n);
      case "XXXX":
      case "XX":
        return Ke(n);
      case "XXXXX":
      case "XXX":
      default:
        return Ke(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return jn(n);
      case "xxxx":
      case "xx":
        return Ke(n);
      case "xxxxx":
      case "xxx":
      default:
        return Ke(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + qn(n, ":");
      case "OOOO":
      default:
        return "GMT" + Ke(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + qn(n, ":");
      case "zzzz":
      default:
        return "GMT" + Ke(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(e.getTime() / 1e3);
    return D(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    const n = e.getTime();
    return D(n, t.length);
  }
};
function qn(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? r + String(a) : r + String(a) + t + D(i, 2);
}
function jn(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + D(Math.abs(e) / 60, 2) : Ke(e, t);
}
function Ke(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = D(Math.trunc(n / 60), 2), i = D(n % 60, 2);
  return r + a + t + i;
}
const Kn = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, ro = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, lc = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return Kn(e, t);
  let i;
  switch (n) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Kn(n, t)).replace("{{time}}", ro(a, t));
}, uc = {
  p: ro,
  P: lc
}, dc = /^D+$/, pc = /^Y+$/, fc = ["D", "DD", "YY", "YYYY"];
function mc(e) {
  return dc.test(e);
}
function vc(e) {
  return pc.test(e);
}
function gc(e, t, r) {
  const n = hc(e, t, r);
  if (console.warn(n), fc.includes(e)) throw new RangeError(n);
}
function hc(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Cc = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _c = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ec = /^'([^]*?)'?$/, yc = /''/g, bc = /[a-zA-Z]/;
function no(e, t, r) {
  var u, d, f, h;
  const n = A1(), a = n.locale ?? ac, i = n.firstWeekContainsDate ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, o = n.weekStartsOn ?? ((h = (f = n.locale) == null ? void 0 : f.options) == null ? void 0 : h.weekStartsOn) ?? 0, s = fe(e);
  if (!S0(s))
    throw new RangeError("Invalid time value");
  let c = t.match(_c).map((v) => {
    const p = v[0];
    if (p === "p" || p === "P") {
      const g = uc[p];
      return g(v, a.formatLong);
    }
    return v;
  }).join("").match(Cc).map((v) => {
    if (v === "''")
      return { isToken: !1, value: "'" };
    const p = v[0];
    if (p === "'")
      return { isToken: !1, value: wc(v) };
    if ($n[p])
      return { isToken: !0, value: v };
    if (p.match(bc))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: v };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return c.map((v) => {
    if (!v.isToken) return v.value;
    const p = v.value;
    (vc(p) || mc(p)) && gc(p, t, String(e));
    const g = $n[p[0]];
    return g(s, p, a.localize, l);
  }).join("");
}
function wc(e) {
  const t = e.match(Ec);
  return t ? t[1].replace(yc, "'") : e;
}
function pr(e) {
  return Math.trunc(+fe(e) / 1e3);
}
function Tc(e) {
  return eo(e, Ji(e));
}
function Sc(e, t) {
  return A0(e, -t);
}
function Ac(e) {
  return eo(e, Sc(Ji(e), 1));
}
const Rc = /* @__PURE__ */ b("div", {
  target: "etb51bn5"
})("padding-block:21px 20px;color:#ffffff;border-block-end:1px solid #484848;", (e) => e.theme.breakpoints.up("tablet"), "{padding:0;border:0;}"), Ic = /* @__PURE__ */ b("span", {
  target: "etb51bn4"
})({
  name: "1efi8gv",
  styles: "font-weight:bold"
}), Pc = /* @__PURE__ */ b("div", {
  target: "etb51bn3"
})("font-size:16px;font-family:", Q, ";line-height:18.75px;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{text-align:start;}"), Lc = /* @__PURE__ */ b("div", {
  target: "etb51bn2"
})("display:flex;flex-flow:row wrap;justify-content:center;align-items:stretch;margin-block-start:16px;", (e) => e.theme.breakpoints.up("tablet"), "{justify-content:flex-start;}");
var Oc = {
  name: "1o82tng",
  styles: "margin-inline-end:12px"
};
const Nc = /* @__PURE__ */ b("img", {
  target: "etb51bn1"
})("inline-size:144px;block-size:48px;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:120px;block-size:40px;margin-inline-end:12px;}", (e) => {
  if (e.$containerWidth > 306)
    return Oc;
}, ";"), xc = /* @__PURE__ */ b("img", {
  target: "etb51bn0"
})("inline-size:162px;block-size:48px;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:135px;block-size:40px;}");
function fr() {
  return fr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fr.apply(null, arguments);
}
const kc = "data:image/png;base64,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", Bc = "data:image/png;base64,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", ao = ({
  ...e
}) => {
  const {
    currentPageType: t,
    handleTrackGA4: r
  } = U(), {
    width: n
  } = P0(), [a, i] = Me(0), o = E1(null);
  te(() => {
    o != null && o.current && i(o.current.offsetWidth);
  }, [n, o]);
  const s = (l, u) => /* @__PURE__ */ m.createElement("a", {
    href: "https://scmp.onelink.me/3586748601/43f04bbb",
    rel: "noreferrer",
    target: "_blank",
    onClick: () => c(u),
    "data-qa": "render-url"
  }, l), c = (l) => {
    r({
      action: "click",
      category: "footer",
      customized_parameters: {
        destination_url: "https://scmp.onelink.me/3586748601/43f04bbb",
        link_name: l
      },
      subcategory: ""
    }), r({
      action: "click",
      category: "appdl",
      customized_parameters: {
        click_type: "download",
        os: l === "App Store" ? "ios" : "android",
        page_type: t,
        position: "footer",
        ...Vi() && {
          inapp_browser: "fb"
        }
      },
      subcategory: ""
    });
  };
  return /* @__PURE__ */ m.createElement(Rc, fr({}, e, {
    "data-qa": "download-app-widget"
  }), /* @__PURE__ */ m.createElement(Pc, null, /* @__PURE__ */ m.createElement(Ic, null, "Read more in "), "the SCMP App"), /* @__PURE__ */ m.createElement(Lc, {
    ref: o
  }, s(/* @__PURE__ */ m.createElement(Nc, {
    $containerWidth: a,
    alt: "app store",
    src: kc
  }), "App Store"), s(/* @__PURE__ */ m.createElement(xc, {
    alt: "google play",
    src: Bc
  }), "Google Play")));
};
ao.displayName = "DownloadAppWidget";
const Uc = (e) => /* @__PURE__ */ C.createElement("svg", { width: 25, height: 25, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { d: "M12.536 22.5c5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10s4.477 10 10 10ZM12.536 8.5v4M12.536 16.5h.01", stroke: "#EB4254", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), Hc = /* @__PURE__ */ b("div", {
  target: "e5ztbbi6"
})({
  name: "t5e8y3",
  styles: "margin-inline-end:10px"
}), io = /* @__PURE__ */ b("div", {
  target: "e5ztbbi5"
})("max-inline-size:666px;color:#ffffff;font-size:14px;font-family:", Q, ";line-height:16px;"), Mc = /* @__PURE__ */ b("div", {
  target: "e5ztbbi4"
})("max-inline-size:666px;color:#ffffff;font-size:16px;font-family:", Q, ";line-height:19px;", (e) => e.theme.breakpoints.up("desktop"), "{font-size:18px;line-height:21px;}"), oo = /* @__PURE__ */ b("div", {
  target: "e5ztbbi3"
})({
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
}), so = /* @__PURE__ */ b("div", {
  target: "e5ztbbi2"
})("padding-block:8px;padding-inline:12px;color:#ffffff;font-size:14px;font-family:", Q, ";line-height:16px;white-space:nowrap;border-radius:3px;background:#4585ff;", (e) => e.theme.breakpoints.up("desktop"), "{padding-block:12px;padding-inline:20px;font-size:16px;line-height:19px;}"), Vc = /* @__PURE__ */ b("div", {
  target: "e5ztbbi1"
})('display:grid;grid-template-areas:"Content" "." "Description" "." "Button";grid-template-rows:min-content 12px min-content 20px min-content;gap:0 0;padding-block:24px;padding-inline:20px;border:1px solid #999999;border-radius:8px;', oo, "{grid-area:Content;}", io, "{grid-area:Description;}", so, "{grid-area:Button;place-self:center center;}", (e) => e.theme.breakpoints.up("desktop"), '{grid-template:"Content Content . Button" min-content ". . . Button" 14px "Description Description . Button" min-content "Description Description . Button" min-content/1fr 1fr 28px min-content;padding:28px;}'), Dc = /* @__PURE__ */ b("div", {
  target: "e5ztbbi0"
})("max-inline-size:908px;margin-block-end:15px;cursor:pointer;", (e) => e.theme.breakpoints.up("desktop"), "{padding:40px;}");
function mr() {
  return mr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mr.apply(null, arguments);
}
const co = ({
  config: e,
  ...t
}) => {
  const {
    buttonText: r,
    desc: n,
    text: a,
    url: i
  } = e, {
    handleRoutePush: o
  } = U();
  return /* @__PURE__ */ m.createElement(Dc, mr({}, t, {
    "data-qa": "print-edition-footer"
  }), /* @__PURE__ */ m.createElement(Vc, {
    onClick: () => {
      o(i, {
        query: {
          module: "covid-19_update_footer",
          pgtype: "homepage"
        },
        type: je.Article
      });
    }
  }, /* @__PURE__ */ m.createElement(oo, null, /* @__PURE__ */ m.createElement(Hc, null, /* @__PURE__ */ m.createElement(Uc, null)), /* @__PURE__ */ m.createElement(Mc, {
    dangerouslySetInnerHTML: {
      __html: a
    }
  })), /* @__PURE__ */ m.createElement(io, null, n), /* @__PURE__ */ m.createElement(so, null, r)));
};
co.displayName = "PrintEditionFooter";
var Fc = { NEXT_PUBLIC_ENV_SLUG: "qa-2-scmpweb-6112-rjx12i", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_PROXY_PORT: "3000", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", npm_config_user_agent: "pnpm/9.10.0 npm/? node/v20.17.0 linux x64", NODE_VERSION: "20.17.0", SENTRY_RELEASE: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_ENABLE_HEAPDUMP: "true", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", YARN_VERSION: "1.22.22", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/unleash", NEXT_PUBLIC_SITE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_EXT_SVC_ENV_SLUG: "staging", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", USE_CHUNK_METRICS: "true", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", NODE_OPTIONS: "--max_old_space_size=8192", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", ANALYZE: "true", NEXT_PUBLIC_COMMIT_SHA: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_CF_BAN_WORKER_SENTRY_ENABLED: "false", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_UNLEASH_API_TOKEN: "token", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", USE_SOURCE_MAP: "true", STORYBOOK_SITE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", NEXT_PUBLIC_USE_CDN: "true", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_CF_BAN_WORKER_MQ_HOST: "staging-rabbitmq-scmp-d8", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech,amp.staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", USE_SERVICE_WORKER: "true", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", DOLLAR_SIGN: "$", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", GITLAB_CI_TOKEN: "wmBPb7CzvxxsRiLK1724", USE_SENTRY_WEBPACK_PLUGIN: "false", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", SENTRY_PROJECT: "scmp-pwa-v2-dev", NEXT_PUBLIC_UNLEASH_PROXY_CLIENT_KEYS: "api-key", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_CF_BAN_WORKER_DRY_RUN: "true", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NODE_PATH: "/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules:/app/node_modules/.pnpm/node_modules", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ENV_SLUG: "qa-2-scmpweb-6112-rjx12i", NEXT_PUBLIC_DRUPAL_HOST: "http://staging-app-scmp-d8", PNPM_PACKAGE_NAME: "scmp-pwa-v2", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", USE_CDN: "true", PWD: "/app", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_CERT_ISSUER: "letsencrypt-staging", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", npm_command: "run-script", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", NX_CLI_SET: "true", NX_VERBOSE_LOGGING: "false", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/app", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "16101179541642696061", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" };
function Xc(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function $c(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var qc = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    this._insertTag = function(a) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, i), n.tags.push(a);
    }, this.isSpeedy = r.speedy === void 0 ? Fc.NODE_ENV === "production" : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag($c(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = Xc(a);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch {
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), ae = "-ms-", p1 = "-moz-", M = "-webkit-", lo = "comm", Qr = "rule", Jr = "decl", jc = "@import", uo = "@keyframes", Kc = "@layer", zc = Math.abs, R1 = String.fromCharCode, Gc = Object.assign;
function Yc(e, t) {
  return ee(e, 0) ^ 45 ? (((t << 2 ^ ee(e, 0)) << 2 ^ ee(e, 1)) << 2 ^ ee(e, 2)) << 2 ^ ee(e, 3) : 0;
}
function po(e) {
  return e.trim();
}
function Wc(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function V(e, t, r) {
  return e.replace(t, r);
}
function vr(e, t) {
  return e.indexOf(t);
}
function ee(e, t) {
  return e.charCodeAt(t) | 0;
}
function Ht(e, t, r) {
  return e.slice(t, r);
}
function Se(e) {
  return e.length;
}
function en(e) {
  return e.length;
}
function Wt(e, t) {
  return t.push(e), e;
}
function Zc(e, t) {
  return e.map(t).join("");
}
var I1 = 1, ct = 1, fo = 0, le = 0, W = 0, ht = "";
function P1(e, t, r, n, a, i, o) {
  return { value: e, root: t, parent: r, type: n, props: a, children: i, line: I1, column: ct, length: o, return: "" };
}
function St(e, t) {
  return Gc(P1("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Qc() {
  return W;
}
function Jc() {
  return W = le > 0 ? ee(ht, --le) : 0, ct--, W === 10 && (ct = 1, I1--), W;
}
function pe() {
  return W = le < fo ? ee(ht, le++) : 0, ct++, W === 10 && (ct = 1, I1++), W;
}
function Ae() {
  return ee(ht, le);
}
function n1() {
  return le;
}
function qt(e, t) {
  return Ht(ht, e, t);
}
function Mt(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function mo(e) {
  return I1 = ct = 1, fo = Se(ht = e), le = 0, [];
}
function vo(e) {
  return ht = "", e;
}
function a1(e) {
  return po(qt(le - 1, gr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function el(e) {
  for (; (W = Ae()) && W < 33; )
    pe();
  return Mt(e) > 2 || Mt(W) > 3 ? "" : " ";
}
function tl(e, t) {
  for (; --t && pe() && !(W < 48 || W > 102 || W > 57 && W < 65 || W > 70 && W < 97); )
    ;
  return qt(e, n1() + (t < 6 && Ae() == 32 && pe() == 32));
}
function gr(e) {
  for (; pe(); )
    switch (W) {
      case e:
        return le;
      case 34:
      case 39:
        e !== 34 && e !== 39 && gr(W);
        break;
      case 40:
        e === 41 && gr(e);
        break;
      case 92:
        pe();
        break;
    }
  return le;
}
function rl(e, t) {
  for (; pe() && e + W !== 57; )
    if (e + W === 84 && Ae() === 47)
      break;
  return "/*" + qt(t, le - 1) + "*" + R1(e === 47 ? e : pe());
}
function nl(e) {
  for (; !Mt(Ae()); )
    pe();
  return qt(e, le);
}
function al(e) {
  return vo(i1("", null, null, null, [""], e = mo(e), 0, [0], e));
}
function i1(e, t, r, n, a, i, o, s, c) {
  for (var l = 0, u = 0, d = o, f = 0, h = 0, v = 0, p = 1, g = 1, _ = 1, E = 0, y = "", w = a, T = i, S = n, A = y; g; )
    switch (v = E, E = pe()) {
      case 40:
        if (v != 108 && ee(A, d - 1) == 58) {
          vr(A += V(a1(E), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += a1(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += el(v);
        break;
      case 92:
        A += tl(n1() - 1, 7);
        continue;
      case 47:
        switch (Ae()) {
          case 42:
          case 47:
            Wt(il(rl(pe(), n1()), t, r), c);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * p:
        s[l++] = Se(A) * _;
      case 125 * p:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            g = 0;
          case 59 + u:
            _ == -1 && (A = V(A, /\f/g, "")), h > 0 && Se(A) - d && Wt(h > 32 ? Gn(A + ";", n, r, d - 1) : Gn(V(A, " ", "") + ";", n, r, d - 2), c);
            break;
          case 59:
            A += ";";
          default:
            if (Wt(S = zn(A, t, r, l, u, a, s, y, w = [], T = [], d), i), E === 123)
              if (u === 0)
                i1(A, t, S, S, w, i, d, s, T);
              else
                switch (f === 99 && ee(A, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    i1(e, S, S, n && Wt(zn(e, S, S, 0, 0, a, s, y, a, w = [], d), T), a, T, d, s, n ? w : T);
                    break;
                  default:
                    i1(A, S, S, S, [""], T, 0, s, T);
                }
        }
        l = u = h = 0, p = _ = 1, y = A = "", d = o;
        break;
      case 58:
        d = 1 + Se(A), h = v;
      default:
        if (p < 1) {
          if (E == 123)
            --p;
          else if (E == 125 && p++ == 0 && Jc() == 125)
            continue;
        }
        switch (A += R1(E), E * p) {
          case 38:
            _ = u > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            s[l++] = (Se(A) - 1) * _, _ = 1;
            break;
          case 64:
            Ae() === 45 && (A += a1(pe())), f = Ae(), u = d = Se(y = A += nl(n1())), E++;
            break;
          case 45:
            v === 45 && Se(A) == 2 && (p = 0);
        }
    }
  return i;
}
function zn(e, t, r, n, a, i, o, s, c, l, u) {
  for (var d = a - 1, f = a === 0 ? i : [""], h = en(f), v = 0, p = 0, g = 0; v < n; ++v)
    for (var _ = 0, E = Ht(e, d + 1, d = zc(p = o[v])), y = e; _ < h; ++_)
      (y = po(p > 0 ? f[_] + " " + E : V(E, /&\f/g, f[_]))) && (c[g++] = y);
  return P1(e, t, r, a === 0 ? Qr : s, c, l, u);
}
function il(e, t, r) {
  return P1(e, t, r, lo, R1(Qc()), Ht(e, 2, -2), 0);
}
function Gn(e, t, r, n) {
  return P1(e, t, r, Jr, Ht(e, 0, n), Ht(e, n + 1, -1), n);
}
function it(e, t) {
  for (var r = "", n = en(e), a = 0; a < n; a++)
    r += t(e[a], a, e, t) || "";
  return r;
}
function ol(e, t, r, n) {
  switch (e.type) {
    case Kc:
      if (e.children.length) break;
    case jc:
    case Jr:
      return e.return = e.return || e.value;
    case lo:
      return "";
    case uo:
      return e.return = e.value + "{" + it(e.children, n) + "}";
    case Qr:
      e.value = e.props.join(",");
  }
  return Se(r = it(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function sl(e) {
  var t = en(e);
  return function(r, n, a, i) {
    for (var o = "", s = 0; s < t; s++)
      o += e[s](r, n, a, i) || "";
    return o;
  };
}
function cl(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var ll = function(t, r, n) {
  for (var a = 0, i = 0; a = i, i = Ae(), a === 38 && i === 12 && (r[n] = 1), !Mt(i); )
    pe();
  return qt(t, le);
}, ul = function(t, r) {
  var n = -1, a = 44;
  do
    switch (Mt(a)) {
      case 0:
        a === 38 && Ae() === 12 && (r[n] = 1), t[n] += ll(le - 1, r, n);
        break;
      case 2:
        t[n] += a1(a);
        break;
      case 4:
        if (a === 44) {
          t[++n] = Ae() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      default:
        t[n] += R1(a);
    }
  while (a = pe());
  return t;
}, dl = function(t, r) {
  return vo(ul(mo(t), r));
}, Yn = /* @__PURE__ */ new WeakMap(), pl = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, a = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !Yn.get(n)) && !a) {
      Yn.set(t, !0);
      for (var i = [], o = dl(r, i), s = n.props, c = 0, l = 0; c < o.length; c++)
        for (var u = 0; u < s.length; u++, l++)
          t.props[l] = i[c] ? o[c].replace(/&\f/g, s[u]) : s[u] + " " + o[c];
    }
  }
}, fl = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function go(e, t) {
  switch (Yc(e, t)) {
    case 5103:
      return M + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return M + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return M + e + p1 + e + ae + e + e;
    case 6828:
    case 4268:
      return M + e + ae + e + e;
    case 6165:
      return M + e + ae + "flex-" + e + e;
    case 5187:
      return M + e + V(e, /(\w+).+(:[^]+)/, M + "box-$1$2" + ae + "flex-$1$2") + e;
    case 5443:
      return M + e + ae + "flex-item-" + V(e, /flex-|-self/, "") + e;
    case 4675:
      return M + e + ae + "flex-line-pack" + V(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return M + e + ae + V(e, "shrink", "negative") + e;
    case 5292:
      return M + e + ae + V(e, "basis", "preferred-size") + e;
    case 6060:
      return M + "box-" + V(e, "-grow", "") + M + e + ae + V(e, "grow", "positive") + e;
    case 4554:
      return M + V(e, /([^-])(transform)/g, "$1" + M + "$2") + e;
    case 6187:
      return V(V(V(e, /(zoom-|grab)/, M + "$1"), /(image-set)/, M + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return V(e, /(image-set\([^]*)/, M + "$1$`$1");
    case 4968:
      return V(V(e, /(.+:)(flex-)?(.*)/, M + "box-pack:$3" + ae + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + M + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return V(e, /(.+)-inline(.+)/, M + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Se(e) - 1 - t > 6) switch (ee(e, t + 1)) {
        case 109:
          if (ee(e, t + 4) !== 45) break;
        case 102:
          return V(e, /(.+:)(.+)-([^]+)/, "$1" + M + "$2-$3$1" + p1 + (ee(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~vr(e, "stretch") ? go(V(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (ee(e, t + 1) !== 115) break;
    case 6444:
      switch (ee(e, Se(e) - 3 - (~vr(e, "!important") && 10))) {
        case 107:
          return V(e, ":", ":" + M) + e;
        case 101:
          return V(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + M + (ee(e, 14) === 45 ? "inline-" : "") + "box$3$1" + M + "$2$3$1" + ae + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (ee(e, t + 11)) {
        case 114:
          return M + e + ae + V(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return M + e + ae + V(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return M + e + ae + V(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return M + e + ae + e + e;
  }
  return e;
}
var ml = function(t, r, n, a) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case Jr:
        t.return = go(t.value, t.length);
        break;
      case uo:
        return it([St(t, {
          value: V(t.value, "@", "@" + M)
        })], a);
      case Qr:
        if (t.length) return Zc(t.props, function(i) {
          switch (Wc(i, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return it([St(t, {
                props: [V(i, /:(read-\w+)/, ":" + p1 + "$1")]
              })], a);
            case "::placeholder":
              return it([St(t, {
                props: [V(i, /:(plac\w+)/, ":" + M + "input-$1")]
              }), St(t, {
                props: [V(i, /:(plac\w+)/, ":" + p1 + "$1")]
              }), St(t, {
                props: [V(i, /:(plac\w+)/, ae + "input-$1")]
              })], a);
          }
          return "";
        });
    }
}, vl = [ml], gl = function(t) {
  var r = t.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(p) {
      var g = p.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(p), p.setAttribute("data-s", ""));
    });
  }
  var a = t.stylisPlugins || vl, i = {}, o, s = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(p) {
      for (var g = p.getAttribute("data-emotion").split(" "), _ = 1; _ < g.length; _++)
        i[g[_]] = !0;
      s.push(p);
    }
  );
  var c, l = [pl, fl];
  {
    var u, d = [ol, cl(function(p) {
      u.insert(p);
    })], f = sl(l.concat(a, d)), h = function(g) {
      return it(al(g), f);
    };
    c = function(g, _, E, y) {
      u = E, h(g ? g + "{" + _.styles + "}" : _.styles), y && (v.inserted[_.name] = !0);
    };
  }
  var v = {
    key: r,
    sheet: new qc({
      key: r,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return v.sheet.hydrate(s), v;
};
let hr;
typeof document == "object" && (hr = gl({
  key: "css",
  prepend: !0
}));
function hl(e) {
  const {
    injectFirst: t,
    children: r
  } = e;
  return t && hr ? /* @__PURE__ */ ie.jsx(B0, {
    value: hr,
    children: r
  }) : r;
}
function Cl(e) {
  return e == null || Object.keys(e).length === 0;
}
function _l(e) {
  const {
    styles: t,
    defaultTheme: r = {}
  } = e, n = typeof t == "function" ? (a) => t(Cl(a) ? r : a) : t;
  return /* @__PURE__ */ ie.jsx(U0, {
    styles: n
  });
}
var El = { NEXT_PUBLIC_ENV_SLUG: "qa-2-scmpweb-6112-rjx12i", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_PROXY_PORT: "3000", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", npm_config_user_agent: "pnpm/9.10.0 npm/? node/v20.17.0 linux x64", NODE_VERSION: "20.17.0", SENTRY_RELEASE: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_ENABLE_HEAPDUMP: "true", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", YARN_VERSION: "1.22.22", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/unleash", NEXT_PUBLIC_SITE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_EXT_SVC_ENV_SLUG: "staging", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", USE_CHUNK_METRICS: "true", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", NODE_OPTIONS: "--max_old_space_size=8192", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", ANALYZE: "true", NEXT_PUBLIC_COMMIT_SHA: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_CF_BAN_WORKER_SENTRY_ENABLED: "false", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_UNLEASH_API_TOKEN: "token", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", USE_SOURCE_MAP: "true", STORYBOOK_SITE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", NEXT_PUBLIC_USE_CDN: "true", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_CF_BAN_WORKER_MQ_HOST: "staging-rabbitmq-scmp-d8", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech,amp.staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", USE_SERVICE_WORKER: "true", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", DOLLAR_SIGN: "$", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", GITLAB_CI_TOKEN: "wmBPb7CzvxxsRiLK1724", USE_SENTRY_WEBPACK_PLUGIN: "false", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", SENTRY_PROJECT: "scmp-pwa-v2-dev", NEXT_PUBLIC_UNLEASH_PROXY_CLIENT_KEYS: "api-key", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_CF_BAN_WORKER_DRY_RUN: "true", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NODE_PATH: "/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules:/app/node_modules/.pnpm/node_modules", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ENV_SLUG: "qa-2-scmpweb-6112-rjx12i", NEXT_PUBLIC_DRUPAL_HOST: "http://staging-app-scmp-d8", PNPM_PACKAGE_NAME: "scmp-pwa-v2", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", USE_CDN: "true", PWD: "/app", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_CERT_ISSUER: "letsencrypt-staging", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", npm_command: "run-script", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", NX_CLI_SET: "true", NX_VERBOSE_LOGGING: "false", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/app", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "16101179541642696061", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" };
function yl(e, t) {
  const r = a4(e, t);
  return El.NODE_ENV !== "production" ? (...n) => {
    const a = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${a})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((i) => i === void 0) && console.error(`MUI: the styled(${a})(...args) API requires all its args to be defined.`), r(...n);
  } : r;
}
const bl = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, wl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: _l,
  StyledEngineProvider: hl,
  ThemeContext: H0,
  css: Lt,
  default: yl,
  internal_processStyles: bl,
  keyframes: M0
}, Symbol.toStringTag, { value: "Module" })), Tl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e0,
  isPlainObject: Bi
}, Symbol.toStringTag, { value: "Module" })), Sl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ot
}, Symbol.toStringTag, { value: "Module" })), Al = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t0,
  private_createBreakpoints: r0,
  unstable_applyStyles: n0
}, Symbol.toStringTag, { value: "Module" })), Rl = ["sx"], Il = (e) => {
  var t, r;
  const n = {
    systemProps: {},
    otherProps: {}
  }, a = (t = e == null || (r = e.theme) == null ? void 0 : r.unstable_sxConfig) != null ? t : Ui;
  return Object.keys(e).forEach((i) => {
    a[i] ? n.systemProps[i] = e[i] : n.otherProps[i] = e[i];
  }), n;
};
function Pl(e) {
  const {
    sx: t
  } = e, r = mt(e, Rl), {
    systemProps: n,
    otherProps: a
  } = Il(r);
  let i;
  return Array.isArray(t) ? i = [n, ...t] : typeof t == "function" ? i = (...o) => {
    const s = t(...o);
    return Bi(s) ? F({}, n, s) : n;
  } : i = F({}, n, t), F({}, a, {
    sx: i
  });
}
const Ll = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a0,
  extendSxProp: Pl,
  unstable_createStyleFunctionSx: i0,
  unstable_defaultSxConfig: Ui
}, Symbol.toStringTag, { value: "Module" })), Wn = (e) => e, Ol = () => {
  let e = Wn;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Wn;
    }
  };
}, ho = Ol();
function Co(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (r = Co(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function Cr() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++) (e = arguments[r]) && (t = Co(e)) && (n && (n += " "), n += t);
  return n;
}
const _o = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Eo(e, t, r = "Mui") {
  const n = _o[t];
  return n ? `${r}-${n}` : `${ho.generate(e)}-${t}`;
}
function Nl(e, t, r = "Mui") {
  const n = {};
  return t.forEach((a) => {
    n[a] = Eo(e, a, r);
  }), n;
}
const xl = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function yo(e) {
  const t = `${e}`.match(xl);
  return t && t[1] || "";
}
function bo(e, t = "") {
  return e.displayName || e.name || yo(e) || t;
}
function Zn(e, t, r) {
  const n = bo(t);
  return e.displayName || (n !== "" ? `${r}(${n})` : r);
}
function kl(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return bo(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case o4:
          return Zn(e, e.render, "ForwardRef");
        case i4:
          return Zn(e, e.type, "memo");
        default:
          return;
      }
  }
}
const Bl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kl,
  getFunctionName: yo
}, Symbol.toStringTag, { value: "Module" }));
function _r(e, t) {
  const r = F({}, t);
  return Object.keys(e).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      r[n] = F({}, e[n], r[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const a = e[n] || {}, i = t[n];
      r[n] = {}, !i || !Object.keys(i) ? r[n] = a : !a || !Object.keys(a) ? r[n] = i : (r[n] = F({}, i), Object.keys(a).forEach((o) => {
        r[n][o] = _r(a[o], i[o]);
      }));
    } else r[n] === void 0 && (r[n] = e[n]);
  }), r;
}
const lt = typeof window < "u" ? C.useLayoutEffect : C.useEffect;
function Ul(...e) {
  return e.reduce((t, r) => r == null ? t : function(...a) {
    t.apply(this, a), r.apply(this, a);
  }, () => {
  });
}
function Hl(e, t = 166) {
  let r;
  function n(...a) {
    const i = () => {
      e.apply(this, a);
    };
    clearTimeout(r), r = setTimeout(i, t);
  }
  return n.clear = () => {
    clearTimeout(r);
  }, n;
}
function Ml(e, t) {
  return () => null;
}
function Vl(e, t) {
  var r, n;
  return /* @__PURE__ */ C.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (r = e.type.muiName) != null ? r : (n = e.type) == null || (n = n._payload) == null || (n = n.value) == null ? void 0 : n.muiName
  ) !== -1;
}
function f1(e) {
  return e && e.ownerDocument || document;
}
function Dl(e) {
  return f1(e).defaultView || window;
}
function Fl(e, t) {
  return () => null;
}
let Qn = 0;
function Xl(e) {
  const [t, r] = C.useState(e), n = e || t;
  return C.useEffect(() => {
    t == null && (Qn += 1, r(`mui-${Qn}`));
  }, [t]), n;
}
const Jn = C.useId;
function $l(e) {
  if (Jn !== void 0) {
    const t = Jn();
    return e ?? t;
  }
  return Xl(e);
}
function ql(e, t, r, n, a) {
  return null;
}
var jl = { NEXT_PUBLIC_ENV_SLUG: "qa-2-scmpweb-6112-rjx12i", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_PROXY_PORT: "3000", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", npm_config_user_agent: "pnpm/9.10.0 npm/? node/v20.17.0 linux x64", NODE_VERSION: "20.17.0", SENTRY_RELEASE: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_ENABLE_HEAPDUMP: "true", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", YARN_VERSION: "1.22.22", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/unleash", NEXT_PUBLIC_SITE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_EXT_SVC_ENV_SLUG: "staging", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", USE_CHUNK_METRICS: "true", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", NODE_OPTIONS: "--max_old_space_size=8192", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", ANALYZE: "true", NEXT_PUBLIC_COMMIT_SHA: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_CF_BAN_WORKER_SENTRY_ENABLED: "false", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_UNLEASH_API_TOKEN: "token", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", USE_SOURCE_MAP: "true", STORYBOOK_SITE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", NEXT_PUBLIC_USE_CDN: "true", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_CF_BAN_WORKER_MQ_HOST: "staging-rabbitmq-scmp-d8", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech,amp.staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", USE_SERVICE_WORKER: "true", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", DOLLAR_SIGN: "$", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", GITLAB_CI_TOKEN: "wmBPb7CzvxxsRiLK1724", USE_SENTRY_WEBPACK_PLUGIN: "false", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", SENTRY_PROJECT: "scmp-pwa-v2-dev", NEXT_PUBLIC_UNLEASH_PROXY_CLIENT_KEYS: "api-key", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_CF_BAN_WORKER_DRY_RUN: "true", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NODE_PATH: "/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules:/app/node_modules/.pnpm/node_modules", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ENV_SLUG: "qa-2-scmpweb-6112-rjx12i", NEXT_PUBLIC_DRUPAL_HOST: "http://staging-app-scmp-d8", PNPM_PACKAGE_NAME: "scmp-pwa-v2", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", USE_CDN: "true", PWD: "/app", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_CERT_ISSUER: "letsencrypt-staging", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", npm_command: "run-script", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", NX_CLI_SET: "true", NX_VERBOSE_LOGGING: "false", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/app", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "16101179541642696061", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" };
function wo({
  controlled: e,
  default: t,
  name: r,
  state: n = "value"
}) {
  const {
    current: a
  } = C.useRef(e !== void 0), [i, o] = C.useState(t), s = a ? e : i;
  if (jl.NODE_ENV !== "production") {
    C.useEffect(() => {
      a !== (e !== void 0) && console.error([`MUI: A component is changing the ${a ? "" : "un"}controlled ${n} state of ${r} to be ${a ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${r} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [n, r, e]);
    const {
      current: l
    } = C.useRef(t);
    C.useEffect(() => {
      !a && !Object.is(l, t) && console.error([`MUI: A component is changing the default ${n} state of an uncontrolled ${r} after being initialized. To suppress this warning opt to use a controlled ${r}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = C.useCallback((l) => {
    a || o(l);
  }, []);
  return [s, c];
}
function Kl(e) {
  const t = C.useRef(e);
  return lt(() => {
    t.current = e;
  }), C.useRef((...r) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...r)
  )).current;
}
class tn {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new tn();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, r) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, r();
    }, t);
  }
}
let L1 = !0, Er = !1;
const zl = new tn(), Gl = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Yl(e) {
  const {
    type: t,
    tagName: r
  } = e;
  return !!(r === "INPUT" && Gl[t] && !e.readOnly || r === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function Wl(e) {
  e.metaKey || e.altKey || e.ctrlKey || (L1 = !0);
}
function j1() {
  L1 = !1;
}
function Zl() {
  this.visibilityState === "hidden" && Er && (L1 = !0);
}
function Ql(e) {
  e.addEventListener("keydown", Wl, !0), e.addEventListener("mousedown", j1, !0), e.addEventListener("pointerdown", j1, !0), e.addEventListener("touchstart", j1, !0), e.addEventListener("visibilitychange", Zl, !0);
}
function Jl(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return L1 || Yl(t);
}
function To() {
  const e = C.useCallback((a) => {
    a != null && Ql(a.ownerDocument);
  }, []), t = C.useRef(!1);
  function r() {
    return t.current ? (Er = !0, zl.start(100, () => {
      Er = !1;
    }), t.current = !1, !0) : !1;
  }
  function n(a) {
    return Jl(a) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: n,
    onBlur: r,
    ref: e
  };
}
function rn(e, t, r = void 0) {
  const n = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (a) => {
      n[a] = e[a].reduce((i, o) => {
        if (o) {
          const s = t(o);
          s !== "" && i.push(s), r && r[o] && i.push(r[o]);
        }
        return i;
      }, []).join(" ");
    }
  ), n;
}
const e3 = /* @__PURE__ */ C.createContext(void 0);
function t3(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  if (!t || !t.components || !t.components[r])
    return n;
  const a = t.components[r];
  return a.defaultProps ? _r(a.defaultProps, n) : !a.styleOverrides && !a.variants ? _r(a, n) : n;
}
function r3({
  props: e,
  name: t
}) {
  const r = C.useContext(e3);
  return t3({
    props: e,
    name: t,
    theme: {
      components: r
    }
  });
}
const n3 = () => /* @__PURE__ */ m.createElement(o0, {
  "data-qa": "article-20-theme-sign-up-button-display"
}, /* @__PURE__ */ m.createElement(s0, null), "GET OUR NEWSLETTER");
n3.displayName = "Article20ThemeSignUpButtonDisplay";
const a3 = (e) => /* @__PURE__ */ C.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 60, height: 51, viewBox: "0 0 60 51", fill: "none", ...e }, /* @__PURE__ */ C.createElement("g", { clipPath: "url(#clip0_3254_37968)" }, /* @__PURE__ */ C.createElement("rect", { width: 60, height: 51, rx: 6, fill: "url(#paint0_linear_3254_37968)" }), /* @__PURE__ */ C.createElement("path", { d: "M0.276732 19.0391L-1 18.6714V20V51V52H0H60H61V51V20V18.6714L59.7233 19.0391L30 27.5987L0.276732 19.0391Z", fill: "#FFCA05", stroke: "white", strokeWidth: 2 })), /* @__PURE__ */ C.createElement("defs", null, /* @__PURE__ */ C.createElement("linearGradient", { id: "paint0_linear_3254_37968", x1: 30, y1: 0, x2: 30, y2: 31.875, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#FFCA05" }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "white" })), /* @__PURE__ */ C.createElement("clipPath", { id: "clip0_3254_37968" }, /* @__PURE__ */ C.createElement("rect", { width: 60, height: 51, rx: 8, fill: "white" })))), i3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 154, height: 24, viewBox: "0 0 154 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1909 3.64817C11.52 4.83676 11.6844 6.3637 11.6844 8.22859H7.07678V6.11617C7.07678 5.55023 6.99861 5.11073 6.84343 4.79998C6.68786 4.48923 6.40891 4.33366 6.00697 4.33366C5.11073 4.33366 4.6628 4.91914 4.6628 6.08896V17.499C4.6628 18.2125 4.75438 18.752 4.93715 19.1179C5.11993 19.4838 5.43987 19.6662 5.897 19.6662C6.35412 19.6662 6.67407 19.4838 6.85722 19.1179C7.03961 18.752 7.13157 18.2125 7.13157 17.499V14.126H5.86979V10.0663H11.6296V23.7807H9.73713L8.94167 21.8059C8.10023 23.2688 6.80243 23.9999 5.04674 23.9999C3.34623 23.9999 2.07985 23.4014 1.24799 22.2036C0.41574 21.0058 0 19.1911 0 16.7591V6.61046C0 4.43482 0.484328 2.78872 1.45375 1.67331C2.42279 0.55828 3.86734 0 5.78741 0C7.34155 0 8.54854 0.311135 9.40799 0.933021C10.2671 1.55452 10.8617 2.45957 11.1909 3.64817ZM13.4941 0.219727H18.2117V19.776H23.0665V23.7805H13.4941V0.219727ZM31.0753 17.5815C31.0753 18.2402 31.0021 18.7521 30.8558 19.118C30.7094 19.4839 30.4259 19.6659 30.0055 19.6659C29.5664 19.6659 29.2648 19.4927 29.1005 19.1452C28.9357 18.798 28.8533 18.2857 28.8533 17.6091V6.11625C28.8533 4.92842 29.2468 4.33374 30.0331 4.33374C30.4534 4.33374 30.732 4.49391 30.8696 4.81385C31.0067 5.13418 31.0753 5.55031 31.0753 6.06222V17.5815ZM30.0054 0C28.1034 0 26.6592 0.51728 25.6714 1.54993C24.6843 2.58295 24.1904 4.1141 24.1904 6.14376V17.3626C24.1904 19.4651 24.6843 21.097 25.6714 22.258C26.6592 23.4198 28.1034 23.9999 30.0054 23.9999C31.9067 23.9999 33.3517 23.424 34.3391 22.2718C35.3265 21.12 35.8204 19.4838 35.8204 17.3626V6.14376C35.8204 4.1141 35.3265 2.58295 34.3391 1.54993C33.3517 0.51728 31.9067 0 30.0054 0ZM42.7868 19.6387C44.0118 19.6387 44.6249 19.054 44.6249 17.8834V14.9484C44.6249 14.2353 44.5195 13.6962 44.3096 13.3302C44.0988 12.9647 43.7287 12.7819 43.1984 12.7819H42.3209V19.6115L42.7868 19.6387ZM43.3079 3.84021H42.3209V9.07892H43.2807C43.6827 9.07892 43.957 8.92795 44.1034 8.62601C44.2498 8.32484 44.323 7.89952 44.323 7.35082V4.99164C44.323 4.22415 43.9842 3.84021 43.3079 3.84021ZM49.0134 6.63766C49.0134 8.88688 48.2083 10.2307 46.5994 10.6698C47.5868 10.9257 48.2819 11.52 48.6842 12.4523C49.0862 13.3853 49.2873 14.6191 49.2873 16.1549C49.2873 18.6604 48.9122 20.5575 48.1627 21.8469C47.4128 23.1355 46.0599 23.7807 44.1034 23.7807H37.7125V0.219556H44.1034C45.8223 0.219556 47.0703 0.64066 47.8474 1.48134C48.6244 2.3224 49.0134 3.69376 49.0134 5.59544V6.63766ZM55.4313 16.2102L56.3092 4.22422H56.5287L57.571 16.2102H55.4313ZM52.4965 0.22002L50.2201 23.7808H54.8009L55.0749 19.9679H57.9276L58.2567 23.7808H62.7276L60.4784 0.22002H52.4965ZM64.1537 0.219727H68.8713V19.776H73.7261V23.7805H64.1537V0.219727ZM78.5473 23.7804H83.1001V0.21958H78.5473V23.7804ZM92.1784 0.21958L94.1532 14.5919L96.1281 0.21958H103.369V23.7804H99.0628V6.80207L96.3476 23.7804H92.1236L89.2437 6.80207V23.7804H84.992V0.21958H92.1784ZM112.133 8.98287C112.051 9.376 111.877 9.67756 111.612 9.88754C111.346 10.0983 110.93 10.2037 110.364 10.2037H110.089V4.49824H110.61C111.269 4.49824 111.708 4.7178 111.927 5.15653C112.146 5.59526 112.256 6.30872 112.256 7.29577C112.256 8.02763 112.215 8.58974 112.133 8.98287ZM115.712 2.04362C114.908 0.827818 113.564 0.219727 111.68 0.219727H105.454V23.7805H110.09V14.4545H112.01C113.856 14.4545 115.136 13.8606 115.85 12.672C116.563 11.4834 116.919 9.71891 116.919 7.37812C116.919 5.03771 116.517 3.25942 115.712 2.04362ZM122.878 4.22422L122 16.2102H124.14L123.098 4.22422H122.878ZM116.788 23.7808L119.066 0.22002H127.047L129.296 23.7808H124.825L124.496 19.9679H121.644L121.37 23.7808H116.788ZM137.415 17.8835C137.415 19.0728 137.049 19.666 136.317 19.666C135.951 19.666 135.677 19.525 135.495 19.2414C135.312 18.9579 135.22 18.5054 135.22 17.8835V6.06191C135.22 5.4952 135.298 5.06566 135.454 4.77292C135.609 4.48056 135.897 4.33381 136.317 4.33381C136.72 4.33381 137.003 4.46217 137.168 4.71813C137.332 4.97447 137.415 5.4404 137.415 6.11632V9.6001H142.105V5.54041C142.105 3.7487 141.574 2.37734 140.514 1.42669C139.454 0.476044 138.055 0.000146484 136.317 0.000146484C134.324 0.000146484 132.861 0.594827 131.929 1.78266C130.997 2.97202 130.53 4.73575 130.53 7.07692V17.9387C130.53 19.8223 131.047 21.3029 132.08 22.3815C133.112 23.4613 134.488 24 136.208 24C140.175 24 142.16 22.0252 142.16 18.0751V13.6322H137.415V17.8835ZM145.753 4.74482H142.955V0.21958H153.268V4.74482H150.47V23.7807H145.753V4.74482Z", fill: "#001246" })), o3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 108, height: 25, viewBox: "0 0 108 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("g", { clipPath: "url(#clip0_2024_40345)" }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0.855469V1.59582H2.9687V23.3497H0V24.0901H2.9687H19.668V19.5134H18.3543V23.3497H9.53687V1.59582H12.5061V0.855469H0Z", fill: "#0A0A66" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M65.3869 23.3492V13.1913C65.3869 7.14114 62.2327 5.97756 58.7445 5.97756C56.4436 5.97756 54.5881 6.52053 52.3986 8.03312V6.21206L44.0229 6.21367V6.95018H45.8309L45.8304 23.3492H43.975V24.0896H45.8304H54.2542V23.3492H52.3986V8.96134C53.9572 7.83658 55.4045 7.2549 56.7405 6.9833C58.8559 7.21597 58.8186 10.3602 58.8186 12.8423V23.3492H56.9631V24.0896H58.8186H65.09H67.2425V23.3492H65.3869ZM40.9727 23.3492V6.21034H40.6757L40.6725 6.21367H34.4821V6.21034H32.5938V6.95029H34.4049L34.4043 21.3386C32.8457 22.4633 31.3985 23.045 30.0626 23.3164C27.9473 23.0839 27.9844 19.9397 27.9844 17.4575V6.21034H27.9784V6.21367H19.6063V6.95029H21.4138L21.416 17.1084C21.416 23.1588 24.5704 24.3225 28.0588 24.3225C30.3593 24.3225 32.2149 23.7793 34.4043 22.2668V24.0896H37.0021H42.8281V23.3492H40.9727ZM78.2677 21.2196C74.3341 22.5771 73.3322 20.5215 73.3322 19.0088C73.3322 15.7123 77.2285 14.2359 78.2677 12.2967V21.2196ZM84.836 23.3493V14.9755C84.836 8.1494 81.6446 6.21027 76.8946 6.21027H75.9669C74.9147 6.2121 74.1451 6.31038 74.1451 6.31038C71.7914 6.59229 70.6794 7.12882 70.2099 7.4417C69.2997 8.00586 68.6892 9.04246 68.6892 10.2285C68.6892 12.0169 70.0763 13.4668 71.7875 13.4668C72.7299 13.4668 73.5734 13.0264 74.1416 12.3326C72.8076 12.1121 71.7875 10.9051 71.7875 9.44888C71.7875 8.00758 72.7871 7.35138 74.1011 7.11333C74.1051 7.11237 74.1086 7.11108 74.1128 7.11032C74.8005 6.99807 75.7037 6.99119 76.527 7.06871C76.5722 7.07291 76.8257 7.10839 76.8625 7.12172C78.2365 7.46256 78.2677 8.63807 78.2677 10.6704C77.7852 15.1693 67.506 13.618 67.506 20.2499C67.506 23.4689 69.8438 24.3223 71.7736 24.3223C74.4455 24.3223 77.1544 22.5771 78.2677 21.7238V24.0895H84.5391H86.6915V23.3493H84.836ZM106.294 7.487C106.294 4.92727 104.661 3.37598 101.915 3.37598C99.6141 3.37598 98.1295 3.91884 95.9402 5.43154V3.60876H95.6435C93.194 6.2459 89.9658 6.51749 87.5165 6.51749V7.25777C88.0732 7.25777 88.704 7.25777 89.3718 7.18024V23.3492H87.5165V24.0896H89.3718H97.7957V23.3492H95.9402V6.35965C96.5919 5.89001 97.1887 5.50627 97.7562 5.20736C97.7625 5.20424 97.769 5.20037 97.7754 5.19726C97.8926 5.13586 98.0085 5.07812 98.1233 5.02404C98.492 4.84158 98.9201 4.63622 99.1368 4.57278C99.1385 4.57235 99.1401 4.57213 99.1418 4.5716C99.4232 4.47182 99.7245 4.41741 100.038 4.41741C101.581 4.41741 102.832 5.18435 102.832 6.79704C102.832 8.16341 101.934 9.31021 100.721 9.62869C101.287 10.4118 102.184 10.9182 103.195 10.9182C104.907 10.9182 106.294 9.46848 106.294 7.6801C106.294 7.65301 106.292 7.62624 106.292 7.59936C106.293 7.56194 106.294 7.52485 106.294 7.487Z", fill: "#0A0A66" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.739 19.7826C106.649 21.232 105.435 22.3801 103.949 22.3801C102.405 22.3801 101.153 21.1401 101.153 19.6103C101.153 18.5162 101.791 17.5701 102.72 17.1201C100.962 17.3702 99.6104 18.8811 99.6104 20.7078C99.6104 22.7094 101.233 24.3319 103.234 24.3319C105.236 24.3319 106.859 22.7094 106.859 20.7078C106.859 20.3881 106.817 20.078 106.739 19.7826Z", fill: "#0A0A66" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M100.744 20.4491C100.744 19.0232 101.621 17.7768 102.875 17.1016C101.042 17.2819 99.6104 18.8277 99.6104 20.708C99.6104 22.7095 101.233 24.332 103.234 24.332C103.522 24.332 103.802 24.2984 104.071 24.235C102.215 23.8412 100.744 22.2957 100.744 20.4491Z", fill: "#00CCCC" })), /* @__PURE__ */ C.createElement("defs", null, /* @__PURE__ */ C.createElement("clipPath", { id: "clip0_2024_40345" }, /* @__PURE__ */ C.createElement("rect", { width: 107.478, height: 24, fill: "white", transform: "translate(0 0.855469)" })))), s3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 163, height: 24, viewBox: "0 0 163 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("g", { clipPath: "url(#clip0_2024_49250)" }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.71059 10.7704C9.11012 10.8409 9.59435 10.8748 10.1605 10.8748C10.9779 10.8748 11.7558 10.7633 12.4998 10.5431C13.2177 10.3331 13.893 9.99804 14.4946 9.55341C15.0706 9.13034 15.5435 8.58258 15.8781 7.95106C16.2113 7.32141 16.3793 6.60988 16.3793 5.81506C16.3186 4.584 15.9501 3.55906 15.2739 2.73741C14.5833 1.90837 13.6777 1.28559 12.6565 0.937412C11.5511 0.550362 10.3872 0.356936 9.216 0.365647H0V0.592941H2.07529V18.1412H0V18.3685H10.2056V18.1412H7.416V10.3765C7.87765 10.5685 8.30824 10.6998 8.70918 10.7704H8.71059ZM10.7153 1.99906C11.0965 2.93506 11.304 4.16047 11.3336 5.67529C11.3336 6.64094 11.2941 7.45129 11.2122 8.10918C11.1318 8.76706 10.9158 9.34024 10.5656 9.82729C10.2155 10.3158 9.67341 10.5586 8.93929 10.5586C8.81223 10.5586 8.57788 10.5191 8.23906 10.4372C7.95035 10.3751 7.67248 10.2704 7.41459 10.1266V0.592941H8.31529C9.53224 0.592941 10.3341 1.06165 10.7153 1.99906ZM19.5529 6.02824C17.9647 6.69234 16.6953 7.94559 16.0108 9.52518C15.6644 10.3166 15.4819 11.17 15.4744 12.0339C15.4744 13.1972 15.7793 14.2913 16.392 15.3148C16.9853 16.3202 17.8186 17.1628 18.8174 17.7671C19.8254 18.3784 20.8828 18.6847 21.9939 18.6847C23.1233 18.6847 24.1892 18.384 25.1944 17.784C26.1916 17.1919 27.0222 16.3564 27.6085 15.3558C28.2113 14.3393 28.512 13.2452 28.512 12.0776C28.512 11.3322 28.3807 10.5798 28.1167 9.82165C27.8455 9.05274 27.4391 8.33846 26.9167 7.71247C26.3618 7.04768 25.6698 6.5107 24.888 6.13835C24.0692 5.73741 23.1332 5.53129 22.0828 5.52141C21.1948 5.52141 20.3506 5.69082 19.5529 6.02824ZM22.8706 6.21882C23.0527 6.51812 23.1671 6.97129 23.2136 7.57694C23.2602 8.18118 23.2842 9.11435 23.2842 10.3736V12.4179C23.2842 14.4395 23.2645 15.8188 23.2249 16.5572C23.1854 17.2955 23.0781 17.7995 22.9002 18.0692C22.7252 18.3388 22.4089 18.4828 21.9515 18.5012C21.5647 18.5012 21.2753 18.3685 21.0833 18.1031C20.8899 17.8362 20.7628 17.4494 20.7021 16.9412C20.6428 16.4329 20.6132 15.7426 20.6132 14.8673C20.6132 14.6414 20.6174 14.2574 20.6245 13.7153C20.6315 13.1718 20.6358 12.7412 20.6358 12.4193V9.94165C20.6358 8.82212 20.664 7.98212 20.7233 7.42165C20.7798 6.85977 20.9068 6.44471 21.0974 6.17506C21.288 5.90541 21.5873 5.76988 21.9967 5.76988C22.3976 5.76988 22.6885 5.91953 22.8706 6.21882ZM35.3816 6.35435C35.2034 6.5069 35.0589 6.69489 34.9573 6.90635C34.8557 7.11782 34.7992 7.34811 34.7915 7.58259C34.7915 8.12188 34.9807 8.58353 35.3576 8.96612C35.7346 9.34729 36.1906 9.53929 36.7285 9.53929C37.2367 9.53929 37.6616 9.34729 38.0075 8.96188C38.3435 8.60085 38.5288 8.12514 38.5256 7.632C38.4833 6.84988 38.0838 6.27106 37.3256 5.89835C36.5661 5.52424 35.6612 5.33788 34.6122 5.33788C33.6846 5.33281 32.7645 5.50533 31.9016 5.84612C31.0504 6.18494 30.3685 6.67482 29.8546 7.32C29.342 7.9626 29.0698 8.76402 29.0852 9.58588C29.0852 11.2235 30.0452 12.4489 31.9652 13.2621C32.904 13.6532 33.6734 14.0922 34.2706 14.5793C34.8692 15.0649 35.1685 15.6805 35.1685 16.4216C35.1304 17.7529 34.272 18.4193 32.5906 18.4193C31.7901 18.4193 31.1746 18.2979 30.744 18.0579C31.1746 18.0579 31.6758 17.9209 32.2433 17.6485C32.8136 17.3732 33.1256 16.7732 33.1821 15.8499C33.1821 15.2132 32.9788 14.6965 32.5722 14.2984C32.1848 13.9093 31.6627 13.6839 31.1139 13.6687C30.7087 13.6687 30.3304 13.7746 29.976 13.9864C29.6216 14.1995 29.3393 14.4805 29.1261 14.8334C28.9144 15.1835 28.8099 15.5534 28.8099 15.9402C28.8099 16.5656 29.0386 17.0838 29.4974 17.4988C29.9576 17.9125 30.5393 18.2174 31.2438 18.4136C31.9496 18.6085 32.6795 18.7158 33.4362 18.7341C34.1633 18.7341 34.8762 18.6353 35.5736 18.4376C36.2711 18.24 36.9021 17.9435 37.4682 17.5511C38.0329 17.1572 38.4791 16.6744 38.8038 16.0998C39.1285 15.5252 39.2894 14.8744 39.2894 14.1459C39.2753 13.4598 39.1186 12.864 38.8207 12.3614C38.5273 11.864 38.1329 11.4336 37.6631 11.0979C37.0838 10.6961 36.4728 10.342 35.8362 10.0391C35.3677 9.82853 34.9004 9.61535 34.4344 9.39953C33.9662 9.19072 33.5366 8.90434 33.1638 8.55247C32.9984 8.39516 32.8662 8.20629 32.775 7.99703C32.6838 7.78777 32.6355 7.56236 32.6329 7.33412C32.6329 6.80471 32.8885 6.37835 33.4009 6.05365C33.9134 5.72894 34.4852 5.56518 35.1205 5.56518C35.7501 5.56518 36.2739 5.664 36.6904 5.85882C36.2071 5.85208 35.7393 6.02921 35.3816 6.35435ZM40.9101 14.6456C40.9101 15.3911 41.0329 16.0588 41.2772 16.6489C41.5242 17.2376 41.9322 17.7106 42.5054 18.0664C43.0772 18.4235 43.8212 18.6141 44.736 18.6395C45.1228 18.6395 45.5252 18.5534 45.9431 18.3798C46.3624 18.2061 46.7054 17.9605 46.9793 17.64C47.2504 17.3209 47.3873 16.9581 47.3873 16.5515V13.5826H47.2009V16.5064C47.2009 16.7986 47.1304 17.064 46.9849 17.3054C46.8409 17.5454 46.6419 17.664 46.392 17.664C46.1365 17.664 45.9388 17.5412 45.7991 17.2969C45.6579 17.0513 45.5873 16.7887 45.5873 16.5064V6.65647H47.7304V5.76988H45.6325V0.727059C44.9647 1.55435 44.3661 2.14306 43.8367 2.49459C43.3073 2.84612 42.6847 3.02118 41.9675 3.02118C41.6277 3.02194 41.2884 2.99217 40.9539 2.93224V5.72612H39.3191V6.61271H40.9101V14.6456ZM53.0965 0.365647V0.638118H55.8409V18.0974H53.1868V18.3685H58.9948V18.0974H56.16V1.95671L61.2706 18.6395L66.3134 1.752V18.1412H63.8061V18.3685H74.6753V18.1412H71.9308V0.638118H74.5849V0.365647H66.3586L63.9191 8.60753L61.4569 0.367059H53.0965V0.365647ZM76.7689 7.2C76.9341 7.008 77.3068 6.79765 77.8899 6.56894C78.4729 6.33882 79.0899 6.22447 79.7435 6.22447C80.1473 6.22447 80.5129 6.29506 80.8391 6.43765C81.1652 6.58024 81.4249 6.80047 81.6184 7.10118C81.8104 7.39906 81.9078 7.77318 81.9078 8.21929V10.0376C81.9078 10.5784 81.6494 11.0245 81.1341 11.376C80.6188 11.7289 80.0711 11.9633 79.4894 12.0776C78.3656 12.2612 77.64 12.3868 77.3153 12.4489C76.9189 12.5384 76.5349 12.6759 76.1718 12.8584C75.7341 13.0701 75.3784 13.3878 75.1073 13.8127C74.8348 14.2376 74.6922 14.7953 74.6767 15.4871C74.6767 16.0631 74.8151 16.5911 75.0932 17.0711C75.3699 17.5511 75.7609 17.9322 76.2649 18.216C76.7689 18.4984 77.3464 18.6395 77.9944 18.6395C79.0673 18.6395 79.9002 18.3784 80.4988 17.8532C81.0974 17.3294 81.4969 16.7845 81.696 16.2212C81.8979 15.6565 81.9981 15.2753 81.9981 15.0762C81.9981 15.2951 82.0842 15.6847 82.2593 16.248C82.4329 16.8127 82.7901 17.3591 83.3294 17.8899C83.8701 18.4193 84.6381 18.6847 85.6348 18.6847C87.5252 18.6438 88.4697 17.7812 88.4697 16.0955V13.7647H88.2833V16.1478C88.2833 16.5614 88.1788 16.9666 87.9727 17.3633C87.7638 17.7614 87.5379 17.9605 87.2951 17.9605C87.1875 17.9615 87.0811 17.9393 86.9829 17.8955C86.8847 17.8516 86.7971 17.7871 86.7261 17.7064C86.5685 17.5358 86.4839 17.3103 86.4904 17.0781V8.60753C86.4904 7.96941 86.208 7.43859 85.6405 7.01788C85.0758 6.59577 84.3473 6.29082 83.4593 6.10024C82.5482 5.90783 81.6192 5.81224 80.688 5.81506C79.8438 5.81506 79.0433 5.93224 78.2866 6.16659C77.5299 6.40094 76.9115 6.76376 76.4315 7.25647C75.9515 7.74635 75.7115 8.34918 75.7115 9.06353C75.7115 9.72 75.9247 10.2748 76.3525 10.7252C76.7802 11.1769 77.3096 11.4028 77.9435 11.4028C78.3671 11.4028 78.7595 11.2941 79.1224 11.0809C79.477 10.8721 79.774 10.5781 79.9865 10.2256C80.1989 9.87314 80.3202 9.47325 80.3393 9.06212C80.3393 8.64847 80.2362 8.27859 80.0287 7.95106C79.8305 7.63833 79.5566 7.38069 79.2323 7.20201C78.908 7.02334 78.5439 6.92941 78.1737 6.92894C77.4988 6.97976 77.0301 7.07012 76.7689 7.2ZM81.6819 15.3176C81.5601 15.8162 81.361 16.2925 81.0918 16.7294C80.8489 17.1106 80.5976 17.2984 80.3393 17.2984C80.0951 17.28 79.9355 17.1049 79.8593 16.776C79.7817 16.4442 79.7435 15.9925 79.7435 15.4207V14.7388C79.7435 13.9186 79.8 13.2776 79.9144 12.8188C80.0287 12.3572 80.3167 11.9901 80.7769 11.7176C81.0614 11.5534 81.3282 11.3604 81.5732 11.1416C81.6943 11.0325 81.8062 10.9135 81.9078 10.7859V13.7125C81.9078 14.2193 81.8329 14.7544 81.6819 15.3176ZM96.7511 5.27012C96.8668 5.58071 96.9939 5.83906 97.1322 6.04659C97.272 6.25412 97.3567 6.35718 97.3864 6.35718C97.4005 6.35718 97.2536 6.30635 96.9445 6.20188C96.6084 6.09147 96.2662 6.00096 95.9195 5.93082C95.5456 5.85379 95.1648 5.815 94.7831 5.81506C94.0306 5.81506 93.2767 5.952 92.5214 6.22447C91.8068 6.47177 91.1625 6.88833 90.6438 7.43859C90.1482 7.97506 89.8913 8.60612 89.8772 9.33459C89.8772 9.90635 90.0155 10.3976 90.2922 10.8056C90.5704 11.2151 90.8711 11.5285 91.1958 11.7473C91.5219 11.9675 91.7266 12.0776 91.8085 12.0776C91.3638 12.2104 90.8075 12.5167 90.1426 12.9981C89.4762 13.4781 89.1431 14.1854 89.1431 15.12C89.1431 16.0588 89.4537 16.7831 90.0748 17.2941C90.696 17.8024 91.2141 18.1327 91.6278 18.2795C91.1732 18.3459 90.6014 18.5548 89.9167 18.9064C89.232 19.2579 88.8904 19.8508 88.8904 20.6852C88.8904 21.3911 89.1699 21.9939 89.7304 22.4951C90.2908 22.9962 91.0038 23.3704 91.8692 23.6245C92.727 23.874 93.6158 24.0005 94.5092 24C95.7064 24 96.8315 23.8024 97.8889 23.4042C98.9449 23.0075 99.8005 22.4019 100.454 21.5859C101.108 20.7713 101.434 19.7746 101.434 18.5958C101.434 17.6612 101.246 16.8551 100.869 16.176C100.492 15.4984 99.8908 14.9718 99.0621 14.5962C98.2334 14.2221 97.1746 14.0344 95.8857 14.0344C95.6118 14.0344 95.1445 14.0569 94.4852 14.1007C93.8259 14.1459 93.3402 14.1671 93.0297 14.1671C91.6489 14.1671 90.96 13.7986 90.96 13.0588C90.96 12.8442 91.0334 12.6819 91.1816 12.5746C91.4104 12.4197 91.6523 12.2851 91.9045 12.1722C92.0654 12.2795 92.4466 12.4306 93.0452 12.6268C93.6452 12.8216 94.2762 12.9205 94.9398 12.9205C95.7073 12.9113 96.4675 12.7704 97.1873 12.504C97.9264 12.2536 98.5979 11.8362 99.1497 11.2842C99.6762 10.7478 99.9402 10.1195 99.9402 9.39953C99.9402 8.79247 99.8019 8.29835 99.528 7.91294C99.2555 7.52894 98.8433 7.11388 98.2941 6.66777C97.7449 6.22306 97.3454 5.84329 97.0941 5.53129C96.8428 5.21929 96.7172 4.81271 96.7172 4.31435C96.7355 3.81176 96.8668 3.41929 97.1082 3.13553C97.3497 2.85318 97.5501 2.66965 97.7068 2.58494C97.6027 2.77737 97.5071 2.97427 97.4202 3.17506C97.3153 3.38927 97.2557 3.62286 97.2452 3.86118C97.2452 4.36376 97.4344 4.79294 97.8141 5.14588C98.1925 5.49882 98.6329 5.67529 99.1355 5.67529C99.6254 5.67529 100.042 5.50447 100.384 5.16C100.724 4.81553 100.906 4.39765 100.928 3.90494C100.928 3.57176 100.834 3.25835 100.645 2.96471C100.443 2.66498 100.171 2.41973 99.8515 2.25076C99.5323 2.08179 99.1762 1.99436 98.8151 1.99624C98.1882 2.04424 97.6645 2.26165 97.2423 2.65129C96.8216 3.03953 96.5986 3.59435 96.5774 4.31576C96.5774 4.64047 96.6339 4.95953 96.7511 5.27012ZM96.0706 10.1492C96.0706 10.8988 96 11.4904 95.8574 11.9195C95.7148 12.3501 95.4085 12.5788 94.9398 12.6042C94.3892 12.6042 94.0362 12.3035 93.8838 11.7007C93.7285 11.0979 93.6522 10.3242 93.6522 9.37835C93.6522 9.25694 93.6494 9.07059 93.6409 8.81929C93.6345 8.62689 93.6308 8.4344 93.6296 8.24188C93.6296 7.51765 93.7115 6.94729 93.8725 6.52941C94.0334 6.11153 94.3525 5.90259 94.8282 5.90259C95.0424 5.90049 95.2511 5.97006 95.4212 6.10024C95.5962 6.23153 95.7473 6.53788 95.8772 7.02353C96.0057 7.50776 96.0706 8.23059 96.0706 9.19624V10.1492ZM97.2 18.4828C97.6729 18.6169 98.1176 18.864 98.5327 19.2254C98.9492 19.5854 99.1652 20.0866 99.1793 20.7304C99.1793 21.4729 98.9506 22.0673 98.4904 22.5148C98.0043 22.9774 97.4041 23.3024 96.7511 23.4565C96.0173 23.6414 95.263 23.7325 94.5064 23.7275C93.4052 23.7275 92.4932 23.4678 91.7689 22.9468C91.0461 22.4245 90.6833 21.6113 90.6833 20.5031C90.6833 19.608 91.1068 18.8668 91.9496 18.2795H96.1609C96.3812 18.2795 96.7285 18.3473 97.2014 18.4828H97.2ZM103.601 7.2C103.766 7.008 104.14 6.79765 104.723 6.56894C105.313 6.33773 105.942 6.22083 106.576 6.22447C106.981 6.22447 107.346 6.29506 107.672 6.43765C107.997 6.58024 108.257 6.80047 108.45 7.10118C108.644 7.39906 108.74 7.77318 108.74 8.21929V10.0376C108.74 10.5784 108.483 11.0245 107.968 11.376C107.452 11.7289 106.904 11.9633 106.323 12.0776C105.198 12.2612 104.473 12.3868 104.149 12.4489C103.825 12.5125 103.443 12.6494 103.005 12.8584C102.568 13.0701 102.212 13.3878 101.941 13.8127C101.668 14.2376 101.524 14.7953 101.51 15.4871C101.502 16.0431 101.646 16.5908 101.925 17.0715C102.205 17.5523 102.61 17.9479 103.097 18.216C103.602 18.4984 104.178 18.6395 104.826 18.6395C105.899 18.6395 106.734 18.3784 107.332 17.8532C107.929 17.3294 108.329 16.7845 108.529 16.2212C108.73 15.6565 108.83 15.2753 108.83 15.0762C108.83 15.2951 108.918 15.6847 109.091 16.248C109.266 16.8127 109.624 17.3591 110.164 17.8899C110.702 18.4193 111.472 18.6847 112.468 18.6847C114.357 18.6438 115.302 17.7812 115.302 16.0955V13.7647H115.117V16.1478C115.117 16.5614 115.012 16.9666 114.805 17.3633C114.596 17.7614 114.37 17.9605 114.127 17.9605C114.02 17.9613 113.914 17.939 113.816 17.8952C113.718 17.8513 113.63 17.7869 113.56 17.7064C113.401 17.5361 113.316 17.3105 113.322 17.0781V8.60753C113.322 7.96941 113.04 7.43859 112.474 7.01788C111.909 6.59577 111.181 6.29082 110.293 6.10024C109.381 5.90779 108.452 5.8122 107.52 5.81506C106.707 5.81052 105.898 5.92903 105.12 6.16659C104.362 6.40094 103.744 6.76376 103.264 7.25647C103.028 7.49377 102.843 7.77611 102.719 8.08661C102.596 8.39711 102.536 8.72938 102.544 9.06353C102.544 9.72 102.758 10.2748 103.186 10.7252C103.612 11.1769 104.143 11.4028 104.777 11.4028C105.2 11.4028 105.593 11.2941 105.954 11.0809C106.309 10.8721 106.606 10.5781 106.818 10.2256C107.031 9.87314 107.152 9.47325 107.171 9.06212C107.171 8.64847 107.068 8.27859 106.862 7.95106C106.664 7.63814 106.39 7.38036 106.066 7.20166C105.742 7.02296 105.377 6.92915 105.007 6.92894C104.332 6.97976 103.864 7.07012 103.601 7.2ZM108.515 15.3176C108.366 15.8824 108.168 16.3511 107.925 16.7294C107.681 17.1106 107.431 17.2984 107.171 17.2984C106.928 17.28 106.768 17.1049 106.691 16.776C106.614 16.4442 106.576 15.9925 106.576 15.4207V14.7388C106.576 13.9186 106.632 13.2776 106.748 12.8188C106.861 12.3572 107.149 11.9901 107.609 11.7176C107.962 11.5031 108.227 11.3111 108.407 11.1416C108.583 10.9708 108.696 10.8522 108.74 10.7859V13.7125C108.74 14.2193 108.665 14.7544 108.515 15.3176ZM118.9 6.88376C119.372 6.88376 119.771 6.98824 120.097 7.19435C120.422 7.40047 120.822 7.71953 121.295 8.15153C121.768 8.58212 122.197 8.90541 122.582 9.12141C122.968 9.33741 123.439 9.44612 123.994 9.44612C124.801 9.43059 125.445 9.25412 125.922 8.91671C126.4 8.57788 126.726 8.24329 126.899 7.91012C127.073 7.57553 127.177 7.32565 127.21 7.16047C127.117 8.34635 126.815 9.23294 126.299 9.82306C125.787 10.4146 125.183 10.7972 124.488 10.9694C123.792 11.1431 122.921 11.256 121.871 11.3082C121.246 11.3563 120.63 11.4776 120.034 11.6696C119.364 11.8793 118.725 12.1764 118.134 12.5534C117.527 12.9388 117.025 13.4146 116.629 13.9821C116.228 14.5588 116.002 15.2385 115.976 15.9402C115.976 16.3581 116.061 16.7774 116.226 17.1995C116.393 17.6202 116.63 17.9661 116.936 18.2358C117.244 18.5054 117.6 18.6395 118.004 18.6395C118.289 18.6395 118.54 18.5435 118.756 18.3487C118.858 18.2657 118.94 18.1612 118.996 18.0429C119.052 17.9245 119.082 17.7951 119.082 17.664C119.082 17.3026 118.978 17.0259 118.768 16.8367C118.543 16.6405 118.252 16.538 117.954 16.5501C117.64 16.5501 117.39 16.6941 117.202 16.9793C117.014 17.2673 116.921 17.4805 116.921 17.6202C116.921 16.5304 117.435 15.9854 118.464 15.9854C118.986 15.9896 119.438 16.104 119.819 16.3313C120.2 16.5586 120.645 16.8918 121.151 17.3322C121.657 17.7713 122.105 18.1002 122.495 18.3162C122.884 18.5322 123.352 18.6409 123.895 18.6409C124.786 18.6409 125.527 18.3798 126.117 17.8588C126.707 17.3365 127.138 16.6687 127.408 15.8513C127.677 15.0353 127.813 14.1713 127.813 13.2579V11.1967H127.581V12.6042C127.581 13.1478 127.324 13.5784 126.812 13.896C126.302 14.2124 125.713 14.3775 125.113 14.3718C124.749 14.3718 124.422 14.3435 124.132 14.2885C123.74 14.2097 123.351 14.1174 122.965 14.0118C122.478 13.8833 122.072 13.7859 121.748 13.7209C121.386 13.6531 121.018 13.621 120.649 13.6249C119.534 13.6616 118.681 13.9228 118.094 14.4113C117.505 14.8984 117.126 15.4376 116.951 16.0264C116.784 16.5719 116.696 17.1387 116.691 17.7092C116.31 17.0541 116.116 16.4668 116.116 15.9402C116.159 15.1101 116.427 14.4155 116.924 13.8565C117.435 13.2892 118.084 12.8645 118.808 12.624C119.593 12.3552 120.417 12.2174 121.247 12.216C122.411 12.1906 123.453 11.9732 124.372 11.5624C125.29 11.1529 126.007 10.5854 126.525 9.86118C127.042 9.13661 127.33 8.27347 127.351 7.38353C127.358 6.91163 127.221 6.44885 126.959 6.05647C126.697 5.66541 126.352 5.47059 125.927 5.47059C125.64 5.4937 125.372 5.62013 125.171 5.82635C125.07 5.91675 124.989 6.02696 124.933 6.15011C124.877 6.27326 124.846 6.40671 124.844 6.54212C124.845 6.67652 124.873 6.80935 124.926 6.93294C124.978 7.05653 125.055 7.16841 125.152 7.26212C125.243 7.364 125.354 7.44546 125.479 7.50118C125.604 7.55689 125.739 7.5856 125.876 7.58541C126.051 7.58541 126.237 7.50776 126.433 7.35529C126.631 7.20282 126.775 7.07718 126.868 6.97835C126.868 7.14776 126.792 7.35953 126.642 7.61365C126.488 7.86635 126.157 7.99341 125.643 7.99341C125.235 7.99341 124.896 7.90165 124.626 7.72094C124.192 7.40897 123.776 7.07341 123.378 6.71576C122.816 6.22588 122.301 5.85882 121.83 5.61459C121.36 5.37035 120.806 5.24894 120.169 5.24894C119.571 5.25459 118.983 5.41197 118.461 5.70635C117.911 6.00036 117.438 6.42142 117.083 6.93459C116.735 7.42434 116.542 8.00691 116.527 8.60753C116.527 9.28094 116.726 9.87953 117.126 10.4061C117.524 10.9327 118.024 11.1967 118.622 11.1967C118.969 11.1967 119.3 11.1134 119.61 10.9468C119.911 10.7896 120.169 10.5619 120.363 10.2833C120.549 10.0189 120.649 9.70331 120.649 9.37976C120.649 8.89271 120.456 8.46353 120.071 8.09506C119.893 7.91768 119.682 7.7773 119.45 7.68206C119.218 7.58682 118.969 7.53861 118.718 7.54024C118.175 7.54024 117.74 7.73506 117.412 8.12471C117.088 8.50485 116.913 8.99021 116.921 9.48988C116.921 7.75341 117.58 6.88376 118.9 6.88376ZM133.662 4.872C134.058 4.62494 134.356 4.30024 134.555 3.89506C134.753 3.49129 134.853 3.06212 134.853 2.60753C134.853 1.90729 134.623 1.29741 134.164 0.777882C133.704 0.259765 133.059 0 132.226 0C131.397 0 130.749 0.261176 130.28 0.780706C129.812 1.30165 129.577 1.91012 129.577 2.60753C129.577 3.05929 129.68 3.48706 129.884 3.89224C130.087 4.29795 130.401 4.63768 130.79 4.872C131.188 5.12047 131.667 5.24329 132.226 5.24329C132.784 5.24329 133.262 5.12047 133.66 4.872H133.662ZM129.878 6.04235V18.3247H134.555V5.85882H127.897V6.04235H129.877H129.878ZM136.793 6.22447V18.3685H141.466V9.85553C141.466 9.43765 141.522 8.99435 141.641 8.52424C141.757 8.05553 141.919 7.66306 142.127 7.34965C142.334 7.03624 142.566 6.87812 142.821 6.87812C143.421 6.87812 143.72 7.78729 143.72 9.60565C143.72 10.2198 143.685 11.0922 143.613 12.2245C143.543 13.3567 143.5 14.0287 143.49 14.2391C143.49 15.1934 143.651 16.0066 143.973 16.6814C144.296 17.3548 144.74 17.8574 145.303 18.1892C145.868 18.5195 146.507 18.6833 147.223 18.6833C148.36 18.6438 149.129 18.3939 149.538 17.9336C149.944 17.4734 150.147 16.8099 150.147 15.9402V13.8071L149.917 13.7633V15.8965C149.917 17.0965 149.647 17.7318 149.106 17.8024C148.957 17.8108 148.81 17.7687 148.687 17.6829C148.565 17.5971 148.476 17.4725 148.433 17.3294C148.316 17.0132 148.258 16.4598 148.258 15.6692C148.28 14.6628 148.311 13.6567 148.348 12.6508C148.36 12.3868 148.374 11.8715 148.393 11.1021C148.393 7.65741 147.151 5.91106 144.665 5.85882C143.879 5.85882 143.207 6.09035 142.65 6.55482C142.093 7.01788 141.68 7.64188 141.415 8.42541V6.04235H135.572V6.22447H136.792H136.793ZM153.734 6.44047C152.778 7.03202 151.991 7.85947 151.447 8.84329C150.889 9.83133 150.585 10.9429 150.563 12.0776C150.563 13.368 150.857 14.5101 151.441 15.5054C152.006 16.4824 152.83 17.2839 153.823 17.8207C154.825 18.3671 155.927 18.6395 157.127 18.6395C158.651 18.6395 159.802 18.288 160.578 17.5849C161.355 16.8805 161.843 16.1506 162.048 15.3953C162.253 14.6386 162.354 14.0344 162.354 13.5798H162.124C162.124 13.7562 162.085 14.064 162.006 14.5031C161.928 14.9407 161.761 15.4348 161.509 15.9882C161.243 16.5561 160.852 17.0562 160.365 17.4508C159.854 17.8744 159.196 18.1186 158.39 18.1849C157.278 18.1849 156.531 17.6908 156.152 16.7026C155.774 15.7144 155.585 14.6202 155.585 13.4188C155.585 12.9049 155.593 12.6494 155.608 12.6494C156.154 12.8894 156.799 13.0094 157.542 13.0094C158.273 13.0094 158.984 12.8894 159.679 12.6494C160.371 12.4094 160.945 12.0339 161.399 11.5242C161.852 11.0132 162.079 10.3807 162.079 9.62824C162.079 9.04377 161.931 8.50306 161.634 8.00612C161.326 7.49627 160.919 7.05286 160.437 6.70165C159.927 6.32449 159.361 6.03049 158.759 5.83059C158.166 5.62771 157.544 5.52281 156.918 5.52C155.792 5.52515 154.69 5.8439 153.736 6.44047H153.734ZM155.855 6.23012C156.049 5.83059 156.344 5.63153 156.737 5.63153C157.262 5.63153 157.604 5.87576 157.763 6.36282C157.923 6.85129 158.003 7.51624 158.003 8.35906V8.96894C158.003 10.0871 157.919 10.9878 157.746 11.6696C157.577 12.3515 157.163 12.6932 156.507 12.6932C156.266 12.6751 156.03 12.6119 155.812 12.5068C155.646 12.4165 155.562 12.2287 155.562 11.9449V7.632C155.562 7.09553 155.661 6.62965 155.855 6.23012Z", fill: "black" })), /* @__PURE__ */ C.createElement("defs", null, /* @__PURE__ */ C.createElement("clipPath", { id: "clip0_2024_49250" }, /* @__PURE__ */ C.createElement("rect", { width: 162.353, height: 24, fill: "white" })))), c3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 187, height: 16, viewBox: "0 0 187 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M153.841 14.4763L154.423 16H151.014L150.026 13.1692H144.076L143.064 16H139.654L145.746 0H148.309L153.515 13.6197L155.306 11.9335C156.364 12.928 157.797 13.2591 159.346 13.2591C161.272 13.2591 162.306 12.5748 162.306 11.3145C162.306 10.7618 162.141 10.2978 161.789 9.98892C161.459 9.70216 161.084 9.54585 160.31 9.43631L158.289 9.17169C156.858 8.97231 155.799 8.55262 155.047 7.86708C154.25 7.11631 153.851 6.09969 153.851 4.77415C153.851 1.968 156.058 0 159.675 0C161.976 0 163.645 0.530462 165.078 1.83385L163.01 3.75754C161.953 2.80615 160.685 2.67446 159.581 2.67446C157.843 2.67446 156.997 3.58031 156.997 4.66338C156.997 5.06092 157.138 5.48062 157.49 5.78954C157.82 6.07754 158.36 6.32 159.041 6.40862L161.014 6.67446C162.54 6.87262 163.504 7.27138 164.208 7.88923C165.101 8.68554 165.5 9.83385 165.5 11.2271C165.5 14.2757 162.8 16 159.299 16C157.089 16 155.341 15.6135 153.841 14.4763ZM70.7308 16V0H81.8077V2.78646H74.0132V6.54031H80.6507V9.32554H74.0132V13.2135H81.8077V16H70.7308ZM63.7388 10.0898L66.2372 0H69.5L65.2021 16H62.5904L59.6428 6.29169L56.6938 16H54.0846L49.8077 0H53.0717L55.5467 10.0898L58.4723 0H60.8132L63.7388 10.0898ZM83.0384 16V0H94.1154V2.78646H86.3209V6.54031H92.9584V9.32554H86.3209V13.2135H94.1154V16H83.0384ZM40.3984 6.67446C41.9246 6.87262 42.8883 7.27138 43.5923 7.88923C44.4858 8.68554 44.8846 9.83385 44.8846 11.2271C44.8846 14.2757 42.1843 16 38.684 16C36.1474 16 34.2212 15.4917 32.5769 13.9225L34.6901 11.9335C35.7486 12.928 37.1812 13.2591 38.7308 13.2591C40.6569 13.2591 41.6908 12.5748 41.6908 11.3145C41.6908 10.7618 41.5258 10.2978 41.1738 9.98892C40.844 9.70216 40.4686 9.54585 39.6944 9.43631L37.6735 9.17169C36.2409 8.97231 35.1837 8.55262 34.4329 7.86708C33.6329 7.11631 33.2341 6.09969 33.2341 4.77415C33.2341 1.968 35.4421 0 39.0594 0C41.3609 0 43.0298 0.530462 44.4624 1.83385L42.3948 3.75754C41.3375 2.80615 40.0698 2.67446 38.9658 2.67446C37.228 2.67446 36.3812 3.58031 36.3812 4.66338C36.3812 5.06092 36.5228 5.48062 36.876 5.78954C37.2034 6.07754 37.7437 6.32 38.4255 6.40862L40.3984 6.67446ZM0.576904 2.78646V0H11.6538V2.78646H7.62183V16H4.6089V2.78646H0.576904ZM21.8963 6.54031V0H25.1923V16H21.8963V9.30462H16.1806V16H12.8846V0H16.1806V6.53908H21.8963V6.54031ZM27.6538 16V0H31.3461V16H27.6538ZM166.731 16V0H170.423V16H166.731ZM176.993 10.5391H181.155L179.109 4.72L176.992 10.5391H176.993ZM180.309 0L186.423 16H183.014L182.026 13.1692H176.076L175.064 16H171.654L177.746 0H180.309ZM144.993 10.5391H149.155L147.109 4.72L144.993 10.5391ZM115.038 16V0H118.731V16H115.038ZM109.715 0L104.168 6.35939L110.115 16H106.307L102.006 8.71877L99.8446 11.1914V16H96.5769V0H99.8446V6.96615L105.742 0H109.715ZM130.362 9.79692V0H133.5V16H130.7L124.331 6.17846V16H121.192V0H123.992L130.362 9.79692Z", fill: "black" })), l3 = /* @__PURE__ */ b("div", {
  target: "e90s7e13"
})('display:grid;grid-template:"Title Image" min-content "Description Image" min-content/auto 60px;gap:4px 12px;align-items:center;color:#000000;font-family:', De, ";"), u3 = /* @__PURE__ */ b("div", {
  target: "e90s7e12"
})("grid-area:Title;color:#000000;font-weight:700;font-size:18px;font-family:", De, ";line-height:25.2px;"), d3 = /* @__PURE__ */ b("div", {
  target: "e90s7e11"
})("grid-area:Description;font-weight:400;font-size:12px;font-family:", Q, ";line-height:14px;"), p3 = /* @__PURE__ */ b("div", {
  target: "e90s7e10"
})({
  name: "g893ev",
  styles: "grid-area:Image"
}), f3 = () => {
  var e, t;
  const {
    config: r
  } = U(), {
    newsletterItemForDisplay: n
  } = qr(), a = {
    [r.newsletter.globalImpact]: /* @__PURE__ */ m.createElement(i3, null),
    [r.newsletter.lunar]: /* @__PURE__ */ m.createElement(o3, null),
    [r.newsletter.postMag]: /* @__PURE__ */ m.createElement(s3, null),
    [r.newsletter.thisWeekInAsia]: /* @__PURE__ */ m.createElement(c3, null)
  }, i = Hi(n), o = (e = n == null ? void 0 : n.entityId) !== null && e !== void 0 ? e : "", s = () => o in a ? a[o] : i;
  return /* @__PURE__ */ m.createElement(l3, {
    "data-qa": "article-20-theme-title"
  }, /* @__PURE__ */ m.createElement(u3, null, s()), /* @__PURE__ */ m.createElement(d3, null, n == null || (t = n.description) === null || t === void 0 ? void 0 : t.text), /* @__PURE__ */ m.createElement(p3, null, /* @__PURE__ */ m.createElement(a3, null)));
};
f3.displayName = "Article20ThemeTitle";
const m3 = /* @__PURE__ */ b("span", {
  target: "erbhhn31"
})("color:#4585ff;font-weight:700;font-size:12px;font-family:", De, ';text-transform:uppercase;&:after{content:"|";margin-inline:6px;color:#000000;}'), v3 = /* @__PURE__ */ b("span", {
  target: "erbhhn30"
})("color:#000000;font-weight:700;font-size:12px;font-family:", De, ";text-transform:uppercase;"), g3 = () => {
  var e;
  const {
    newsletterItemForDisplay: t
  } = qr();
  return /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(m3, null, "NEWSLETTER"), /* @__PURE__ */ m.createElement(v3, null, t == null || (e = t.summary) === null || e === void 0 ? void 0 : e.text));
};
g3.displayName = "Article20ThemeSummary";
const h3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), C3 = /* @__PURE__ */ b("div", {
  target: "e1ylzbp51"
})("font-size:14px;font-family:", Q, ";"), _3 = /* @__PURE__ */ b(h3, {
  target: "e1ylzbp50"
})({
  name: "1o82tng",
  styles: "margin-inline-end:12px"
}), E3 = () => /* @__PURE__ */ m.createElement(C3, {
  "data-qa": "article-theme-sign-up-button-display"
}, /* @__PURE__ */ m.createElement(_3, null), "GET OUR NEWSLETTER");
E3.displayName = "ArticleThemeSignUpButtonDisplay";
const y3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 154, height: 24, viewBox: "0 0 154 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1909 3.64817C11.52 4.83676 11.6844 6.3637 11.6844 8.22859H7.07678V6.11617C7.07678 5.55023 6.99861 5.11073 6.84343 4.79998C6.68786 4.48923 6.40891 4.33366 6.00697 4.33366C5.11073 4.33366 4.6628 4.91914 4.6628 6.08896V17.499C4.6628 18.2125 4.75438 18.752 4.93715 19.1179C5.11993 19.4838 5.43987 19.6662 5.897 19.6662C6.35412 19.6662 6.67407 19.4838 6.85722 19.1179C7.03961 18.752 7.13157 18.2125 7.13157 17.499V14.126H5.86979V10.0663H11.6296V23.7807H9.73713L8.94167 21.8059C8.10023 23.2688 6.80243 23.9999 5.04674 23.9999C3.34623 23.9999 2.07985 23.4014 1.24799 22.2036C0.41574 21.0058 0 19.1911 0 16.7591V6.61046C0 4.43482 0.484328 2.78872 1.45375 1.67331C2.42279 0.55828 3.86734 0 5.78741 0C7.34155 0 8.54854 0.311135 9.40799 0.933021C10.2671 1.55452 10.8617 2.45957 11.1909 3.64817ZM13.4941 0.219727H18.2117V19.776H23.0665V23.7805H13.4941V0.219727ZM31.0753 17.5815C31.0753 18.2402 31.0021 18.7521 30.8558 19.118C30.7094 19.4839 30.4259 19.6659 30.0055 19.6659C29.5664 19.6659 29.2648 19.4927 29.1005 19.1452C28.9357 18.798 28.8533 18.2857 28.8533 17.6091V6.11625C28.8533 4.92842 29.2468 4.33374 30.0331 4.33374C30.4534 4.33374 30.732 4.49391 30.8696 4.81385C31.0067 5.13418 31.0753 5.55031 31.0753 6.06222V17.5815ZM30.0054 0C28.1034 0 26.6592 0.51728 25.6714 1.54993C24.6843 2.58295 24.1904 4.1141 24.1904 6.14376V17.3626C24.1904 19.4651 24.6843 21.097 25.6714 22.258C26.6592 23.4198 28.1034 23.9999 30.0054 23.9999C31.9067 23.9999 33.3517 23.424 34.3391 22.2718C35.3265 21.12 35.8204 19.4838 35.8204 17.3626V6.14376C35.8204 4.1141 35.3265 2.58295 34.3391 1.54993C33.3517 0.51728 31.9067 0 30.0054 0ZM42.7868 19.6387C44.0118 19.6387 44.6249 19.054 44.6249 17.8834V14.9484C44.6249 14.2353 44.5195 13.6962 44.3096 13.3302C44.0988 12.9647 43.7287 12.7819 43.1984 12.7819H42.3209V19.6115L42.7868 19.6387ZM43.3079 3.84021H42.3209V9.07892H43.2807C43.6827 9.07892 43.957 8.92795 44.1034 8.62601C44.2498 8.32484 44.323 7.89952 44.323 7.35082V4.99164C44.323 4.22415 43.9842 3.84021 43.3079 3.84021ZM49.0134 6.63766C49.0134 8.88688 48.2083 10.2307 46.5994 10.6698C47.5868 10.9257 48.2819 11.52 48.6842 12.4523C49.0862 13.3853 49.2873 14.6191 49.2873 16.1549C49.2873 18.6604 48.9122 20.5575 48.1627 21.8469C47.4128 23.1355 46.0599 23.7807 44.1034 23.7807H37.7125V0.219556H44.1034C45.8223 0.219556 47.0703 0.64066 47.8474 1.48134C48.6244 2.3224 49.0134 3.69376 49.0134 5.59544V6.63766ZM55.4313 16.2102L56.3092 4.22422H56.5287L57.571 16.2102H55.4313ZM52.4965 0.22002L50.2201 23.7808H54.8009L55.0749 19.9679H57.9276L58.2567 23.7808H62.7276L60.4784 0.22002H52.4965ZM64.1537 0.219727H68.8713V19.776H73.7261V23.7805H64.1537V0.219727ZM78.5473 23.7804H83.1001V0.21958H78.5473V23.7804ZM92.1784 0.21958L94.1532 14.5919L96.1281 0.21958H103.369V23.7804H99.0628V6.80207L96.3476 23.7804H92.1236L89.2437 6.80207V23.7804H84.992V0.21958H92.1784ZM112.133 8.98287C112.051 9.376 111.877 9.67756 111.612 9.88754C111.346 10.0983 110.93 10.2037 110.364 10.2037H110.089V4.49824H110.61C111.269 4.49824 111.708 4.7178 111.927 5.15653C112.146 5.59526 112.256 6.30872 112.256 7.29577C112.256 8.02763 112.215 8.58974 112.133 8.98287ZM115.712 2.04362C114.908 0.827818 113.564 0.219727 111.68 0.219727H105.454V23.7805H110.09V14.4545H112.01C113.856 14.4545 115.136 13.8606 115.85 12.672C116.563 11.4834 116.919 9.71891 116.919 7.37812C116.919 5.03771 116.517 3.25942 115.712 2.04362ZM122.878 4.22422L122 16.2102H124.14L123.098 4.22422H122.878ZM116.788 23.7808L119.066 0.22002H127.047L129.296 23.7808H124.825L124.496 19.9679H121.644L121.37 23.7808H116.788ZM137.415 17.8835C137.415 19.0728 137.049 19.666 136.317 19.666C135.951 19.666 135.677 19.525 135.495 19.2414C135.312 18.9579 135.22 18.5054 135.22 17.8835V6.06191C135.22 5.4952 135.298 5.06566 135.454 4.77292C135.609 4.48056 135.897 4.33381 136.317 4.33381C136.72 4.33381 137.003 4.46217 137.168 4.71813C137.332 4.97447 137.415 5.4404 137.415 6.11632V9.6001H142.105V5.54041C142.105 3.7487 141.574 2.37734 140.514 1.42669C139.454 0.476044 138.055 0.000146484 136.317 0.000146484C134.324 0.000146484 132.861 0.594827 131.929 1.78266C130.997 2.97202 130.53 4.73575 130.53 7.07692V17.9387C130.53 19.8223 131.047 21.3029 132.08 22.3815C133.112 23.4613 134.488 24 136.208 24C140.175 24 142.16 22.0252 142.16 18.0751V13.6322H137.415V17.8835ZM145.753 4.74482H142.955V0.21958H153.268V4.74482H150.47V23.7807H145.753V4.74482Z", fill: "#001246" })), b3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 108, height: 25, viewBox: "0 0 108 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("g", { clipPath: "url(#clip0_2024_40345)" }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0.855469V1.59582H2.9687V23.3497H0V24.0901H2.9687H19.668V19.5134H18.3543V23.3497H9.53687V1.59582H12.5061V0.855469H0Z", fill: "#0A0A66" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M65.3869 23.3492V13.1913C65.3869 7.14114 62.2327 5.97756 58.7445 5.97756C56.4436 5.97756 54.5881 6.52053 52.3986 8.03312V6.21206L44.0229 6.21367V6.95018H45.8309L45.8304 23.3492H43.975V24.0896H45.8304H54.2542V23.3492H52.3986V8.96134C53.9572 7.83658 55.4045 7.2549 56.7405 6.9833C58.8559 7.21597 58.8186 10.3602 58.8186 12.8423V23.3492H56.9631V24.0896H58.8186H65.09H67.2425V23.3492H65.3869ZM40.9727 23.3492V6.21034H40.6757L40.6725 6.21367H34.4821V6.21034H32.5938V6.95029H34.4049L34.4043 21.3386C32.8457 22.4633 31.3985 23.045 30.0626 23.3164C27.9473 23.0839 27.9844 19.9397 27.9844 17.4575V6.21034H27.9784V6.21367H19.6063V6.95029H21.4138L21.416 17.1084C21.416 23.1588 24.5704 24.3225 28.0588 24.3225C30.3593 24.3225 32.2149 23.7793 34.4043 22.2668V24.0896H37.0021H42.8281V23.3492H40.9727ZM78.2677 21.2196C74.3341 22.5771 73.3322 20.5215 73.3322 19.0088C73.3322 15.7123 77.2285 14.2359 78.2677 12.2967V21.2196ZM84.836 23.3493V14.9755C84.836 8.1494 81.6446 6.21027 76.8946 6.21027H75.9669C74.9147 6.2121 74.1451 6.31038 74.1451 6.31038C71.7914 6.59229 70.6794 7.12882 70.2099 7.4417C69.2997 8.00586 68.6892 9.04246 68.6892 10.2285C68.6892 12.0169 70.0763 13.4668 71.7875 13.4668C72.7299 13.4668 73.5734 13.0264 74.1416 12.3326C72.8076 12.1121 71.7875 10.9051 71.7875 9.44888C71.7875 8.00758 72.7871 7.35138 74.1011 7.11333C74.1051 7.11237 74.1086 7.11108 74.1128 7.11032C74.8005 6.99807 75.7037 6.99119 76.527 7.06871C76.5722 7.07291 76.8257 7.10839 76.8625 7.12172C78.2365 7.46256 78.2677 8.63807 78.2677 10.6704C77.7852 15.1693 67.506 13.618 67.506 20.2499C67.506 23.4689 69.8438 24.3223 71.7736 24.3223C74.4455 24.3223 77.1544 22.5771 78.2677 21.7238V24.0895H84.5391H86.6915V23.3493H84.836ZM106.294 7.487C106.294 4.92727 104.661 3.37598 101.915 3.37598C99.6141 3.37598 98.1295 3.91884 95.9402 5.43154V3.60876H95.6435C93.194 6.2459 89.9658 6.51749 87.5165 6.51749V7.25777C88.0732 7.25777 88.704 7.25777 89.3718 7.18024V23.3492H87.5165V24.0896H89.3718H97.7957V23.3492H95.9402V6.35965C96.5919 5.89001 97.1887 5.50627 97.7562 5.20736C97.7625 5.20424 97.769 5.20037 97.7754 5.19726C97.8926 5.13586 98.0085 5.07812 98.1233 5.02404C98.492 4.84158 98.9201 4.63622 99.1368 4.57278C99.1385 4.57235 99.1401 4.57213 99.1418 4.5716C99.4232 4.47182 99.7245 4.41741 100.038 4.41741C101.581 4.41741 102.832 5.18435 102.832 6.79704C102.832 8.16341 101.934 9.31021 100.721 9.62869C101.287 10.4118 102.184 10.9182 103.195 10.9182C104.907 10.9182 106.294 9.46848 106.294 7.6801C106.294 7.65301 106.292 7.62624 106.292 7.59936C106.293 7.56194 106.294 7.52485 106.294 7.487Z", fill: "#0A0A66" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.739 19.7826C106.649 21.232 105.435 22.3801 103.949 22.3801C102.405 22.3801 101.153 21.1401 101.153 19.6103C101.153 18.5162 101.791 17.5701 102.72 17.1201C100.962 17.3702 99.6104 18.8811 99.6104 20.7078C99.6104 22.7094 101.233 24.3319 103.234 24.3319C105.236 24.3319 106.859 22.7094 106.859 20.7078C106.859 20.3881 106.817 20.078 106.739 19.7826Z", fill: "#0A0A66" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M100.744 20.4491C100.744 19.0232 101.621 17.7768 102.875 17.1016C101.042 17.2819 99.6104 18.8277 99.6104 20.708C99.6104 22.7095 101.233 24.332 103.234 24.332C103.522 24.332 103.802 24.2984 104.071 24.235C102.215 23.8412 100.744 22.2957 100.744 20.4491Z", fill: "#00CCCC" })), /* @__PURE__ */ C.createElement("defs", null, /* @__PURE__ */ C.createElement("clipPath", { id: "clip0_2024_40345" }, /* @__PURE__ */ C.createElement("rect", { width: 107.478, height: 24, fill: "white", transform: "translate(0 0.855469)" })))), w3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 163, height: 24, viewBox: "0 0 163 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("g", { clipPath: "url(#clip0_2024_49250)" }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.71059 10.7704C9.11012 10.8409 9.59435 10.8748 10.1605 10.8748C10.9779 10.8748 11.7558 10.7633 12.4998 10.5431C13.2177 10.3331 13.893 9.99804 14.4946 9.55341C15.0706 9.13034 15.5435 8.58258 15.8781 7.95106C16.2113 7.32141 16.3793 6.60988 16.3793 5.81506C16.3186 4.584 15.9501 3.55906 15.2739 2.73741C14.5833 1.90837 13.6777 1.28559 12.6565 0.937412C11.5511 0.550362 10.3872 0.356936 9.216 0.365647H0V0.592941H2.07529V18.1412H0V18.3685H10.2056V18.1412H7.416V10.3765C7.87765 10.5685 8.30824 10.6998 8.70918 10.7704H8.71059ZM10.7153 1.99906C11.0965 2.93506 11.304 4.16047 11.3336 5.67529C11.3336 6.64094 11.2941 7.45129 11.2122 8.10918C11.1318 8.76706 10.9158 9.34024 10.5656 9.82729C10.2155 10.3158 9.67341 10.5586 8.93929 10.5586C8.81223 10.5586 8.57788 10.5191 8.23906 10.4372C7.95035 10.3751 7.67248 10.2704 7.41459 10.1266V0.592941H8.31529C9.53224 0.592941 10.3341 1.06165 10.7153 1.99906ZM19.5529 6.02824C17.9647 6.69234 16.6953 7.94559 16.0108 9.52518C15.6644 10.3166 15.4819 11.17 15.4744 12.0339C15.4744 13.1972 15.7793 14.2913 16.392 15.3148C16.9853 16.3202 17.8186 17.1628 18.8174 17.7671C19.8254 18.3784 20.8828 18.6847 21.9939 18.6847C23.1233 18.6847 24.1892 18.384 25.1944 17.784C26.1916 17.1919 27.0222 16.3564 27.6085 15.3558C28.2113 14.3393 28.512 13.2452 28.512 12.0776C28.512 11.3322 28.3807 10.5798 28.1167 9.82165C27.8455 9.05274 27.4391 8.33846 26.9167 7.71247C26.3618 7.04768 25.6698 6.5107 24.888 6.13835C24.0692 5.73741 23.1332 5.53129 22.0828 5.52141C21.1948 5.52141 20.3506 5.69082 19.5529 6.02824ZM22.8706 6.21882C23.0527 6.51812 23.1671 6.97129 23.2136 7.57694C23.2602 8.18118 23.2842 9.11435 23.2842 10.3736V12.4179C23.2842 14.4395 23.2645 15.8188 23.2249 16.5572C23.1854 17.2955 23.0781 17.7995 22.9002 18.0692C22.7252 18.3388 22.4089 18.4828 21.9515 18.5012C21.5647 18.5012 21.2753 18.3685 21.0833 18.1031C20.8899 17.8362 20.7628 17.4494 20.7021 16.9412C20.6428 16.4329 20.6132 15.7426 20.6132 14.8673C20.6132 14.6414 20.6174 14.2574 20.6245 13.7153C20.6315 13.1718 20.6358 12.7412 20.6358 12.4193V9.94165C20.6358 8.82212 20.664 7.98212 20.7233 7.42165C20.7798 6.85977 20.9068 6.44471 21.0974 6.17506C21.288 5.90541 21.5873 5.76988 21.9967 5.76988C22.3976 5.76988 22.6885 5.91953 22.8706 6.21882ZM35.3816 6.35435C35.2034 6.5069 35.0589 6.69489 34.9573 6.90635C34.8557 7.11782 34.7992 7.34811 34.7915 7.58259C34.7915 8.12188 34.9807 8.58353 35.3576 8.96612C35.7346 9.34729 36.1906 9.53929 36.7285 9.53929C37.2367 9.53929 37.6616 9.34729 38.0075 8.96188C38.3435 8.60085 38.5288 8.12514 38.5256 7.632C38.4833 6.84988 38.0838 6.27106 37.3256 5.89835C36.5661 5.52424 35.6612 5.33788 34.6122 5.33788C33.6846 5.33281 32.7645 5.50533 31.9016 5.84612C31.0504 6.18494 30.3685 6.67482 29.8546 7.32C29.342 7.9626 29.0698 8.76402 29.0852 9.58588C29.0852 11.2235 30.0452 12.4489 31.9652 13.2621C32.904 13.6532 33.6734 14.0922 34.2706 14.5793C34.8692 15.0649 35.1685 15.6805 35.1685 16.4216C35.1304 17.7529 34.272 18.4193 32.5906 18.4193C31.7901 18.4193 31.1746 18.2979 30.744 18.0579C31.1746 18.0579 31.6758 17.9209 32.2433 17.6485C32.8136 17.3732 33.1256 16.7732 33.1821 15.8499C33.1821 15.2132 32.9788 14.6965 32.5722 14.2984C32.1848 13.9093 31.6627 13.6839 31.1139 13.6687C30.7087 13.6687 30.3304 13.7746 29.976 13.9864C29.6216 14.1995 29.3393 14.4805 29.1261 14.8334C28.9144 15.1835 28.8099 15.5534 28.8099 15.9402C28.8099 16.5656 29.0386 17.0838 29.4974 17.4988C29.9576 17.9125 30.5393 18.2174 31.2438 18.4136C31.9496 18.6085 32.6795 18.7158 33.4362 18.7341C34.1633 18.7341 34.8762 18.6353 35.5736 18.4376C36.2711 18.24 36.9021 17.9435 37.4682 17.5511C38.0329 17.1572 38.4791 16.6744 38.8038 16.0998C39.1285 15.5252 39.2894 14.8744 39.2894 14.1459C39.2753 13.4598 39.1186 12.864 38.8207 12.3614C38.5273 11.864 38.1329 11.4336 37.6631 11.0979C37.0838 10.6961 36.4728 10.342 35.8362 10.0391C35.3677 9.82853 34.9004 9.61535 34.4344 9.39953C33.9662 9.19072 33.5366 8.90434 33.1638 8.55247C32.9984 8.39516 32.8662 8.20629 32.775 7.99703C32.6838 7.78777 32.6355 7.56236 32.6329 7.33412C32.6329 6.80471 32.8885 6.37835 33.4009 6.05365C33.9134 5.72894 34.4852 5.56518 35.1205 5.56518C35.7501 5.56518 36.2739 5.664 36.6904 5.85882C36.2071 5.85208 35.7393 6.02921 35.3816 6.35435ZM40.9101 14.6456C40.9101 15.3911 41.0329 16.0588 41.2772 16.6489C41.5242 17.2376 41.9322 17.7106 42.5054 18.0664C43.0772 18.4235 43.8212 18.6141 44.736 18.6395C45.1228 18.6395 45.5252 18.5534 45.9431 18.3798C46.3624 18.2061 46.7054 17.9605 46.9793 17.64C47.2504 17.3209 47.3873 16.9581 47.3873 16.5515V13.5826H47.2009V16.5064C47.2009 16.7986 47.1304 17.064 46.9849 17.3054C46.8409 17.5454 46.6419 17.664 46.392 17.664C46.1365 17.664 45.9388 17.5412 45.7991 17.2969C45.6579 17.0513 45.5873 16.7887 45.5873 16.5064V6.65647H47.7304V5.76988H45.6325V0.727059C44.9647 1.55435 44.3661 2.14306 43.8367 2.49459C43.3073 2.84612 42.6847 3.02118 41.9675 3.02118C41.6277 3.02194 41.2884 2.99217 40.9539 2.93224V5.72612H39.3191V6.61271H40.9101V14.6456ZM53.0965 0.365647V0.638118H55.8409V18.0974H53.1868V18.3685H58.9948V18.0974H56.16V1.95671L61.2706 18.6395L66.3134 1.752V18.1412H63.8061V18.3685H74.6753V18.1412H71.9308V0.638118H74.5849V0.365647H66.3586L63.9191 8.60753L61.4569 0.367059H53.0965V0.365647ZM76.7689 7.2C76.9341 7.008 77.3068 6.79765 77.8899 6.56894C78.4729 6.33882 79.0899 6.22447 79.7435 6.22447C80.1473 6.22447 80.5129 6.29506 80.8391 6.43765C81.1652 6.58024 81.4249 6.80047 81.6184 7.10118C81.8104 7.39906 81.9078 7.77318 81.9078 8.21929V10.0376C81.9078 10.5784 81.6494 11.0245 81.1341 11.376C80.6188 11.7289 80.0711 11.9633 79.4894 12.0776C78.3656 12.2612 77.64 12.3868 77.3153 12.4489C76.9189 12.5384 76.5349 12.6759 76.1718 12.8584C75.7341 13.0701 75.3784 13.3878 75.1073 13.8127C74.8348 14.2376 74.6922 14.7953 74.6767 15.4871C74.6767 16.0631 74.8151 16.5911 75.0932 17.0711C75.3699 17.5511 75.7609 17.9322 76.2649 18.216C76.7689 18.4984 77.3464 18.6395 77.9944 18.6395C79.0673 18.6395 79.9002 18.3784 80.4988 17.8532C81.0974 17.3294 81.4969 16.7845 81.696 16.2212C81.8979 15.6565 81.9981 15.2753 81.9981 15.0762C81.9981 15.2951 82.0842 15.6847 82.2593 16.248C82.4329 16.8127 82.7901 17.3591 83.3294 17.8899C83.8701 18.4193 84.6381 18.6847 85.6348 18.6847C87.5252 18.6438 88.4697 17.7812 88.4697 16.0955V13.7647H88.2833V16.1478C88.2833 16.5614 88.1788 16.9666 87.9727 17.3633C87.7638 17.7614 87.5379 17.9605 87.2951 17.9605C87.1875 17.9615 87.0811 17.9393 86.9829 17.8955C86.8847 17.8516 86.7971 17.7871 86.7261 17.7064C86.5685 17.5358 86.4839 17.3103 86.4904 17.0781V8.60753C86.4904 7.96941 86.208 7.43859 85.6405 7.01788C85.0758 6.59577 84.3473 6.29082 83.4593 6.10024C82.5482 5.90783 81.6192 5.81224 80.688 5.81506C79.8438 5.81506 79.0433 5.93224 78.2866 6.16659C77.5299 6.40094 76.9115 6.76376 76.4315 7.25647C75.9515 7.74635 75.7115 8.34918 75.7115 9.06353C75.7115 9.72 75.9247 10.2748 76.3525 10.7252C76.7802 11.1769 77.3096 11.4028 77.9435 11.4028C78.3671 11.4028 78.7595 11.2941 79.1224 11.0809C79.477 10.8721 79.774 10.5781 79.9865 10.2256C80.1989 9.87314 80.3202 9.47325 80.3393 9.06212C80.3393 8.64847 80.2362 8.27859 80.0287 7.95106C79.8305 7.63833 79.5566 7.38069 79.2323 7.20201C78.908 7.02334 78.5439 6.92941 78.1737 6.92894C77.4988 6.97976 77.0301 7.07012 76.7689 7.2ZM81.6819 15.3176C81.5601 15.8162 81.361 16.2925 81.0918 16.7294C80.8489 17.1106 80.5976 17.2984 80.3393 17.2984C80.0951 17.28 79.9355 17.1049 79.8593 16.776C79.7817 16.4442 79.7435 15.9925 79.7435 15.4207V14.7388C79.7435 13.9186 79.8 13.2776 79.9144 12.8188C80.0287 12.3572 80.3167 11.9901 80.7769 11.7176C81.0614 11.5534 81.3282 11.3604 81.5732 11.1416C81.6943 11.0325 81.8062 10.9135 81.9078 10.7859V13.7125C81.9078 14.2193 81.8329 14.7544 81.6819 15.3176ZM96.7511 5.27012C96.8668 5.58071 96.9939 5.83906 97.1322 6.04659C97.272 6.25412 97.3567 6.35718 97.3864 6.35718C97.4005 6.35718 97.2536 6.30635 96.9445 6.20188C96.6084 6.09147 96.2662 6.00096 95.9195 5.93082C95.5456 5.85379 95.1648 5.815 94.7831 5.81506C94.0306 5.81506 93.2767 5.952 92.5214 6.22447C91.8068 6.47177 91.1625 6.88833 90.6438 7.43859C90.1482 7.97506 89.8913 8.60612 89.8772 9.33459C89.8772 9.90635 90.0155 10.3976 90.2922 10.8056C90.5704 11.2151 90.8711 11.5285 91.1958 11.7473C91.5219 11.9675 91.7266 12.0776 91.8085 12.0776C91.3638 12.2104 90.8075 12.5167 90.1426 12.9981C89.4762 13.4781 89.1431 14.1854 89.1431 15.12C89.1431 16.0588 89.4537 16.7831 90.0748 17.2941C90.696 17.8024 91.2141 18.1327 91.6278 18.2795C91.1732 18.3459 90.6014 18.5548 89.9167 18.9064C89.232 19.2579 88.8904 19.8508 88.8904 20.6852C88.8904 21.3911 89.1699 21.9939 89.7304 22.4951C90.2908 22.9962 91.0038 23.3704 91.8692 23.6245C92.727 23.874 93.6158 24.0005 94.5092 24C95.7064 24 96.8315 23.8024 97.8889 23.4042C98.9449 23.0075 99.8005 22.4019 100.454 21.5859C101.108 20.7713 101.434 19.7746 101.434 18.5958C101.434 17.6612 101.246 16.8551 100.869 16.176C100.492 15.4984 99.8908 14.9718 99.0621 14.5962C98.2334 14.2221 97.1746 14.0344 95.8857 14.0344C95.6118 14.0344 95.1445 14.0569 94.4852 14.1007C93.8259 14.1459 93.3402 14.1671 93.0297 14.1671C91.6489 14.1671 90.96 13.7986 90.96 13.0588C90.96 12.8442 91.0334 12.6819 91.1816 12.5746C91.4104 12.4197 91.6523 12.2851 91.9045 12.1722C92.0654 12.2795 92.4466 12.4306 93.0452 12.6268C93.6452 12.8216 94.2762 12.9205 94.9398 12.9205C95.7073 12.9113 96.4675 12.7704 97.1873 12.504C97.9264 12.2536 98.5979 11.8362 99.1497 11.2842C99.6762 10.7478 99.9402 10.1195 99.9402 9.39953C99.9402 8.79247 99.8019 8.29835 99.528 7.91294C99.2555 7.52894 98.8433 7.11388 98.2941 6.66777C97.7449 6.22306 97.3454 5.84329 97.0941 5.53129C96.8428 5.21929 96.7172 4.81271 96.7172 4.31435C96.7355 3.81176 96.8668 3.41929 97.1082 3.13553C97.3497 2.85318 97.5501 2.66965 97.7068 2.58494C97.6027 2.77737 97.5071 2.97427 97.4202 3.17506C97.3153 3.38927 97.2557 3.62286 97.2452 3.86118C97.2452 4.36376 97.4344 4.79294 97.8141 5.14588C98.1925 5.49882 98.6329 5.67529 99.1355 5.67529C99.6254 5.67529 100.042 5.50447 100.384 5.16C100.724 4.81553 100.906 4.39765 100.928 3.90494C100.928 3.57176 100.834 3.25835 100.645 2.96471C100.443 2.66498 100.171 2.41973 99.8515 2.25076C99.5323 2.08179 99.1762 1.99436 98.8151 1.99624C98.1882 2.04424 97.6645 2.26165 97.2423 2.65129C96.8216 3.03953 96.5986 3.59435 96.5774 4.31576C96.5774 4.64047 96.6339 4.95953 96.7511 5.27012ZM96.0706 10.1492C96.0706 10.8988 96 11.4904 95.8574 11.9195C95.7148 12.3501 95.4085 12.5788 94.9398 12.6042C94.3892 12.6042 94.0362 12.3035 93.8838 11.7007C93.7285 11.0979 93.6522 10.3242 93.6522 9.37835C93.6522 9.25694 93.6494 9.07059 93.6409 8.81929C93.6345 8.62689 93.6308 8.4344 93.6296 8.24188C93.6296 7.51765 93.7115 6.94729 93.8725 6.52941C94.0334 6.11153 94.3525 5.90259 94.8282 5.90259C95.0424 5.90049 95.2511 5.97006 95.4212 6.10024C95.5962 6.23153 95.7473 6.53788 95.8772 7.02353C96.0057 7.50776 96.0706 8.23059 96.0706 9.19624V10.1492ZM97.2 18.4828C97.6729 18.6169 98.1176 18.864 98.5327 19.2254C98.9492 19.5854 99.1652 20.0866 99.1793 20.7304C99.1793 21.4729 98.9506 22.0673 98.4904 22.5148C98.0043 22.9774 97.4041 23.3024 96.7511 23.4565C96.0173 23.6414 95.263 23.7325 94.5064 23.7275C93.4052 23.7275 92.4932 23.4678 91.7689 22.9468C91.0461 22.4245 90.6833 21.6113 90.6833 20.5031C90.6833 19.608 91.1068 18.8668 91.9496 18.2795H96.1609C96.3812 18.2795 96.7285 18.3473 97.2014 18.4828H97.2ZM103.601 7.2C103.766 7.008 104.14 6.79765 104.723 6.56894C105.313 6.33773 105.942 6.22083 106.576 6.22447C106.981 6.22447 107.346 6.29506 107.672 6.43765C107.997 6.58024 108.257 6.80047 108.45 7.10118C108.644 7.39906 108.74 7.77318 108.74 8.21929V10.0376C108.74 10.5784 108.483 11.0245 107.968 11.376C107.452 11.7289 106.904 11.9633 106.323 12.0776C105.198 12.2612 104.473 12.3868 104.149 12.4489C103.825 12.5125 103.443 12.6494 103.005 12.8584C102.568 13.0701 102.212 13.3878 101.941 13.8127C101.668 14.2376 101.524 14.7953 101.51 15.4871C101.502 16.0431 101.646 16.5908 101.925 17.0715C102.205 17.5523 102.61 17.9479 103.097 18.216C103.602 18.4984 104.178 18.6395 104.826 18.6395C105.899 18.6395 106.734 18.3784 107.332 17.8532C107.929 17.3294 108.329 16.7845 108.529 16.2212C108.73 15.6565 108.83 15.2753 108.83 15.0762C108.83 15.2951 108.918 15.6847 109.091 16.248C109.266 16.8127 109.624 17.3591 110.164 17.8899C110.702 18.4193 111.472 18.6847 112.468 18.6847C114.357 18.6438 115.302 17.7812 115.302 16.0955V13.7647H115.117V16.1478C115.117 16.5614 115.012 16.9666 114.805 17.3633C114.596 17.7614 114.37 17.9605 114.127 17.9605C114.02 17.9613 113.914 17.939 113.816 17.8952C113.718 17.8513 113.63 17.7869 113.56 17.7064C113.401 17.5361 113.316 17.3105 113.322 17.0781V8.60753C113.322 7.96941 113.04 7.43859 112.474 7.01788C111.909 6.59577 111.181 6.29082 110.293 6.10024C109.381 5.90779 108.452 5.8122 107.52 5.81506C106.707 5.81052 105.898 5.92903 105.12 6.16659C104.362 6.40094 103.744 6.76376 103.264 7.25647C103.028 7.49377 102.843 7.77611 102.719 8.08661C102.596 8.39711 102.536 8.72938 102.544 9.06353C102.544 9.72 102.758 10.2748 103.186 10.7252C103.612 11.1769 104.143 11.4028 104.777 11.4028C105.2 11.4028 105.593 11.2941 105.954 11.0809C106.309 10.8721 106.606 10.5781 106.818 10.2256C107.031 9.87314 107.152 9.47325 107.171 9.06212C107.171 8.64847 107.068 8.27859 106.862 7.95106C106.664 7.63814 106.39 7.38036 106.066 7.20166C105.742 7.02296 105.377 6.92915 105.007 6.92894C104.332 6.97976 103.864 7.07012 103.601 7.2ZM108.515 15.3176C108.366 15.8824 108.168 16.3511 107.925 16.7294C107.681 17.1106 107.431 17.2984 107.171 17.2984C106.928 17.28 106.768 17.1049 106.691 16.776C106.614 16.4442 106.576 15.9925 106.576 15.4207V14.7388C106.576 13.9186 106.632 13.2776 106.748 12.8188C106.861 12.3572 107.149 11.9901 107.609 11.7176C107.962 11.5031 108.227 11.3111 108.407 11.1416C108.583 10.9708 108.696 10.8522 108.74 10.7859V13.7125C108.74 14.2193 108.665 14.7544 108.515 15.3176ZM118.9 6.88376C119.372 6.88376 119.771 6.98824 120.097 7.19435C120.422 7.40047 120.822 7.71953 121.295 8.15153C121.768 8.58212 122.197 8.90541 122.582 9.12141C122.968 9.33741 123.439 9.44612 123.994 9.44612C124.801 9.43059 125.445 9.25412 125.922 8.91671C126.4 8.57788 126.726 8.24329 126.899 7.91012C127.073 7.57553 127.177 7.32565 127.21 7.16047C127.117 8.34635 126.815 9.23294 126.299 9.82306C125.787 10.4146 125.183 10.7972 124.488 10.9694C123.792 11.1431 122.921 11.256 121.871 11.3082C121.246 11.3563 120.63 11.4776 120.034 11.6696C119.364 11.8793 118.725 12.1764 118.134 12.5534C117.527 12.9388 117.025 13.4146 116.629 13.9821C116.228 14.5588 116.002 15.2385 115.976 15.9402C115.976 16.3581 116.061 16.7774 116.226 17.1995C116.393 17.6202 116.63 17.9661 116.936 18.2358C117.244 18.5054 117.6 18.6395 118.004 18.6395C118.289 18.6395 118.54 18.5435 118.756 18.3487C118.858 18.2657 118.94 18.1612 118.996 18.0429C119.052 17.9245 119.082 17.7951 119.082 17.664C119.082 17.3026 118.978 17.0259 118.768 16.8367C118.543 16.6405 118.252 16.538 117.954 16.5501C117.64 16.5501 117.39 16.6941 117.202 16.9793C117.014 17.2673 116.921 17.4805 116.921 17.6202C116.921 16.5304 117.435 15.9854 118.464 15.9854C118.986 15.9896 119.438 16.104 119.819 16.3313C120.2 16.5586 120.645 16.8918 121.151 17.3322C121.657 17.7713 122.105 18.1002 122.495 18.3162C122.884 18.5322 123.352 18.6409 123.895 18.6409C124.786 18.6409 125.527 18.3798 126.117 17.8588C126.707 17.3365 127.138 16.6687 127.408 15.8513C127.677 15.0353 127.813 14.1713 127.813 13.2579V11.1967H127.581V12.6042C127.581 13.1478 127.324 13.5784 126.812 13.896C126.302 14.2124 125.713 14.3775 125.113 14.3718C124.749 14.3718 124.422 14.3435 124.132 14.2885C123.74 14.2097 123.351 14.1174 122.965 14.0118C122.478 13.8833 122.072 13.7859 121.748 13.7209C121.386 13.6531 121.018 13.621 120.649 13.6249C119.534 13.6616 118.681 13.9228 118.094 14.4113C117.505 14.8984 117.126 15.4376 116.951 16.0264C116.784 16.5719 116.696 17.1387 116.691 17.7092C116.31 17.0541 116.116 16.4668 116.116 15.9402C116.159 15.1101 116.427 14.4155 116.924 13.8565C117.435 13.2892 118.084 12.8645 118.808 12.624C119.593 12.3552 120.417 12.2174 121.247 12.216C122.411 12.1906 123.453 11.9732 124.372 11.5624C125.29 11.1529 126.007 10.5854 126.525 9.86118C127.042 9.13661 127.33 8.27347 127.351 7.38353C127.358 6.91163 127.221 6.44885 126.959 6.05647C126.697 5.66541 126.352 5.47059 125.927 5.47059C125.64 5.4937 125.372 5.62013 125.171 5.82635C125.07 5.91675 124.989 6.02696 124.933 6.15011C124.877 6.27326 124.846 6.40671 124.844 6.54212C124.845 6.67652 124.873 6.80935 124.926 6.93294C124.978 7.05653 125.055 7.16841 125.152 7.26212C125.243 7.364 125.354 7.44546 125.479 7.50118C125.604 7.55689 125.739 7.5856 125.876 7.58541C126.051 7.58541 126.237 7.50776 126.433 7.35529C126.631 7.20282 126.775 7.07718 126.868 6.97835C126.868 7.14776 126.792 7.35953 126.642 7.61365C126.488 7.86635 126.157 7.99341 125.643 7.99341C125.235 7.99341 124.896 7.90165 124.626 7.72094C124.192 7.40897 123.776 7.07341 123.378 6.71576C122.816 6.22588 122.301 5.85882 121.83 5.61459C121.36 5.37035 120.806 5.24894 120.169 5.24894C119.571 5.25459 118.983 5.41197 118.461 5.70635C117.911 6.00036 117.438 6.42142 117.083 6.93459C116.735 7.42434 116.542 8.00691 116.527 8.60753C116.527 9.28094 116.726 9.87953 117.126 10.4061C117.524 10.9327 118.024 11.1967 118.622 11.1967C118.969 11.1967 119.3 11.1134 119.61 10.9468C119.911 10.7896 120.169 10.5619 120.363 10.2833C120.549 10.0189 120.649 9.70331 120.649 9.37976C120.649 8.89271 120.456 8.46353 120.071 8.09506C119.893 7.91768 119.682 7.7773 119.45 7.68206C119.218 7.58682 118.969 7.53861 118.718 7.54024C118.175 7.54024 117.74 7.73506 117.412 8.12471C117.088 8.50485 116.913 8.99021 116.921 9.48988C116.921 7.75341 117.58 6.88376 118.9 6.88376ZM133.662 4.872C134.058 4.62494 134.356 4.30024 134.555 3.89506C134.753 3.49129 134.853 3.06212 134.853 2.60753C134.853 1.90729 134.623 1.29741 134.164 0.777882C133.704 0.259765 133.059 0 132.226 0C131.397 0 130.749 0.261176 130.28 0.780706C129.812 1.30165 129.577 1.91012 129.577 2.60753C129.577 3.05929 129.68 3.48706 129.884 3.89224C130.087 4.29795 130.401 4.63768 130.79 4.872C131.188 5.12047 131.667 5.24329 132.226 5.24329C132.784 5.24329 133.262 5.12047 133.66 4.872H133.662ZM129.878 6.04235V18.3247H134.555V5.85882H127.897V6.04235H129.877H129.878ZM136.793 6.22447V18.3685H141.466V9.85553C141.466 9.43765 141.522 8.99435 141.641 8.52424C141.757 8.05553 141.919 7.66306 142.127 7.34965C142.334 7.03624 142.566 6.87812 142.821 6.87812C143.421 6.87812 143.72 7.78729 143.72 9.60565C143.72 10.2198 143.685 11.0922 143.613 12.2245C143.543 13.3567 143.5 14.0287 143.49 14.2391C143.49 15.1934 143.651 16.0066 143.973 16.6814C144.296 17.3548 144.74 17.8574 145.303 18.1892C145.868 18.5195 146.507 18.6833 147.223 18.6833C148.36 18.6438 149.129 18.3939 149.538 17.9336C149.944 17.4734 150.147 16.8099 150.147 15.9402V13.8071L149.917 13.7633V15.8965C149.917 17.0965 149.647 17.7318 149.106 17.8024C148.957 17.8108 148.81 17.7687 148.687 17.6829C148.565 17.5971 148.476 17.4725 148.433 17.3294C148.316 17.0132 148.258 16.4598 148.258 15.6692C148.28 14.6628 148.311 13.6567 148.348 12.6508C148.36 12.3868 148.374 11.8715 148.393 11.1021C148.393 7.65741 147.151 5.91106 144.665 5.85882C143.879 5.85882 143.207 6.09035 142.65 6.55482C142.093 7.01788 141.68 7.64188 141.415 8.42541V6.04235H135.572V6.22447H136.792H136.793ZM153.734 6.44047C152.778 7.03202 151.991 7.85947 151.447 8.84329C150.889 9.83133 150.585 10.9429 150.563 12.0776C150.563 13.368 150.857 14.5101 151.441 15.5054C152.006 16.4824 152.83 17.2839 153.823 17.8207C154.825 18.3671 155.927 18.6395 157.127 18.6395C158.651 18.6395 159.802 18.288 160.578 17.5849C161.355 16.8805 161.843 16.1506 162.048 15.3953C162.253 14.6386 162.354 14.0344 162.354 13.5798H162.124C162.124 13.7562 162.085 14.064 162.006 14.5031C161.928 14.9407 161.761 15.4348 161.509 15.9882C161.243 16.5561 160.852 17.0562 160.365 17.4508C159.854 17.8744 159.196 18.1186 158.39 18.1849C157.278 18.1849 156.531 17.6908 156.152 16.7026C155.774 15.7144 155.585 14.6202 155.585 13.4188C155.585 12.9049 155.593 12.6494 155.608 12.6494C156.154 12.8894 156.799 13.0094 157.542 13.0094C158.273 13.0094 158.984 12.8894 159.679 12.6494C160.371 12.4094 160.945 12.0339 161.399 11.5242C161.852 11.0132 162.079 10.3807 162.079 9.62824C162.079 9.04377 161.931 8.50306 161.634 8.00612C161.326 7.49627 160.919 7.05286 160.437 6.70165C159.927 6.32449 159.361 6.03049 158.759 5.83059C158.166 5.62771 157.544 5.52281 156.918 5.52C155.792 5.52515 154.69 5.8439 153.736 6.44047H153.734ZM155.855 6.23012C156.049 5.83059 156.344 5.63153 156.737 5.63153C157.262 5.63153 157.604 5.87576 157.763 6.36282C157.923 6.85129 158.003 7.51624 158.003 8.35906V8.96894C158.003 10.0871 157.919 10.9878 157.746 11.6696C157.577 12.3515 157.163 12.6932 156.507 12.6932C156.266 12.6751 156.03 12.6119 155.812 12.5068C155.646 12.4165 155.562 12.2287 155.562 11.9449V7.632C155.562 7.09553 155.661 6.62965 155.855 6.23012Z", fill: "black" })), /* @__PURE__ */ C.createElement("defs", null, /* @__PURE__ */ C.createElement("clipPath", { id: "clip0_2024_49250" }, /* @__PURE__ */ C.createElement("rect", { width: 162.353, height: 24, fill: "white" })))), T3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 187, height: 16, viewBox: "0 0 187 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M153.841 14.4763L154.423 16H151.014L150.026 13.1692H144.076L143.064 16H139.654L145.746 0H148.309L153.515 13.6197L155.306 11.9335C156.364 12.928 157.797 13.2591 159.346 13.2591C161.272 13.2591 162.306 12.5748 162.306 11.3145C162.306 10.7618 162.141 10.2978 161.789 9.98892C161.459 9.70216 161.084 9.54585 160.31 9.43631L158.289 9.17169C156.858 8.97231 155.799 8.55262 155.047 7.86708C154.25 7.11631 153.851 6.09969 153.851 4.77415C153.851 1.968 156.058 0 159.675 0C161.976 0 163.645 0.530462 165.078 1.83385L163.01 3.75754C161.953 2.80615 160.685 2.67446 159.581 2.67446C157.843 2.67446 156.997 3.58031 156.997 4.66338C156.997 5.06092 157.138 5.48062 157.49 5.78954C157.82 6.07754 158.36 6.32 159.041 6.40862L161.014 6.67446C162.54 6.87262 163.504 7.27138 164.208 7.88923C165.101 8.68554 165.5 9.83385 165.5 11.2271C165.5 14.2757 162.8 16 159.299 16C157.089 16 155.341 15.6135 153.841 14.4763ZM70.7308 16V0H81.8077V2.78646H74.0132V6.54031H80.6507V9.32554H74.0132V13.2135H81.8077V16H70.7308ZM63.7388 10.0898L66.2372 0H69.5L65.2021 16H62.5904L59.6428 6.29169L56.6938 16H54.0846L49.8077 0H53.0717L55.5467 10.0898L58.4723 0H60.8132L63.7388 10.0898ZM83.0384 16V0H94.1154V2.78646H86.3209V6.54031H92.9584V9.32554H86.3209V13.2135H94.1154V16H83.0384ZM40.3984 6.67446C41.9246 6.87262 42.8883 7.27138 43.5923 7.88923C44.4858 8.68554 44.8846 9.83385 44.8846 11.2271C44.8846 14.2757 42.1843 16 38.684 16C36.1474 16 34.2212 15.4917 32.5769 13.9225L34.6901 11.9335C35.7486 12.928 37.1812 13.2591 38.7308 13.2591C40.6569 13.2591 41.6908 12.5748 41.6908 11.3145C41.6908 10.7618 41.5258 10.2978 41.1738 9.98892C40.844 9.70216 40.4686 9.54585 39.6944 9.43631L37.6735 9.17169C36.2409 8.97231 35.1837 8.55262 34.4329 7.86708C33.6329 7.11631 33.2341 6.09969 33.2341 4.77415C33.2341 1.968 35.4421 0 39.0594 0C41.3609 0 43.0298 0.530462 44.4624 1.83385L42.3948 3.75754C41.3375 2.80615 40.0698 2.67446 38.9658 2.67446C37.228 2.67446 36.3812 3.58031 36.3812 4.66338C36.3812 5.06092 36.5228 5.48062 36.876 5.78954C37.2034 6.07754 37.7437 6.32 38.4255 6.40862L40.3984 6.67446ZM0.576904 2.78646V0H11.6538V2.78646H7.62183V16H4.6089V2.78646H0.576904ZM21.8963 6.54031V0H25.1923V16H21.8963V9.30462H16.1806V16H12.8846V0H16.1806V6.53908H21.8963V6.54031ZM27.6538 16V0H31.3461V16H27.6538ZM166.731 16V0H170.423V16H166.731ZM176.993 10.5391H181.155L179.109 4.72L176.992 10.5391H176.993ZM180.309 0L186.423 16H183.014L182.026 13.1692H176.076L175.064 16H171.654L177.746 0H180.309ZM144.993 10.5391H149.155L147.109 4.72L144.993 10.5391ZM115.038 16V0H118.731V16H115.038ZM109.715 0L104.168 6.35939L110.115 16H106.307L102.006 8.71877L99.8446 11.1914V16H96.5769V0H99.8446V6.96615L105.742 0H109.715ZM130.362 9.79692V0H133.5V16H130.7L124.331 6.17846V16H121.192V0H123.992L130.362 9.79692Z", fill: "black" })), S3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 22, height: 19, viewBox: "0 0 22 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1567 3.20829L19.7717 4.20332L11.0769 10.0104L2.3814 4.20332L2.95515 3.20829L11.0769 8.5998L19.1567 3.20829ZM20.4279 2.42031C20.4279 2.08813 20.3184 1.80524 20.1002 1.57014C19.8812 1.33503 19.6209 1.21748 19.3209 1.21748H2.83215C2.5314 1.21748 2.27115 1.33503 2.0529 1.57014C1.8339 1.80524 1.72515 2.08813 1.72515 2.42031V15.6507C1.72515 15.9829 1.8339 16.2665 2.0529 16.5009C2.27115 16.7367 2.5314 16.8535 2.83215 16.8535H19.3209C19.6209 16.8535 19.8812 16.7367 20.1002 16.5009C20.3184 16.2665 20.4279 15.9829 20.4279 15.6507V2.42031ZM20.9207 0.719966C21.3579 1.19018 21.5769 1.75671 21.5769 2.42031V15.6097C21.5769 16.2733 21.3579 16.8406 20.9207 17.3101C20.4827 17.7803 19.9494 18.0146 19.3209 18.0146H2.83215C2.20365 18.0146 1.6704 17.7803 1.23315 17.3101C0.795154 16.8406 0.576904 16.2733 0.576904 15.6097V2.42031C0.576904 1.75671 0.795154 1.19018 1.23315 0.719966C1.6704 0.250513 2.20365 0.0146484 2.83215 0.0146484H19.3209C19.9494 0.0146484 20.4827 0.250513 20.9207 0.719966Z", fill: "black" })), A3 = /* @__PURE__ */ b(S3, {
  target: "e5xr1380"
})({
  name: "afd8d5",
  styles: "margin-inline-start:12px"
}), R3 = () => {
  var e;
  const {
    config: t
  } = U(), {
    newsletterItemForDisplay: r
  } = qr(), n = {
    [t.newsletter.globalImpact]: /* @__PURE__ */ m.createElement(y3, null),
    [t.newsletter.lunar]: /* @__PURE__ */ m.createElement(b3, null),
    [t.newsletter.postMag]: /* @__PURE__ */ m.createElement(w3, null),
    [t.newsletter.thisWeekInAsia]: /* @__PURE__ */ m.createElement(T3, null)
  }, a = Hi(r), i = (e = r == null ? void 0 : r.entityId) !== null && e !== void 0 ? e : "";
  return i in n ? /* @__PURE__ */ m.createElement(m.Fragment, null, n[i], /* @__PURE__ */ m.createElement(A3, null)) : /* @__PURE__ */ m.createElement(m.Fragment, null, a);
};
R3.displayName = "ArticleThemeTitle";
const I3 = (e) => /* @__PURE__ */ C.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 491, height: 50, viewBox: "0 0 491 50", className: "large-logo", ...e }, /* @__PURE__ */ C.createElement("g", { fill: "none" }, /* @__PURE__ */ C.createElement("path", { fill: "#FFF", d: "M344.522 20.758l.007.223c0 1.717-1.026 2.891-2.822 2.891-1.266 0-2.215-.834-2.215-1.954 0-.38.116-.787.341-1.193-.916 0-2.983 1.489-2.983 2.966v12.033c0 .937.344 1.133 1.096 1.199l1.003.088v.456h-10.193v-.456l.855-.108c.846-.129 1.051-.222 1.051-1.24V23.134c0-1.745-.624-2.178-2.112-2.387v-.439l8.175-2.019v3.039c1.34-1.816 3.243-3.039 4.963-3.039 1.47 0 2.485.751 2.764 1.973l7.985-1.973v3.279c1.521-1.441 3.433-3.246 6.143-3.246 3.349 0 4.896 2.044 4.896 4.752v12.735c0 .92.36.995 1.032 1.093l.884.108v.456h-9.977v-.456l.951-.108c.624-.084.949-.222.949-1.02V23.524c0-1.208-.675-2.019-1.899-2.019-1.579 0-2.871 1.237-2.871 2.569v11.62c0 .998.309 1.11 1.003 1.208l.906.108v.456h-9.798v-.456l.884-.146c.482-.087.833-.098.833-1.055V23.285c0-1.666-.364-2.303-1.849-2.528zm-88.417 16.681h-9.968v-.454l.964-.121c.627-.075.932-.204.932-1.022V23.488c0-1.197-.662-2.02-1.896-2.02-1.566 0-2.855 1.23-2.855 2.571v11.624c0 1.017.303 1.111.987 1.201l.91.121v.454h-9.804v-.454l.89-.15c.482-.085.842-.112.842-1.053V23.253c0-1.754-.386-2.297-2.118-2.529v-.449l8.18-2.014v3.266c1.501-1.427 3.43-3.239 6.14-3.239 3.362 0 4.895 2.045 4.895 4.766V35.78c0 .92.367.992 1.019 1.082l.881.121v.454zm-23.08-23.618c0 1.764-1.412 3.163-3.327 3.163-1.922 0-3.301-1.399-3.301-3.163 0-1.768 1.379-3.188 3.301-3.188 1.916 0 3.327 1.42 3.327 3.188zm1.713 23.618h-9.936v-.454c.305-.063.906-.121.906-.121.656-.09.984-.184.984-1.054V23.286c0-1.758-.402-2.33-2.099-2.561v-.449l8.28-2.014v17.295c0 1.124.267 1.217 1.163 1.346l.701.082v.454zm-10.621 0h-9.959v-.454l1.022-.121c.604-.061.874-.33.874-1.054V23.582c0-1.465-.73-2.113-1.932-2.113-1.465 0-2.812 1.23-2.812 2.478v11.776c0 1 .321 1.051 1.019 1.141l.865.121v.454h-9.962v-.454l1.132-.15c.517-.061.755-.346.755-.85V14.533c0-2.165-.646-2.372-2.103-2.61v-.436l8.294-2.011v12.051c1.24-1.573 3.69-3.266 6.049-3.266 2.685 0 4.876 1.549 4.876 4.758v12.732c0 .998.331 1 1.077 1.112l.803.121v.454zm-21.649-4.309c-1.286 2.006-4.112 5.017-9.209 5.017-8.805 0-13.504-5.174-13.504-13.197 0-9.832 6.478-13.926 13.472-13.926 3.562 0 5.414 1.164 6.767 1.164.412 0 1.064-.124 1.575-.235l.083 6.36h-.82l-2.475-4.522c-1.038-.79-2.446-1.311-4.783-1.311-4.349 0-6.853 4.904-6.853 11.438 0 7.482 3.472 11.539 7.837 11.539 4.76 0 6.378-1.949 7.384-3.032l.527.705zm-28.246 4.309h-9.975v-.454l1.022-.121c.592-.061.884-.33.884-1.054V23.582c0-1.465-.752-2.113-1.942-2.113-1.443 0-2.822 1.23-2.822 2.478v11.776c0 1 .331 1.051 1.025 1.141l.871.121v.454h-9.975v-.454l1.148-.15c.514-.061.749-.346.749-.85V14.533c0-2.165-.637-2.372-2.096-2.61v-.436l8.278-2.011v12.051c1.257-1.573 3.7-3.266 6.059-3.266 2.687 0 4.86 1.549 4.86 4.758v12.732c0 .998.363 1 1.099 1.112l.813.121v.454zm-19.807-3.1c-1.013 1.766-3.231 3.522-6.755 3.522-3.38 0-4.957-2.294-4.957-4.619V20.454h-2.274v-.443l8.047-6.457h.466v5.38h4.639l-.537 1.52h-4.103v12.254c0 1.647.873 2.321 2.044 2.321 1.075 0 2.302-.713 3.122-1.375l.305.684zm-13.551 2.584l-7.99.732v-3.047c-1.294 1.497-3.725 3.282-6.186 3.282-3.184 0-4.822-2.08-4.822-4.789v-9.966c0-1.745-.59-2.246-2.099-2.41v-.449l8.276-2.014v13.931c0 1.428.551 2.247 1.932 2.247.906 0 1.244-.142 1.921-.58.784-.525.864-.95.864-1.908v-8.818c0-1.745-.575-2.178-2.094-2.41v-.449l8.279-2.014v16.722c0 1.28.995 1.383 1.919 1.505v.433zm-40.776-7.824c0 5.385-4.4 8.821-10.432 8.821-3.208 0-6.161-.875-7.798-2.055v-5.921h.729l2.231 4.934c1.336.863 2.739 1.611 5.043 1.611 3.193 0 4.928-2.076 4.928-4.483 0-2.152-1.625-3.841-5.565-5.062-4.917-1.533-7.646-3.744-7.646-7.954 0-4.554 4.576-7.943 9.647-7.943 3.172 0 5.476 1.347 6.125 1.347.281 0 .755-.061 1.016-.092v5.869h-.695l-2.453-4.394c-.762-.802-2.767-1.151-4.228-1.151-2.679 0-4.689 1.505-4.689 3.736 0 2.204 1.446 3.246 6.026 4.76 5.304 1.751 7.76 3.778 7.76 7.976zm166.538 3.438v-6.439c-1.749 2.067-4.513 2.203-4.513 6.439 0 1.574.736 2.632 2.048 2.632 1.337 0 2.465-1.497 2.465-2.632zm9.225 2.801c-.437.86-2.282 2.552-4.992 2.552s-3.677-1.453-3.996-3.128c-1.077 1.674-2.517 3.128-5.716 3.128-3.227 0-5.043-1.905-5.043-4.6 0-2.862 1.649-4.355 5.924-6.006 2.778-1.071 4.674-1.467 4.674-4.472 0-2.535-1.006-3.415-2.286-3.415-1.694 0-2.735 1.079-2.906 1.351.308.169 1.443.672 1.443 2.273 0 1.658-1.401 2.635-2.964 2.635-1.723 0-2.533-1.322-2.533-2.845 0-2.571 3.488-4.549 8.711-4.549 4.42 0 6.647 2.105 6.647 5.742v9.733c0 1.477.167 2.073 1.132 2.073.521 0 1.08-.353 1.578-.85l.324.378zm-162.307-7.203c0-6.636-.628-8.908-2.899-8.908-2.355 0-2.92 2.242-2.92 8.849 0 6.19.565 8.847 2.92 8.847 2.271 0 2.899-2.631 2.899-8.788zm6.336 0c0 5.763-4.122 9.755-9.235 9.755-5.158 0-9.279-4.012-9.279-9.815 0-5.758 4.163-9.813 9.279-9.813 5.113 0 9.235 4.063 9.235 9.873zm371.029 6.164c-1.015 1.75-3.214 3.591-6.734 3.591-3.385 0-4.96-2.298-4.96-4.612V20.492h-2.279v-.452l8.062-6.432h.454v5.358h4.641l-.533 1.526h-4.108v12.263c0 1.634.887 2.299 2.048 2.299 1.093 0 2.006-.677 2.922-1.349l.488.594zm-14.018-3.067c0 4.106-3.642 6.629-8.159 6.629-3.999 0-5.635-1.056-6.409-1.437V31.55h.449l2.138 4.085c.865.594 2.53 1.14 3.864 1.14 2.167 0 3.674-1.051 3.674-2.896 0-1.962-2.427-2.627-4.973-3.496-2.832-.957-5.339-2.5-5.339-5.789 0-3.989 3.536-6.304 7.531-6.304 3.401 0 4.857 1.262 5.767 1.032v4.696h-.414l-2.186-3.587c-.681-.52-1.903-1.034-3.15-1.034-2.54 0-3.729.869-3.729 2.434 0 1.718 2.392 2.402 4.985 3.326 3.276 1.165 5.95 2.399 5.95 6.075zm-79.77 6.235h-9.949v-.456l.952-.108c.62-.084.935-.222.935-1.02V23.525c0-1.208-.675-2.164-1.887-2.164-1.594 0-2.867 1.381-2.867 2.714v11.62c0 .998.305 1.11.98 1.208l.906.108v.456H376.4v-.456l.878-.146c.498-.087.842-.098.842-1.055V23.286c0-1.757-.383-2.305-2.089-2.538v-.439l8.155-2.019v3.279c1.517-1.441 3.437-3.246 6.136-3.246 3.375 0 4.906 2.044 4.906 4.752V35.81c0 .92.363.995 1.032 1.093l.862.108v.456zM374.07 13.86c0 1.75-1.408 3.147-3.33 3.147-1.916 0-3.289-1.397-3.289-3.147 0-1.76 1.373-3.179 3.289-3.179 1.922 0 3.33 1.42 3.33 3.179zm1.765 23.607h-9.932v-.456c.318-.053.903-.108.903-.108.663-.092 1.001-.18 1.001-1.061V23.325c0-1.763-.412-2.344-2.106-2.577v-.439l8.29-2.019v17.29c0 1.143.241 1.232 1.151 1.343l.694.088v.456zm-65.032 0h-12.254v-.456l1.433-.175c1.097-.134 1.351-.31 1.351-1.46v-.497l-.44-17.809h-.113l-7.464 20.609h-1.19l-7.22-20.491h-.096l-.241 16.091-.029 1.038c0 2.173.582 2.461 2.299 2.694v.456h-6.59v-.456c1.726-.33 2.588-1.104 2.655-3.713l.508-18.203.019-.687c0-1.09-.324-2.061-1.739-2.218 0 0-.708-.078-1.144-.115v-.468h9.148l5.484 16.408h.096l5.947-16.408h8.036v.468c-1.408.115-2.154.502-2.154 1.533l.042 1.511.707 20.166c.042 1.056.469 1.418 1.521 1.552l1.427.175v.456zm143.567-9.301c0-6.637-.63-8.896-2.903-8.896-2.356 0-2.915 2.242-2.915 8.828 0 6.201.56 8.854 2.915 8.854 2.273 0 2.903-2.635 2.903-8.786zm6.339 0c0 5.749-4.134 9.755-9.242 9.755-5.146 0-9.267-4.023-9.267-9.823 0-5.755 4.153-9.808 9.267-9.808 5.108 0 9.242 4.069 9.242 9.876zm-23.79-9.544c0-4.263-1.514-5.961-4.465-5.961-.717 0-1.28.092-1.723.193v12.047c.289.024.537.105 1.617.105 3.057 0 4.571-1.671 4.571-6.385zm6.676.08c0 4.728-4.484 7.36-10.373 7.36-.874 0-1.317.014-2.491-.066v9.407c0 .826.354 1.278 1.906 1.432l1.109.116v.515h-12.163v-.515l1.514-.177c.964-.108 1.299-.38 1.299-1.258V14.171c0-1.511-.849-1.862-2.812-2.096v-.468h10.553c7.438 0 11.459 1.703 11.459 7.095zm-32.443 23.361c0-1.371-1.115-1.785-4.112-2.394l-5.075-1.032c-.829.699-1.723 1.297-1.723 3.21 0 1.897 2.048 3.08 5.31 3.08 3.585 0 5.6-1.467 5.6-2.864zm-3.244-17.021c0-4.25-.662-5.771-2.24-5.771-1.694 0-2.208 1.521-2.208 5.771 0 4.192.514 5.596 2.208 5.596 1.578 0 2.24-1.404 2.24-5.596zm8.489-6.275l-1.144 2.317-3.112-.166c1.003.954 1.8 2.158 1.8 4.124 0 3.991-3.709 6.722-8.274 6.722-1.044 0-2.282-.147-3.14-.362-.17.297-.299.657-.299.963 0 .465.887.799 1.925.997l5.333 1.015c4.735.932 6.673 2.205 6.673 5.207 0 3.944-5.153 6.389-10.669 6.389-5.101 0-9.531-.906-9.531-3.732 0-2.394 2.584-3.327 4.725-3.939-1.71-.697-2.302-2.164-2.302-3.21 0-1.977 1.527-3.016 3.06-4.134-2.555-1.073-4.034-3.198-4.034-5.917 0-3.956 3.726-6.835 8.258-6.835 1.81 0 2.909.401 3.71.76l7.02-.2zm-94.364 9.399c0-6.637-.637-8.896-2.919-8.896-2.353 0-2.909 2.242-2.909 8.828 0 6.201.556 8.854 2.909 8.854 2.282 0 2.919-2.635 2.919-8.786zm6.323 0c0 5.749-4.13 9.755-9.241 9.755-5.143 0-9.268-4.023-9.268-9.823 0-5.755 4.153-9.808 9.268-9.808 5.111 0 9.241 4.069 9.241 9.876z" }), /* @__PURE__ */ C.createElement("path", { fill: "#FEFEFE", d: "M0 49.95h63.74V0H0z" }), /* @__PURE__ */ C.createElement("path", { fill: "#ffca05", d: "M5.499 44.357h23.61V5.587H5.498z" }), /* @__PURE__ */ C.createElement("path", { fill: "#001246", d: "M34.632 44.357h23.61V5.587h-23.61z" }))), P3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 170, height: 68, viewBox: "0 0 170 68", xmlns: "http://www.w3.org/2000/svg", className: "small-logo", ...e }, /* @__PURE__ */ C.createElement("g", { fill: "none" }, /* @__PURE__ */ C.createElement("path", { d: "M72.432 64.145h-4.137v-.187l.4-.05c.26-.031.387-.084.387-.422V58.39c0-.494-.275-.834-.787-.834-.65 0-1.185.508-1.185 1.061v4.797c0 .42.126.458.41.495l.377.05v.187h-4.069v-.187l.37-.062c.2-.035.35-.046.35-.434v-5.17c0-.724-.16-.948-.88-1.044v-.185l3.396-.831v1.347c.623-.588 1.423-1.336 2.548-1.336 1.395 0 2.031.844 2.031 1.967v5.252c0 .38.153.409.423.446l.366.05v.187zM62.853 54.4c0 .727-.585 1.304-1.38 1.304-.798 0-1.37-.577-1.37-1.305 0-.73.572-1.315 1.37-1.315.795 0 1.38.586 1.38 1.315m.711 9.746h-4.123v-.187l.376-.05c.272-.037.408-.076.408-.435v-5.168c0-.726-.167-.961-.87-1.057v-.185l3.436-.831v7.137c0 .463.11.502.483.555l.29.034v.187zm-4.407 0h-4.133v-.187l.424-.05c.25-.025.363-.136.363-.435v-5.046c0-.604-.303-.872-.802-.872-.608 0-1.167.508-1.167 1.023v4.859c0 .413.133.434.423.471l.359.05v.187h-4.135v-.187l.47-.062c.215-.025.313-.143.313-.35v-8.853c0-.893-.268-.979-.872-1.077v-.18l3.442-.83v4.973c.514-.648 1.531-1.347 2.51-1.347 1.114 0 2.024.639 2.024 1.963v5.254c0 .412.138.413.447.459l.334.05v.187zm-8.985-1.778c-.534.828-1.707 2.07-3.822 2.07-3.654 0-5.605-2.134-5.605-5.445 0-4.058 2.688-5.747 5.591-5.747 1.478 0 2.247.48 2.808.48.171 0 .442-.05.654-.097l.035 2.625h-.34l-1.028-1.866c-.43-.326-1.015-.541-1.985-.541-1.805 0-2.844 2.024-2.844 4.72 0 3.087 1.441 4.762 3.253 4.762 1.975 0 2.646-.805 3.064-1.252l.219.291zM38.45 64.145h-4.14v-.187l.424-.05c.245-.025.367-.136.367-.435v-5.046c0-.604-.312-.872-.806-.872-.599 0-1.171.508-1.171 1.023v4.859c0 .413.137.434.425.471l.362.05v.187h-4.14v-.187l.476-.062c.214-.025.311-.143.311-.35v-8.853c0-.893-.264-.979-.87-1.077v-.18l3.436-.83v4.973c.521-.648 1.535-1.347 2.515-1.347 1.115 0 2.017.639 2.017 1.963v5.254c0 .412.15.413.456.459l.337.05v.187zm-8.221-1.279c-.42.729-1.341 1.453-2.803 1.453-1.403 0-2.057-.946-2.057-1.906v-5.276h-.944v-.183l3.34-2.665h.193v2.22h1.925l-.223.628h-1.702v5.056c0 .68.362.958.848.958.446 0 .956-.294 1.296-.567l.127.282zm-5.624 1.066l-3.316.302v-1.257c-.537.618-1.546 1.354-2.567 1.354-1.322 0-2.002-.858-2.002-1.976v-4.112c0-.72-.244-.927-.87-.995v-.185l3.434-.831v5.748c0 .59.228.928.801.928.377 0 .517-.059.798-.24.325-.216.359-.391.359-.787v-3.638c0-.72-.24-.9-.87-.995v-.185l3.436-.831v6.9c0 .528.413.57.797.621v.18zM7.682 60.704c0 2.222-1.826 3.64-4.33 3.64-1.33 0-2.557-.362-3.236-.848v-2.444H.42l.926 2.037c.554.355 1.136.665 2.093.665 1.325 0 2.045-.857 2.045-1.85 0-.889-.675-1.586-2.31-2.09C1.134 59.182 0 58.269 0 56.532c0-1.88 1.9-3.277 4.004-3.277 1.316 0 2.272.555 2.542.555l.422-.037v2.422h-.29l-1.016-1.814c-.316-.33-1.148-.475-1.755-.475-1.112 0-1.946.621-1.946 1.542 0 .91.6 1.339 2.501 1.964 2.202.723 3.22 1.56 3.22 3.292m69.116 1.419v-2.658c-.725.853-1.873.91-1.873 2.658 0 .65.306 1.086.85 1.086.555 0 1.023-.618 1.023-1.086zm3.829 1.156c-.181.354-.947 1.053-2.072 1.053-1.124 0-1.526-.6-1.658-1.291-.447.69-1.045 1.29-2.372 1.29-1.34 0-2.093-.785-2.093-1.898 0-1.181.684-1.797 2.459-2.479 1.152-.441 1.94-.605 1.94-1.845 0-1.046-.418-1.409-.95-1.409-.702 0-1.135.445-1.205.557.128.07.599.278.599.938 0 .685-.582 1.088-1.23 1.088-.715 0-1.051-.546-1.051-1.174 0-1.06 1.447-1.877 3.615-1.877 1.834 0 2.759.869 2.759 2.37v4.015c0 .61.069.856.47.856.215 0 .448-.145.654-.35l.135.156zm-67.36-2.973c0-2.738-.261-3.676-1.204-3.676-.977 0-1.212.925-1.212 3.651 0 2.554.235 3.651 1.212 3.651.943 0 1.204-1.085 1.204-3.626m2.63 0c0 2.378-1.712 4.025-3.834 4.025-2.14 0-3.851-1.655-3.851-4.05 0-2.376 1.728-4.05 3.851-4.05 2.122 0 3.833 1.677 3.833 4.075M169.88 62.85c-.422.722-1.334 1.482-2.795 1.482-1.405 0-2.058-.948-2.058-1.904v-5.276h-.946v-.185l3.346-2.656h.188v2.212h1.927l-.222.63h-1.705v5.06c0 .674.368.948.85.948.454 0 .832-.28 1.212-.556l.203.245zm-5.818-1.266c0 1.694-1.511 2.736-3.386 2.736-1.66 0-2.338-.436-2.66-.594v-2.011h.187l.887 1.686c.359.245 1.05.47 1.604.47.898 0 1.524-.434 1.524-1.195 0-.81-1.007-1.084-2.064-1.443-1.175-.394-2.215-1.031-2.215-2.389 0-1.646 1.467-2.601 3.125-2.601 1.412 0 2.016.52 2.394.426v1.937h-.173l-.907-1.48a2.314 2.314 0 0 0-1.307-.426c-1.054 0-1.548.359-1.548 1.005 0 .708.993.99 2.07 1.372 1.359.48 2.469.99 2.469 2.507m-33.106 2.573h-4.129v-.189l.395-.044c.257-.034.388-.092.388-.421v-5.1c0-.498-.28-.892-.783-.892-.662 0-1.19.57-1.19 1.12v4.795c0 .412.127.458.407.498l.376.044v.189h-4.064v-.189l.365-.06c.207-.036.35-.04.35-.435v-5.168c0-.725-.16-.951-.868-1.048v-.181l3.385-.833v1.353c.63-.594 1.426-1.339 2.546-1.339 1.401 0 2.036.844 2.036 1.96v5.256c0 .38.15.41.428.45l.358.045v.189zm-9.566-9.742c0 .722-.585 1.299-1.383 1.299-.795 0-1.365-.577-1.365-1.299 0-.726.57-1.312 1.365-1.312.798 0 1.382.586 1.382 1.312m.733 9.742h-4.123v-.189a7.34 7.34 0 0 1 .375-.044c.275-.038.415-.074.415-.438v-5.165c0-.727-.17-.967-.874-1.064v-.181l3.44-.833v7.135c0 .472.101.508.478.554l.289.036v.189zm-4.335 0h-4.14v-.189l.394-.044c.26-.034.394-.092.394-.421v-5.1c0-.498-.28-.833-.789-.833-.655 0-1.19.51-1.19 1.06v4.796c0 .412.127.458.415.498l.377.044v.189h-4.067v-.189l.367-.06c.2-.036.345-.04.345-.435v-5.168c0-.725-.167-.978-.872-1.057v-.172l3.39-.833v1.353c.631-.594 1.425-1.339 2.55-1.339 1.39 0 2.031.844 2.031 1.96v5.256c0 .38.15.41.429.45l.366.045v.189zm-8.657-6.803c0 .709-.426 1.193-1.172 1.193-.526 0-.919-.344-.919-.807 0-.156.048-.325.141-.492-.38 0-1.238.615-1.238 1.224v4.965c0 .387.143.468.455.495l.416.037v.188h-4.23v-.188l.355-.045c.35-.053.436-.092.436-.511v-5.17c0-.72-.259-.9-.876-.986v-.18l3.392-.834v1.254c.556-.75 1.346-1.254 2.06-1.254.722 0 1.18.434 1.18 1.11m-13.998 6.804h-5.085v-.189l.595-.072c.455-.055.56-.128.56-.602v-.205l-.183-7.35h-.046l-3.098 8.505h-.494l-2.996-8.456h-.04l-.1 6.64-.012.429c0 .897.241 1.015.954 1.111v.189h-2.735v-.189c.717-.136 1.074-.455 1.102-1.532l.21-7.512.009-.283c0-.45-.135-.85-.722-.916l-.475-.047v-.193h3.797l2.276 6.771h.04l2.468-6.771h3.335v.193c-.584.047-.894.208-.894.633l.017.623.294 8.322c.017.436.195.585.63.64l.593.072v.189zm59.583-3.839c0-2.738-.261-3.67-1.204-3.67-.978 0-1.21.925-1.21 3.642 0 2.56.232 3.654 1.21 3.654.943 0 1.204-1.087 1.204-3.626m2.631 0c0 2.373-1.715 4.026-3.835 4.026-2.136 0-3.846-1.66-3.846-4.054 0-2.374 1.723-4.047 3.846-4.047 2.12 0 3.835 1.68 3.835 4.075m-9.873-3.938c0-1.76-.628-2.46-1.853-2.46a3.14 3.14 0 0 0-.715.08v4.971c.12.01.222.043.67.043 1.27 0 1.898-.689 1.898-2.634m2.77.033c0 1.951-1.86 3.037-4.304 3.037-.363 0-.547.006-1.034-.027v3.882c0 .34.147.528.79.591l.461.048v.213h-5.048v-.213l.629-.073c.4-.044.538-.157.538-.52v-8.808c0-.623-.352-.768-1.167-.865v-.193h4.38c3.087 0 4.756.703 4.756 2.928m-13.465 9.64c0-.566-.463-.737-1.706-.988l-2.107-.425c-.344.288-.715.535-.715 1.324 0 .783.85 1.271 2.204 1.271 1.488 0 2.324-.605 2.324-1.182zm-1.346-7.024c0-1.753-.275-2.381-.93-2.381-.703 0-.916.628-.916 2.38 0 1.731.213 2.31.916 2.31.655 0 .93-.579.93-2.31zm3.523-2.59l-.475.956-1.291-.068c.416.394.747.89.747 1.702 0 1.647-1.54 2.774-3.434 2.774-.433 0-.947-.06-1.303-.15a.854.854 0 0 0-.124.398c0 .192.368.33.799.411l2.213.42c1.965.384 2.77.91 2.77 2.148 0 1.628-2.139 2.637-4.428 2.637-2.117 0-3.956-.374-3.956-1.54 0-.988 1.073-1.373 1.961-1.626-.71-.287-.955-.892-.955-1.324 0-.816.634-1.245 1.27-1.706-1.06-.443-1.674-1.32-1.674-2.442 0-1.633 1.546-2.82 3.427-2.82.75 0 1.207.165 1.54.313l2.913-.082zm-39.163 3.879c0-2.738-.264-3.67-1.21-3.67-.977 0-1.208.925-1.208 3.642 0 2.56.23 3.654 1.207 3.654.947 0 1.211-1.087 1.211-3.626m2.625 0c0 2.373-1.715 4.026-3.836 4.026-2.134 0-3.846-1.66-3.846-4.054 0-2.374 1.724-4.047 3.846-4.047 2.121 0 3.836 1.68 3.836 4.075M60.245 37.936h49.39V0h-49.39z", fill: "#FEFEFE" }), /* @__PURE__ */ C.createElement("path", { fill: "#ffca05", d: "M64.506 33.69H82.8V4.242H64.506z" }), /* @__PURE__ */ C.createElement("path", { fill: "#001B54", d: "M87.08 33.69h18.294V4.242H87.08z" }))), L3 = /* @__PURE__ */ b(I3, {
  target: "emqcp92"
})("display:none;inline-size:100%;block-size:auto;min-inline-size:270px;max-inline-size:320px;", (e) => e.theme.breakpoints.up("tablet"), "{display:block;}"), O3 = /* @__PURE__ */ b(P3, {
  target: "emqcp91"
})("display:block;", (e) => e.theme.breakpoints.up("tablet"), "{display:none;}"), N3 = /* @__PURE__ */ b("a", {
  target: "emqcp90"
})({
  name: "1i1khhi",
  styles: "block-size:auto;cursor:pointer;fill:#ffffff"
});
function yr() {
  return yr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yr.apply(null, arguments);
}
const So = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    homeAsPath: r
  } = U();
  return /* @__PURE__ */ m.createElement(N3, yr({}, e, {
    href: r,
    onClick: (n) => {
      n.preventDefault(), t(r);
    },
    "data-qa": "logo"
  }), /* @__PURE__ */ m.createElement(L3, null), /* @__PURE__ */ m.createElement(O3, null));
};
So.displayName = "Logo";
const x3 = () => {
  var e;
  const {
    config: t
  } = U(), r = {
    description: "Mobile sitemap display on the bottom of the page",
    links: [{
      isExternal: !0,
      label: "Digital Subscription",
      url: {
        alias: t.subscribe.host
      }
    }, {
      isExternal: !0,
      label: "Bundle Subscription",
      url: {
        alias: `${t.subscribe.host}/bundle`
      }
    }, {
      isExternal: !0,
      label: "Group Subscriptions",
      url: {
        alias: `${t.subscribe.host}/group`,
        applicationId: "group-subscriptions"
      }
    }, {
      label: "Mobile Editions",
      url: {
        alias: "/mobile"
      }
    }, {
      isExternal: !0,
      label: "ePaper",
      url: {
        alias: "/epaper"
      }
    }, {
      label: "RSS Feeds",
      url: {
        alias: "/rss"
      }
    }, {
      label: "Newsletters",
      url: {
        alias: "/newsletters"
      }
    }, {
      isExternal: !0,
      label: "Buy SCMP Photos",
      url: {
        alias: "https://photo.scmp.com/",
        applicationId: "photo"
      }
    }, {
      isExternal: !0,
      label: "Syndication & Licensing",
      url: {
        alias: "https://enterprise.scmp.com/licensing"
      }
    }],
    linksSecondary: [{
      label: "All Topics",
      url: {
        alias: "/topics"
      }
    }, {
      label: "All Authors",
      url: {
        alias: "/authors"
      }
    }, {
      isExternal: !0,
      label: "SCMP Publishers",
      url: {
        alias: "https://corp.scmp.com/",
        applicationId: "scmp-publishers"
      }
    }, {
      label: "Policies and Standards",
      url: {
        alias: "/policies-and-standards",
        entityId: "3074375",
        entityUuid: "dd1bc258-b7b9-437c-bc4c-99130d8a5a3f",
        type: je.Page
      }
    }, {
      label: "Privacy Policy",
      url: {
        alias: "/privacy-policy",
        entityId: "800172",
        entityUuid: "d1c18b93-cb6c-48a2-bf84-7c2acb96d4cc",
        type: je.Page
      }
    }, {
      label: "Terms & Conditions",
      url: {
        alias: "/terms-conditions",
        entityId: "800173",
        entityUuid: "c18b91b9-6e24-45dc-ba05-974848666e4b",
        type: je.Page
      }
    }, {
      label: "Commenting Guidelines",
      url: {
        alias: "/commenting-submission-guidelines",
        entityId: "3076709",
        entityUuid: "3460b664-d04c-44d0-83db-cec47ac0152c",
        type: je.Page
      }
    }, {
      isExternal: !0,
      label: "Help Center",
      url: {
        alias: "https://help.scmp.com/hc",
        applicationId: "help-center"
      }
    }, {
      isExternal: !0,
      label: "Career with SCMP",
      url: {
        alias: "https://corp.scmp.com/work-for-us/",
        applicationId: "career-with-scmp"
      }
    }, {
      label: "Contact Us",
      url: {
        alias: "/contact-us",
        entityId: "800171",
        entityUuid: "b580e1d5-6698-42df-a1c2-1f7bdb2a0a04",
        type: je.Page
      }
    }],
    name: "Mobile Footer sitemap"
  };
  return {
    desktopSitemap: {
      description: "Sitemap display on the bottom of the page.",
      name: "Footer sitemap",
      sections: [{
        label: "Products & Services",
        links: r.links
      }, {
        label: "About Us",
        links: (e = r.linksSecondary) !== null && e !== void 0 ? e : []
      }, {
        label: "Our Sites",
        links: [{
          isExternal: !0,
          label: "Young Post",
          url: {
            alias: "/yp",
            applicationId: "yp"
          }
        }, {
          isExternal: !0,
          label: "Posties",
          url: {
            alias: "/posties",
            applicationId: "posties"
          }
        }, {
          isExternal: !0,
          label: "Serviced Apartments",
          url: {
            alias: "http://www.ays.com.hk/",
            applicationId: "serviced-apartments"
          }
        }, {
          label: "SCMP Cooking",
          url: {
            alias: "/cooking",
            applicationId: "scmp-cooking"
          }
        }, {
          isExternal: !0,
          label: "Cosmopolitan",
          url: {
            alias: "https://www.cosmopolitan.com.hk",
            applicationId: "cosmopolitan"
          }
        }, {
          isExternal: !0,
          label: "ELLE",
          url: {
            alias: "https://www.elle.com.hk",
            applicationId: "elle"
          }
        }, {
          isExternal: !0,
          label: "Esquire",
          url: {
            alias: "https://www.esquirehk.com",
            applicationId: "esquire"
          }
        }, {
          label: "ELLE MEN",
          url: {
            alias: "https://www.ellemen.com.hk/ ",
            applicationId: "elle-men"
          }
        }, {
          isExternal: !0,
          label: "Harper's BAZAAR",
          url: {
            alias: "https://www.harpersbazaar.com.hk",
            applicationId: "harpers-bazaar"
          }
        }, {
          isExternal: !0,
          label: "CosMart",
          url: {
            alias: "https://www.cosmart.hk",
            applicationId: "cosmart"
          }
        }]
      }, {
        label: "Other",
        links: [{
          isExternal: !0,
          label: "Advertising+",
          url: {
            alias: "http://advertising.scmp.com/",
            applicationId: "advertising-with-us"
          }
        }, {
          isExternal: !0,
          label: "SCMP Live",
          url: {
            alias: "http://www.scmpevents.com",
            applicationId: "scmp-events"
          }
        }, {
          isExternal: !0,
          label: "Enterprise+",
          url: {
            alias: "https://enterprise.scmp.com/",
            applicationId: "enterprise"
          }
        }, {
          label: "Learn",
          url: {
            alias: "https://www.scmplearn.com/",
            applicationId: "scmp-learn"
          }
        }, {
          label: "SCMP PR Blog",
          url: {
            alias: "/topics/scmp-pr-blog",
            entityId: "512674",
            entityUuid: "b39eda92-a5a8-443c-8ebf-0d3989acb0f3",
            type: je.Topic
          }
        }]
      }]
    },
    mobileSitemap: r
  };
}, k3 = /* @__PURE__ */ b("nav", {
  target: "eug6sto6"
})("display:flex;flex-flow:row;justify-content:flex-start;align-items:flex-start;inline-size:100%;", (e) => e.theme.breakpoints.only("tablet"), "{flex:1 1 auto;inline-size:auto;min-block-size:360px;}", (e) => e.theme.breakpoints.up("desktop"), "{flex:0.7 1 0;inline-size:auto;min-block-size:0;}"), ea = /* @__PURE__ */ b("div", {
  target: "eug6sto5"
})("display:flex;flex-flow:row;justify-content:space-between;align-items:flex-start;inline-size:100%;margin-block-start:27px;color:#ffffff;", (e) => e.theme.breakpoints.up("tablet"), "{display:flex;flex:1 1 0;flex-flow:column;justify-content:flex-start;align-items:flex-start;margin-block-start:0;}"), B3 = /* @__PURE__ */ b("h3", {
  target: "eug6sto4"
})("margin:0;padding:0;font-weight:bold;font-size:14px;font-family:", Q, ";line-height:16px;border:0;"), br = /* @__PURE__ */ b("ul", {
  target: "eug6sto3"
})({
  name: "8jsgjm",
  styles: "margin:0;padding:0;border:0;list-style:none"
}), U3 = /* @__PURE__ */ b(br, {
  target: "eug6sto2"
})({
  name: "va2k03",
  styles: "text-align:end"
}), K1 = /* @__PURE__ */ b("li", {
  target: "eug6sto1"
})("margin-block-end:14px;font-size:12px;font-family:", Q, ";line-height:14px;vertical-align:top;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block:10px;margin-inline:0;}"), H3 = /* @__PURE__ */ b("a", {
  target: "eug6sto0"
})({
  name: "a3w9x2",
  styles: "color:#ffffff;text-decoration:none"
});
function wr() {
  return wr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wr.apply(null, arguments);
}
const Ao = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    handleTrackGA4: r
  } = U(), {
    desktopSitemap: n,
    mobileSitemap: a
  } = x3(), i = Bt(kt.breakpoints.only("mobile"), !1), o = (l) => /* @__PURE__ */ m.createElement(H3, {
    href: l.url.alias,
    onClick: (u) => {
      u.preventDefault(), t(l.url.alias, {
        applicationId: l.url.applicationId,
        entityId: l.url.entityId,
        entityUuid: l.url.entityUuid,
        isExternal: l.isExternal,
        type: l.url.type
      }), r({
        action: "click",
        category: "footer",
        customized_parameters: {
          destination_url: l.isExternal ? l.url.alias : `${window.location.origin}${l.url.alias}`,
          link_name: l.label
        },
        subcategory: ""
      });
    },
    "data-qa": "render-anchor"
  }, l.label), s = () => n.sections.map((l) => /* @__PURE__ */ m.createElement(ea, {
    key: l.label
  }, /* @__PURE__ */ m.createElement(B3, null, l.label), /* @__PURE__ */ m.createElement(br, null, l.links.map((u, d) => /* @__PURE__ */ m.createElement(K1, {
    key: d
  }, o(u)))))), c = () => {
    var l;
    return /* @__PURE__ */ m.createElement(ea, {
      "data-qa": "render-mobile-sitemap"
    }, /* @__PURE__ */ m.createElement(br, null, a.links.map((u, d) => /* @__PURE__ */ m.createElement(K1, {
      key: d
    }, o(u)))), /* @__PURE__ */ m.createElement(U3, null, (l = a.linksSecondary) === null || l === void 0 ? void 0 : l.map((u, d) => /* @__PURE__ */ m.createElement(K1, {
      key: d
    }, o(u)))));
  };
  return /* @__PURE__ */ m.createElement(k3, wr({}, e, {
    "data-qa": "sitemap"
  }), i ? c() : s());
};
Ao.displayName = "Sitemap";
const M3 = "https://www.facebook.com/scmp", V3 = "https://www.instagram.com/scmpnews", D3 = "https://www.linkedin.com/company/south-china-morning-post", F3 = "https://www.twitter.com/scmpnews", X3 = "https://www.youtube.com/southchinamorningpost";
let we = /* @__PURE__ */ function(e) {
  return e.Facebook = "facebook", e.Instagram = "instagram", e.Linkedin = "linkedin", e.Twitter = "twitter", e.Youtube = "youtube", e;
}({});
const $3 = (e) => /* @__PURE__ */ C.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 18, viewBox: "0 0 10 18", ...e }, /* @__PURE__ */ C.createElement("path", { d: "M2.696 18V9.95H0v-3.2h2.696V4.23C2.696 1.49 4.37 0 6.813 0 7.984 0 8.99.088 9.281.127v2.861H7.587C6.257 2.988 6 3.621 6 4.546V6.75h3l-.411 3.2H6V18" })), q3 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fill: "none", d: "M-3-3h24v24H-3z" }), /* @__PURE__ */ C.createElement("path", { d: "M9 1.624c2.402 0 2.687.01 3.636.052.877.04 1.353.187 1.67.31.392.144.746.374 1.036.673.3.29.53.645.673 1.036.124.317.27.794.31 1.67.043.95.053 1.234.053 3.636 0 2.403-.01 2.687-.053 3.636-.04.877-.186 1.354-.31 1.67a2.982 2.982 0 0 1-1.707 1.708c-.317.124-.794.27-1.67.31-.95.043-1.234.053-3.637.053-2.402 0-2.687-.01-3.635-.053-.877-.04-1.354-.186-1.671-.31a2.786 2.786 0 0 1-1.036-.673 2.777 2.777 0 0 1-.673-1.036c-.123-.317-.27-.793-.31-1.67-.043-.95-.052-1.233-.052-3.636 0-2.402.01-2.687.052-3.636.04-.877.187-1.353.31-1.67.144-.392.374-.746.673-1.036.29-.3.645-.53 1.036-.673.317-.124.794-.27 1.67-.31.95-.043 1.234-.052 3.636-.052H9zM9.001 0c-2.443 0-2.75.01-3.71.055C4.333.1 3.68.253 3.108.475c-.6.226-1.144.58-1.594 1.038-.458.45-.812.994-1.038 1.594C.253 3.68.101 4.334.057 5.291.014 6.25.003 6.556.003 9s.01 2.75.054 3.71.196 1.611.418 2.183c.226.6.58 1.144 1.038 1.593.45.458.994.813 1.594 1.039.572.222 1.227.374 2.184.418.958.043 1.266.054 3.71.054 2.443 0 2.75-.01 3.71-.054.959-.044 1.61-.196 2.182-.418a4.598 4.598 0 0 0 2.632-2.632c.222-.572.374-1.227.418-2.184.043-.958.054-1.266.054-3.71 0-2.443-.01-2.75-.054-3.71-.044-.959-.196-1.61-.418-2.182a4.411 4.411 0 0 0-1.038-1.593A4.417 4.417 0 0 0 14.893.475C14.32.253 13.666.101 12.709.057 11.75.014 11.444.003 9 .003L9.001 0z" }), /* @__PURE__ */ C.createElement("path", { d: "M9 4.38a4.62 4.62 0 1 0 0 9.24 4.62 4.62 0 0 0 0-9.24zM9 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" }), /* @__PURE__ */ C.createElement("circle", { cx: 13.803, cy: 4.197, r: 1.08 })), j3 = (e) => /* @__PURE__ */ C.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 20, viewBox: "0 0 21 20", ...e }, /* @__PURE__ */ C.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M4.846 6.611V19.75H.482V6.611h4.364zm.279-4.086c0 .681-.217 1.223-.65 1.625-.495.433-1.099.65-1.811.65-.743 0-1.331-.217-1.764-.65-.433-.402-.65-.944-.65-1.625S.467 1.302.9.9C1.395.467 1.999.25 2.711.25c.681 0 1.269.217 1.764.65.433.433.65.975.65 1.625zm15.461 9.657v7.568h-4.364v-7.057c0-.929-.17-1.656-.511-2.182-.371-.526-.929-.789-1.671-.789-.526 0-.99.155-1.393.464-.402.31-.696.696-.882 1.161-.093.248-.139.604-.139 1.068v7.336H7.262c.031-2.352.046-5.215.046-8.589V7.216l-.046-.604h4.364v1.904c.31-.464.48-.712.511-.743.155-.217.418-.449.789-.696.31-.248.681-.449 1.114-.604.402-.124.913-.186 1.532-.186 1.517 0 2.739.495 3.668 1.486.898.99 1.346 2.461 1.346 4.411z" })), K3 = (e) => /* @__PURE__ */ C.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 17, viewBox: "0 0 20 17", ...e }, /* @__PURE__ */ C.createElement("path", { d: "M20 2c-.6.8-1.3 1.5-2 2v.6c0 1.2-.2 2.3-.5 3.3C17.2 9 16.7 10 16 11c-.5.9-1.3 1.8-2.3 2.7-1 .8-2.1 1.4-3.3 1.9-1.2.4-2.6.7-4.1.7-2.3 0-4.4-.7-6.3-1.9.4.1.7.1 1 .1 1.8 0 3.6-.6 5.1-1.8-.9 0-1.7-.3-2.4-.8s-1.2-1.2-1.5-2c.4 0 .7.1.8.1.4 0 .8-.1 1.1-.2-.9-.2-1.7-.7-2.4-1.4-.6-.8-.9-1.6-.9-2.6v-.1c.6.4 1.2.5 1.9.5-.6-.3-1-.8-1.4-1.4-.3-.6-.5-1.2-.5-2 0-.7.2-1.4.6-2 1 1.2 2.3 2.2 3.7 3 1.5.7 3.1 1.2 4.8 1.3-.1-.4-.2-.7-.2-1 0-1.1.4-2.1 1.2-2.9.8-.8 1.8-1.2 3-1.2s2.2.4 3 1.3c.9-.2 1.8-.5 2.6-1-.3 1-.9 1.7-1.8 2.3.7-.1 1.5-.3 2.3-.6z" })), z3 = (e) => /* @__PURE__ */ C.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 18, viewBox: "0 0 25 18", ...e }, /* @__PURE__ */ C.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M16.99 9.71c.284-.158.426-.395.426-.71 0-.316-.142-.553-.426-.71l-6.914-4.357c-.284-.189-.584-.189-.9 0-.284.158-.426.41-.426.758v8.619c0 .347.142.6.426.758a.69.69 0 0 0 .426.142.912.912 0 0 0 .474-.142l6.914-4.357zm7.341-2.747v4.073c0 .474-.047 1.089-.142 1.847-.032.758-.126 1.421-.284 1.989a3.243 3.243 0 0 1-.947 1.658c-.442.442-.995.71-1.658.805-2.368.221-5.399.332-9.093.332s-6.725-.111-9.093-.332c-.663-.095-1.216-.363-1.658-.805a3.236 3.236 0 0 1-.947-1.658c-.158-.568-.253-1.231-.284-1.989a15.477 15.477 0 0 1-.142-1.847V6.963c0-.474.047-1.089.142-1.847.032-.758.126-1.421.284-1.989a3.243 3.243 0 0 1 .947-1.658c.442-.442.995-.71 1.658-.805C5.482.443 8.513.332 12.207.332s6.725.111 9.093.332c.663.095 1.216.363 1.658.805.474.442.789.995.947 1.658.158.568.253 1.231.284 1.989.095.758.142 1.373.142 1.847z" })), Ro = /* @__PURE__ */ b("div", {
  target: "eapy92n1"
})({
  name: "16cp6bs",
  styles: "display:inline-block;inline-size:22px;max-block-size:22px;margin-inline-start:20px;svg{inline-size:23px;block-size:23px;fill:#ffffff;}"
}), G3 = /* @__PURE__ */ b("div", {
  target: "eapy92n0"
})("display:flex;", Ro, ":first-child{margin-inline-start:0;}");
function Tr() {
  return Tr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tr.apply(null, arguments);
}
const Io = ({
  ...e
}) => {
  const {
    handleTrackGA4: t
  } = U(), r = {
    [we.Facebook]: {
      icon: $3,
      url: M3
    },
    [we.Instagram]: {
      icon: q3,
      url: V3
    },
    [we.Linkedin]: {
      icon: j3,
      url: D3
    },
    [we.Twitter]: {
      icon: K3,
      url: F3
    },
    [we.Youtube]: {
      icon: z3,
      url: X3
    }
  }, n = (a) => {
    const {
      icon: i,
      url: o
    } = r[a];
    return /* @__PURE__ */ m.createElement(Ro, {
      key: a,
      "data-qa": "render-icon"
    }, /* @__PURE__ */ m.createElement("a", {
      href: o,
      rel: "noopener noreferrer",
      target: "_blank",
      title: "Follow SCMP",
      onClick: () => {
        t({
          action: "click",
          category: "footer",
          customized_parameters: {
            destination_url: o,
            link_name: a,
            social_platform: a
          },
          subcategory: ""
        });
      }
    }, /* @__PURE__ */ m.createElement(i, null)));
  };
  return /* @__PURE__ */ m.createElement(G3, Tr({}, e, {
    "data-qa": "social-media"
  }), [we.Facebook, we.Twitter, we.Youtube, we.Instagram, we.Linkedin].map((a) => n(a)));
};
Io.displayName = "SocialMedia";
async function Y3(e) {
  const t = await jr.post("/piano/renew", {
    subscriptionId: e
  }), {
    code: r,
    data: n
  } = t.data;
  return r === 0 && n === !0;
}
const ye = /* @__PURE__ */ b("button", {
  target: "e1uch9rj1"
})("padding-block:8px;padding-inline:12px;color:#001246;font-size:14px;font-family:", De, ";line-height:16px;white-space:nowrap;text-align:center;text-transform:uppercase;border-radius:2px;background:#ffca05;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{padding-block:6px;padding-inline:10px;}"), W3 = /* @__PURE__ */ b("span", {
  target: "e1uch9rj0"
})((e) => {
  switch (e.$variant) {
    case "dark":
      return /* @__PURE__ */ Lt(ye, "{color:#ffffff;background:#222222;}", "");
    case "dark-blue":
      return /* @__PURE__ */ Lt(ye, "{color:#ffffff;font-weight:700;background:#001246;}", "");
    case "light-blue":
      return /* @__PURE__ */ Lt(ye, "{padding-block:7px;padding-inline:8px;color:#ffffff;background:#4585ff;}", "");
    default:
      return null;
  }
}, ";"), Po = ({
  className: e
}) => {
  const {
    handleTrackGA4: t,
    rosettaInstance: r
  } = U(), {
    computeGA4CommonParameters: n
  } = Ze(), [a, i] = Me(!1);
  te(() => {
    r != null && r.rulesEngine.getOutcome("user.autoRenewEnabled") || i(!0);
  }, [r == null ? void 0 : r.rulesEngine]);
  const {
    captureTrackImpressionEventTargetElement: o
  } = Ft({
    ga4Event: ue(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...n(),
        call_to_action: "enable auto-renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [n])
  });
  return a ? /* @__PURE__ */ m.createElement(ye, {
    className: e,
    ref: o,
    onClick: () => {
      (async () => {
        const c = r == null ? void 0 : r.rulesEngine.getOutcome("user.autoRenewSubscriptionId");
        t({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...n(),
            call_to_action: "enable auto-renew",
            trigger_point: "masthead enable auto-renew button"
          },
          subcategory: "entry_point"
        }), !(!c || !await Y3(c)) && (window.postMessage({
          type: "PIANO_AUTORENEW_CONFIRMATION"
        }, "*"), r == null || r.rulesEngine.addRule(new r.Rule("user.autoRenewEnabled").priority(10).when(() => !0).then(!0)), await (r == null ? void 0 : r.rulesEngine.run()), i(!1));
      })();
    },
    "data-qa": "auto-renew-button"
  }, "Enable Auto-renew") : null;
};
Po.displayName = "AutoRenewButton";
const Z3 = (e) => /* @__PURE__ */ C.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ C.createElement("path", { d: "M12 16.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75Z", fill: "#EB4254", stroke: "#EB4254", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ C.createElement("path", { d: "M12 13.5V5.25", stroke: "#EB4254", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ C.createElement("path", { d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Z", stroke: "#EB4254", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ C.createElement("circle", { cx: 12, cy: 17, r: 1, fill: "#EB4254" })), Q3 = /* @__PURE__ */ b(ye, {
  target: "e7roqsw1"
})("display:flex;color:#eb4254;border:1px solid #eb4254;background:#fff6f7;", (e) => e.theme.breakpoints.up("tablet"), "{border-radius:2px;}"), J3 = /* @__PURE__ */ b(Z3, {
  target: "e7roqsw0"
})("inline-size:17.5px;margin-inline-end:5px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-inline-end:9px;}"), Lo = ({
  className: e
}) => {
  const {
    config: t,
    handleTrackGA4: r
  } = U(), {
    computeGA4CommonParameters: n
  } = Ze(), {
    captureTrackImpressionEventTargetElement: a
  } = Ft({
    ga4Event: ue(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...n(),
        call_to_action: "update payment",
        trigger_point: "masthead grace period renewal failure banner"
      },
      subcategory: "entry_point"
    }), [n])
  });
  return /* @__PURE__ */ m.createElement(Q3, {
    className: e,
    ref: a,
    onClick: () => {
      r({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...n(),
          call_to_action: "update payment",
          trigger_point: "masthead grace period renewal failure banner"
        },
        subcategory: "entry_point"
      }), window.location.href = `${t.accounts.host}/settings`;
    },
    "data-qa": "grace-period-button"
  }, /* @__PURE__ */ m.createElement(J3, null), "Renewal Failed");
};
Lo.displayName = "GracePeriodButton";
const Oo = ({
  className: e,
  location: t
}) => {
  const {
    config: r,
    currentPageType: n,
    handleTrackGA4: a,
    handleTrackMixPanel: i
  } = U(), {
    computeGA4CommonParameters: o
  } = Ze(), {
    captureTrackImpressionEventTargetElement: s
  } = Ft({
    ga4Event: null
  });
  return /* @__PURE__ */ m.createElement(ye, {
    className: e,
    ref: s,
    onClick: () => {
      i({
        name: "Subscription Entry Point",
        property: {
          Location: `${n === de.Article ? "Article" : "Homepage"} Masthead`
        }
      });
      const c = (() => {
        if (t === "masthead")
          return "masthead reactivation button";
        switch (n) {
          case de.Article:
            return "article footer";
          case de.Homepage:
            return "homepage footer";
          case de.Section:
            return "section footer";
          default:
            return "footer";
        }
      })();
      a({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...o(),
          call_to_action: "reactivation",
          trigger_point: c
        },
        subcategory: "entry_point"
      }), window.location.href = `${r.subscribe.host}/?product=winback`;
    },
    "data-qa": "reactivate-button"
  }, "Reactivate Access");
};
Oo.displayName = "ReactivateButton";
const No = ({
  className: e
}) => {
  const {
    handleTrackGA4: t,
    rosettaInstance: r
  } = U(), {
    computeGA4CommonParameters: n
  } = Ze(), {
    captureTrackImpressionEventTargetElement: a,
    intersection: i
  } = Ft({
    ga4Event: ue(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...n(),
        call_to_action: "renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [n])
  });
  return /* @__PURE__ */ m.createElement(ye, {
    className: e,
    ref: a,
    onClick: () => {
      var o, s;
      t({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...n(),
          call_to_action: "renew",
          trigger_point: "masthead renewal button"
        },
        subcategory: "entry_point"
      });
      const c = r == null || (o = r.rulesEngine.getOutcome("user")) === null || o === void 0 ? void 0 : o.expiryReminder, {
        bottom: l,
        left: u,
        right: d,
        top: f
      } = (s = i == null ? void 0 : i.boundingClientRect) !== null && s !== void 0 ? s : {};
      window.postMessage({
        bottom: l,
        expiryReminder: c,
        left: u,
        right: d,
        top: f,
        type: "PIANO_RENEW_POPUP"
      }, "*");
    },
    "data-qa": "renew-button"
  }, "Renew & Save");
};
No.displayName = "RenewButton";
const nn = ({
  className: e,
  location: t
}) => {
  const {
    config: r,
    currentPageType: n,
    handleTrackGA4: a,
    handleTrackMixPanel: i
  } = U(), {
    computeGA4CommonParameters: o
  } = Ze();
  return /* @__PURE__ */ m.createElement(ye, {
    className: e,
    onClick: () => {
      i({
        name: "Subscription Entry Point",
        property: {
          Location: (() => {
            switch (t) {
              case "footer":
                return "Homepage Footer";
              case "print-button":
                return "Print Icon Pop-up";
              case "masthead":
                return n === de.Article ? "Article Masthead" : "Homepage Masthead";
            }
          })()
        }
      }), a({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...o(),
          call_to_action: "subscribe",
          trigger_point: (() => {
            switch (t) {
              case "footer":
                switch (n) {
                  case de.Article:
                    return "article footer";
                  case de.Section:
                    return "section footer";
                  case de.Homepage:
                    return "homepage footer";
                  default:
                    return "footer";
                }
              case "masthead":
                return n === de.Article ? "article masthead" : "masthead";
              case "print-button":
                return "print article";
            }
          })()
        },
        subcategory: "entry_point"
      }), window.location.href = r.subscribe.host;
    },
    "data-qa": "subscribe-button"
  }, "Subscribe");
};
nn.displayName = "SubscribeButton";
const xo = ({
  className: e
}) => {
  const {
    config: t,
    currentPageType: r,
    handleTrackGA4: n,
    handleTrackMixPanel: a
  } = U(), {
    computeGA4CommonParameters: i
  } = Ze(), {
    captureTrackImpressionEventTargetElement: o
  } = Ft({
    ga4Event: ue(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...i(),
        call_to_action: "upgrade",
        trigger_point: r === de.Article ? "article masthead upgrade button" : "masthead"
      },
      subcategory: "entry_point"
    }), [i, r])
  });
  return /* @__PURE__ */ m.createElement(ye, {
    className: e,
    ref: o,
    onClick: () => {
      a({
        name: "Subscription Entry Point",
        property: {
          Location: `${r === de.Article ? "Article" : "Homepage"} Masthead`
        }
      }), n({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...i(),
          call_to_action: "upgrade",
          trigger_point: r === de.Article ? "article masthead upgrade button" : "masthead"
        },
        subcategory: "entry_point"
      }), window.location.href = `${t.accounts.host}/manage/subscription?upgrade=true`, window.postMessage({
        type: "PIANO_UPGRADE_POPUP"
      }, "*");
    },
    "data-qa": "upgrade-button"
  }, "Upgrade & Save");
};
xo.displayName = "UpgradeButton";
const ko = ({
  className: e
}) => {
  const {
    handleTrackGA4: t
  } = U();
  return /* @__PURE__ */ m.createElement(ye, {
    className: e,
    onClick: () => {
      t({
        action: "click",
        category: "plus",
        subcategory: "masthead"
      });
      const r = new URL("/plus", location.origin), n = new URL(location.href).searchParams;
      r.search = n.toString(), window.location.href = r.toString();
    },
    "data-qa": "scmp-plus-button"
  }, "SCMP ", /* @__PURE__ */ m.createElement("i", null, "Plus"));
};
ko.displayName = "ScmpPlusButton";
const Bo = ({
  className: e
}) => {
  const {
    currentPageType: t,
    handleTrackGA4: r,
    handleTrackMixPanel: n
  } = U(), {
    computeGA4CommonParameters: a
  } = Ze();
  return /* @__PURE__ */ m.createElement(ye, {
    className: e,
    onClick: () => {
      n({
        name: "Subscription Entry Point",
        property: {
          Location: `${t === de.Article ? "Article" : "Homepage"} Masthead`
        }
      }), r({
        action: "click",
        category: "epaper",
        customized_parameters: {
          call_to_action: "read epaper",
          ...a(),
          trigger_point: "masthead"
        },
        subcategory: ""
      }), window.location.href = "/epaper";
    },
    "data-qa": "epaper-button"
  }, "Read ePaper");
};
Bo.displayName = "EpaperButton";
const e6 = ({
  className: e,
  location: t = "masthead",
  variant: r
}) => {
  const {
    rosettaInstance: n
  } = U(), a = Bt(kt.breakpoints.only("mobile"), !1), i = n == null ? void 0 : n.rulesEngine.getOutcome("ui.masthead.button"), o = Ye(() => i == null ? void 0 : i.getDisplayVariant({
    shouldIncludeEpaper: !0,
    shouldIncludeScmpPlus: !a
  }), [a, i]), s = Ye(() => o === "SCMPPLUS" ? "dark-blue" : r, [o, r]), c = () => {
    switch (o) {
      case "AUTORENEW":
        return /* @__PURE__ */ m.createElement(Po, {
          className: e
        });
      case "GRACEPERIOD":
        return /* @__PURE__ */ m.createElement(Lo, {
          className: e
        });
      case "REACTIVATE":
        return /* @__PURE__ */ m.createElement(Oo, {
          className: e,
          location: t
        });
      case "RENEW":
        return /* @__PURE__ */ m.createElement(No, {
          className: e
        });
      case "SUBSCRIBE":
        return /* @__PURE__ */ m.createElement(nn, {
          className: e,
          location: t
        });
      case "UPGRADE":
        return /* @__PURE__ */ m.createElement(xo, {
          className: e
        });
      case "EPAPER":
        return /* @__PURE__ */ m.createElement(Bo, {
          className: e
        });
      case "SCMPPLUS":
        return /* @__PURE__ */ m.createElement(ko, {
          className: e
        });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ m.createElement(W3, {
    $variant: s,
    "data-qa": "subscription-button"
  }, c());
};
e6.displayName = "SubscriptionButton";
const t6 = /* @__PURE__ */ b("div", {
  target: "e1smqk2m4"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;margin-block-end:16px;color:#d2d2d2;font-size:14px;font-family:", Q, ";", (e) => e.theme.breakpoints.up("tablet"), "{display:flex;flex-flow:row;justify-content:flex-start;align-items:center;}"), r6 = /* @__PURE__ */ b("div", {
  target: "e1smqk2m3"
})("display:flex;flex-flow:column;flex-grow:1;justify-content:center;align-items:center;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{display:flex;flex-flow:column;justify-content:flex-start;align-items:flex-start;margin-inline-end:19px;text-align:start;}", (e) => e.theme.breakpoints.up("mediumDesktop"), "{margin-inline-end:38px;}"), n6 = /* @__PURE__ */ b("div", {
  target: "e1smqk2m2"
})({
  name: "643dng",
  styles: "display:inline-block;padding-block-start:16px;font-weight:bold;line-height:16px;border-block-start:1px solid #484848"
}), a6 = /* @__PURE__ */ b("div", {
  target: "e1smqk2m1"
})({
  name: "su6pk1",
  styles: "margin-block-start:4px;line-height:16px"
}), i6 = /* @__PURE__ */ b("div", {
  target: "e1smqk2m0"
})("flex-shrink:1;margin-block-start:16px;", (e) => e.theme.breakpoints.up("desktop"), "{margin-block-start:0;}");
function Sr() {
  return Sr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sr.apply(null, arguments);
}
const Uo = ({
  ...e
}) => /* @__PURE__ */ m.createElement(t6, Sr({}, e, {
  "data-qa": "subscription-widget"
}), /* @__PURE__ */ m.createElement(r6, null, /* @__PURE__ */ m.createElement(n6, null, "Subscribe to the SCMP"), /* @__PURE__ */ m.createElement(a6, null, "Critical insights and analysis on China that matter to the world")), /* @__PURE__ */ m.createElement(i6, null, /* @__PURE__ */ m.createElement(nn, {
  location: "footer"
})));
Uo.displayName = "SubscriptionWidget";
const Ho = /* @__PURE__ */ b(So, {
  target: "e1x94w6213"
})(""), Mo = /* @__PURE__ */ b(Io, {
  target: "e1x94w6212"
})(""), Vo = /* @__PURE__ */ b(Uo, {
  target: "e1x94w6211"
})(""), Do = /* @__PURE__ */ b(c0, {
  target: "e1x94w6210"
})("padding-block:16px;padding-inline:0;border-block-start:1px solid #484848;border-block-end:1px solid #484848;", (e) => e.theme.breakpoints.only("tablet"), "{border-block-end:0;}"), Fo = /* @__PURE__ */ b("div", {
  target: "e1x94w629"
})((e) => e.theme.breakpoints.up("desktop"), "{margin-block-start:22px;}"), Xo = /* @__PURE__ */ b(Ao, {
  target: "e1x94w628"
})(""), o6 = /* @__PURE__ */ b("div", {
  target: "e1x94w627"
})('display:grid;grid-template-areas:"Logo" "SocialMedia";row-gap:30px;justify-items:center;padding-block-end:20px;', Ho, "{grid-area:Logo;}", Mo, "{grid-area:SocialMedia;}", (e) => e.theme.breakpoints.up("tablet"), '{grid-template-areas:"Logo . SocialMedia";grid-template-columns:max-content 1fr;justify-items:unset;padding-block-end:40px;}'), s6 = /* @__PURE__ */ b("div", {
  target: "e1x94w626"
})({
  name: "1vcob1d",
  styles: "display:flex;justify-content:center;align-items:center"
});
var c6 = {
  name: "rh8ts9",
  styles: 'grid-template-areas:"Newsletter DownloadApp"'
}, l6 = {
  name: "iyfgxq",
  styles: 'grid-template-areas:"Subscription DownloadApp" "Newsletter . "'
};
const $o = /* @__PURE__ */ b("div", {
  target: "e1x94w625"
})(Vo, "{grid-area:Subscription;}", Do, "{grid-area:Newsletter;}", Fo, "{grid-area:DownloadApp;}", (e) => e.theme.breakpoints.up("tablet"), "{display:inline-grid;max-inline-size:396px;>div{max-inline-size:396px;}}", (e) => e.theme.breakpoints.only("tablet"), "{grid-template-rows:repeat(2, min-content);grid-template-columns:396px max-content;justify-content:space-between;align-items:center;max-inline-size:unset;margin-block-end:24px;border-block-end:1px #484848 solid;", (e) => e.$isShowSubscription ? l6 : c6, ";}", (e) => e.theme.breakpoints.up("desktop"), '{grid-template:"Subscription" min-content "Newsletter" min-content "DownloadApp" min-content/fit-content(100%);inline-size:auto;margin-inline-end:30px;}'), u6 = /* @__PURE__ */ b("div", {
  target: "e1x94w624"
})("inline-size:100%;", $o, "{grid-area:Widget;}", Xo, "{grid-area:Sitemap;}", (e) => e.theme.breakpoints.only("tablet"), '{display:grid;grid-template-areas:"Widget" "Sitemap";}', (e) => e.theme.breakpoints.up("desktop"), '{display:grid;grid-template-areas:"Widget Sitemap" "Widget Sitemap" "Widget Sitemap";grid-template-columns:30% 1fr;}'), d6 = /* @__PURE__ */ b("div", {
  target: "e1x94w623"
})((e) => e.theme.breakpoints.up("tablet"), "{margin-block-start:32px;}"), p6 = /* @__PURE__ */ b("p", {
  target: "e1x94w622"
})("color:#ffffff;font-size:9px;font-family:", Q, ";line-height:10px;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{color:#cccccc;font-size:14px;line-height:16px;text-align:start;}"), f6 = /* @__PURE__ */ b("div", {
  target: "e1x94w621"
})("margin-block:0;margin-inline:auto;", k0(), ";"), m6 = /* @__PURE__ */ b("div", {
  target: "e1x94w620"
})("padding-block:32px;padding-inline:0;background-color:#222222;overflow:hidden;", (e) => e.theme.breakpoints.up("tablet"), "{padding-block:32px 17px;}");
function Ar() {
  return Ar = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ar.apply(null, arguments);
}
const qo = ({
  printEditionFooterConfig: e,
  ...t
}) => {
  const {
    currentPageType: r,
    handleTrackGA4: n,
    isShowSubscription: a
  } = U(), i = ue(() => ({
    action: "imp",
    category: "appdl",
    customized_parameters: {
      page_type: r,
      position: "footer",
      ...Vi() && {
        inapp_browser: "fb"
      }
    },
    subcategory: ""
  }), [r]), {
    captureTrackImpressionEventTargetElement: o
  } = b0({
    ga4TrackingHandler: n,
    getGa4Event: i,
    options: {
      isSendGA4Tracking: !0,
      shouldSendOnce: !0
    }
  });
  return /* @__PURE__ */ m.createElement(m6, {
    "data-qa": "base-footer"
  }, /* @__PURE__ */ m.createElement(f6, null, /* @__PURE__ */ m.createElement(o6, null, /* @__PURE__ */ m.createElement(Ho, null), /* @__PURE__ */ m.createElement(Mo, null)), (e == null ? void 0 : e.isEnabled) && /* @__PURE__ */ m.createElement(s6, null, /* @__PURE__ */ m.createElement(co, {
    config: e
  })), /* @__PURE__ */ m.createElement(u6, null, /* @__PURE__ */ m.createElement($o, {
    $isShowSubscription: a
  }, a && /* @__PURE__ */ m.createElement(Vo, null), /* @__PURE__ */ m.createElement(Do, Ar({}, t, {
    variant: l0.Footer
  })), /* @__PURE__ */ m.createElement(Fo, {
    ref: o
  }, /* @__PURE__ */ m.createElement(ao, null))), /* @__PURE__ */ m.createElement(Xo, null)), /* @__PURE__ */ m.createElement(d6, null, /* @__PURE__ */ m.createElement(p6, null, "Copyright © ", (/* @__PURE__ */ new Date()).getFullYear(), " South China Morning Post Publishers Ltd. All rights reserved."))));
};
qo.displayName = "BaseFooter";
var v6 = m, g6 = v6.createContext({
  wrapPrepareQueryResource: function(t) {
    return t();
  }
}), O1 = g6, h6 = m, C6 = J, _6 = C6.__internal.createRelayContext, jo = _6(h6), E6 = function(e, t, r, n, a, i, o, s) {
  if (!e) {
    var c;
    if (t === void 0)
      c = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var l = [r, n, a, i, o, s], u = 0;
      c = new Error(
        t.replace(/%s/g, function() {
          return l[u++];
        })
      ), c.name = "Invariant Violation";
    }
    throw c.framesToPop = 1, c;
  }
}, xe = E6, y6 = jo, b6 = xe, w6 = m, T6 = w6.useContext;
function S6() {
  var e = T6(y6);
  return e == null && b6(!1), e.environment;
}
var ve = S6;
function N1(e) {
  return function() {
    return e;
  };
}
var Ct = function() {
};
Ct.thatReturns = N1;
Ct.thatReturnsFalse = N1(!1);
Ct.thatReturnsTrue = N1(!0);
Ct.thatReturnsNull = N1(null);
Ct.thatReturnsThis = function() {
  return this;
};
Ct.thatReturnsArgument = function(e) {
  return e;
};
var A6 = O1, R6 = ve, I6 = m, Ko = m, P6 = Ko.useContext, L6 = Ko.useEffect;
function O6(e) {
  var t = e.entryPointReference, r = e.props, n = t.getComponent, a = t.queries, i = t.entryPoints, o = t.extraProps, s = t.rootModuleID, c = n(), l = P6(A6), u = R6();
  return L6(function() {
    u.__log({
      name: "entrypoint.root.consume",
      profilerContext: l,
      rootModuleID: s
    });
  }, [u, l, s]), /* @__PURE__ */ I6.createElement(c, {
    entryPoints: i,
    extraProps: o,
    props: r,
    queries: a
  });
}
var N6 = O6, zo = { exports: {} }, Go = { exports: {} }, Yo = { exports: {} }, Wo = { exports: {} };
(function(e) {
  function t(r) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Wo);
var Zo = Wo.exports, Qo = { exports: {} };
(function(e) {
  var t = Zo.default;
  function r(n, a) {
    if (t(n) != "object" || !n) return n;
    var i = n[Symbol.toPrimitive];
    if (i !== void 0) {
      var o = i.call(n, a || "default");
      if (t(o) != "object") return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (a === "string" ? String : Number)(n);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Qo);
var x6 = Qo.exports;
(function(e) {
  var t = Zo.default, r = x6;
  function n(a) {
    var i = r(a, "string");
    return t(i) == "symbol" ? i : i + "";
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Yo);
var k6 = Yo.exports;
(function(e) {
  var t = k6;
  function r(n, a, i) {
    return (a = t(a)) in n ? Object.defineProperty(n, a, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : n[a] = i, n;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Go);
var x1 = Go.exports;
(function(e) {
  var t = x1;
  function r(a, i) {
    var o = Object.keys(a);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(a);
      i && (s = s.filter(function(c) {
        return Object.getOwnPropertyDescriptor(a, c).enumerable;
      })), o.push.apply(o, s);
    }
    return o;
  }
  function n(a) {
    for (var i = 1; i < arguments.length; i++) {
      var o = arguments[i] != null ? arguments[i] : {};
      i % 2 ? r(Object(o), !0).forEach(function(s) {
        t(a, s, o[s]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(o)) : r(Object(o)).forEach(function(s) {
        Object.defineProperty(a, s, Object.getOwnPropertyDescriptor(o, s));
      });
    }
    return a;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(zo);
var Je = zo.exports, B6 = Ee.default, ta = B6(Je), U6 = xe, Jo = m, Fe = J, ra = Fe.__internal.fetchQueryDeduped, na = Fe.Observable, aa = Fe.PreloadableQueryRegistry, ia = Fe.RelayFeatureFlags, oa = Fe.ReplaySubject, sa = Fe.createOperationDescriptor, H6 = Fe.getRequest, M6 = Fe.getRequestIdentifier, ca = null, la = 100001;
function V6() {
  if (ca === null) {
    var e, t;
    ca = (e = Jo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || e === void 0 || (t = e.ReactCurrentDispatcher) === null || t === void 0 ? void 0 : t.current;
  }
}
function D6(e, t, r, n, a) {
  var i, o, s;
  (i = Jo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (o = i.ReactCurrentDispatcher) === null || o === void 0 || o.current, la++;
  var c = (s = n == null ? void 0 : n.fetchPolicy) !== null && s !== void 0 ? s : "store-or-network", l = (0, ta.default)((0, ta.default)({}, n == null ? void 0 : n.networkCacheConfig), {}, {
    force: !0
  }), u, d = !1, f = function(q, z) {
    return d = !0, e.executeWithSource({
      operation: q,
      source: z
    });
  }, h = new oa(), v = na.create(function($) {
    return h.subscribe($);
  }), p, g = null, _ = !1, E = function(q) {
    _ = !0;
    var z, Z = new oa();
    if (ia.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === !0) {
      var G = "raw-network-request-" + M6(q, r);
      z = ra(e, G, function() {
        var ne = e.getNetwork();
        return ne.execute(q, r, l);
      });
    } else {
      var re = e.getNetwork();
      z = re.execute(q, r, l);
    }
    var ke = z.subscribe({
      error: function(Be) {
        g = Be, Z.error(Be);
      },
      next: function(Be) {
        Z.next(Be);
      },
      complete: function() {
        Z.complete();
      }
    }), oe = ke.unsubscribe;
    return p = oe, na.create(function(ne) {
      var Be = Z.subscribe(ne);
      return function() {
        Be.unsubscribe(), p();
      };
    });
  }, y, w = function(q, z) {
    ia.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === !0 && (_ = !0);
    var Z = ra(e, q.request.identifier, z).subscribe({
      error: function(re) {
        h.error(re);
      },
      next: function(re) {
        h.next(re);
      },
      complete: function() {
        h.complete();
      }
    });
    y = Z.unsubscribe;
  }, T = function(q) {
    var z = sa(q, r, l);
    if (u = e.retain(z), c !== "store-only") {
      var Z = c !== "store-or-network" || e.check(z).status !== "available";
      Z && w(z, function() {
        var G = E(q.params), re = f(z, G);
        return re;
      });
    }
  }, S, A, R;
  if (t.kind === "PreloadableConcreteRequest") {
    var I = t;
    S = I.params;
    var L = S;
    R = L.id, R === null && U6(!1);
    var O = aa.get(R);
    if (O != null)
      T(O);
    else {
      var P = c === "store-only" ? null : E(S), x = aa.onLoad(R, function($) {
        A();
        var q = sa($, r, l);
        u = e.retain(q), P != null && w(q, function() {
          return f(q, P);
        });
      });
      A = x.dispose;
    }
  } else {
    var k = t, N = H6(k);
    S = N.params, R = S.cacheID != null ? S.cacheID : S.id, T(N);
  }
  var B = !1, H = !1, K = !1, X = function() {
    H || (u && u.dispose(), H = !0);
  }, Y = function() {
    K || (d ? y && y() : p && p(), A && A(), K = !0);
  };
  return {
    kind: "PreloadedQuery",
    environment: e,
    environmentProviderOptions: a,
    dispose: function() {
      B || (X(), Y(), B = !0);
    },
    releaseQuery: X,
    cancelNetworkRequest: Y,
    fetchKey: la,
    id: R,
    get isDisposed() {
      return B || H;
    },
    get networkError() {
      return g;
    },
    name: S.name,
    networkCacheConfig: l,
    fetchPolicy: c,
    source: _ ? v : void 0,
    variables: r
  };
}
var et = {
  loadQuery: D6,
  useTrackLoadQueryInRender: V6
}, F6 = et, X6 = F6.loadQuery;
function es(e, t, r) {
  var n = null;
  t.root.getModuleIfRequired() == null && (n = t.root.load());
  var a = t.getPreloadProps(r), i = a.queries, o = a.entryPoints, s = a.extraProps, c = {}, l = {};
  if (i != null) {
    var u = Object.keys(i);
    u.forEach(function(h) {
      var v = i[h], p = v.environmentProviderOptions, g = v.options, _ = v.parameters, E = v.variables, y = e.getEnvironment(p);
      c[h] = X6(y, _, E, {
        fetchPolicy: g == null ? void 0 : g.fetchPolicy,
        networkCacheConfig: g == null ? void 0 : g.networkCacheConfig,
        __nameForWarning: "loadEntryPoint"
      }, p);
    });
  }
  if (o != null) {
    var d = Object.keys(o);
    d.forEach(function(h) {
      var v = o[h];
      if (v != null) {
        var p = v.entryPoint, g = v.entryPointParams;
        l[h] = es(e, p, g);
      }
    });
  }
  var f = !1;
  return {
    dispose: function() {
      f || (c != null && Object.values(c).forEach(function(v) {
        var p = v.dispose;
        p();
      }), l != null && Object.values(l).forEach(function(v) {
        var p = v.dispose;
        p();
      }), f = !0);
    },
    entryPoints: l,
    extraProps: s ?? null,
    getComponent: function() {
      var v = t.root.getModuleIfRequired();
      if (v == null) {
        var p;
        throw n = (p = n) !== null && p !== void 0 ? p : t.root.load(), n;
      }
      var g = v.default != null ? v.default : v;
      return g;
    },
    get isDisposed() {
      return f;
    },
    queries: c,
    rootModuleID: t.root.getModuleId()
  };
}
var ts = es, $6 = jo, rs = m, q6 = rs.useMemo;
function j6(e) {
  var t = e.children, r = e.environment, n = e.getEnvironmentForActor, a = q6(function() {
    return {
      environment: r,
      getEnvironmentForActor: n
    };
  }, [r, n]);
  return /* @__PURE__ */ rs.createElement($6.Provider, {
    value: a
  }, t);
}
var K6 = j6, ns = { exports: {} }, as = { exports: {} }, is = { exports: {} };
(function(e) {
  function t(r, n) {
    (n == null || n > r.length) && (n = r.length);
    for (var a = 0, i = Array(n); a < n; a++) i[a] = r[a];
    return i;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(is);
var os = is.exports;
(function(e) {
  var t = os;
  function r(n, a) {
    if (n) {
      if (typeof n == "string") return t(n, a);
      var i = {}.toString.call(n).slice(8, -1);
      return i === "Object" && n.constructor && (i = n.constructor.name), i === "Map" || i === "Set" ? Array.from(n) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? t(n, a) : void 0;
    }
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(as);
var ss = as.exports;
(function(e) {
  var t = ss;
  function r(n, a) {
    var i = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (!i) {
      if (Array.isArray(n) || (i = t(n)) || a && n && typeof n.length == "number") {
        i && (n = i);
        var o = 0, s = function() {
        };
        return {
          s,
          n: function() {
            return o >= n.length ? {
              done: !0
            } : {
              done: !1,
              value: n[o++]
            };
          },
          e: function(f) {
            throw f;
          },
          f: s
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var c, l = !0, u = !1;
    return {
      s: function() {
        i = i.call(n);
      },
      n: function() {
        var f = i.next();
        return l = f.done, f;
      },
      e: function(f) {
        u = !0, c = f;
      },
      f: function() {
        try {
          l || i.return == null || i.return();
        } finally {
          if (u) throw c;
        }
      }
    };
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ns);
var cs = ns.exports, ls = m, z6 = ls.useEffect, G6 = ls.useRef;
function Y6() {
  var e = G6(!0);
  return z6(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
var jt = Y6, W6 = Ee.default, ua = W6(cs), Z6 = ts, Q6 = et, J6 = Q6.useTrackLoadQueryInRender, e5 = jt, k1 = m, da = k1.useCallback, z1 = k1.useEffect, pa = k1.useRef, fa = k1.useState, t5 = {
  kind: "NullEntryPointReference"
};
function r5(e, t, r) {
  var n, a, i, o;
  J6();
  var s = (n = r == null || (a = r.TEST_ONLY__initialEntryPointData) === null || a === void 0 ? void 0 : a.entryPointReference) !== null && n !== void 0 ? n : t5, c = (i = r == null || (o = r.TEST_ONLY__initialEntryPointData) === null || o === void 0 ? void 0 : o.entryPointParams) !== null && i !== void 0 ? i : null, l = e5(), u = pa(/* @__PURE__ */ new Set([s])), d = fa(s), f = d[0], h = d[1], v = fa(c), p = v[0], g = v[1], _ = da(function() {
    if (l.current) {
      var w = {
        kind: "NullEntryPointReference"
      };
      u.current.add(w), h(w);
    }
  }, [h, l]), E = da(function(w) {
    if (l.current) {
      var T = Z6(e, t, w);
      u.current.add(T), h(T), g(w);
    }
  }, [e, t, h, l]), y = pa(!1);
  return z1(function() {
    return function() {
      y.current = !0;
    };
  }, []), z1(function() {
    if (y.current === !0) {
      y.current = !1, f.kind !== "NullEntryPointReference" && p != null && E(p);
      return;
    }
    var w = u.current;
    if (l.current) {
      var T = (0, ua.default)(w), S;
      try {
        for (T.s(); !(S = T.n()).done; ) {
          var A = S.value;
          if (A === f)
            break;
          w.delete(A), A.kind !== "NullEntryPointReference" && A.dispose();
        }
      } catch (R) {
        T.e(R);
      } finally {
        T.f();
      }
    }
  }, [f, p, E, l]), z1(function() {
    return function() {
      var T = (0, ua.default)(u.current), S;
      try {
        for (T.s(); !(S = T.n()).done; ) {
          var A = S.value;
          A.kind !== "NullEntryPointReference" && A.dispose();
        }
      } catch (R) {
        T.e(R);
      } finally {
        T.f();
      }
    };
  }, []), [f.kind === "NullEntryPointReference" ? null : f, E, _];
}
var n5 = r5, us = null;
function a5(e) {
  us = e;
}
function i5() {
  return us;
}
var B1 = {
  inject: a5,
  get: i5
}, o5 = m, s5 = o5.useMemo;
function c5(e) {
  return s5(function() {
    return {
      current: e
    };
  }, []);
}
var ds = c5, ps = { exports: {} }, fs = { exports: {} };
(function(e) {
  var t = os;
  function r(n) {
    if (Array.isArray(n)) return t(n);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(fs);
var l5 = fs.exports, ms = { exports: {} };
(function(e) {
  function t(r) {
    if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ms);
var u5 = ms.exports, vs = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(vs);
var d5 = vs.exports;
(function(e) {
  var t = l5, r = u5, n = ss, a = d5;
  function i(o) {
    return t(o) || r(o) || n(o) || a();
  }
  e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ps);
var p5 = ps.exports, f5 = xe, m5 = /* @__PURE__ */ function() {
  function e(r) {
    this._capacity = r, this._capacity > 0 || f5(!1), this._map = /* @__PURE__ */ new Map();
  }
  var t = e.prototype;
  return t.set = function(n, a) {
    if (this._map.delete(n), this._map.set(n, a), this._map.size > this._capacity) {
      var i = this._map.keys().next();
      i.done || this._map.delete(i.value);
    }
  }, t.get = function(n) {
    var a = this._map.get(n);
    return a != null && (this._map.delete(n), this._map.set(n, a)), a;
  }, t.has = function(n) {
    return this._map.has(n);
  }, t.delete = function(n) {
    this._map.delete(n);
  }, t.size = function() {
    return this._map.size;
  }, t.capacity = function() {
    return this._capacity - this._map.size;
  }, t.clear = function() {
    this._map.clear();
  }, e;
}();
function v5(e) {
  return new m5(e);
}
var gs = {
  create: v5
}, g5 = Ee.default, G1 = g5(x1), h5 = 5 * 60 * 1e3, C5 = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    (0, G1.default)(this, "_retainCount", 0), (0, G1.default)(this, "_retainDisposable", null), (0, G1.default)(this, "_releaseTemporaryRetain", null), this._retain = function(a) {
      return n._retainCount++, n._retainCount === 1 && (n._retainDisposable = r(a)), {
        dispose: function() {
          n._retainCount = Math.max(0, n._retainCount - 1), n._retainCount === 0 && n._retainDisposable != null && (n._retainDisposable.dispose(), n._retainDisposable = null);
        }
      };
    };
  }
  var t = e.prototype;
  return t.temporaryRetain = function(n) {
    var a = this, i;
    if (n.isServer())
      return {
        dispose: function() {
        }
      };
    var o = this._retain(n), s = null, c = function() {
      clearTimeout(s), s = null, a._releaseTemporaryRetain = null, o.dispose();
    };
    return s = setTimeout(c, h5), (i = this._releaseTemporaryRetain) === null || i === void 0 || i.call(this), this._releaseTemporaryRetain = c, {
      dispose: function() {
        var u;
        (u = a._releaseTemporaryRetain) === null || u === void 0 || u.call(a);
      }
    };
  }, t.permanentRetain = function(n) {
    var a = this._retain(n);
    return this.releaseTemporaryRetain(), a;
  }, t.releaseTemporaryRetain = function() {
    var n;
    (n = this._releaseTemporaryRetain) === null || n === void 0 || n.call(this), this._releaseTemporaryRetain = null;
  }, t.getRetainCount = function() {
    return this._retainCount;
  }, e;
}(), hs = C5, Cs = Ee.default, Zt = Cs(Je), _s = Cs(x1), _5 = gs, E5 = hs, y5 = xe, b5 = J, w5 = b5.isPromise, T5 = 1e3, Es = "store-or-network", ys = "store-and-network", S5 = typeof WeakMap == "function";
function m1(e) {
  return e.request.node.params.metadata.live !== void 0;
}
function Rr(e, t, r, n, a) {
  var i = r ?? (m1(t) ? ys : Es), o = n ?? e.UNSTABLE_getDefaultRenderPolicy(), s = "".concat(i, "-").concat(o, "-").concat(t.request.identifier);
  return a != null ? "".concat(s, "-").concat(a) : s;
}
function ma(e, t) {
  var r = {
    __id: e.fragment.dataID,
    __fragments: (0, _s.default)({}, e.fragment.node.name, e.request.variables),
    __fragmentOwner: e.request
  };
  return {
    cacheIdentifier: t,
    fragmentNode: e.request.node.fragment,
    fragmentRef: r,
    operation: e
  };
}
var A5 = 2e5;
function Y1(e, t, r, n, a, i) {
  var o = m1(t), s = n, c = a, l = new E5(function(d) {
    var f = d.retain(t);
    return {
      dispose: function() {
        o && c != null && c.unsubscribe(), f.dispose(), i(u);
      }
    };
  }), u = {
    cacheIdentifier: e,
    id: A5++,
    processedPayloadsCount: 0,
    operationAvailability: r,
    getValue: function() {
      return s;
    },
    setValue: function(f) {
      s = f;
    },
    setNetworkSubscription: function(f) {
      o && c != null && c.unsubscribe(), c = f;
    },
    temporaryRetain: function(f) {
      return l.temporaryRetain(f);
    },
    permanentRetain: function(f) {
      return l.permanentRetain(f);
    },
    releaseTemporaryRetain: function() {
      l.releaseTemporaryRetain();
    }
  };
  return u;
}
var R5 = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    (0, _s.default)(this, "_clearCacheEntry", function(a) {
      n._cache.delete(a.cacheIdentifier);
    }), this._environment = r, this._cache = _5.create(T5);
  }
  var t = e.prototype;
  return t.prepare = function(n, a, i, o, s, c, l) {
    var u = Rr(this._environment, n, i, o, c);
    return this.prepareWithIdentifier(u, n, a, i, o, s, l);
  }, t.prepareWithIdentifier = function(n, a, i, o, s, c, l) {
    var u = this._environment, d = o ?? (m1(a) ? ys : Es), f = s ?? u.UNSTABLE_getDefaultRenderPolicy(), h = this._cache.get(n), v = null, p = h != null;
    h == null && (h = this._fetchAndSaveQuery(n, a, i, d, f, l, (0, Zt.default)((0, Zt.default)({}, c), {}, {
      unsubscribe: function(E) {
        v != null && v.dispose();
        var y = c == null ? void 0 : c.unsubscribe;
        y && y(E);
      }
    }))), v = h.temporaryRetain(u);
    var g = h.getValue();
    if (w5(g))
      throw u.__log({
        name: "suspense.query",
        fetchPolicy: d,
        isPromiseCached: p,
        operation: a,
        queryAvailability: h.operationAvailability,
        renderPolicy: f
      }), g;
    if (g instanceof Error)
      throw g;
    return g;
  }, t.retain = function(n, a) {
    var i = this._environment, o = n.cacheIdentifier, s = n.operation, c = this._getOrCreateCacheEntry(o, s, null, n, null), l = c.permanentRetain(i);
    return i.__log({
      name: "queryresource.retain",
      profilerContext: a,
      resourceID: c.id
    }), {
      dispose: function() {
        l.dispose();
      }
    };
  }, t.releaseTemporaryRetain = function(n) {
    var a = this._cache.get(n.cacheIdentifier);
    a != null && a.releaseTemporaryRetain();
  }, t.TESTS_ONLY__getCacheEntry = function(n, a, i, o) {
    var s = this._environment, c = Rr(s, n, a, i, o);
    return this._cache.get(c);
  }, t._getOrCreateCacheEntry = function(n, a, i, o, s) {
    var c = this._cache.get(n);
    return c == null && (c = Y1(n, a, i, o, s, this._clearCacheEntry), this._cache.set(n, c)), c;
  }, t._fetchAndSaveQuery = function(n, a, i, o, s, c, l) {
    var u = this, d = this._environment, f = d.check(a), h = f.status, v = h === "available", p = v || s === "partial" && h !== "stale", g, _, E = function() {
    };
    switch (o) {
      case "store-only": {
        g = !1, _ = !0;
        break;
      }
      case "store-or-network": {
        g = !v, _ = p;
        break;
      }
      case "store-and-network": {
        g = !0, _ = p;
        break;
      }
      case "network-only":
      default: {
        g = !0, _ = !1;
        break;
      }
    }
    if (_) {
      var y = ma(a, n), w = Y1(n, a, f, y, null, this._clearCacheEntry);
      this._cache.set(n, w);
    }
    if (g) {
      var T = ma(a, n), S;
      i.subscribe({
        start: function(P) {
          S = P;
          var x = u._cache.get(n);
          x && x.setNetworkSubscription(S);
          var k = l == null ? void 0 : l.start;
          if (k) {
            var N = (0, Zt.default)((0, Zt.default)({}, P), {}, {
              unsubscribe: function() {
                m1(a) && P.unsubscribe();
              }
            });
            k(N);
          }
        },
        next: function() {
          var P = u._getOrCreateCacheEntry(n, a, f, T, S);
          P.processedPayloadsCount += 1, P.setValue(T), E();
          var x = l == null ? void 0 : l.next;
          if (x != null) {
            var k = d.lookup(a.fragment);
            x(k);
          }
        },
        error: function(P) {
          var x = u._getOrCreateCacheEntry(n, a, f, P, S);
          x.processedPayloadsCount === 0 && x.setValue(P), E(), S = null, x.setNetworkSubscription(null);
          var k = l == null ? void 0 : l.error;
          k && k(P);
        },
        complete: function() {
          E(), S = null;
          var P = u._cache.get(n);
          P && P.setNetworkSubscription(null);
          var x = l == null ? void 0 : l.complete;
          x && x();
        },
        unsubscribe: l == null ? void 0 : l.unsubscribe
      });
      var A = this._cache.get(n);
      if (!A) {
        var R = new Promise(function(O) {
          E = O;
        });
        R.displayName = "Relay(" + a.fragment.node.name + ")", A = Y1(n, a, f, R, S, this._clearCacheEntry), this._cache.set(n, A);
      }
    } else {
      var I = l == null ? void 0 : l.complete;
      I && I();
    }
    var L = this._cache.get(n);
    return L == null && y5(!1), d.__log({
      name: "queryresource.fetch",
      resourceID: L.id,
      operation: a,
      profilerContext: c,
      fetchPolicy: o,
      renderPolicy: s,
      queryAvailability: f,
      shouldFetch: g
    }), L;
  }, e;
}();
function bs(e) {
  return new R5(e);
}
var va = S5 ? /* @__PURE__ */ new WeakMap() : /* @__PURE__ */ new Map();
function I5(e) {
  var t = va.get(e);
  if (t)
    return t;
  var r = bs(e);
  return va.set(e, r), r;
}
var an = {
  createQueryResource: bs,
  getQueryResourceForEnvironment: I5,
  getQueryCacheIdentifier: Rr
}, on = Ee.default, Qt = on(Je), ga = on(x1), Jt = on(p5), P5 = gs, L5 = an, ha = L5.getQueryResourceForEnvironment, O5 = hs, nt = xe, Pe = J, ws = Pe.__internal, N5 = ws.fetchQuery, x5 = ws.getPromiseForActiveRequest, Te = Pe.RelayFeatureFlags, k5 = Pe.createOperationDescriptor, B5 = Pe.getFragmentIdentifier, U5 = Pe.getPendingOperationsForFragment, H5 = Pe.getSelector, M5 = Pe.getVariablesFromFragment, Ca = Pe.handlePotentialSnapshotErrors, W1 = Pe.isPromise, _a = Pe.recycleNodesInto, V5 = typeof WeakMap == "function", D5 = 1e6, Ea = Object.freeze([]);
function ya(e) {
  return Array.isArray(e) ? e.some(function(t) {
    return t.isMissingData;
  }) : e.isMissingData;
}
function F5(e) {
  var t, r;
  return Array.isArray(e) ? e.some(function(n) {
    var a, i;
    return ((a = (i = n.missingClientEdges) === null || i === void 0 ? void 0 : i.length) !== null && a !== void 0 ? a : 0) > 0;
  }) : ((t = (r = e.missingClientEdges) === null || r === void 0 ? void 0 : r.length) !== null && t !== void 0 ? t : 0) > 0;
}
function ba(e) {
  return Array.isArray(e) ? e.map(function(t) {
    return t.missingLiveResolverFields;
  }).filter(Boolean).flat() : e.missingLiveResolverFields;
}
function X5(e, t) {
  Array.isArray(e) ? e.forEach(t) : t(e);
}
function qe(e, t, r) {
  return Array.isArray(t) ? {
    cacheKey: e,
    snapshot: t,
    data: t.map(function(n) {
      return n.data;
    }),
    isMissingData: ya(t),
    storeEpoch: r
  } : {
    cacheKey: e,
    snapshot: t,
    data: t.data,
    isMissingData: ya(t),
    storeEpoch: r
  };
}
var $5 = /* @__PURE__ */ function() {
  function e(r) {
    (0, ga.default)(this, "_cache", /* @__PURE__ */ new Map()), (0, ga.default)(this, "_retainCounts", /* @__PURE__ */ new Map()), this._environment = r;
  }
  var t = e.prototype;
  return t.get = function(n) {
    var a, i;
    return (a = (i = this._cache.get(n)) === null || i === void 0 ? void 0 : i[0]) !== null && a !== void 0 ? a : void 0;
  }, t.recordQueryResults = function(n, a) {
    var i = this, o = this._cache.get(n);
    if (o) {
      var c = o[0], l = o[1];
      a.forEach(function(u) {
        c.push(u);
      }), l.temporaryRetain(this._environment);
    } else {
      var s = new O5(function() {
        return i._retain(n);
      });
      this._cache.set(n, [a, s]), s.temporaryRetain(this._environment);
    }
  }, t._retain = function(n) {
    var a = this, i, o = ((i = this._retainCounts.get(n)) !== null && i !== void 0 ? i : 0) + 1;
    return this._retainCounts.set(n, o), {
      dispose: function() {
        var c, l = ((c = a._retainCounts.get(n)) !== null && c !== void 0 ? c : 0) - 1;
        l > 0 ? a._retainCounts.set(n, l) : (a._retainCounts.delete(n), a._cache.delete(n));
      }
    };
  }, e;
}(), q5 = /* @__PURE__ */ function() {
  function e(r) {
    this._environment = r, this._cache = P5.create(D5), Te.ENABLE_CLIENT_EDGES && (this._clientEdgeQueryResultsCache = new $5(r));
  }
  var t = e.prototype;
  return t.read = function(n, a, i, o) {
    return this.readWithIdentifier(n, a, B5(n, a), i, o);
  }, t.readWithIdentifier = function(n, a, i, o, s) {
    var c = this, l, u, d, f, h = this._environment;
    if (a == null)
      return {
        cacheKey: i,
        data: null,
        isMissingData: !1,
        snapshot: null,
        storeEpoch: 0
      };
    var v = h.getStore().getEpoch();
    if ((n == null || (l = n.metadata) === null || l === void 0 ? void 0 : l.plural) === !0 && (Array.isArray(a) || nt(!1), a.length === 0))
      return {
        cacheKey: i,
        data: Ea,
        isMissingData: !1,
        snapshot: Ea,
        storeEpoch: v
      };
    var p = this._cache.get(i);
    if (p != null) {
      var g;
      if (p.kind === "pending" && W1(p.promise))
        throw h.__log({
          name: "suspense.fragment",
          data: p.result.data,
          fragment: n,
          isRelayHooks: !0,
          isMissingData: p.result.isMissingData,
          isPromiseCached: !0,
          pendingOperations: p.pendingOperations
        }), p.promise;
      if (p.kind === "done" && p.result.snapshot && !((g = ba(p.result.snapshot)) !== null && g !== void 0 && g.length))
        return this._throwOrLogErrorsInSnapshot(p.result.snapshot), p.result.isMissingData && h.__log({
          name: "fragmentresource.missing_data",
          data: p.result.data,
          fragment: n,
          isRelayHooks: !0,
          cached: !0
        }), p.result;
    }
    var _ = H5(n, a);
    _ == null && nt(!1);
    var E = null, y = null;
    if (Te.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && p != null && p.kind === "missing" ? (E = p.result, y = p.snapshot) : (y = _.kind === "PluralReaderSelector" ? _.selectors.map(function(N) {
      return h.lookup(N);
    }) : h.lookup(_), E = qe(i, y, v)), !E.isMissingData)
      return this._throwOrLogErrorsInSnapshot(y), this._cache.set(i, {
        kind: "done",
        result: E
      }), E;
    var w = null;
    if (Te.ENABLE_CLIENT_EDGES && ((u = n.metadata) === null || u === void 0 ? void 0 : u.hasClientEdges) === !0 && F5(y)) {
      w = [];
      var T = ha(this._environment), S = [];
      X5(y, function(N) {
        var B;
        (B = N.missingClientEdges) === null || B === void 0 || B.forEach(function(H) {
          var K, X = H.request, Y = H.clientEdgeDestinationID, $ = c._performClientEdgeQuery(T, n, a, X, Y), q = $.queryResult, z = $.requestDescriptor;
          S.push(q), (K = w) === null || K === void 0 || K.push(z);
        });
      }), this._clientEdgeQueryResultsCache == null && nt(!1), this._clientEdgeQueryResultsCache.recordQueryResults(i, S);
    }
    var A = [];
    Te.ENABLE_CLIENT_EDGES && w && (A = w.map(function(N) {
      return x5(c._environment, N);
    }).filter(Boolean));
    var R = _.kind === "PluralReaderSelector" ? _.selectors[0].owner : _.owner, I = this._getAndSavePromiseForFragmentRequestInFlight(i, n, R, E), L = I == null ? void 0 : I.promise, O = (d = (f = ba(y)) === null || f === void 0 ? void 0 : f.map(function(N) {
      var B = N.liveStateID, H = h.getStore();
      return H.getLiveResolverPromise(B);
    })) !== null && d !== void 0 ? d : [];
    if (A.length || O.length || W1(L)) {
      var P, x;
      h.__log({
        name: "suspense.fragment",
        data: E.data,
        fragment: n,
        isRelayHooks: !0,
        isPromiseCached: !1,
        isMissingData: E.isMissingData,
        pendingOperations: [].concat((0, Jt.default)((P = I == null ? void 0 : I.pendingOperations) !== null && P !== void 0 ? P : []), (0, Jt.default)((x = w) !== null && x !== void 0 ? x : []))
      });
      var k = [];
      if (A.length > 0 && (k = k.concat(A)), O.length > 0 && (k = k.concat(O)), k.length > 0)
        throw L && k.push(L), Promise.all(k);
      if (L)
        throw L;
    }
    return Te.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && E.isMissingData && this._cache.set(i, {
      kind: "done",
      result: E
    }), this._throwOrLogErrorsInSnapshot(y), h.__log({
      name: "fragmentresource.missing_data",
      data: E.data,
      fragment: n,
      isRelayHooks: !0,
      cached: !1
    }), qe(i, y, v);
  }, t._performClientEdgeQuery = function(n, a, i, o, s) {
    var c = M5(a, i), l = (0, Qt.default)((0, Qt.default)({}, c), {}, {
      id: s
    }), u = k5(o, l, {}), d = N5(this._environment, u), f = n.prepare(u, d);
    return {
      requestDescriptor: u.request,
      queryResult: f
    };
  }, t._throwOrLogErrorsInSnapshot = function(n) {
    var a = this;
    Array.isArray(n) ? n.forEach(function(i) {
      Ca(a._environment, i.missingRequiredFields, i.relayResolverErrors, i.errorResponseFields);
    }) : Ca(this._environment, n.missingRequiredFields, n.relayResolverErrors, n.errorResponseFields);
  }, t.readSpec = function(n, a, i) {
    var o = {};
    for (var s in n)
      o[s] = this.read(n[s], a[s], i, s);
    return o;
  }, t.subscribe = function(n, a) {
    var i = this, o = this._environment, s = n.cacheKey, c = n.snapshot;
    if (!c)
      return {
        dispose: function() {
        }
      };
    var l = this.checkMissedUpdates(n), u = l[0], d = l[1];
    u && a();
    var f = [];
    if (Array.isArray(c) ? (Array.isArray(d) || nt(!1), d.forEach(function(_, E) {
      f.push(o.subscribe(_, function(y) {
        var w = o.getStore().getEpoch();
        i._updatePluralSnapshot(s, d, y, E, w), a();
      }));
    })) : (d != null && !Array.isArray(d) || nt(!1), f.push(o.subscribe(d, function(_) {
      var E = o.getStore().getEpoch(), y = qe(s, _, E);
      Te.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && y.isMissingData ? i._cache.set(s, {
        kind: "missing",
        result: y,
        snapshot: _
      }) : i._cache.set(s, {
        kind: "done",
        result: qe(s, _, E)
      }), a();
    }))), Te.ENABLE_CLIENT_EDGES) {
      var h, v, p = (h = (v = this._clientEdgeQueryResultsCache) === null || v === void 0 ? void 0 : v.get(s)) !== null && h !== void 0 ? h : void 0;
      if (p != null && p.length) {
        var g = ha(this._environment);
        p.forEach(function(_) {
          f.push(g.retain(_));
        });
      }
    }
    return {
      dispose: function() {
        f.forEach(function(E) {
          return E.dispose();
        }), i._cache.delete(s);
      }
    };
  }, t.subscribeSpec = function(n, a) {
    var i = this, o = Object.keys(n).map(function(s) {
      return i.subscribe(n[s], a);
    });
    return {
      dispose: function() {
        o.forEach(function(c) {
          c.dispose();
        });
      }
    };
  }, t.checkMissedUpdates = function(n) {
    var a = this._environment, i = n.snapshot;
    if (!i)
      return [!1, null];
    var o = null;
    if (o = a.getStore().getEpoch(), n.storeEpoch === o)
      return [!1, n.snapshot];
    var s = n.cacheKey;
    if (Array.isArray(i)) {
      var c = !1, l = [];
      if (i.forEach(function(_, E) {
        var y = a.lookup(_.selector), w = _.data, T = y.data, S = _a(w, T);
        S !== w && (y = (0, Qt.default)((0, Qt.default)({}, y), {}, {
          data: S
        }), c = !0), l[E] = y;
      }), c) {
        var u = qe(s, l, o);
        Te.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && u.isMissingData ? this._cache.set(s, {
          kind: "missing",
          result: u,
          snapshot: l
        }) : this._cache.set(s, {
          kind: "done",
          result: u
        });
      }
      return [c, l];
    }
    var d = a.lookup(i.selector), f = i.data, h = d.data, v = _a(f, h), p = {
      data: v,
      isMissingData: d.isMissingData,
      missingClientEdges: d.missingClientEdges,
      missingLiveResolverFields: d.missingLiveResolverFields,
      seenRecords: d.seenRecords,
      selector: d.selector,
      missingRequiredFields: d.missingRequiredFields,
      relayResolverErrors: d.relayResolverErrors,
      errorResponseFields: d.errorResponseFields
    };
    if (v !== f) {
      var g = qe(s, p, o);
      Te.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && g.isMissingData ? this._cache.set(s, {
        kind: "missing",
        result: g,
        snapshot: p
      }) : this._cache.set(s, {
        kind: "done",
        result: g
      });
    }
    return [v !== f, p];
  }, t.checkMissedUpdatesSpec = function(n) {
    var a = this;
    return Object.keys(n).some(function(i) {
      return a.checkMissedUpdates(n[i])[0];
    });
  }, t._getAndSavePromiseForFragmentRequestInFlight = function(n, a, i, o) {
    var s = this, c = U5(this._environment, a, i);
    if (c == null)
      return null;
    var l = c.promise, u = c.pendingOperations, d = l.then(function() {
      s._cache.delete(n);
    }).catch(function(f) {
      s._cache.delete(n);
    });
    return d.displayName = l.displayName, this._cache.set(n, {
      kind: "pending",
      pendingOperations: u,
      promise: d,
      result: o
    }), {
      promise: d,
      pendingOperations: u
    };
  }, t._updatePluralSnapshot = function(n, a, i, o, s) {
    var c, l = this._cache.get(n);
    if (W1(l)) {
      wa(i.selector.node.name);
      return;
    }
    var u = l == null || (c = l.result) === null || c === void 0 ? void 0 : c.snapshot;
    if (u && !Array.isArray(u)) {
      wa(i.selector.node.name);
      return;
    }
    var d = u ? (0, Jt.default)(u) : (0, Jt.default)(a);
    d[o] = i;
    var f = qe(n, d, s);
    Te.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE && f.isMissingData ? this._cache.set(n, {
      kind: "missing",
      result: f,
      snapshot: d
    }) : this._cache.set(n, {
      kind: "done",
      result: f
    });
  }, e;
}();
function wa(e) {
  nt(!1);
}
function Ts(e) {
  return new q5(e);
}
var Ta = V5 ? /* @__PURE__ */ new WeakMap() : /* @__PURE__ */ new Map();
function j5(e) {
  var t = Ta.get(e);
  if (t)
    return t;
  var r = Ts(e);
  return Ta.set(e, r), r;
}
var Ss = {
  createFragmentResource: Ts,
  getFragmentResourceForEnvironment: j5
}, K5 = { NEXT_PUBLIC_ENV_SLUG: "qa-2-scmpweb-6112-rjx12i", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_PROXY_PORT: "3000", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", npm_config_user_agent: "pnpm/9.10.0 npm/? node/v20.17.0 linux x64", NODE_VERSION: "20.17.0", SENTRY_RELEASE: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_ENABLE_HEAPDUMP: "true", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", YARN_VERSION: "1.22.22", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/unleash", NEXT_PUBLIC_SITE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_EXT_SVC_ENV_SLUG: "staging", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", USE_CHUNK_METRICS: "true", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", NODE_OPTIONS: "--max_old_space_size=8192", NEXT_PUBLIC_SENTRY_DSN: "https://3e9cef74cb0d4f6390d2c26317588aba@o259355.ingest.sentry.io/6598533", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", ANALYZE: "true", NEXT_PUBLIC_COMMIT_SHA: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_CF_BAN_WORKER_SENTRY_ENABLED: "false", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "be1d5c425bf7fe5cd9ca242b4fb6b274bf63552e", NEXT_PUBLIC_UNLEASH_API_TOKEN: "token", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", USE_SOURCE_MAP: "true", STORYBOOK_SITE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa-v2.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", NEXT_PUBLIC_USE_CDN: "true", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://qa-2-scmpweb-6112-rjx12i-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_CF_BAN_WORKER_MQ_HOST: "staging-rabbitmq-scmp-d8", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CF_BAN_WORKER_SITE_HOSTS: "staging-scmp-pwa-v2.product-web.dev-2.scmp.tech,amp.staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", USE_SERVICE_WORKER: "true", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", DOLLAR_SIGN: "$", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", GITLAB_CI_TOKEN: "wmBPb7CzvxxsRiLK1724", USE_SENTRY_WEBPACK_PLUGIN: "false", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", SENTRY_PROJECT: "scmp-pwa-v2-dev", NEXT_PUBLIC_UNLEASH_PROXY_CLIENT_KEYS: "api-key", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NEXT_PUBLIC_CF_BAN_WORKER_DRY_RUN: "true", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NODE_PATH: "/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.6.4_@swc-node+register@1.9.2_@swc+core@1.7.22_@swc+helpers@0.5.12__@swc+types@0.1.12_ty_nyw5s2opw32rtlh3u3mguxe3fu/node_modules:/app/node_modules/.pnpm/node_modules", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", ENV_SLUG: "qa-2-scmpweb-6112-rjx12i", NEXT_PUBLIC_DRUPAL_HOST: "http://staging-app-scmp-d8", PNPM_PACKAGE_NAME: "scmp-pwa-v2", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", USE_CDN: "true", PWD: "/app", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_CERT_ISSUER: "letsencrypt-staging", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", npm_command: "run-script", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", NX_CLI_SET: "true", NX_VERBOSE_LOGGING: "false", NX_LOAD_DOT_ENV_FILES: "true", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", FORCE_COLOR: "true", NX_WORKSPACE_ROOT: "/app", NX_TASK_TARGET_PROJECT: "scmp-sdk", NX_TASK_TARGET_TARGET: "build", NX_TASK_HASH: "16101179541642696061", LERNA_PACKAGE_NAME: "scmp-sdk", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" }, z5 = ve, Sa = ds, G5 = Ss, Y5 = G5.getFragmentResourceForEnvironment, As = m, W5 = As.useEffect, Z5 = As.useState, Rs = J, Q5 = Rs.RelayFeatureFlags, J5 = Rs.getFragmentIdentifier;
function e7(e, t, r) {
  var n = z5(), a = Y5(n), i = Sa(!1), o = Z5(0), s = o[1], c = J5(e, t), l = a.readWithIdentifier(e, t, c, r), u = Sa(!0);
  function d() {
    u.current = !0;
    var v = a.checkMissedUpdates(l)[0];
    v && h();
  }
  function f() {
    u.current = !1;
  }
  function h() {
    i.current === !1 || u.current === !1 || s(function(v) {
      return v + 1;
    });
  }
  return W5(function() {
    i.current = !0;
    var v = a.subscribe(l, h);
    return function() {
      i.current = !1, v.dispose();
    };
  }, [n, c]), (Q5.LOG_MISSING_RECORDS_IN_PROD || K5.NODE_ENV !== "production") && t != null && (l.data === void 0 || Array.isArray(l.data) && l.data.length > 0 && l.data.every(function(v) {
    return v === void 0;
  })), {
    data: l.data,
    disableStoreUpdates: f,
    enableStoreUpdates: d
  };
}
var sn = e7, t7 = B1, r7 = sn, n7 = et, a7 = n7.useTrackLoadQueryInRender, i7 = m;
i7.useDebugValue;
var o7 = J, s7 = o7.getFragment;
function c7(e, t) {
  a7();
  var r = s7(e), n = r7(r, t, "useFragment()"), a = n.data;
  return a;
}
function l7(e, t) {
  var r = t7.get();
  return r ? r.useFragment(e, t) : c7(e, t);
}
var u7 = l7, Aa = ds, Is = m, Z1 = Is.useCallback, d7 = Is.useEffect;
function p7() {
  var e = Aa(null), t = Aa(!1), r = Z1(function() {
    e.current != null && (e.current.unsubscribe(), e.current = null), t.current = !1;
  }, []), n = Z1(function(i) {
    e.current = i, t.current = !0;
  }, []), a = Z1(function() {
    e.current = null, t.current = !1;
  }, []);
  return d7(function() {
    return r;
  }, [r]), {
    isFetchingRef: t,
    startFetch: n,
    disposeFetch: r,
    completeFetch: a
  };
}
var Ps = p7, f7 = B1, m7 = sn, v7 = O1, Ls = an, g7 = Ls.getQueryCacheIdentifier, h7 = Ls.getQueryResourceForEnvironment, C7 = Ps, _7 = ve, U1 = m, E7 = U1.useContext, Q1 = U1.useEffect, y7 = U1.useState, b7 = U1.useRef;
function w7(e) {
  var t = e.query, r = e.componentDisplayName, n = e.fetchObservable, a = e.fetchPolicy, i = e.fetchKey, o = e.renderPolicy, s = _7(), c = E7(v7), l = h7(s), u = y7(0), d = u[0], f = u[1], h = C7(), v = h.startFetch, p = h.completeFetch, g = "".concat(d, "-").concat(i ?? ""), _ = g7(s, t, a, o, g), E = c.wrapPrepareQueryResource(function() {
    return l.prepareWithIdentifier(_, t, n, a, o, {
      start: v,
      complete: p,
      error: p
    }, c);
  }), y = b7(!1);
  Q1(function() {
    return function() {
      y.current = !0;
    };
  }, []), Q1(function() {
    if (y.current === !0) {
      y.current = !1, f(function(R) {
        return R + 1;
      });
      return;
    }
    var A = l.retain(E, c);
    return function() {
      A.dispose();
    };
  }, [s, _]), Q1(function() {
    l.releaseTemporaryRetain(E);
  });
  var w = E.fragmentNode, T = E.fragmentRef, S = T7(w, T, r);
  return S;
}
function T7(e, t, r) {
  var n = f7.get();
  if (n && n.useFragment__internal)
    return n.useFragment__internal(e, t, r);
  var a = m7(e, t, r), i = a.data;
  return i;
}
var Os = w7, J1 = [], er = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */
function S7(e, t) {
  var r = J1.length ? J1.pop() : [], n = er.length ? er.pop() : [], a = Ir(e, t, r, n);
  return r.length = 0, n.length = 0, J1.push(r), er.push(n), a;
}
function Ir(e, t, r, n) {
  if (e === t)
    return e !== 0 || 1 / e == 1 / t;
  if (e == null || t == null || typeof e != "object" || typeof t != "object")
    return !1;
  var a = Object.prototype.toString, i = a.call(e);
  if (i != a.call(t))
    return !1;
  switch (i) {
    case "[object String]":
      return e == String(t);
    case "[object Number]":
      return isNaN(e) || isNaN(t) ? !1 : e == Number(t);
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object RegExp]":
      return e.source == t.source && e.global == t.global && e.multiline == t.multiline && e.ignoreCase == t.ignoreCase;
  }
  for (var o = r.length; o--; )
    if (r[o] == e)
      return n[o] == t;
  r.push(e), n.push(t);
  var s = 0;
  if (i === "[object Array]") {
    if (s = e.length, s !== t.length)
      return !1;
    for (; s--; )
      if (!Ir(e[s], t[s], r, n))
        return !1;
  } else {
    if (e.constructor !== t.constructor)
      return !1;
    if (e.hasOwnProperty("valueOf") && t.hasOwnProperty("valueOf"))
      return e.valueOf() == t.valueOf();
    var c = Object.keys(e);
    if (c.length != Object.keys(t).length)
      return !1;
    for (var l = 0; l < c.length; l++)
      if (!Ir(e[c[l]], t[c[l]], r, n))
        return !1;
  }
  return r.pop(), n.pop(), !0;
}
var A7 = S7, R7 = A7, I7 = m, P7 = I7.useState;
function L7(e) {
  var t = P7(e), r = t[0], n = t[1];
  return R7(e, r) ? r : (n(e), e);
}
var O7 = L7, Ra = O7, N7 = m, Ns = J, x7 = Ns.createOperationDescriptor, k7 = Ns.getRequest, B7 = N7.useMemo;
function U7(e, t, r) {
  var n = Ra(t), a = Ra(r || {});
  return B7(function() {
    return x7(k7(e), n, a);
  }, [e, n, a]);
}
var xs = U7, H7 = et, M7 = H7.useTrackLoadQueryInRender, V7 = Os, D7 = xs, F7 = ve, X7 = J, $7 = X7.__internal.fetchQuery;
function q7(e, t, r) {
  M7();
  var n = F7(), a = D7(e, t, r && r.networkCacheConfig ? r.networkCacheConfig : {
    force: !0
  }), i = V7({
    componentDisplayName: "useLazyLoadQuery()",
    fetchKey: r == null ? void 0 : r.fetchKey,
    fetchObservable: $7(n, a),
    fetchPolicy: r == null ? void 0 : r.fetchPolicy,
    query: a,
    renderPolicy: r == null ? void 0 : r.UNSTABLE_renderPolicy
  });
  return i;
}
var j7 = q7, K7 = Ee.default, Ia = K7(Je), z7 = jt, G7 = ve, H1 = m, Y7 = J, W7 = Y7.commitMutation, Z7 = H1.useState, Q7 = H1.useEffect, tr = H1.useRef, Pa = H1.useCallback;
function J7(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : W7, r = G7(), n = z7(), a = tr(r), i = tr(e), o = tr(/* @__PURE__ */ new Set()), s = Z7(!1), c = s[0], l = s[1], u = Pa(function(f) {
    a.current === r && i.current === e && (o.current.delete(f), n.current && l(o.current.size > 0));
  }, [r, n, e]);
  Q7(function() {
    (a.current !== r || i.current !== e) && (o.current = /* @__PURE__ */ new Set(), n.current && l(!1), a.current = r, i.current = e);
  }, [r, n, e]);
  var d = Pa(function(f) {
    n.current && l(!0);
    var h = t(r, (0, Ia.default)((0, Ia.default)({}, f), {}, {
      mutation: e,
      onCompleted: function(p, g) {
        var _;
        u(h), (_ = f.onCompleted) === null || _ === void 0 || _.call(f, p, g);
      },
      onError: function(p) {
        var g;
        u(h), (g = f.onError) === null || g === void 0 || g.call(f, p);
      },
      onUnsubscribe: function() {
        var p;
        u(h), (p = f.onUnsubscribe) === null || p === void 0 || p.call(f);
      },
      onNext: function() {
        var p;
        (p = f.onNext) === null || p === void 0 || p.call(f);
      }
    }));
    return o.current.add(h), h;
  }, [u, t, r, n, e]);
  return [d, c];
}
var e8 = J7, t8 = Ee.default, La = t8(cs), ks = et, r8 = ks.loadQuery, n8 = ks.useTrackLoadQueryInRender, a8 = jt, i8 = ve, M1 = m, Oa = M1.useCallback, rr = M1.useEffect, Na = M1.useRef, xa = M1.useState, o8 = J, s8 = o8.getRequest, nr = {
  kind: "NullQueryReference"
};
function ka(e) {
  if (e.kind === "PreloadableConcreteRequest")
    return e.params.metadata.live !== void 0;
  var t = s8(e);
  return t.params.metadata.live !== void 0;
}
function c8(e, t) {
  var r = t ?? nr, n = i8();
  n8();
  var a = a8(), i = Na(/* @__PURE__ */ new Set([r])), o = xa(function() {
    return r;
  }), s = o[0], c = o[1], l = xa(function() {
    return r;
  }), u = l[0], d = l[1];
  r !== u && (i.current.add(r), d(r), c(r));
  var f = Oa(function() {
    a.current && (i.current.add(nr), c(nr));
  }, [a]), h = Oa(function(p, g) {
    var _ = g != null && g.hasOwnProperty("__environment") ? {
      fetchPolicy: g.fetchPolicy,
      networkCacheConfig: g.networkCacheConfig,
      __nameForWarning: g.__nameForWarning
    } : g;
    if (a.current) {
      var E, y = r8((E = g == null ? void 0 : g.__environment) !== null && E !== void 0 ? E : n, e, p, _);
      i.current.add(y), c(y);
    }
  }, [n, e, c, a]), v = Na(!1);
  return rr(function() {
    return function() {
      v.current = !0;
    };
  }, []), rr(function() {
    if (v.current === !0) {
      v.current = !1, s.kind !== "NullQueryReference" && h(s.variables, {
        fetchPolicy: s.fetchPolicy,
        networkCacheConfig: s.networkCacheConfig
      });
      return;
    }
    var p = i.current;
    if (a.current) {
      var g = (0, La.default)(p), _;
      try {
        for (g.s(); !(_ = g.n()).done; ) {
          var E = _.value;
          if (E === s)
            break;
          p.delete(E), E.kind !== "NullQueryReference" && (ka(e) ? E.dispose && E.dispose() : E.releaseQuery && E.releaseQuery());
        }
      } catch (y) {
        g.e(y);
      } finally {
        g.f();
      }
    }
  }, [s, a, h, e]), rr(function() {
    return function() {
      var g = (0, La.default)(i.current), _;
      try {
        for (g.s(); !(_ = g.n()).done; ) {
          var E = _.value;
          E.kind !== "NullQueryReference" && (ka(e) ? E.dispose && E.dispose() : E.releaseQuery && E.releaseQuery());
        }
      } catch (y) {
        g.e(y);
      } finally {
        g.f();
      }
    };
  }, [e]), [s.kind === "NullQueryReference" ? null : s, h, f];
}
var Bs = c8, l8 = Ee.default, Ot = l8(Je), u8 = O1, d8 = an, p8 = d8.getQueryResourceForEnvironment, f8 = jt, m8 = Bs, v8 = ve, g8 = Ss, h8 = g8.getFragmentResourceForEnvironment, C8 = sn, _8 = xe, cn = m, E8 = cn.useCallback, y8 = cn.useContext, b8 = cn.useReducer, _t = J, w8 = _t.__internal.fetchQuery, T8 = _t.createOperationDescriptor, S8 = _t.getFragmentIdentifier, Ba = _t.getRefetchMetadata, A8 = _t.getSelector, R8 = _t.getValueAtPath;
function I8(e, t) {
  switch (t.type) {
    case "refetch": {
      var r;
      return (0, Ot.default)((0, Ot.default)({}, e), {}, {
        fetchPolicy: t.fetchPolicy,
        mirroredEnvironment: (r = t.refetchEnvironment) !== null && r !== void 0 ? r : e.mirroredEnvironment,
        onComplete: t.onComplete,
        refetchEnvironment: t.refetchEnvironment,
        refetchQuery: t.refetchQuery,
        renderPolicy: t.renderPolicy
      });
    }
    case "reset":
      return {
        fetchPolicy: void 0,
        mirroredEnvironment: t.environment,
        mirroredFragmentIdentifier: t.fragmentIdentifier,
        onComplete: void 0,
        refetchQuery: null,
        renderPolicy: void 0
      };
    default:
      throw t.type, new Error("useRefetchableFragmentNode: Unexpected action type");
  }
}
function P8(e, t, r) {
  var n = v8(), a = Ba(e, r), i = a.refetchableRequest, o = a.fragmentRefPathInResponse, s = S8(e, t), c = b8(I8, {
    fetchPolicy: void 0,
    mirroredEnvironment: n,
    mirroredFragmentIdentifier: s,
    onComplete: void 0,
    refetchEnvironment: null,
    refetchQuery: null,
    renderPolicy: void 0
  }), l = c[0], u = c[1], d = l.fetchPolicy, f = l.mirroredEnvironment, h = l.mirroredFragmentIdentifier, v = l.onComplete, p = l.refetchEnvironment, g = l.refetchQuery, _ = l.renderPolicy, E = p ?? n, y = p8(E), w = h8(E), T = y8(u8), S = E !== f || s !== h, A = m8(i), R = A[0], I = A[1], L = A[2], O = t, P = Ba(e, r), x = P.identifierInfo;
  if (S)
    u({
      type: "reset",
      environment: E,
      fragmentIdentifier: s
    }), L();
  else if (g != null && R != null) {
    var k = function(G) {
      v && v(G ?? null);
    }, N = R.source != null ? R.source : w8(E, g), B = T.wrapPrepareQueryResource(function() {
      return y.prepare(g, N, d, _, {
        error: k,
        complete: function() {
          k();
        }
      }, R.fetchKey, T);
    }), H = w.read(B.fragmentNode, B.fragmentRef, r).data;
    H == null && _8(!1);
    var K = R8(H, o);
    O = K;
  }
  var X = C8(e, O, r), Y = X.data, $ = X.disableStoreUpdates, q = X.enableStoreUpdates, z = L8(r, u, L, Y, s, e, o, x, I, t, i);
  return {
    fragmentData: Y,
    fragmentRef: O,
    refetch: z,
    disableStoreUpdates: $,
    enableStoreUpdates: q
  };
}
function L8(e, t, r, n, a, i, o, s, c, l, u) {
  var d = f8(), f = (s == null ? void 0 : s.identifierField) != null && n != null && typeof n == "object" ? n[s.identifierField] : null;
  return E8(function(h, v) {
    if (d.current !== !0)
      return {
        dispose: function() {
        }
      };
    var p = v == null ? void 0 : v.__environment, g = v == null ? void 0 : v.fetchPolicy, _ = v == null ? void 0 : v.UNSTABLE_renderPolicy, E = v == null ? void 0 : v.onComplete, y = A8(i, l), w, T;
    if (y == null)
      w = {}, T = {};
    else if (y.kind === "PluralReaderSelector") {
      var S, A, R, I;
      w = (S = (A = y.selectors[0]) === null || A === void 0 ? void 0 : A.owner.variables) !== null && S !== void 0 ? S : {}, T = (R = (I = y.selectors[0]) === null || I === void 0 ? void 0 : I.variables) !== null && R !== void 0 ? R : {};
    } else
      w = y.owner.variables, T = y.variables;
    var L = (0, Ot.default)((0, Ot.default)((0, Ot.default)({}, w), T), h);
    s != null && !h.hasOwnProperty(s.identifierQueryVariableName) && (L[s.identifierQueryVariableName] = f);
    var O = T8(u, L, {
      force: !0
    });
    return c(O.request.variables, {
      fetchPolicy: g,
      __environment: p,
      __nameForWarning: "refetch"
    }), t({
      type: "refetch",
      fetchPolicy: g,
      onComplete: E,
      refetchEnvironment: p,
      refetchQuery: O,
      renderPolicy: _
    }), {
      dispose: r
    };
  }, [a, t, r, f, c]);
}
var Us = P8, O8 = ve, N8 = xe, ln = m, Hs = J, x8 = Hs.__internal.getObservableForActiveRequest, k8 = Hs.getSelector, B8 = ln.useEffect, U8 = ln.useState, H8 = ln.useMemo;
function M8(e, t) {
  var r = O8(), n = H8(function() {
    var s = k8(e, t);
    return s == null ? null : (s.kind !== "SingularReaderSelector" && N8(!1), x8(r, s.owner));
  }, [r, e, t]), a = U8(n != null), i = a[0], o = a[1];
  return B8(function() {
    var s;
    if (o(n != null), n != null) {
      var c = function() {
        o(!1);
      };
      s = n.subscribe({
        complete: c,
        error: c
      });
    }
    return function() {
      s && s.unsubscribe();
    };
  }, [n]), i;
}
var V8 = M8, D8 = Ee.default, At = D8(Je), F8 = Ps, X8 = jt, $8 = V8, q8 = ve, It = xe, un = m, j8 = un.useCallback, K8 = un.useEffect, Ua = un.useState, tt = J, z8 = tt.__internal.fetchQuery, G8 = tt.ConnectionInterface, Y8 = tt.createOperationDescriptor, W8 = tt.getPaginationVariables, Z8 = tt.getRefetchMetadata, Q8 = tt.getSelector, J8 = tt.getValueAtPath;
function e9(e) {
  var t = e.direction, r = e.fragmentNode, n = e.fragmentRef, a = e.fragmentIdentifier, i = e.fragmentData, o = e.connectionPathInFragmentData, s = e.paginationRequest, c = e.paginationMetadata, l = e.componentDisplayName, u = e.observer, d = e.onReset, f = q8(), h = F8(), v = h.isFetchingRef, p = h.startFetch, g = h.disposeFetch, _ = h.completeFetch, E = Z8(r, l), y = E.identifierInfo, w = (y == null ? void 0 : y.identifierField) != null && i != null && typeof i == "object" ? i[y.identifierField] : null, T = X8(), S = Ua(f), A = S[0], R = S[1], I = Ua(a), L = I[0], O = I[1], P = $8(r, n), x = f !== A || a !== L;
  x && (g(), d(), R(f), O(a));
  var k = t9(t, r, i, o), N = k.cursor, B = k.hasMore;
  K8(function() {
    return function() {
      g();
    };
  }, [g]);
  var H = j8(function(K, X) {
    var Y = X == null ? void 0 : X.onComplete;
    if (T.current !== !0)
      return {
        dispose: function() {
        }
      };
    var $ = Q8(r, n);
    if (v.current === !0 || i == null || P)
      return Y && Y(null), {
        dispose: function() {
        }
      };
    $ != null && $.kind !== "PluralReaderSelector" || It(!1);
    var q = $.owner.variables, z = $.variables, Z = X == null ? void 0 : X.UNSTABLE_extraVariables, G = (0, At.default)((0, At.default)({}, q), z), re = W8(t, K, N, G, (0, At.default)({}, Z), c);
    y != null && (re[y.identifierQueryVariableName] = w);
    var ke = Y8(s, re, {
      force: !0
    });
    return z8(f, ke).subscribe((0, At.default)((0, At.default)({}, u), {}, {
      start: function(ne) {
        p(ne), u.start && u.start(ne);
      },
      complete: function() {
        _(), u.complete && u.complete(), Y && Y(null);
      },
      error: function(ne) {
        _(), u.error && u.error(ne), Y && Y(ne);
      }
    })), {
      dispose: g
    };
  }, [f, w, t, N, p, g, _, v, P, i, r.name, n, l]);
  return [H, B, g];
}
function t9(e, t, r, n) {
  var a, i, o = G8.get(), s = o.EDGES, c = o.PAGE_INFO, l = o.HAS_NEXT_PAGE, u = o.HAS_PREV_PAGE, d = o.END_CURSOR, f = o.START_CURSOR, h = J8(r, n);
  if (h == null)
    return {
      cursor: null,
      hasMore: !1
    };
  typeof h != "object" && It(!1);
  var v = h[s], p = h[c];
  if (v == null || p == null)
    return {
      cursor: null,
      hasMore: !1
    };
  Array.isArray(v) || It(!1), typeof p != "object" && It(!1);
  var g = e === "forward" ? (a = p[d]) !== null && a !== void 0 ? a : null : (i = p[f]) !== null && i !== void 0 ? i : null;
  g === null || typeof g == "string" || It(!1);
  var _;
  return e === "forward" ? _ = g != null && p[l] === !0 : _ = g != null && p[u] === !0, {
    cursor: g,
    hasMore: _
  };
}
var r9 = e9, n9 = Ee.default, v1 = n9(Je), a9 = B1, i9 = Us, o9 = r9, dn = m, s9 = dn.useCallback;
dn.useDebugValue;
var c9 = dn.useState, pn = J, l9 = pn.getFragment, u9 = pn.getFragmentIdentifier, d9 = pn.getPaginationMetadata;
function p9(e, t) {
  var r = l9(e), n = "usePaginationFragment()", a = d9(r, n), i = a.connectionPathInFragmentData, o = a.paginationRequest, s = a.paginationMetadata, c = i9(r, t, n), l = c.fragmentData, u = c.fragmentRef, d = c.refetch, f = u9(r, u), h = Ha({
    componentDisplayName: n,
    connectionPathInFragmentData: i,
    direction: "backward",
    fragmentData: l,
    fragmentIdentifier: f,
    fragmentNode: r,
    fragmentRef: u,
    paginationMetadata: s,
    paginationRequest: o
  }), v = h[0], p = h[1], g = h[2], _ = h[3], E = Ha({
    componentDisplayName: n,
    connectionPathInFragmentData: i,
    direction: "forward",
    fragmentData: l,
    fragmentIdentifier: f,
    fragmentNode: r,
    fragmentRef: u,
    paginationMetadata: s,
    paginationRequest: o
  }), y = E[0], w = E[1], T = E[2], S = E[3], A = s9(function(R, I) {
    return S(), _(), d(R, (0, v1.default)((0, v1.default)({}, I), {}, {
      __environment: void 0
    }));
  }, [S, _, d]);
  return {
    data: l,
    loadNext: y,
    loadPrevious: v,
    hasNext: w,
    hasPrevious: p,
    isLoadingNext: T,
    isLoadingPrevious: g,
    refetch: A
  };
}
function Ha(e) {
  var t = c9(!1), r = t[0], n = t[1], a = {
    start: function() {
      return n(!0);
    },
    complete: function() {
      return n(!1);
    },
    error: function() {
      return n(!1);
    }
  }, i = function() {
    return n(!1);
  }, o = o9((0, v1.default)((0, v1.default)({}, e), {}, {
    observer: a,
    onReset: i
  })), s = o[0], c = o[1], l = o[2];
  return [s, c, r, l];
}
function f9(e, t) {
  var r = a9.get();
  return r ? r.usePaginationFragment(e, t) : p9(e, t);
}
var m9 = f9, v9 = et, g9 = v9.useTrackLoadQueryInRender, h9 = Os, C9 = xs, _9 = ve, E9 = xe, y9 = m;
y9.useDebugValue;
var b9 = J, Ms = b9.__internal, w9 = Ms.fetchQueryDeduped, T9 = Ms.fetchQuery;
function S9(e, t, r) {
  g9();
  var n = _9(), a = t.fetchKey, i = t.fetchPolicy, o = t.source, s = t.variables, c = t.networkCacheConfig, l = C9(e, s, c), u;
  if (t.kind === "PreloadedQuery_DEPRECATED")
    l.request.node.params.name !== t.name && E9(!1), u = {
      componentDisplayName: "usePreloadedQuery()",
      fetchKey: a,
      fetchObservable: w9(n, l.request.identifier, function() {
        return n === t.environment && o != null ? n.executeWithSource({
          operation: l,
          source: o
        }) : n.execute({
          operation: l
        });
      }),
      fetchPolicy: i,
      query: l,
      renderPolicy: r == null ? void 0 : r.UNSTABLE_renderPolicy
    };
  else {
    var d = T9(n, l), f;
    o != null && n === t.environment ? f = o.ifEmpty(d) : (t.environment, f = d), u = {
      componentDisplayName: "usePreloadedQuery()",
      fetchObservable: f,
      fetchKey: a,
      fetchPolicy: i,
      query: l,
      renderPolicy: r == null ? void 0 : r.UNSTABLE_renderPolicy
    };
  }
  var h = h9(u);
  return h;
}
var A9 = S9, R9 = B1, I9 = Us, P9 = m;
P9.useDebugValue;
var L9 = J, O9 = L9.getFragment;
function N9(e, t) {
  var r = O9(e), n = I9(r, t, "useRefetchableFragment()"), a = n.fragmentData, i = n.refetch;
  return [a, i];
}
function x9(e, t) {
  var r = R9.get();
  return r ? r.useRefetchableFragment(e, t) : N9(e, t);
}
var k9 = x9, B9 = ve, Vs = m, U9 = Vs.useEffect, H9 = Vs.useRef;
function M9(e, t) {
  var r = B9(), n = H9(null), a = Array.from(e).sort().join("");
  return U9(function() {
    var i = r.getStore(), o = i.lookupInvalidationState(e), s = i.subscribeToInvalidationState(o, t);
    return n.current = s, function() {
      return s.dispose();
    };
  }, [a, t, r]), {
    dispose: function() {
      n.current != null && n.current.dispose();
    }
  };
}
var V9 = M9, D9 = ve, F9 = m, X9 = F9.useEffect, $9 = J, q9 = $9.requestSubscription;
function j9(e, t) {
  var r = t ?? q9, n = D9();
  X9(function() {
    var a = r(n, e), i = a.dispose;
    return i;
  }, [n, e, r]);
}
var K9 = j9, z9 = N6, G9 = ts, Y9 = et, W9 = Y9.loadQuery, Z9 = O1, Q9 = K6, J9 = n5, eu = u7, tu = j7, ru = e8, nu = m9, au = A9, iu = Bs, ou = k9, su = ve, cu = V9, lu = K9, He = J, uu = {
  ConnectionHandler: He.ConnectionHandler,
  applyOptimisticMutation: He.applyOptimisticMutation,
  commitLocalUpdate: He.commitLocalUpdate,
  commitMutation: He.commitMutation,
  graphql: He.graphql,
  readInlineData: He.readInlineData,
  requestSubscription: He.requestSubscription,
  EntryPointContainer: z9,
  RelayEnvironmentProvider: Q9,
  ProfilerContext: Z9,
  fetchQuery: He.fetchQuery,
  loadQuery: W9,
  loadEntryPoint: G9,
  useFragment: eu,
  useLazyLoadQuery: tu,
  useEntryPointLoader: J9,
  useQueryLoader: iu,
  useMutation: ru,
  usePaginationFragment: nu,
  usePreloadedQuery: au,
  useRefetchableFragment: ou,
  useRelayEnvironment: su,
  useSubscribeToInvalidationState: cu,
  useSubscription: lu
}, Ds = uu;
const Fs = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "footerNewsletterId"
  }], t = [{
    kind: "Literal",
    name: "filter",
    value: {
      entityId: "scmp_pwa_widget"
    }
  }], r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "json",
    storageKey: null
  }, a = [{
    fields: [{
      kind: "Variable",
      name: "entityId",
      variableName: "footerNewsletterId"
    }],
    kind: "ObjectValue",
    name: "filter"
  }], i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "name",
    storageKey: null
  }, o = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "alternativeName",
    storageKey: null
  }, s = [{
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "text",
    storageKey: null
  }], c = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "summary",
    plural: !1,
    selections: s,
    storageKey: null
  }, l = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "homepageDescription",
    plural: !1,
    selections: s,
    storageKey: null
  }, u = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "id",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "footerDisplayQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [
          r,
          n
          /*: any*/
        ],
        storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_widget"})'
      }, {
        alias: null,
        args: a,
        concreteType: "Newsletter",
        kind: "LinkedField",
        name: "newsletter",
        plural: !1,
        selections: [
          r,
          i,
          o,
          c,
          l
          /*: any*/
        ],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "footerDisplayQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [
          r,
          n,
          u
          /*: any*/
        ],
        storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_widget"})'
      }, {
        alias: null,
        args: a,
        concreteType: "Newsletter",
        kind: "LinkedField",
        name: "newsletter",
        plural: !1,
        selections: [
          r,
          i,
          o,
          c,
          l,
          u
          /*: any*/
        ],
        storageKey: null
      }]
    },
    params: {
      cacheID: "aeccf4f9e4f975b246fac8ec525ecc1f",
      id: null,
      metadata: {},
      name: "footerDisplayQuery",
      operationKind: "query",
      text: `query footerDisplayQuery(
  $footerNewsletterId: String
) {
  appConfig(filter: {entityId: "scmp_pwa_widget"}) {
    entityId
    json
    id
  }
  newsletter(filter: {entityId: $footerNewsletterId}) {
    entityId
    name
    alternativeName
    summary {
      text
    }
    homepageDescription {
      text
    }
    id
  }
}
`
    }
  };
}();
Fs.hash = "88d7d054c9fb5b7bbe088e9d86c9ec22";
function Pr() {
  return Pr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pr.apply(null, arguments);
}
const Xs = ({
  queryReference: e,
  ...t
}) => {
  var r, n, a, i, o, s;
  const {
    config: c
  } = U(), l = Ds.usePreloadedQuery($s, e), u = (r = l.appConfig) === null || r === void 0 ? void 0 : r.json, d = l.newsletter;
  return /* @__PURE__ */ m.createElement(qo, Pr({}, t, {
    newsletterItems: [{
      alternativeName: d.alternativeName,
      entityId: d.entityId,
      homepageDescription: {
        text: (n = (a = d.homepageDescription) === null || a === void 0 ? void 0 : a.text) !== null && n !== void 0 ? n : ""
      },
      name: d.name,
      summary: {
        text: (i = (o = d.summary) === null || o === void 0 ? void 0 : o.text) !== null && i !== void 0 ? i : ""
      }
    }],
    printEditionFooterConfig: u == null || (s = u[c.environment]) === null || s === void 0 ? void 0 : s.print_edition_footer,
    "data-qa": "footer-display"
  }));
};
Xs.displayName = "FooterDisplay";
const $s = Fs;
function Lr() {
  return Lr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lr.apply(null, arguments);
}
const du = ({
  loadingComponent: e,
  ...t
}) => {
  const {
    config: r
  } = U(), [n, a, i] = Ds.useQueryLoader($s);
  return te(() => (a({
    footerNewsletterId: r.newsletter.globalImpact
  }), i), [a, i, r.newsletter.globalImpact]), /* @__PURE__ */ m.createElement(J2, {
    fallback: e ?? "loading...",
    "data-qa": "footer"
  }, n && /* @__PURE__ */ m.createElement(Xs, Lr({}, t, {
    queryReference: n
  })));
};
du.displayName = "Footer";
const pu = /* @__PURE__ */ b("div", {
  target: "e1que4v90"
})({
  name: "u25i9k",
  styles: "display:flex;flex-flow:column;justify-content:flex-start;align-items:center;inline-size:600px;min-block-size:252px;margin:auto;padding-block:40px;padding-inline:0;border-radius:8px;background-color:#ffffff;outline:none"
}), qs = ({
  children: e,
  isShow: t,
  onClose: r
}) => /* @__PURE__ */ m.createElement(Y0, {
  open: t,
  onClose: r,
  "data-qa": "popup"
}, /* @__PURE__ */ m.createElement(pu, null, e));
qs.displayName = "Popup";
const fu = /* @__PURE__ */ b(u0, {
  target: "e1qc5gx50"
})(d0, "{margin-block-start:0;}", p0, "{font-size:21px;line-height:27px;}", f0, "{font-size:16px;}", m0, "{font-size:14px;}"), mu = ({
  isShow: e,
  onClose: t
}) => /* @__PURE__ */ m.createElement(qs, {
  isShow: e,
  onClose: t,
  "data-qa": "sign-up-popup"
}, /* @__PURE__ */ m.createElement(V0, {
  theme: {
    signUpSuccess: {
      hasCheckEmail: !0
    }
  }
}, /* @__PURE__ */ m.createElement(fu, null)));
mu.displayName = "SignUpPopup";
const vu = () => {
  const {
    set: e,
    value: t
  } = Oe("isFirstTimeVisitNotification", {
    defaultValue: !0
  });
  return {
    isFirstTime: t,
    setIsFirstTime: e
  };
}, gu = /* @__PURE__ */ b(D0, {
  target: "egbuww0"
})(".", F0.dot, "{z-index:0;inline-size:4px;block-size:4px;min-inline-size:4px;border-radius:50%;background:#eb4254;transform:none;transition:none;translate:2px 0;}"), hu = ({
  children: e
}) => {
  const {
    isFirstTime: t
  } = vu();
  return /* @__PURE__ */ m.createElement(gu, {
    invisible: !t,
    variant: "dot",
    "data-qa": "dashboard-badge"
  }, e);
}, js = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "entityUuids"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "first"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "scmpPlusPaywallTypeIds"
  }], t = [{
    fields: [{
      kind: "Variable",
      name: "paywallTypeIds",
      variableName: "scmpPlusPaywallTypeIds"
    }],
    kind: "ObjectValue",
    name: "exclude"
  }, {
    fields: [{
      kind: "Variable",
      name: "entityUuids",
      variableName: "entityUuids"
    }],
    kind: "ObjectValue",
    name: "filter"
  }, {
    kind: "Variable",
    name: "first",
    variableName: "first"
  }], r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityUuid",
    storageKey: null
  }, n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, a = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "__typename",
    storageKey: null
  }, i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "urlAlias",
    storageKey: null
  }, o = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "headline",
    storageKey: null
  }, s = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "socialHeadline",
    storageKey: null
  }, c = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "id",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "hooksUseReadingHistoryWithArticleQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [r, n, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryPanelArticle",
              selections: [a, r, n, i, o, s, {
                alias: null,
                args: null,
                concreteType: "Application",
                kind: "LinkedField",
                name: "application",
                plural: !1,
                selections: [
                  r
                  /*: any*/
                ],
                storageKey: null
              }],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryActionMenuBookmarkButtonArticle",
              selections: [
                i,
                n
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryActionMenuSocialButtonArticle",
              selections: [
                r,
                n,
                i,
                o,
                s
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "hooksRemoveReadingHistoryArticle",
              selections: [
                r,
                n
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "hooksUseReadingHistoryWithArticleQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [
              r,
              n,
              a,
              i,
              o,
              s,
              {
                alias: null,
                args: null,
                concreteType: "Application",
                kind: "LinkedField",
                name: "application",
                plural: !1,
                selections: [
                  r,
                  c
                  /*: any*/
                ],
                storageKey: null
              },
              c
              /*: any*/
            ],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }]
    },
    params: {
      cacheID: "09c86431a1ac0204ba9edf1bd9f7cdda",
      id: null,
      metadata: {},
      name: "hooksUseReadingHistoryWithArticleQuery",
      operationKind: "query",
      text: `query hooksUseReadingHistoryWithArticleQuery(
  $entityUuids: [String]!
  $first: Int!
  $scmpPlusPaywallTypeIds: [String]
) {
  articles(exclude: {paywallTypeIds: $scmpPlusPaywallTypeIds}, filter: {entityUuids: $entityUuids}, first: $first) {
    edges {
      node {
        entityUuid
        entityId
        ...readingHistoryPanelArticle
        ...readingHistoryActionMenuBookmarkButtonArticle
        ...readingHistoryActionMenuSocialButtonArticle
        ...hooksRemoveReadingHistoryArticle
        id
      }
    }
  }
}

fragment hooksRemoveReadingHistoryArticle on Article {
  entityUuid
  entityId
}

fragment readingHistoryActionMenuBookmarkButtonArticle on Article {
  urlAlias
  entityId
}

fragment readingHistoryActionMenuSocialButtonArticle on Article {
  entityUuid
  entityId
  urlAlias
  headline
  socialHeadline
}

fragment readingHistoryPanelArticle on Article {
  __typename
  entityUuid
  entityId
  urlAlias
  headline
  socialHeadline
  application {
    entityUuid
    id
  }
}
`
    }
  };
}();
js.hash = "cbde35cb215893f736ea456fd1a2e149";
const Ks = {
  kind: "InlineDataFragment",
  name: "hooksRemoveReadingHistoryArticle"
};
Ks.hash = "9cf9cb93788ef385dc0937902f020c9b";
var Cu = zr, _u = ji, Eu = Ki, yu = $i, bu = qi, wu = Gr, Tu = 200;
function Su(e, t, r, n) {
  var a = -1, i = _u, o = !0, s = e.length, c = [], l = t.length;
  if (!s)
    return c;
  r && (t = yu(t, bu(r))), n ? (i = Eu, o = !1) : t.length >= Tu && (i = wu, o = !1, t = new Cu(t));
  e:
    for (; ++a < s; ) {
      var u = e[a], d = r == null ? u : r(u);
      if (u = n || u !== 0 ? u : 0, o && d === d) {
        for (var f = l; f--; )
          if (t[f] === d)
            continue e;
        c.push(u);
      } else i(t, d, n) || c.push(u);
    }
  return c;
}
var Au = Su;
function Ru(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var zs = Ru, Iu = b1, Pu = $t, Lu = "[object Arguments]";
function Ou(e) {
  return Pu(e) && Iu(e) == Lu;
}
var Nu = Ou, Ma = Nu, xu = $t, Gs = Object.prototype, ku = Gs.hasOwnProperty, Bu = Gs.propertyIsEnumerable, Uu = Ma(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ma : function(e) {
  return xu(e) && ku.call(e, "callee") && !Bu.call(e, "callee");
}, V1 = Uu, Hu = Array.isArray, be = Hu, Va = Yr, Mu = V1, Vu = be, Da = Va ? Va.isConcatSpreadable : void 0;
function Du(e) {
  return Vu(e) || Mu(e) || !!(Da && e && e[Da]);
}
var Fu = Du, Xu = zs, $u = Fu;
function Ys(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = $u), a || (a = []); ++i < o; ) {
    var s = e[i];
    t > 0 && r(s) ? t > 1 ? Ys(s, t - 1, r, n, a) : Xu(a, s) : n || (a[a.length] = s);
  }
  return a;
}
var qu = Ys, ju = Au, Ku = qu, zu = W0, Fa = Z0, Gu = zu(function(e, t) {
  return Fa(e) ? ju(e, Ku(t, 1, Fa, !0)) : [];
}), Yu = Gu;
const Wu = /* @__PURE__ */ T1(Yu);
var Zu = Wr;
function Qu() {
  this.__data__ = new Zu(), this.size = 0;
}
var Ju = Qu;
function ed(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var td = ed;
function rd(e) {
  return this.__data__.get(e);
}
var nd = rd;
function ad(e) {
  return this.__data__.has(e);
}
var id = ad, od = Wr, sd = zi, cd = Gi, ld = 200;
function ud(e, t) {
  var r = this.__data__;
  if (r instanceof od) {
    var n = r.__data__;
    if (!sd || n.length < ld - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new cd(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var dd = ud, pd = Wr, fd = Ju, md = td, vd = nd, gd = id, hd = dd;
function Et(e) {
  var t = this.__data__ = new pd(e);
  this.size = t.size;
}
Et.prototype.clear = fd;
Et.prototype.delete = md;
Et.prototype.get = vd;
Et.prototype.has = gd;
Et.prototype.set = hd;
var Ws = Et;
function Cd(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var _d = Cd, Ed = zr, yd = _d, bd = Gr, wd = 1, Td = 2;
function Sd(e, t, r, n, a, i) {
  var o = r & wd, s = e.length, c = t.length;
  if (s != c && !(o && c > s))
    return !1;
  var l = i.get(e), u = i.get(t);
  if (l && u)
    return l == t && u == e;
  var d = -1, f = !0, h = r & Td ? new Ed() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < s; ) {
    var v = e[d], p = t[d];
    if (n)
      var g = o ? n(p, v, d, t, e, i) : n(v, p, d, e, t, i);
    if (g !== void 0) {
      if (g)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!yd(t, function(_, E) {
        if (!bd(h, E) && (v === _ || a(v, _, r, n, i)))
          return h.push(E);
      })) {
        f = !1;
        break;
      }
    } else if (!(v === p || a(v, p, r, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var Zs = Sd, Ad = gt, Rd = Ad.Uint8Array, Id = Rd;
function Pd(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var Ld = Pd;
function Od(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var fn = Od, Xa = Yr, $a = Id, Nd = Q0, xd = Zs, kd = Ld, Bd = fn, Ud = 1, Hd = 2, Md = "[object Boolean]", Vd = "[object Date]", Dd = "[object Error]", Fd = "[object Map]", Xd = "[object Number]", $d = "[object RegExp]", qd = "[object Set]", jd = "[object String]", Kd = "[object Symbol]", zd = "[object ArrayBuffer]", Gd = "[object DataView]", qa = Xa ? Xa.prototype : void 0, ar = qa ? qa.valueOf : void 0;
function Yd(e, t, r, n, a, i, o) {
  switch (r) {
    case Gd:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case zd:
      return !(e.byteLength != t.byteLength || !i(new $a(e), new $a(t)));
    case Md:
    case Vd:
    case Xd:
      return Nd(+e, +t);
    case Dd:
      return e.name == t.name && e.message == t.message;
    case $d:
    case jd:
      return e == t + "";
    case Fd:
      var s = kd;
    case qd:
      var c = n & Ud;
      if (s || (s = Bd), e.size != t.size && !c)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      n |= Hd, o.set(e, t);
      var u = xd(s(e), s(t), n, a, i, o);
      return o.delete(e), u;
    case Kd:
      if (ar)
        return ar.call(e) == ar.call(t);
  }
  return !1;
}
var Wd = Yd, Zd = zs, Qd = be;
function Jd(e, t, r) {
  var n = t(e);
  return Qd(e) ? n : Zd(n, r(e));
}
var ep = Jd;
function tp(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var rp = tp;
function np() {
  return [];
}
var ap = np, ip = rp, op = ap, sp = Object.prototype, cp = sp.propertyIsEnumerable, ja = Object.getOwnPropertySymbols, lp = ja ? function(e) {
  return e == null ? [] : (e = Object(e), ip(ja(e), function(t) {
    return cp.call(e, t);
  }));
} : op, up = lp;
function dp(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var pp = dp, g1 = { exports: {} };
function fp() {
  return !1;
}
var mp = fp;
g1.exports;
(function(e, t) {
  var r = gt, n = mp, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || n;
  e.exports = l;
})(g1, g1.exports);
var mn = g1.exports, vp = 9007199254740991, gp = /^(?:0|[1-9]\d*)$/;
function hp(e, t) {
  var r = typeof e;
  return t = t ?? vp, !!t && (r == "number" || r != "symbol" && gp.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Qs = hp, Cp = b1, _p = Yi, Ep = $t, yp = "[object Arguments]", bp = "[object Array]", wp = "[object Boolean]", Tp = "[object Date]", Sp = "[object Error]", Ap = "[object Function]", Rp = "[object Map]", Ip = "[object Number]", Pp = "[object Object]", Lp = "[object RegExp]", Op = "[object Set]", Np = "[object String]", xp = "[object WeakMap]", kp = "[object ArrayBuffer]", Bp = "[object DataView]", Up = "[object Float32Array]", Hp = "[object Float64Array]", Mp = "[object Int8Array]", Vp = "[object Int16Array]", Dp = "[object Int32Array]", Fp = "[object Uint8Array]", Xp = "[object Uint8ClampedArray]", $p = "[object Uint16Array]", qp = "[object Uint32Array]", j = {};
j[Up] = j[Hp] = j[Mp] = j[Vp] = j[Dp] = j[Fp] = j[Xp] = j[$p] = j[qp] = !0;
j[yp] = j[bp] = j[kp] = j[wp] = j[Bp] = j[Tp] = j[Sp] = j[Ap] = j[Rp] = j[Ip] = j[Pp] = j[Lp] = j[Op] = j[Np] = j[xp] = !1;
function jp(e) {
  return Ep(e) && _p(e.length) && !!j[Cp(e)];
}
var Kp = jp, h1 = { exports: {} };
h1.exports;
(function(e, t) {
  var r = J0, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
    try {
      var c = a && a.require && a.require("util").types;
      return c || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(h1, h1.exports);
var zp = h1.exports, Gp = Kp, Yp = qi, Ka = zp, za = Ka && Ka.isTypedArray, Wp = za ? Yp(za) : Gp, vn = Wp, Zp = pp, Qp = V1, Jp = be, ef = mn, tf = Qs, rf = vn, nf = Object.prototype, af = nf.hasOwnProperty;
function of(e, t) {
  var r = Jp(e), n = !r && Qp(e), a = !r && !n && ef(e), i = !r && !n && !a && rf(e), o = r || n || a || i, s = o ? Zp(e.length, String) : [], c = s.length;
  for (var l in e)
    (t || af.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    tf(l, c))) && s.push(l);
  return s;
}
var sf = of, cf = Object.prototype;
function lf(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || cf;
  return e === r;
}
var Js = lf;
function uf(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var df = uf, pf = df, ff = pf(Object.keys, Object), mf = ff, vf = Js, gf = mf, hf = Object.prototype, Cf = hf.hasOwnProperty;
function _f(e) {
  if (!vf(e))
    return gf(e);
  var t = [];
  for (var r in Object(e))
    Cf.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var e2 = _f, Ef = sf, yf = e2, bf = Zr;
function wf(e) {
  return bf(e) ? Ef(e) : yf(e);
}
var gn = wf, Tf = ep, Sf = up, Af = gn;
function Rf(e) {
  return Tf(e, Af, Sf);
}
var If = Rf, Ga = If, Pf = 1, Lf = Object.prototype, Of = Lf.hasOwnProperty;
function Nf(e, t, r, n, a, i) {
  var o = r & Pf, s = Ga(e), c = s.length, l = Ga(t), u = l.length;
  if (c != u && !o)
    return !1;
  for (var d = c; d--; ) {
    var f = s[d];
    if (!(o ? f in t : Of.call(t, f)))
      return !1;
  }
  var h = i.get(e), v = i.get(t);
  if (h && v)
    return h == t && v == e;
  var p = !0;
  i.set(e, t), i.set(t, e);
  for (var g = o; ++d < c; ) {
    f = s[d];
    var _ = e[f], E = t[f];
    if (n)
      var y = o ? n(E, _, f, t, e, i) : n(_, E, f, e, t, i);
    if (!(y === void 0 ? _ === E || a(_, E, r, n, i) : y)) {
      p = !1;
      break;
    }
    g || (g = f == "constructor");
  }
  if (p && !g) {
    var w = e.constructor, T = t.constructor;
    w != T && "constructor" in e && "constructor" in t && !(typeof w == "function" && w instanceof w && typeof T == "function" && T instanceof T) && (p = !1);
  }
  return i.delete(e), i.delete(t), p;
}
var xf = Nf, kf = w1, Bf = gt, Uf = kf(Bf, "DataView"), Hf = Uf, Mf = w1, Vf = gt, Df = Mf(Vf, "Promise"), Ff = Df, Xf = w1, $f = gt, qf = Xf($f, "Set"), t2 = qf, jf = w1, Kf = gt, zf = jf(Kf, "WeakMap"), Gf = zf, Or = Hf, Nr = zi, xr = Ff, kr = t2, Br = Gf, r2 = b1, yt = e4, Ya = "[object Map]", Yf = "[object Object]", Wa = "[object Promise]", Za = "[object Set]", Qa = "[object WeakMap]", Ja = "[object DataView]", Wf = yt(Or), Zf = yt(Nr), Qf = yt(xr), Jf = yt(kr), em = yt(Br), ze = r2;
(Or && ze(new Or(new ArrayBuffer(1))) != Ja || Nr && ze(new Nr()) != Ya || xr && ze(xr.resolve()) != Wa || kr && ze(new kr()) != Za || Br && ze(new Br()) != Qa) && (ze = function(e) {
  var t = r2(e), r = t == Yf ? e.constructor : void 0, n = r ? yt(r) : "";
  if (n)
    switch (n) {
      case Wf:
        return Ja;
      case Zf:
        return Ya;
      case Qf:
        return Wa;
      case Jf:
        return Za;
      case em:
        return Qa;
    }
  return t;
});
var n2 = ze, ir = Ws, tm = Zs, rm = Wd, nm = xf, ei = n2, ti = be, ri = mn, am = vn, im = 1, ni = "[object Arguments]", ai = "[object Array]", e1 = "[object Object]", om = Object.prototype, ii = om.hasOwnProperty;
function sm(e, t, r, n, a, i) {
  var o = ti(e), s = ti(t), c = o ? ai : ei(e), l = s ? ai : ei(t);
  c = c == ni ? e1 : c, l = l == ni ? e1 : l;
  var u = c == e1, d = l == e1, f = c == l;
  if (f && ri(e)) {
    if (!ri(t))
      return !1;
    o = !0, u = !1;
  }
  if (f && !u)
    return i || (i = new ir()), o || am(e) ? tm(e, t, r, n, a, i) : rm(e, t, c, r, n, a, i);
  if (!(r & im)) {
    var h = u && ii.call(e, "__wrapped__"), v = d && ii.call(t, "__wrapped__");
    if (h || v) {
      var p = h ? e.value() : e, g = v ? t.value() : t;
      return i || (i = new ir()), a(p, g, r, n, i);
    }
  }
  return f ? (i || (i = new ir()), nm(e, t, r, n, a, i)) : !1;
}
var cm = sm, lm = cm, oi = $t;
function a2(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !oi(e) && !oi(t) ? e !== e && t !== t : lm(e, t, r, n, a2, a);
}
var i2 = a2, um = Ws, dm = i2, pm = 1, fm = 2;
function mm(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = r[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = r[a];
    var c = s[0], l = e[c], u = s[1];
    if (o && s[2]) {
      if (l === void 0 && !(c in e))
        return !1;
    } else {
      var d = new um();
      if (n)
        var f = n(l, u, c, e, t, d);
      if (!(f === void 0 ? dm(u, l, pm | fm, n, d) : f))
        return !1;
    }
  }
  return !0;
}
var vm = mm, gm = t4;
function hm(e) {
  return e === e && !gm(e);
}
var o2 = hm, Cm = o2, _m = gn;
function Em(e) {
  for (var t = _m(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, Cm(a)];
  }
  return t;
}
var ym = Em;
function bm(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var s2 = bm, wm = vm, Tm = ym, Sm = s2;
function Am(e) {
  var t = Tm(e);
  return t.length == 1 && t[0][2] ? Sm(t[0][0], t[0][1]) : function(r) {
    return r === e || wm(r, e, t);
  };
}
var Rm = Am, Im = b1, Pm = $t, Lm = "[object Symbol]";
function Om(e) {
  return typeof e == "symbol" || Pm(e) && Im(e) == Lm;
}
var hn = Om, Nm = be, xm = hn, km = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Bm = /^\w*$/;
function Um(e, t) {
  if (Nm(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || xm(e) ? !0 : Bm.test(e) || !km.test(e) || t != null && e in Object(t);
}
var Cn = Um, c2 = Gi, Hm = "Expected a function";
function _n(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Hm);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (_n.Cache || c2)(), r;
}
_n.Cache = c2;
var Mm = _n, Vm = Mm, Dm = 500;
function Fm(e) {
  var t = Vm(e, function(n) {
    return r.size === Dm && r.clear(), n;
  }), r = t.cache;
  return t;
}
var Xm = Fm, $m = Xm, qm = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, jm = /\\(\\)?/g, Km = $m(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(qm, function(r, n, a, i) {
    t.push(a ? i.replace(jm, "$1") : n || r);
  }), t;
}), zm = Km, si = Yr, Gm = $i, Ym = be, Wm = hn, Zm = 1 / 0, ci = si ? si.prototype : void 0, li = ci ? ci.toString : void 0;
function l2(e) {
  if (typeof e == "string")
    return e;
  if (Ym(e))
    return Gm(e, l2) + "";
  if (Wm(e))
    return li ? li.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Zm ? "-0" : t;
}
var Qm = l2, Jm = Qm;
function ev(e) {
  return e == null ? "" : Jm(e);
}
var tv = ev, rv = be, nv = Cn, av = zm, iv = tv;
function ov(e, t) {
  return rv(e) ? e : nv(e, t) ? [e] : av(iv(e));
}
var u2 = ov, sv = hn, cv = 1 / 0;
function lv(e) {
  if (typeof e == "string" || sv(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -cv ? "-0" : t;
}
var D1 = lv, uv = u2, dv = D1;
function pv(e, t) {
  t = uv(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[dv(t[r++])];
  return r && r == n ? e : void 0;
}
var d2 = pv, fv = d2;
function mv(e, t, r) {
  var n = e == null ? void 0 : fv(e, t);
  return n === void 0 ? r : n;
}
var vv = mv;
function gv(e, t) {
  return e != null && t in Object(e);
}
var hv = gv, Cv = u2, _v = V1, Ev = be, yv = Qs, bv = Yi, wv = D1;
function Tv(e, t, r) {
  t = Cv(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = wv(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && bv(a) && yv(o, a) && (Ev(e) || _v(e)));
}
var Sv = Tv, Av = hv, Rv = Sv;
function Iv(e, t) {
  return e != null && Rv(e, t, Av);
}
var Pv = Iv, Lv = i2, Ov = vv, Nv = Pv, xv = Cn, kv = o2, Bv = s2, Uv = D1, Hv = 1, Mv = 2;
function Vv(e, t) {
  return xv(e) && kv(t) ? Bv(Uv(e), t) : function(r) {
    var n = Ov(r, e);
    return n === void 0 && n === t ? Nv(r, e) : Lv(t, n, Hv | Mv);
  };
}
var Dv = Vv;
function Fv(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Xv = Fv, $v = d2;
function qv(e) {
  return function(t) {
    return $v(t, e);
  };
}
var jv = qv, Kv = Xv, zv = jv, Gv = Cn, Yv = D1;
function Wv(e) {
  return Gv(e) ? Kv(Yv(e)) : zv(e);
}
var Zv = Wv, Qv = Rm, Jv = Dv, eg = r4, tg = be, rg = Zv;
function ng(e) {
  return typeof e == "function" ? e : e == null ? eg : typeof e == "object" ? tg(e) ? Jv(e[0], e[1]) : Qv(e) : rg(e);
}
var p2 = ng;
function ag() {
}
var ig = ag, or = t2, og = ig, sg = fn, cg = 1 / 0, lg = or && 1 / sg(new or([, -0]))[1] == cg ? function(e) {
  return new or(e);
} : og, ug = lg, dg = zr, pg = ji, fg = Ki, mg = Gr, vg = ug, gg = fn, hg = 200;
function Cg(e, t, r) {
  var n = -1, a = pg, i = e.length, o = !0, s = [], c = s;
  if (r)
    o = !1, a = fg;
  else if (i >= hg) {
    var l = t ? null : vg(e);
    if (l)
      return gg(l);
    o = !1, a = mg, c = new dg();
  } else
    c = t ? [] : s;
  e:
    for (; ++n < i; ) {
      var u = e[n], d = t ? t(u) : u;
      if (u = r || u !== 0 ? u : 0, o && d === d) {
        for (var f = c.length; f--; )
          if (c[f] === d)
            continue e;
        t && c.push(d), s.push(u);
      } else a(c, d, r) || (c !== s && c.push(d), s.push(u));
    }
  return s;
}
var _g = Cg, Eg = p2, yg = _g;
function bg(e, t) {
  return e && e.length ? yg(e, Eg(t)) : [];
}
var wg = bg;
const Tg = /* @__PURE__ */ T1(wg), ui = async (e, t, r, n = 0) => (await e.get(`items/${t}`, {
  params: {
    limit: r,
    offset: n,
    tz: En()
  },
  withCredentials: !0
})).data.data || [], Sg = (e, t, r) => e.post("/create", r.map(({
  createdAt: n,
  entityUuid: a,
  expiresAt: i
}) => ({
  createdAt: n,
  entitySubType: "article",
  entityType: "node",
  entityUuid: a,
  expiresAt: i,
  itemType: "log",
  userUuid: t
})), {
  withCredentials: !0
}), Ag = (e, t, r) => e.post("/items/delete", {
  entityUuids: [t]
}, {
  params: {
    day: f2(r),
    tz: En()
  },
  withCredentials: !0
}), Rg = (e, t, r) => e.delete(`/items/${r}`, {
  params: {
    day: f2(t),
    tz: En()
  },
  withCredentials: !0
}), En = () => Intl.DateTimeFormat().resolvedOptions().timeZone, f2 = (e) => no(new Date(e), "yyyy-MM-dd"), sr = {
  lastSyncedDate: "userArticleReadingHistoryLastUpdate",
  pending: "userNewArticleReadingHistory",
  synced: "userArticleReadingHistory"
}, di = 50, at = (e) => no(e, "dd MMM yyyy"), Ig = () => {
  const {
    currentArticleUuid: e,
    user: t
  } = U(), {
    createReadingHistory: r,
    fetchReadingHistory: n,
    lastSyncedDate: a,
    resetLocalReadingHistory: i,
    syncReadingHistory: o
  } = yn();
  vt(async () => {
    await n();
  }), te(() => {
    t || i();
  }, [i, t]), te(() => {
    e && r(e);
  }, [r, e]), L0(() => {
    T4(/* @__PURE__ */ new Date(), new Date(a ?? 0)) < 1 || o();
  }, [o, e, a]);
}, Pg = () => {
  const {
    user: e
  } = U(), {
    pendingReadingHistory: t,
    syncedReadingHistory: r
  } = m2();
  return {
    readingHistory: Ye(() => e ? [...t ?? [], ...r ?? []].sort((i, o) => o.createdAt - i.createdAt) : [], [t, r, e])
  };
}, yn = () => {
  const {
    config: e,
    handleTrackGA4: t,
    user: r
  } = U(), n = Ye(() => jr.create({
    baseURL: e.readingHistory.host,
    headers: {
      apikey: e.readingHistory.apiKey
    }
  }), [e]), {
    lastSyncedDate: a,
    pendingReadingHistory: i,
    setLastSyncedDate: o,
    setPendingReadingHistory: s,
    setSyncedReadingHistory: c
  } = m2(), l = ue(async () => {
    if (!r || a) return;
    const p = await ui(n, r.uuid, di);
    c(p.map((g) => ({
      createdAt: new Date(g.createdAt).getTime(),
      entityUuid: g.entityUuid
    }))), o(Date.now());
  }, [n, a, o, c, r]), u = ue(async () => {
    if (!r || !i || i.length === 0) return;
    const p = i.map((g) => ({
      createdAt: new Date(g.createdAt),
      entityUuid: g.entityUuid,
      expiresAt: new Date(g.createdAt)
    }));
    await Sg(n, r.uuid, p);
    try {
      const g = await ui(n, r.uuid, di);
      c(g.map((_) => ({
        createdAt: new Date(_.createdAt).getTime(),
        entityUuid: _.entityUuid
      }))), o(Date.now());
    } catch {
      c((g) => [...i ?? [], ...g ?? []]);
    } finally {
      s([]);
    }
  }, [n, i, o, s, c, r]), d = ue((p) => {
    if (!r) return;
    const g = {
      createdAt: Date.now(),
      entityUuid: p
    };
    s((_) => Tg([g, ..._ ?? []], (y) => `${y.entityUuid}-${at(y.createdAt)}`)), c((_) => [..._ ?? []].filter((E) => !(E.entityUuid === g.entityUuid && at(E.createdAt) === at(g.createdAt))));
  }, [s, c, r]), f = ue(async (p) => {
    if (!r) return;
    const g = (_) => [..._ ?? []].filter((E) => at(E.createdAt) !== p);
    s(g), c(g), await Rg(n, p, r.uuid), t({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "clear"
      },
      subcategory: ""
    });
  }, [n, t, s, c, r]), h = ue(async (p, g) => {
    if (!r) return;
    const {
      entityId: _,
      entityUuid: E
    } = l1(Ks, p), y = (w) => [...w ?? []].filter((T) => !(T.entityUuid === E && T.createdAt === g));
    s(y), c(y), await Ag(n, E, at(g)), t({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "remove",
        article_id: _ ?? ""
      },
      subcategory: ""
    });
  }, [n, t, s, c, r]), v = ue(() => {
    s([]), c([]), o(0);
  }, [o, s, c]);
  return {
    clearReadingHistory: f,
    createReadingHistory: d,
    fetchReadingHistory: l,
    lastSyncedDate: a,
    removeReadingHistory: h,
    resetLocalReadingHistory: v,
    syncReadingHistory: u
  };
}, m2 = () => {
  const {
    set: e,
    value: t
  } = Oe(sr.pending), {
    set: r,
    value: n
  } = Oe(sr.synced), {
    set: a,
    value: i
  } = Oe(sr.lastSyncedDate);
  return {
    lastSyncedDate: i,
    pendingReadingHistory: t,
    setLastSyncedDate: a,
    setPendingReadingHistory: e,
    setSyncedReadingHistory: r,
    syncedReadingHistory: n
  };
}, Lg = () => {
  const e = Wi(), {
    readingHistory: t
  } = Pg(), r = O0(), n = E1(), [a, i] = Xt(async () => {
    const o = Wu(t.map((c) => c.entityUuid), [...r.keys()]);
    if (o.length > 0) {
      const c = js, l = {
        entityUuids: [...o],
        first: o.length,
        scmpPlusPaywallTypeIds: [C0.article.paywallTypeId]
      }, u = E0(c), d = y0(u, l), f = await Zi(e, c, l).toPromise();
      n.current = e.retain(d), f == null || f.articles.edges.forEach(({
        node: h
      }) => {
        r.set(h.entityUuid, h);
      });
    }
    return t.map((c) => {
      const l = r.get(c.entityUuid);
      if (l)
        return {
          ...c,
          article: l
        };
    }).filter(R0);
  }, []);
  return te(() => (i.execute(), () => {
    var o;
    (o = n.current) === null || o === void 0 || o.dispose();
  }), [i, t]), {
    state: a
  };
}, v2 = () => {
  const {
    set: e,
    value: t
  } = Oe("isFirstTimeVisitSCMPNotificationWidgetVersionTwo", {
    defaultValue: !0
  });
  return {
    isFirstTime: t,
    setIsFirstTime: e
  };
}, Og = (e) => /* @__PURE__ */ C.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0157 10.0393L20 18.9843L19.0629 20L10 10.9764L1.01571 20L0 18.9843L8.98429 10.0393L0 1.01571L1.01571 0L10 9.02357L19.0629 0L20 1.01571L11.0157 10.0393Z", fill: "#001246" })), Ng = (e) => /* @__PURE__ */ C.createElement("svg", { width: 32, height: 25, viewBox: "0 0 32 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 25H32V0H0V25Z", fill: "#FEFEFE" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.76069 22.2007H14.6138V2.79626H2.76019L2.76069 22.2007Z", fill: "#FFCA05" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3866 22.2007H29.2397V2.79626H17.3866V22.2007Z", fill: "#001246" })), xg = (e) => {
  const [t, r] = Xt(async () => {
    const a = await Promise.allSettled(e.map((i) => i()));
    for (const i of a)
      if (!(i.status === "rejected" || i.value === null))
        return i.value;
  });
  return Di(() => {
    r.execute();
  }, [e]), {
    message: t.status === "success" ? t.result : void 0
  };
}, g2 = {
  kind: "InlineDataFragment",
  name: "readingHistoryPanelArticle"
};
g2.hash = "af787a050af248c5e8bd042565039780";
var bn = {}, cr = {};
function kg(e) {
  return r3(e);
}
var Kt = {}, lr = { exports: {} }, pi;
function Bg() {
  return pi || (pi = 1, function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(r) {
        for (var n = 1; n < arguments.length; n++) {
          var a = arguments[n];
          for (var i in a) ({}).hasOwnProperty.call(a, i) && (r[i] = a[i]);
        }
        return r;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(null, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(lr)), lr.exports;
}
var ur = { exports: {} }, fi;
function Ug() {
  return fi || (fi = 1, function(e) {
    function t(r, n) {
      if (r == null) return {};
      var a = {};
      for (var i in r) if ({}.hasOwnProperty.call(r, i)) {
        if (n.indexOf(i) >= 0) continue;
        a[i] = r[i];
      }
      return a;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ur)), ur.exports;
}
const Hg = /* @__PURE__ */ Qe(wl), Mg = /* @__PURE__ */ Qe(Tl), Vg = /* @__PURE__ */ Qe(Sl), Dg = /* @__PURE__ */ Qe(Bl), Fg = /* @__PURE__ */ Qe(Al), Xg = /* @__PURE__ */ Qe(Ll);
var bt = Ee;
Object.defineProperty(Kt, "__esModule", {
  value: !0
});
var $g = Kt.default = rh;
Kt.shouldForwardProp = o1;
Kt.systemDefaultTheme = void 0;
var ge = bt(Bg()), Ur = bt(Ug()), mi = Wg(Hg), qg = Mg;
bt(Vg);
bt(Dg);
var jg = bt(Fg), Kg = bt(Xg);
const zg = ["ownerState"], Gg = ["variants"], Yg = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function h2(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (h2 = function(n) {
    return n ? r : t;
  })(e);
}
function Wg(e, t) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var r = h2(t);
  if (r && r.has(e)) return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e) if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
    var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
    o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
  }
  return n.default = e, r && r.set(e, n), n;
}
function Zg(e) {
  return Object.keys(e).length === 0;
}
function Qg(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function o1(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Jg = Kt.systemDefaultTheme = (0, jg.default)(), eh = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function t1({
  defaultTheme: e,
  theme: t,
  themeId: r
}) {
  return Zg(t) ? e : t[r] || t;
}
function th(e) {
  return e ? (t, r) => r[e] : null;
}
function s1(e, t) {
  let {
    ownerState: r
  } = t, n = (0, Ur.default)(t, zg);
  const a = typeof e == "function" ? e((0, ge.default)({
    ownerState: r
  }, n)) : e;
  if (Array.isArray(a))
    return a.flatMap((i) => s1(i, (0, ge.default)({
      ownerState: r
    }, n)));
  if (a && typeof a == "object" && Array.isArray(a.variants)) {
    const {
      variants: i = []
    } = a;
    let s = (0, Ur.default)(a, Gg);
    return i.forEach((c) => {
      let l = !0;
      typeof c.props == "function" ? l = c.props((0, ge.default)({
        ownerState: r
      }, n, r)) : Object.keys(c.props).forEach((u) => {
        (r == null ? void 0 : r[u]) !== c.props[u] && n[u] !== c.props[u] && (l = !1);
      }), l && (Array.isArray(s) || (s = [s]), s.push(typeof c.style == "function" ? c.style((0, ge.default)({
        ownerState: r
      }, n, r)) : c.style));
    }), s;
  }
  return a;
}
function rh(e = {}) {
  const {
    themeId: t,
    defaultTheme: r = Jg,
    rootShouldForwardProp: n = o1,
    slotShouldForwardProp: a = o1
  } = e, i = (o) => (0, Kg.default)((0, ge.default)({}, o, {
    theme: t1((0, ge.default)({}, o, {
      defaultTheme: r,
      themeId: t
    }))
  }));
  return i.__mui_systemSx = !0, (o, s = {}) => {
    (0, mi.internal_processStyles)(o, (T) => T.filter((S) => !(S != null && S.__mui_systemSx)));
    const {
      name: c,
      slot: l,
      skipVariantsResolver: u,
      skipSx: d,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: f = th(eh(l))
    } = s, h = (0, Ur.default)(s, Yg), v = u !== void 0 ? u : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      l && l !== "Root" && l !== "root" || !1
    ), p = d || !1;
    let g, _ = o1;
    l === "Root" || l === "root" ? _ = n : l ? _ = a : Qg(o) && (_ = void 0);
    const E = (0, mi.default)(o, (0, ge.default)({
      shouldForwardProp: _,
      label: g
    }, h)), y = (T) => typeof T == "function" && T.__emotion_real !== T || (0, qg.isPlainObject)(T) ? (S) => s1(T, (0, ge.default)({}, S, {
      theme: t1({
        theme: S.theme,
        defaultTheme: r,
        themeId: t
      })
    })) : T, w = (T, ...S) => {
      let A = y(T);
      const R = S ? S.map(y) : [];
      c && f && R.push((O) => {
        const P = t1((0, ge.default)({}, O, {
          defaultTheme: r,
          themeId: t
        }));
        if (!P.components || !P.components[c] || !P.components[c].styleOverrides)
          return null;
        const x = P.components[c].styleOverrides, k = {};
        return Object.entries(x).forEach(([N, B]) => {
          k[N] = s1(B, (0, ge.default)({}, O, {
            theme: P
          }));
        }), f(O, k);
      }), c && !v && R.push((O) => {
        var P;
        const x = t1((0, ge.default)({}, O, {
          defaultTheme: r,
          themeId: t
        })), k = x == null || (P = x.components) == null || (P = P[c]) == null ? void 0 : P.variants;
        return s1({
          variants: k
        }, (0, ge.default)({}, O, {
          theme: x
        }));
      }), p || R.push(i);
      const I = R.length - S.length;
      if (Array.isArray(T) && I > 0) {
        const O = new Array(I).fill("");
        A = [...T, ...O], A.raw = [...T.raw, ...O];
      }
      const L = E(A, ...R);
      return o.muiName && (L.muiName = o.muiName), L;
    };
    return E.withConfig && (w.withConfig = E.withConfig), w;
  };
}
function nh(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const ah = (e) => nh(e) && e !== "classes", ih = $g({
  themeId: v0,
  defaultTheme: g0,
  rootShouldForwardProp: ah
});
function oh(e) {
  return Eo("MuiSvgIcon", e);
}
Nl("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const sh = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], ch = (e) => {
  const {
    color: t,
    fontSize: r,
    classes: n
  } = e, a = {
    root: ["root", t !== "inherit" && `color${ot(t)}`, `fontSize${ot(r)}`]
  };
  return rn(a, oh, n);
}, lh = ih("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "inherit" && t[`color${ot(r.color)}`], t[`fontSize${ot(r.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n, a, i, o, s, c, l, u, d, f, h, v;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (r = e.transitions) == null || (n = r.create) == null ? void 0 : n.call(r, "fill", {
      duration: (a = e.transitions) == null || (a = a.duration) == null ? void 0 : a.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((i = e.typography) == null || (o = i.pxToRem) == null ? void 0 : o.call(i, 20)) || "1.25rem",
      medium: ((s = e.typography) == null || (c = s.pxToRem) == null ? void 0 : c.call(s, 24)) || "1.5rem",
      large: ((l = e.typography) == null || (u = l.pxToRem) == null ? void 0 : u.call(l, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (d = (f = (e.vars || e).palette) == null || (f = f[t.color]) == null ? void 0 : f.main) != null ? d : {
      action: (h = (e.vars || e).palette) == null || (h = h.action) == null ? void 0 : h.active,
      disabled: (v = (e.vars || e).palette) == null || (v = v.action) == null ? void 0 : v.disabled,
      inherit: void 0
    }[t.color]
  };
}), Hr = /* @__PURE__ */ C.forwardRef(function(t, r) {
  const n = kg({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: a,
    className: i,
    color: o = "inherit",
    component: s = "svg",
    fontSize: c = "medium",
    htmlColor: l,
    inheritViewBox: u = !1,
    titleAccess: d,
    viewBox: f = "0 0 24 24"
  } = n, h = mt(n, sh), v = /* @__PURE__ */ C.isValidElement(a) && a.type === "svg", p = F({}, n, {
    color: o,
    component: s,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: u,
    viewBox: f,
    hasSvgAsChild: v
  }), g = {};
  u || (g.viewBox = f);
  const _ = ch(p);
  return /* @__PURE__ */ ie.jsxs(lh, F({
    as: s,
    className: Cr(_.root, i),
    focusable: "false",
    color: l,
    "aria-hidden": d ? void 0 : !0,
    role: d ? "img" : void 0,
    ref: r
  }, g, h, v && a.props, {
    ownerState: p,
    children: [v ? a.props.children : a, d ? /* @__PURE__ */ ie.jsx("title", {
      children: d
    }) : null]
  }));
});
Hr.muiName = "SvgIcon";
function uh(e, t) {
  function r(n, a) {
    return /* @__PURE__ */ ie.jsx(Hr, F({
      "data-testid": `${t}Icon`,
      ref: a
    }, n, {
      children: e
    }));
  }
  return r.muiName = Hr.muiName, /* @__PURE__ */ C.memo(/* @__PURE__ */ C.forwardRef(r));
}
const dh = {
  configure: (e) => {
    ho.configure(e);
  }
}, ph = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: ot,
  createChainedFunction: Ul,
  createSvgIcon: uh,
  debounce: Hl,
  deprecatedPropType: Ml,
  isMuiElement: Vl,
  ownerDocument: f1,
  ownerWindow: Dl,
  requirePropFactory: Fl,
  setRef: dr,
  unstable_ClassNameGenerator: dh,
  unstable_useEnhancedEffect: lt,
  unstable_useId: $l,
  unsupportedProp: ql,
  useControlled: wo,
  useEventCallback: Kl,
  useForkRef: st,
  useIsFocusVisible: To
}, Symbol.toStringTag, { value: "Module" })), fh = /* @__PURE__ */ Qe(ph);
var vi;
function mh() {
  return vi || (vi = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = fh;
  }(cr)), cr;
}
var vh = Ee;
Object.defineProperty(bn, "__esModule", {
  value: !0
});
var C2 = bn.default = void 0, gh = vh(mh()), hh = ie;
C2 = bn.default = (0, gh.default)(/* @__PURE__ */ (0, hh.jsx)("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreHoriz");
var gi = n4;
function Ch(e, t, r) {
  t == "__proto__" && gi ? gi(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var _h = Ch;
function Eh(e, t, r, n) {
  for (var a = -1, i = e == null ? 0 : e.length; ++a < i; ) {
    var o = e[a];
    t(n, o, r(o), e);
  }
  return n;
}
var yh = Eh;
function bh(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var c = o[e ? s : ++a];
      if (r(i[c], c, i) === !1)
        break;
    }
    return t;
  };
}
var wh = bh, Th = wh, Sh = Th(), Ah = Sh, Rh = Ah, Ih = gn;
function Ph(e, t) {
  return e && Rh(e, t, Ih);
}
var Lh = Ph, Oh = Zr;
function Nh(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!Oh(r))
      return e(r, n);
    for (var a = r.length, i = t ? a : -1, o = Object(r); (t ? i-- : ++i < a) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var xh = Nh, kh = Lh, Bh = xh, Uh = Bh(kh), Hh = Uh, Mh = Hh;
function Vh(e, t, r, n) {
  return Mh(e, function(a, i, o) {
    t(n, a, r(a), o);
  }), n;
}
var Dh = Vh, Fh = yh, Xh = Dh, $h = p2, qh = be;
function jh(e, t) {
  return function(r, n) {
    var a = qh(r) ? Fh : Xh, i = t ? t() : {};
    return a(r, e, $h(n), i);
  };
}
var Kh = jh, zh = _h, Gh = Kh, Yh = Object.prototype, Wh = Yh.hasOwnProperty, Zh = Gh(function(e, t, r) {
  Wh.call(e, r) ? e[r].push(t) : zh(e, r, [t]);
}), Qh = Zh;
const Jh = /* @__PURE__ */ T1(Qh), _2 = {
  kind: "InlineDataFragment",
  name: "readingHistoryActionMenuBookmarkButtonArticle"
};
_2.hash = "a7c80ae823596510ff3e2edc0684d236";
const E2 = {
  kind: "InlineDataFragment",
  name: "readingHistoryActionMenuSocialButtonArticle"
};
E2.hash = "f4c88864c5a03b3f32c07b9080058e99";
const eC = () => {
  const {
    bookmark: e
  } = U(), t = ue(({
    entityId: n
  }) => e.check({
    entityId: n
  }), [e]);
  return {
    bindBookmarkButton: ue(({
      entityId: n,
      trackings: a
    }, i) => ({
      isBookmarked: t({
        entityId: n
      }),
      onClick: (c) => {
        e.update({
          action: c,
          entityId: n,
          trackings: a
        }), i == null || i();
      }
    }), [e, t]),
    checkIsBookmarked: t
  };
}, tC = (e) => /* @__PURE__ */ C.createElement("svg", { width: "16px", height: "18px", viewBox: "0 0 16 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ C.createElement("defs", null, /* @__PURE__ */ C.createElement("filter", { id: "filter-1" }, /* @__PURE__ */ C.createElement("feColorMatrix", { in: "SourceGraphic", type: "matrix", values: "0 0 0 0 0.000000 0 0 0 0 0.070588 0 0 0 0 0.274510 0 0 0 1.000000 0" }))), /* @__PURE__ */ C.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ C.createElement("g", { id: "icon_savearticle", transform: "translate(-306.000000, -22.000000)" }, /* @__PURE__ */ C.createElement("g", { transform: "translate(306.000000, 22.000000)", fill: "#4585FF", id: "Fill-14" }, /* @__PURE__ */ C.createElement("path", { d: "M14.8618719,3.16414286 C14.8618719,2.62542857 14.6777537,2.15678571 14.3101478,1.75757143 C13.9425419,1.35964286 13.5055764,1.16035714 12.9998818,1.16035714 L3.00011823,1.16035714 C2.49442365,1.16035714 2.05682759,1.35964286 1.68922167,1.75757143 C1.32161576,2.15678571 1.13749754,2.62542857 1.13749754,3.16414286 L1.13749754,16.1016429 L8.06904433,11.5662857 L14.8618719,16.0662857 L14.8618719,3.16414286 Z M15.1374187,0.914142857 C15.7124729,1.52357143 16,2.26221429 16,3.12878571 L16,18 L8.06904433,12.7967143 L0,18 L0,3.12878571 C0,2.26221429 0.287527094,1.52357143 0.861950739,0.914142857 C1.43637438,0.305357143 2.12618719,0 2.93075862,0 L13.0686108,0 C13.8738128,0 14.5629951,0.305357143 15.1374187,0.914142857 L15.1374187,0.914142857 Z" }))))), rC = (e) => /* @__PURE__ */ C.createElement("svg", { width: "25px", height: "28px", viewBox: "0 0 25 28", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ C.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ C.createElement("g", { id: "icons_bookmarks-copy", transform: "translate(-272.000000, -439.000000)" }, /* @__PURE__ */ C.createElement("g", { id: "icon_bookmark_desktop_on", transform: "translate(272.000000, 439.000000)" }, /* @__PURE__ */ C.createElement("path", { d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z", id: "Path", fill: "#4585FF", opacity: 0.30392674 }), /* @__PURE__ */ C.createElement("path", { d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z M23.6522167,1.422 C24.5507389,2.37 25,3.519 25,4.867 L25,28 L12.6078818,19.906 L0,28 L0,4.867 C0,3.519 0.449261084,2.37 1.34679803,1.422 C2.24433498,0.475 3.32216749,0 4.57931034,0 L20.4197044,0 C21.6778325,0 22.7546798,0.475 23.6522167,1.422 L23.6522167,1.422 Z", id: "Fill-14", fill: "#4585ff" }))))), nC = /* @__PURE__ */ b("button", {
  target: "e1wwhs9u2"
})({
  name: "6o7kh4",
  styles: "display:flex;justify-content:center;align-items:center;inline-size:30px;block-size:30px;padding:7.5px;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer"
}), y2 = {
  name: "16o2qwc",
  styles: "inline-size:100%;block-size:100%"
}, aC = /* @__PURE__ */ b(tC, {
  target: "e1wwhs9u1"
})(y2, ";"), iC = /* @__PURE__ */ b(rC, {
  target: "e1wwhs9u0"
})(y2, ";"), b2 = ({
  className: e,
  isBookmarked: t,
  onClick: r
}) => {
  const n = (a) => {
    r == null || r(t ? "unbookmark" : "bookmark", a);
  };
  return /* @__PURE__ */ m.createElement(nC, {
    "aria-label": t ? "unbookmark" : "bookmark",
    className: e,
    onClick: n,
    "data-qa": "bookmark-button"
  }, t ? /* @__PURE__ */ m.createElement(iC, null) : /* @__PURE__ */ m.createElement(aC, null));
};
b2.displayName = "BookmarkButton";
var se = "top", Ce = "bottom", _e = "right", ce = "left", wn = "auto", zt = [se, Ce, _e, ce], ut = "start", Vt = "end", oC = "clippingParents", w2 = "viewport", Rt = "popper", sC = "reference", hi = /* @__PURE__ */ zt.reduce(function(e, t) {
  return e.concat([t + "-" + ut, t + "-" + Vt]);
}, []), T2 = /* @__PURE__ */ [].concat(zt, [wn]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ut, t + "-" + Vt]);
}, []), cC = "beforeRead", lC = "read", uC = "afterRead", dC = "beforeMain", pC = "main", fC = "afterMain", mC = "beforeWrite", vC = "write", gC = "afterWrite", hC = [cC, lC, uC, dC, pC, fC, mC, vC, gC];
function Ie(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function me(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function We(e) {
  var t = me(e).Element;
  return e instanceof t || e instanceof Element;
}
function he(e) {
  var t = me(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Tn(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = me(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function CC(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, i = t.elements[r];
    !he(i) || !Ie(i) || (Object.assign(i.style, n), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function _C(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), s = o.reduce(function(c, l) {
        return c[l] = "", c;
      }, {});
      !he(a) || !Ie(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(c) {
        a.removeAttribute(c);
      }));
    });
  };
}
const EC = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: CC,
  effect: _C,
  requires: ["computeStyles"]
};
function Re(e) {
  return e.split("-")[0];
}
var Ge = Math.max, C1 = Math.min, dt = Math.round;
function Mr() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function S2() {
  return !/^((?!chrome|android).)*safari/i.test(Mr());
}
function pt(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), a = 1, i = 1;
  t && he(e) && (a = e.offsetWidth > 0 && dt(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && dt(n.height) / e.offsetHeight || 1);
  var o = We(e) ? me(e) : window, s = o.visualViewport, c = !S2() && r, l = (n.left + (c && s ? s.offsetLeft : 0)) / a, u = (n.top + (c && s ? s.offsetTop : 0)) / i, d = n.width / a, f = n.height / i;
  return {
    width: d,
    height: f,
    top: u,
    right: l + d,
    bottom: u + f,
    left: l,
    x: l,
    y: u
  };
}
function Sn(e) {
  var t = pt(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function A2(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Tn(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Ne(e) {
  return me(e).getComputedStyle(e);
}
function yC(e) {
  return ["table", "td", "th"].indexOf(Ie(e)) >= 0;
}
function Xe(e) {
  return ((We(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function F1(e) {
  return Ie(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Tn(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Xe(e)
  );
}
function Ci(e) {
  return !he(e) || // https://github.com/popperjs/popper-core/issues/837
  Ne(e).position === "fixed" ? null : e.offsetParent;
}
function bC(e) {
  var t = /firefox/i.test(Mr()), r = /Trident/i.test(Mr());
  if (r && he(e)) {
    var n = Ne(e);
    if (n.position === "fixed")
      return null;
  }
  var a = F1(e);
  for (Tn(a) && (a = a.host); he(a) && ["html", "body"].indexOf(Ie(a)) < 0; ) {
    var i = Ne(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Gt(e) {
  for (var t = me(e), r = Ci(e); r && yC(r) && Ne(r).position === "static"; )
    r = Ci(r);
  return r && (Ie(r) === "html" || Ie(r) === "body" && Ne(r).position === "static") ? t : r || bC(e) || t;
}
function An(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Nt(e, t, r) {
  return Ge(e, C1(t, r));
}
function wC(e, t, r) {
  var n = Nt(e, t, r);
  return n > r ? r : n;
}
function R2() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function I2(e) {
  return Object.assign({}, R2(), e);
}
function P2(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var TC = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, I2(typeof t != "number" ? t : P2(t, zt));
};
function SC(e) {
  var t, r = e.state, n = e.name, a = e.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, s = Re(r.placement), c = An(s), l = [ce, _e].indexOf(s) >= 0, u = l ? "height" : "width";
  if (!(!i || !o)) {
    var d = TC(a.padding, r), f = Sn(i), h = c === "y" ? se : ce, v = c === "y" ? Ce : _e, p = r.rects.reference[u] + r.rects.reference[c] - o[c] - r.rects.popper[u], g = o[c] - r.rects.reference[c], _ = Gt(i), E = _ ? c === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, y = p / 2 - g / 2, w = d[h], T = E - f[u] - d[v], S = E / 2 - f[u] / 2 + y, A = Nt(w, S, T), R = c;
    r.modifiersData[n] = (t = {}, t[R] = A, t.centerOffset = A - S, t);
  }
}
function AC(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || A2(t.elements.popper, a) && (t.elements.arrow = a));
}
const RC = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: SC,
  effect: AC,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ft(e) {
  return e.split("-")[1];
}
var IC = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function PC(e, t) {
  var r = e.x, n = e.y, a = t.devicePixelRatio || 1;
  return {
    x: dt(r * a) / a || 0,
    y: dt(n * a) / a || 0
  };
}
function _i(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, s = e.position, c = e.gpuAcceleration, l = e.adaptive, u = e.roundOffsets, d = e.isFixed, f = o.x, h = f === void 0 ? 0 : f, v = o.y, p = v === void 0 ? 0 : v, g = typeof u == "function" ? u({
    x: h,
    y: p
  }) : {
    x: h,
    y: p
  };
  h = g.x, p = g.y;
  var _ = o.hasOwnProperty("x"), E = o.hasOwnProperty("y"), y = ce, w = se, T = window;
  if (l) {
    var S = Gt(r), A = "clientHeight", R = "clientWidth";
    if (S === me(r) && (S = Xe(r), Ne(S).position !== "static" && s === "absolute" && (A = "scrollHeight", R = "scrollWidth")), S = S, a === se || (a === ce || a === _e) && i === Vt) {
      w = Ce;
      var I = d && S === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        S[A]
      );
      p -= I - n.height, p *= c ? 1 : -1;
    }
    if (a === ce || (a === se || a === Ce) && i === Vt) {
      y = _e;
      var L = d && S === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        S[R]
      );
      h -= L - n.width, h *= c ? 1 : -1;
    }
  }
  var O = Object.assign({
    position: s
  }, l && IC), P = u === !0 ? PC({
    x: h,
    y: p
  }, me(r)) : {
    x: h,
    y: p
  };
  if (h = P.x, p = P.y, c) {
    var x;
    return Object.assign({}, O, (x = {}, x[w] = E ? "0" : "", x[y] = _ ? "0" : "", x.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + p + "px)" : "translate3d(" + h + "px, " + p + "px, 0)", x));
  }
  return Object.assign({}, O, (t = {}, t[w] = E ? p + "px" : "", t[y] = _ ? h + "px" : "", t.transform = "", t));
}
function LC(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, i = r.adaptive, o = i === void 0 ? !0 : i, s = r.roundOffsets, c = s === void 0 ? !0 : s, l = {
    placement: Re(t.placement),
    variation: ft(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, _i(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, _i(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const OC = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: LC,
  data: {}
};
var r1 = {
  passive: !0
};
function NC(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, i = a === void 0 ? !0 : a, o = n.resize, s = o === void 0 ? !0 : o, c = me(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && l.forEach(function(u) {
    u.addEventListener("scroll", r.update, r1);
  }), s && c.addEventListener("resize", r.update, r1), function() {
    i && l.forEach(function(u) {
      u.removeEventListener("scroll", r.update, r1);
    }), s && c.removeEventListener("resize", r.update, r1);
  };
}
const xC = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: NC,
  data: {}
};
var kC = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function c1(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return kC[t];
  });
}
var BC = {
  start: "end",
  end: "start"
};
function Ei(e) {
  return e.replace(/start|end/g, function(t) {
    return BC[t];
  });
}
function Rn(e) {
  var t = me(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function In(e) {
  return pt(Xe(e)).left + Rn(e).scrollLeft;
}
function UC(e, t) {
  var r = me(e), n = Xe(e), a = r.visualViewport, i = n.clientWidth, o = n.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    var l = S2();
    (l || !l && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + In(e),
    y: c
  };
}
function HC(e) {
  var t, r = Xe(e), n = Rn(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = Ge(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = Ge(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -n.scrollLeft + In(e), c = -n.scrollTop;
  return Ne(a || r).direction === "rtl" && (s += Ge(r.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: c
  };
}
function Pn(e) {
  var t = Ne(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function L2(e) {
  return ["html", "body", "#document"].indexOf(Ie(e)) >= 0 ? e.ownerDocument.body : he(e) && Pn(e) ? e : L2(F1(e));
}
function xt(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = L2(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = me(n), o = a ? [i].concat(i.visualViewport || [], Pn(n) ? n : []) : n, s = t.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(xt(F1(o)))
  );
}
function Vr(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function MC(e, t) {
  var r = pt(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function yi(e, t, r) {
  return t === w2 ? Vr(UC(e, r)) : We(t) ? MC(t, r) : Vr(HC(Xe(e)));
}
function VC(e) {
  var t = xt(F1(e)), r = ["absolute", "fixed"].indexOf(Ne(e).position) >= 0, n = r && he(e) ? Gt(e) : e;
  return We(n) ? t.filter(function(a) {
    return We(a) && A2(a, n) && Ie(a) !== "body";
  }) : [];
}
function DC(e, t, r, n) {
  var a = t === "clippingParents" ? VC(e) : [].concat(t), i = [].concat(a, [r]), o = i[0], s = i.reduce(function(c, l) {
    var u = yi(e, l, n);
    return c.top = Ge(u.top, c.top), c.right = C1(u.right, c.right), c.bottom = C1(u.bottom, c.bottom), c.left = Ge(u.left, c.left), c;
  }, yi(e, o, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function O2(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? Re(n) : null, i = n ? ft(n) : null, o = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, c;
  switch (a) {
    case se:
      c = {
        x: o,
        y: t.y - r.height
      };
      break;
    case Ce:
      c = {
        x: o,
        y: t.y + t.height
      };
      break;
    case _e:
      c = {
        x: t.x + t.width,
        y: s
      };
      break;
    case ce:
      c = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var l = a ? An(a) : null;
  if (l != null) {
    var u = l === "y" ? "height" : "width";
    switch (i) {
      case ut:
        c[l] = c[l] - (t[u] / 2 - r[u] / 2);
        break;
      case Vt:
        c[l] = c[l] + (t[u] / 2 - r[u] / 2);
        break;
    }
  }
  return c;
}
function Dt(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, i = r.strategy, o = i === void 0 ? e.strategy : i, s = r.boundary, c = s === void 0 ? oC : s, l = r.rootBoundary, u = l === void 0 ? w2 : l, d = r.elementContext, f = d === void 0 ? Rt : d, h = r.altBoundary, v = h === void 0 ? !1 : h, p = r.padding, g = p === void 0 ? 0 : p, _ = I2(typeof g != "number" ? g : P2(g, zt)), E = f === Rt ? sC : Rt, y = e.rects.popper, w = e.elements[v ? E : f], T = DC(We(w) ? w : w.contextElement || Xe(e.elements.popper), c, u, o), S = pt(e.elements.reference), A = O2({
    reference: S,
    element: y,
    strategy: "absolute",
    placement: a
  }), R = Vr(Object.assign({}, y, A)), I = f === Rt ? R : S, L = {
    top: T.top - I.top + _.top,
    bottom: I.bottom - T.bottom + _.bottom,
    left: T.left - I.left + _.left,
    right: I.right - T.right + _.right
  }, O = e.modifiersData.offset;
  if (f === Rt && O) {
    var P = O[a];
    Object.keys(L).forEach(function(x) {
      var k = [_e, Ce].indexOf(x) >= 0 ? 1 : -1, N = [se, Ce].indexOf(x) >= 0 ? "y" : "x";
      L[x] += P[N] * k;
    });
  }
  return L;
}
function FC(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, i = r.rootBoundary, o = r.padding, s = r.flipVariations, c = r.allowedAutoPlacements, l = c === void 0 ? T2 : c, u = ft(n), d = u ? s ? hi : hi.filter(function(v) {
    return ft(v) === u;
  }) : zt, f = d.filter(function(v) {
    return l.indexOf(v) >= 0;
  });
  f.length === 0 && (f = d);
  var h = f.reduce(function(v, p) {
    return v[p] = Dt(e, {
      placement: p,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[Re(p)], v;
  }, {});
  return Object.keys(h).sort(function(v, p) {
    return h[v] - h[p];
  });
}
function XC(e) {
  if (Re(e) === wn)
    return [];
  var t = c1(e);
  return [Ei(e), t, Ei(t)];
}
function $C(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !0 : o, c = r.fallbackPlacements, l = r.padding, u = r.boundary, d = r.rootBoundary, f = r.altBoundary, h = r.flipVariations, v = h === void 0 ? !0 : h, p = r.allowedAutoPlacements, g = t.options.placement, _ = Re(g), E = _ === g, y = c || (E || !v ? [c1(g)] : XC(g)), w = [g].concat(y).reduce(function(Z, G) {
      return Z.concat(Re(G) === wn ? FC(t, {
        placement: G,
        boundary: u,
        rootBoundary: d,
        padding: l,
        flipVariations: v,
        allowedAutoPlacements: p
      }) : G);
    }, []), T = t.rects.reference, S = t.rects.popper, A = /* @__PURE__ */ new Map(), R = !0, I = w[0], L = 0; L < w.length; L++) {
      var O = w[L], P = Re(O), x = ft(O) === ut, k = [se, Ce].indexOf(P) >= 0, N = k ? "width" : "height", B = Dt(t, {
        placement: O,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: l
      }), H = k ? x ? _e : ce : x ? Ce : se;
      T[N] > S[N] && (H = c1(H));
      var K = c1(H), X = [];
      if (i && X.push(B[P] <= 0), s && X.push(B[H] <= 0, B[K] <= 0), X.every(function(Z) {
        return Z;
      })) {
        I = O, R = !1;
        break;
      }
      A.set(O, X);
    }
    if (R)
      for (var Y = v ? 3 : 1, $ = function(G) {
        var re = w.find(function(ke) {
          var oe = A.get(ke);
          if (oe)
            return oe.slice(0, G).every(function(ne) {
              return ne;
            });
        });
        if (re)
          return I = re, "break";
      }, q = Y; q > 0; q--) {
        var z = $(q);
        if (z === "break") break;
      }
    t.placement !== I && (t.modifiersData[n]._skip = !0, t.placement = I, t.reset = !0);
  }
}
const qC = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: $C,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function bi(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function wi(e) {
  return [se, _e, Ce, ce].some(function(t) {
    return e[t] >= 0;
  });
}
function jC(e) {
  var t = e.state, r = e.name, n = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = Dt(t, {
    elementContext: "reference"
  }), s = Dt(t, {
    altBoundary: !0
  }), c = bi(o, n), l = bi(s, a, i), u = wi(c), d = wi(l);
  t.modifiersData[r] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const KC = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: jC
};
function zC(e, t, r) {
  var n = Re(e), a = [ce, se].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [ce, _e].indexOf(n) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function GC(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, i = a === void 0 ? [0, 0] : a, o = T2.reduce(function(u, d) {
    return u[d] = zC(d, t.rects, i), u;
  }, {}), s = o[t.placement], c = s.x, l = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += l), t.modifiersData[n] = o;
}
const YC = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: GC
};
function WC(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = O2({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const ZC = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: WC,
  data: {}
};
function QC(e) {
  return e === "x" ? "y" : "x";
}
function JC(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !1 : o, c = r.boundary, l = r.rootBoundary, u = r.altBoundary, d = r.padding, f = r.tether, h = f === void 0 ? !0 : f, v = r.tetherOffset, p = v === void 0 ? 0 : v, g = Dt(t, {
    boundary: c,
    rootBoundary: l,
    padding: d,
    altBoundary: u
  }), _ = Re(t.placement), E = ft(t.placement), y = !E, w = An(_), T = QC(w), S = t.modifiersData.popperOffsets, A = t.rects.reference, R = t.rects.popper, I = typeof p == "function" ? p(Object.assign({}, t.rects, {
    placement: t.placement
  })) : p, L = typeof I == "number" ? {
    mainAxis: I,
    altAxis: I
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, I), O = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, P = {
    x: 0,
    y: 0
  };
  if (S) {
    if (i) {
      var x, k = w === "y" ? se : ce, N = w === "y" ? Ce : _e, B = w === "y" ? "height" : "width", H = S[w], K = H + g[k], X = H - g[N], Y = h ? -R[B] / 2 : 0, $ = E === ut ? A[B] : R[B], q = E === ut ? -R[B] : -A[B], z = t.elements.arrow, Z = h && z ? Sn(z) : {
        width: 0,
        height: 0
      }, G = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : R2(), re = G[k], ke = G[N], oe = Nt(0, A[B], Z[B]), ne = y ? A[B] / 2 - Y - oe - re - L.mainAxis : $ - oe - re - L.mainAxis, Be = y ? -A[B] / 2 + Y + oe + ke + L.mainAxis : q + oe + ke + L.mainAxis, X1 = t.elements.arrow && Gt(t.elements.arrow), G2 = X1 ? w === "y" ? X1.clientTop || 0 : X1.clientLeft || 0 : 0, On = (x = O == null ? void 0 : O[w]) != null ? x : 0, Y2 = H + ne - On - G2, W2 = H + Be - On, Nn = Nt(h ? C1(K, Y2) : K, H, h ? Ge(X, W2) : X);
      S[w] = Nn, P[w] = Nn - H;
    }
    if (s) {
      var xn, Z2 = w === "x" ? se : ce, Q2 = w === "x" ? Ce : _e, $e = S[T], Yt = T === "y" ? "height" : "width", kn = $e + g[Z2], Bn = $e - g[Q2], $1 = [se, ce].indexOf(_) !== -1, Un = (xn = O == null ? void 0 : O[T]) != null ? xn : 0, Hn = $1 ? kn : $e - A[Yt] - R[Yt] - Un + L.altAxis, Mn = $1 ? $e + A[Yt] + R[Yt] - Un - L.altAxis : Bn, Vn = h && $1 ? wC(Hn, $e, Mn) : Nt(h ? Hn : kn, $e, h ? Mn : Bn);
      S[T] = Vn, P[T] = Vn - $e;
    }
    t.modifiersData[n] = P;
  }
}
const e_ = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: JC,
  requiresIfExists: ["offset"]
};
function t_(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function r_(e) {
  return e === me(e) || !he(e) ? Rn(e) : t_(e);
}
function n_(e) {
  var t = e.getBoundingClientRect(), r = dt(t.width) / e.offsetWidth || 1, n = dt(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function a_(e, t, r) {
  r === void 0 && (r = !1);
  var n = he(t), a = he(t) && n_(t), i = Xe(t), o = pt(e, a, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Ie(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Pn(i)) && (s = r_(t)), he(t) ? (c = pt(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = In(i))), {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function i_(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!r.has(s)) {
        var c = t.get(s);
        c && a(c);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || a(i);
  }), n;
}
function o_(e) {
  var t = i_(e);
  return hC.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function s_(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function c_(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Ti = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Si() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function l_(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, i = a === void 0 ? Ti : a;
  return function(s, c, l) {
    l === void 0 && (l = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ti, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: c
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, h = {
      state: u,
      setOptions: function(_) {
        var E = typeof _ == "function" ? _(u.options) : _;
        p(), u.options = Object.assign({}, i, u.options, E), u.scrollParents = {
          reference: We(s) ? xt(s) : s.contextElement ? xt(s.contextElement) : [],
          popper: xt(c)
        };
        var y = o_(c_([].concat(n, u.options.modifiers)));
        return u.orderedModifiers = y.filter(function(w) {
          return w.enabled;
        }), v(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var _ = u.elements, E = _.reference, y = _.popper;
          if (Si(E, y)) {
            u.rects = {
              reference: a_(E, Gt(y), u.options.strategy === "fixed"),
              popper: Sn(y)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(L) {
              return u.modifiersData[L.name] = Object.assign({}, L.data);
            });
            for (var w = 0; w < u.orderedModifiers.length; w++) {
              if (u.reset === !0) {
                u.reset = !1, w = -1;
                continue;
              }
              var T = u.orderedModifiers[w], S = T.fn, A = T.options, R = A === void 0 ? {} : A, I = T.name;
              typeof S == "function" && (u = S({
                state: u,
                options: R,
                name: I,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: s_(function() {
        return new Promise(function(g) {
          h.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        p(), f = !0;
      }
    };
    if (!Si(s, c))
      return h;
    h.setOptions(l).then(function(g) {
      !f && l.onFirstUpdate && l.onFirstUpdate(g);
    });
    function v() {
      u.orderedModifiers.forEach(function(g) {
        var _ = g.name, E = g.options, y = E === void 0 ? {} : E, w = g.effect;
        if (typeof w == "function") {
          var T = w({
            state: u,
            name: _,
            instance: h,
            options: y
          }), S = function() {
          };
          d.push(T || S);
        }
      });
    }
    function p() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return h;
  };
}
var u_ = [xC, ZC, OC, EC, YC, qC, e_, RC, KC], d_ = /* @__PURE__ */ l_({
  defaultModifiers: u_
});
function p_(e) {
  return typeof e == "function" ? e() : e;
}
const f_ = /* @__PURE__ */ C.forwardRef(function(t, r) {
  const {
    children: n,
    container: a,
    disablePortal: i = !1
  } = t, [o, s] = C.useState(null), c = st(/* @__PURE__ */ C.isValidElement(n) ? n.ref : null, r);
  if (lt(() => {
    i || s(p_(a) || document.body);
  }, [a, i]), lt(() => {
    if (o && !i)
      return dr(r, o), () => {
        dr(r, null);
      };
  }, [r, o, i]), i) {
    if (/* @__PURE__ */ C.isValidElement(n)) {
      const l = {
        ref: c
      };
      return /* @__PURE__ */ C.cloneElement(n, l);
    }
    return /* @__PURE__ */ ie.jsx(C.Fragment, {
      children: n
    });
  }
  return /* @__PURE__ */ ie.jsx(C.Fragment, {
    children: o && /* @__PURE__ */ C4.createPortal(n, o)
  });
}), N2 = "base";
function m_(e) {
  return `${N2}--${e}`;
}
function v_(e, t) {
  return `${N2}-${e}-${t}`;
}
function Ln(e, t) {
  const r = _o[t];
  return r ? m_(r) : v_(e, t);
}
function x2(e, t) {
  const r = {};
  return t.forEach((n) => {
    r[n] = Ln(e, n);
  }), r;
}
const k2 = "Popper";
function g_(e) {
  return Ln(k2, e);
}
x2(k2, ["root"]);
function h_(e) {
  return typeof e == "string";
}
function C_(e, t, r) {
  return e === void 0 || h_(e) ? t : F({}, t, {
    ownerState: F({}, t.ownerState, r)
  });
}
const __ = {
  disableDefaultClasses: !1
}, E_ = /* @__PURE__ */ C.createContext(__);
function B2(e) {
  const {
    disableDefaultClasses: t
  } = C.useContext(E_);
  return (r) => t ? "" : e(r);
}
function y_(e, t = []) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    r[n] = e[n];
  }), r;
}
function b_(e, t, r) {
  return typeof e == "function" ? e(t, r) : e;
}
function Ai(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((r) => !(r.match(/^on[A-Z]/) && typeof e[r] == "function")).forEach((r) => {
    t[r] = e[r];
  }), t;
}
function w_(e) {
  const {
    getSlotProps: t,
    additionalProps: r,
    externalSlotProps: n,
    externalForwardedProps: a,
    className: i
  } = e;
  if (!t) {
    const h = Cr(r == null ? void 0 : r.className, i, a == null ? void 0 : a.className, n == null ? void 0 : n.className), v = F({}, r == null ? void 0 : r.style, a == null ? void 0 : a.style, n == null ? void 0 : n.style), p = F({}, r, a, n);
    return h.length > 0 && (p.className = h), Object.keys(v).length > 0 && (p.style = v), {
      props: p,
      internalRef: void 0
    };
  }
  const o = y_(F({}, a, n)), s = Ai(n), c = Ai(a), l = t(o), u = Cr(l == null ? void 0 : l.className, r == null ? void 0 : r.className, i, a == null ? void 0 : a.className, n == null ? void 0 : n.className), d = F({}, l == null ? void 0 : l.style, r == null ? void 0 : r.style, a == null ? void 0 : a.style, n == null ? void 0 : n.style), f = F({}, l, r, c, s);
  return u.length > 0 && (f.className = u), Object.keys(d).length > 0 && (f.style = d), {
    props: f,
    internalRef: l.ref
  };
}
const T_ = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Pt(e) {
  var t;
  const {
    elementType: r,
    externalSlotProps: n,
    ownerState: a,
    skipResolvingSlotProps: i = !1
  } = e, o = mt(e, T_), s = i ? {} : b_(n, a), {
    props: c,
    internalRef: l
  } = w_(F({}, o, {
    externalSlotProps: s
  })), u = st(l, s == null ? void 0 : s.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return C_(r, F({}, c, {
    ref: u
  }), a);
}
const S_ = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], A_ = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function R_(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Dr(e) {
  return typeof e == "function" ? e() : e;
}
function I_(e) {
  return e.nodeType !== void 0;
}
const P_ = () => rn({
  root: ["root"]
}, B2(g_)), L_ = {}, O_ = /* @__PURE__ */ C.forwardRef(function(t, r) {
  var n;
  const {
    anchorEl: a,
    children: i,
    direction: o,
    disablePortal: s,
    modifiers: c,
    open: l,
    placement: u,
    popperOptions: d,
    popperRef: f,
    slotProps: h = {},
    slots: v = {},
    TransitionProps: p
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, g = mt(t, S_), _ = C.useRef(null), E = st(_, r), y = C.useRef(null), w = st(y, f), T = C.useRef(w);
  lt(() => {
    T.current = w;
  }, [w]), C.useImperativeHandle(f, () => y.current, []);
  const S = R_(u, o), [A, R] = C.useState(S), [I, L] = C.useState(Dr(a));
  C.useEffect(() => {
    y.current && y.current.forceUpdate();
  }), C.useEffect(() => {
    a && L(Dr(a));
  }, [a]), lt(() => {
    if (!I || !l)
      return;
    const N = (K) => {
      R(K.placement);
    };
    let B = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: K
      }) => {
        N(K);
      }
    }];
    c != null && (B = B.concat(c)), d && d.modifiers != null && (B = B.concat(d.modifiers));
    const H = d_(I, _.current, F({
      placement: S
    }, d, {
      modifiers: B
    }));
    return T.current(H), () => {
      H.destroy(), T.current(null);
    };
  }, [I, s, c, l, d, S]);
  const O = {
    placement: A
  };
  p !== null && (O.TransitionProps = p);
  const P = P_(), x = (n = v.root) != null ? n : "div", k = Pt({
    elementType: x,
    externalSlotProps: h.root,
    externalForwardedProps: g,
    additionalProps: {
      role: "tooltip",
      ref: E
    },
    ownerState: t,
    className: P.root
  });
  return /* @__PURE__ */ ie.jsx(x, F({}, k, {
    children: typeof i == "function" ? i(O) : i
  }));
}), N_ = /* @__PURE__ */ C.forwardRef(function(t, r) {
  const {
    anchorEl: n,
    children: a,
    container: i,
    direction: o = "ltr",
    disablePortal: s = !1,
    keepMounted: c = !1,
    modifiers: l,
    open: u,
    placement: d = "bottom",
    popperOptions: f = L_,
    popperRef: h,
    style: v,
    transition: p = !1,
    slotProps: g = {},
    slots: _ = {}
  } = t, E = mt(t, A_), [y, w] = C.useState(!0), T = () => {
    w(!1);
  }, S = () => {
    w(!0);
  };
  if (!c && !u && (!p || y))
    return null;
  let A;
  if (i)
    A = i;
  else if (n) {
    const L = Dr(n);
    A = L && I_(L) ? f1(L).body : f1(null).body;
  }
  const R = !u && c && (!p || y) ? "none" : void 0, I = p ? {
    in: u,
    onEnter: T,
    onExited: S
  } : void 0;
  return /* @__PURE__ */ ie.jsx(f_, {
    disablePortal: s,
    container: A,
    children: /* @__PURE__ */ ie.jsx(O_, F({
      anchorEl: n,
      direction: o,
      disablePortal: s,
      modifiers: l,
      ref: r,
      open: p ? !y : u,
      placement: d,
      popperOptions: f,
      popperRef: h,
      slotProps: g,
      slots: _
    }, E, {
      style: F({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: R
      }, v),
      TransitionProps: I,
      children: a
    }))
  });
}), x_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("g", { id: "icon_tick1_24x24" }, /* @__PURE__ */ C.createElement("path", { id: "Fill 58", fillRule: "evenodd", clipRule: "evenodd", d: "M6.88586 12.8573L2 7.94102L3.96978 5.98439L6.88586 8.89321L12.4116 3.3335L14.381 5.31554L6.88586 12.8573Z", fill: "white" }))), k_ = /* @__PURE__ */ b(x_, {
  target: "e1qkx15u3"
})(""), B_ = /* @__PURE__ */ b("button", {
  target: "e1qkx15u2"
})({
  name: "1hq88fc",
  styles: "padding:0;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer"
}), U_ = /* @__PURE__ */ b(N_, {
  target: "e1qkx15u1"
})("z-index:", S1.Tooltip, ";"), H_ = /* @__PURE__ */ b("div", {
  target: "e1qkx15u0"
})("display:flex;gap:4px;justify-content:center;align-items:center;inline-size:114px;block-size:32px;color:#ffffff;font-weight:700;font-size:14px;font-family:", Q, ";line-height:16px;text-align:center;background-color:#000000;"), U2 = ({
  children: e,
  className: t,
  disablePortal: r = !0,
  LabelComponent: n,
  onClick: a,
  showLabel: i,
  tooltipPlacement: o = "right",
  url: s,
  variant: c
}) => {
  const [l, u] = h4(), [d, f] = Me(!1), [h, v] = Me(!1), p = E1(null), g = Bt(kt.breakpoints.up("tablet")), _ = () => {
    u(s);
    const w = () => {
      f(!0), setTimeout(() => {
        f(!1), a == null || a();
      }, 1e3);
    }, T = () => {
      u(s), v(!0), a == null || a();
    };
    switch (c) {
      case "tooltip":
        w();
        break;
      case "label":
        T();
        break;
      case "responsive":
        g ? w() : T();
        break;
    }
  }, E = () => {
    const w = /* @__PURE__ */ m.createElement("span", {
      className: "copy"
    }, "Copy Link"), S = h ? /* @__PURE__ */ m.createElement("span", {
      className: "copied"
    }, "Link Copied") : w;
    switch (c) {
      case "tooltip":
        return w;
      case "label":
        return S;
    }
  }, y = Ye(() => [{
    name: "offset",
    options: {
      offset: [0, 12]
    }
  }], []);
  return /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(B_, {
    className: t,
    ref: p,
    type: "button",
    onClick: () => _()
  }, e, i && /* @__PURE__ */ m.createElement(n, null, E())), /* @__PURE__ */ m.createElement(U_, {
    anchorEl: p.current,
    disablePortal: r,
    modifiers: y,
    open: d,
    placement: o
  }, /* @__PURE__ */ m.createElement(H_, null, "Link Copied", /* @__PURE__ */ m.createElement(k_, null))));
};
U2.displayName = "CopyLinkButton";
const M_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0662 16.9829C19.2728 16.7763 19.376 16.5187 19.376 16.2098C19.376 15.901 19.2718 15.6566 19.0662 15.4766L16.7879 13.1973C16.6079 12.9907 16.3502 12.8884 16.0148 12.8884C15.7316 12.8884 15.4749 13.004 15.2428 13.2361L15.6672 13.6605C15.7448 13.7382 15.8093 13.8149 15.8604 13.8926C15.8972 13.9273 15.9266 13.9691 15.9466 14.0155C15.9667 14.062 15.977 14.112 15.9769 14.1626C16.0025 14.2147 16.0148 14.317 16.0148 14.4714C16.0148 14.7812 15.9125 15.0256 15.706 15.2056C15.6112 15.3046 15.4972 15.383 15.3709 15.4361C15.2446 15.4892 15.1088 15.5159 14.9718 15.5145C14.8675 15.518 14.7633 15.5052 14.663 15.4766C14.5678 15.4343 14.4774 15.3822 14.393 15.3212C14.343 15.2968 14.2972 15.2645 14.2575 15.2255C14.2196 15.1867 14.1865 15.1668 14.1609 15.1668L13.7365 14.7424C13.5044 14.9224 13.3888 15.1801 13.3888 15.5145C13.3888 15.8498 13.4911 16.1066 13.6976 16.2875L15.9381 18.5659C16.1958 18.7724 16.4525 18.8757 16.7102 18.8757C16.9944 18.8757 17.2379 18.7714 17.4444 18.5659L19.0662 16.9829ZM11.2639 9.25723C11.3743 9.15307 11.4621 9.02735 11.5219 8.88785C11.5817 8.74836 11.6122 8.59807 11.6116 8.4463C11.6116 8.13747 11.5093 7.89305 11.3027 7.71211L9.06226 5.3949C8.80458 5.18837 8.54785 5.08606 8.29017 5.08606C8.00596 5.08606 7.76249 5.18837 7.55597 5.3949L5.93506 7.01675C5.72854 7.19675 5.62528 7.44211 5.62528 7.75095C5.62528 8.05978 5.72949 8.3042 5.93506 8.48514L8.21343 10.8024C8.41995 11.0089 8.67763 11.1112 8.98647 11.1112C9.26972 11.1112 9.52646 10.9956 9.75856 10.7635C9.75856 10.7379 9.69414 10.6612 9.5653 10.5324L9.14089 10.107C9.0632 9.97816 9.02436 9.88911 9.02436 9.83701C8.99576 9.73666 8.98298 9.63246 8.98647 9.52817C8.98647 9.21839 9.08878 8.96166 9.2953 8.75514C9.39015 8.65631 9.50421 8.57793 9.63047 8.52481C9.75673 8.4717 9.89253 8.44498 10.0295 8.4463C10.0816 8.44626 10.1334 8.45263 10.1839 8.46525C10.2344 8.47787 10.2863 8.48424 10.3383 8.4842C10.4928 8.56188 10.5827 8.61398 10.6083 8.63956L10.8404 8.79398L11.0716 9.02608C11.1184 9.07097 11.1578 9.12311 11.1881 9.1805L11.2648 9.25723H11.2639ZM21.5 16.2108C21.5 17.1373 21.1911 17.8838 20.5725 18.4503L18.9507 20.0722C18.6604 20.3716 18.3118 20.6084 17.9265 20.7679C17.5411 20.9274 17.1272 21.0063 16.7102 20.9996C15.8093 20.9996 15.0618 20.6908 14.4697 20.0722L12.1913 17.7549C11.5727 17.1629 11.2639 16.4163 11.2639 15.5145C11.2639 14.6135 11.586 13.8538 12.2302 13.2361L11.2639 12.2698C10.6197 12.914 9.86087 13.2361 8.98552 13.2361C8.08364 13.2361 7.32387 12.9273 6.7062 12.3086L4.42878 9.99143C4.12915 9.70123 3.89219 9.3527 3.73251 8.96735C3.57283 8.582 3.49383 8.16802 3.50038 7.75095C3.50038 6.8756 3.80921 6.12909 4.42783 5.51047L6.04874 3.88861C6.64178 3.29652 7.38829 3 8.29017 3C9.19109 3 9.93855 3.30884 10.5306 3.92745L12.809 6.20583C13.4276 6.8235 13.7365 7.57001 13.7365 8.4463C13.7365 9.34723 13.4144 10.1203 12.7702 10.7635L13.7365 11.7298C14.3541 11.0856 15.1139 10.7635 16.0148 10.7635C16.9167 10.7635 17.6765 11.0724 18.2942 11.691L20.5725 13.9693C21.1911 14.588 21.5 15.3354 21.5 16.2108Z", fill: "white" })), V_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 24, height: 18, viewBox: "0 0 24 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { d: "M2.551 17.21H21.4493C21.8605 17.2095 22.2546 17.0459 22.5453 16.7551C22.836 16.4644 22.9995 16.0702 23 15.659V2.551C22.9996 2.13983 22.8361 1.7456 22.5454 1.45483C22.2547 1.16405 21.8605 1.00048 21.4493 1H2.551C2.13976 1.00038 1.74549 1.16391 1.4547 1.4547C1.16391 1.74549 1.00038 2.13977 1 2.551V15.659C1.00048 16.0702 1.16405 16.4645 1.45481 16.7552C1.74558 17.046 2.13979 17.2096 2.551 17.21ZM22.2756 14.3171L14.926 9.08379L22.2756 3.85124V14.3171ZM1.72432 2.551C1.72452 2.33182 1.81167 2.12166 1.96666 1.96667C2.12165 1.81168 2.33181 1.72453 2.551 1.72433H21.4493C21.6685 1.72453 21.8786 1.81169 22.0335 1.96669C22.1885 2.12169 22.2755 2.33185 22.2756 2.551V2.96216L21.9011 3.22889L14.3018 8.63925L13.9894 8.8617L13.6773 9.08379L13.1841 9.43507C12.8384 9.68116 12.4246 9.81341 12.0002 9.81341C11.5758 9.81341 11.162 9.68116 10.8162 9.43507L10.3231 9.08379L10.011 8.8617L9.69852 8.63925L2.0992 3.22889L1.72432 2.96216V2.551ZM1.72432 3.85124L9.07398 9.08379L1.72432 14.3171V3.85124ZM1.72432 15.2062L2.09955 14.9394L9.69852 9.5287L10.396 10.0251C10.8645 10.3584 11.4252 10.5375 12.0002 10.5375C12.5751 10.5375 13.1358 10.3584 13.6044 10.0251L14.3018 9.5287L21.9011 14.9394L22.2756 15.2062V15.659C22.2754 15.8782 22.1884 16.0883 22.0335 16.2432C21.8785 16.3982 21.6685 16.4854 21.4493 16.4857H2.551C2.33184 16.4854 2.12174 16.3982 1.96677 16.2433C1.8118 16.0883 1.72461 15.8782 1.72432 15.659V15.2062Z", fill: "black", stroke: "black", strokeWidth: 0.3 })), D_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 10.0606V18.1419C22.5 18.6539 22.3039 19.0912 21.9108 19.4547C21.5178 19.8182 21.0465 20 20.4961 20H4.50388C3.95423 20 3.48218 19.8182 3.08917 19.4547C2.69687 19.0912 2.5 18.6539 2.5 18.1419V10.0606L12.5194 14.1818L22.5 10.0606ZM22.5 8.80827L12.5194 12.9701L2.5 8.80827V5.85888C2.5 5.34688 2.69687 4.90876 3.08917 4.54525C3.48218 4.18175 3.95423 4 4.50388 4H20.4961C21.0465 4 21.5178 4.18175 21.9108 4.54525C22.3039 4.90876 22.5 5.34688 22.5 5.85888V8.80827Z", fill: "white" })), F_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.0509 8.56273C20.0509 8.6817 19.9552 8.77825 19.8371 8.77825H17.7405V9.59119H19.8371C19.9552 9.59119 20.0509 9.68774 20.0509 9.80671V10.5808C20.0509 10.6998 19.9552 10.7964 19.8371 10.7964H17.7405V11.6093H19.8371C19.9552 11.6093 20.0509 11.7059 20.0509 11.8248V12.599C20.0509 12.7179 19.9552 12.8145 19.8371 12.8145H16.7543C16.7262 12.8145 16.6984 12.809 16.6725 12.7982C16.6466 12.7874 16.6232 12.7715 16.6034 12.7516L16.6 12.7481C16.5614 12.7084 16.5397 12.6552 16.5397 12.5998V7.78773C16.5397 7.72997 16.5629 7.67738 16.6 7.63945C16.6 7.63773 16.6017 7.63686 16.6034 7.63514L16.6052 7.63342C16.6451 7.59457 16.6986 7.57291 16.7543 7.57307H19.8371C19.9552 7.57307 20.0509 7.66876 20.0509 7.78859V8.56187V8.56273ZM15.7905 12.5998C15.7905 12.6568 15.7679 12.7114 15.7276 12.7516C15.6874 12.7919 15.6328 12.8145 15.5759 12.8145H14.8043C14.7857 12.8143 14.7671 12.8117 14.7491 12.8067H14.7466C14.7416 12.8053 14.7367 12.8036 14.7319 12.8016C14.7293 12.8016 14.7276 12.7998 14.7259 12.799L14.7147 12.7947C14.7111 12.7931 14.7077 12.7914 14.7043 12.7895L14.6983 12.7869C14.6933 12.7836 14.6884 12.7802 14.6836 12.7766C14.6621 12.7626 14.6434 12.7448 14.6284 12.724L12.431 9.74119V12.5998C12.431 12.6281 12.4255 12.6561 12.4146 12.6822C12.4038 12.7083 12.3879 12.732 12.3679 12.7519C12.3478 12.7719 12.3241 12.7877 12.2979 12.7984C12.2718 12.8091 12.2438 12.8146 12.2155 12.8145H11.4448C11.4166 12.8145 11.3886 12.8089 11.3625 12.7981C11.3364 12.7872 11.3127 12.7713 11.2927 12.7513C11.2728 12.7313 11.257 12.7075 11.2463 12.6814C11.2355 12.6552 11.2301 12.6272 11.2302 12.599V7.78859C11.2302 7.73158 11.2528 7.67689 11.293 7.6365C11.3332 7.59611 11.3878 7.5733 11.4448 7.57307H12.2233L12.2345 7.5748L12.2457 7.57566L12.2543 7.57738C12.2595 7.57738 12.2629 7.57911 12.2672 7.57997L12.275 7.58169L12.2879 7.586L12.294 7.58859L12.3069 7.59376C12.3095 7.59376 12.3112 7.59549 12.3138 7.59721C12.3198 7.60029 12.3255 7.60374 12.331 7.60755C12.3353 7.60928 12.3388 7.61273 12.3422 7.61531C12.3484 7.61939 12.3542 7.624 12.3595 7.62911L12.3638 7.63255L12.3767 7.64549L12.3776 7.64721C12.3838 7.654 12.3896 7.6612 12.3948 7.66876L14.5905 10.6464V7.78773C14.5907 7.73087 14.6134 7.6764 14.6536 7.63619C14.6938 7.59599 14.7483 7.5733 14.8052 7.57307H15.5767C15.6337 7.5733 15.6883 7.59611 15.7286 7.6365C15.7688 7.67689 15.7914 7.73158 15.7914 7.78859V12.599L15.7905 12.5998ZM10.4793 12.5998C10.4793 12.628 10.4738 12.6559 10.463 12.682C10.4522 12.708 10.4364 12.7317 10.4164 12.7516C10.3965 12.7715 10.3728 12.7874 10.3468 12.7981C10.3208 12.8089 10.2928 12.8145 10.2647 12.8145H9.4931C9.46491 12.8144 9.43702 12.8087 9.41102 12.7978C9.38502 12.7869 9.36142 12.771 9.34157 12.751C9.32172 12.731 9.306 12.7073 9.29532 12.6812C9.28464 12.6551 9.2792 12.6272 9.27931 12.599V7.78859C9.27931 7.66962 9.375 7.57307 9.4931 7.57307H10.2647C10.3217 7.5733 10.3763 7.59611 10.4165 7.6365C10.4567 7.67689 10.4793 7.73158 10.4793 7.78859V12.599V12.5998ZM8.61897 12.5998C8.61897 12.6566 8.59647 12.7111 8.5564 12.7513C8.51633 12.7915 8.46195 12.8143 8.40517 12.8145H5.32328C5.26788 12.8144 5.21469 12.7928 5.175 12.7541C5.17328 12.7541 5.17155 12.7516 5.17155 12.7516L5.1681 12.7481C5.12994 12.7082 5.10863 12.6551 5.10862 12.5998V7.78773C5.10862 7.73072 5.13121 7.67603 5.17144 7.63564C5.21167 7.59524 5.26627 7.57244 5.32328 7.57221H6.09483C6.21293 7.57221 6.30862 7.66876 6.30862 7.78773V11.6084H8.40517C8.52328 11.6084 8.61897 11.705 8.61897 11.824V12.5981V12.5998ZM23.5 9.96102C23.5 5.01961 18.5655 0.999756 12.5 0.999756C6.43535 0.999756 1.5 5.01961 1.5 9.96102C1.5 14.3912 5.41379 18.1007 10.6991 18.8025C11.0578 18.88 11.5457 19.0395 11.669 19.3464C11.7793 19.6257 11.7414 20.0637 11.7043 20.3456L11.5474 21.2904C11.4991 21.5697 11.3259 22.3826 12.5 21.8852C13.6741 21.3895 18.8345 18.1412 21.1431 15.4748H21.1422C22.7362 13.7197 23.5 11.9386 23.5 9.96102Z", fill: "white" })), X_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1923 3.11364V5.99353H15.4265C14.7463 5.99353 14.3143 6.12034 14.1314 6.37257C13.896 6.65045 13.7783 7.04265 13.7783 7.54712V9.59409H17.0746L16.6427 12.8149H13.7783V21H10.3644V12.8149H7.5V9.59409H10.3644V7.2443C10.3644 5.93047 10.7439 4.88274 11.5023 4.09901C12.3131 3.36657 13.36 3 14.6415 3C15.7142 3 16.5645 3.03811 17.1923 3.11364Z", fill: "white" })), $_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { d: "M12.5 1C6.425 1 1.5 5.56 1.5 11.185C1.5 14.39 3.1 17.25 5.6 19.117V23L9.345 20.944C10.345 21.221 11.403 21.37 12.5 21.37C18.575 21.37 23.5 16.81 23.5 11.185C23.5 5.56 18.575 1 12.5 1ZM13.018 14.895L10.292 11.643L4.974 14.895L10.824 7.947L13.616 11.199L18.868 7.947L13.018 14.895Z", fill: "white" })), q_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { d: "M1.22617 11.5325C1.22617 11.5325 10.0717 8.23976 13.1395 7.08029C14.3155 6.61654 18.3036 5.13241 18.3036 5.13241C18.3036 5.13241 20.1443 4.48316 19.9909 6.05997C19.9398 6.70929 19.5307 8.98175 19.1217 11.4398C18.5081 14.9181 17.8434 18.7211 17.8434 18.7211C17.8434 18.7211 17.7412 19.7878 16.872 19.9733C16.0028 20.1588 14.5711 19.324 14.3155 19.1385C14.1109 18.9994 10.4807 16.9123 9.15133 15.892C8.7934 15.6138 8.38439 15.0573 9.20242 14.408C11.0431 12.8775 13.2417 10.976 14.5711 9.77022C15.1847 9.21366 15.7982 7.9151 13.2417 9.49191C9.61151 11.7644 6.0324 13.8978 6.0324 13.8978C6.0324 13.8978 5.21429 14.3616 3.68041 13.9442C2.14645 13.5268 0.356899 12.9703 0.356899 12.9703C0.356899 12.9703 -0.870152 12.2746 1.22617 11.5325V11.5325Z", fill: "white" })), j_ = (e) => /* @__PURE__ */ C.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...e }, /* @__PURE__ */ C.createElement("path", { d: "M11.2349 8.85148L16.6988 2.5H15.4041L10.6598 8.0149L6.87048 2.5H2.5L8.23013 10.8395L2.5 17.5H3.79485L8.80497 11.6761L12.8067 17.5H17.1772L11.2346 8.85148H11.2349ZM9.46146 10.913L8.88088 10.0825L4.2614 3.47476H6.25021L9.97818 8.80746L10.5588 9.63788L15.4047 16.5696H13.4159L9.46146 10.9133V10.913Z", fill: "white" })), K_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.614 13.205C15.782 13.205 16.25 13.423 17.021 13.858C17.791 14.26 18.209 14.511 18.276 14.612C18.31 14.645 18.326 14.712 18.326 14.812C18.326 15.114 18.243 15.482 18.076 15.918C17.908 16.286 17.573 16.604 17.071 16.872C16.568 17.107 16.083 17.224 15.614 17.224C15.112 17.224 14.191 16.939 12.852 16.37C11.9614 15.9346 11.1472 15.3578 10.441 14.662C9.771 13.992 9.068 13.105 8.331 12C7.628 10.995 7.276 10.075 7.276 9.237V9.087C7.343 8.217 7.695 7.463 8.331 6.827C8.565 6.626 8.817 6.525 9.084 6.525H9.336C9.436 6.559 9.536 6.575 9.637 6.575C9.837 6.575 9.955 6.609 9.989 6.675C10.056 6.709 10.139 6.826 10.239 7.027C10.239 7.094 10.299 7.27 10.416 7.555C10.533 7.839 10.625 8.099 10.692 8.333C10.926 8.936 11.043 9.288 11.043 9.388C11.043 9.589 10.893 9.857 10.591 10.192C10.256 10.527 10.089 10.761 10.089 10.895C10.089 10.962 10.106 11.029 10.139 11.095C10.4881 11.8396 10.9836 12.5062 11.596 13.055C12.2362 13.6494 12.9649 14.1406 13.756 14.511C13.956 14.578 14.074 14.611 14.107 14.611C14.241 14.611 14.492 14.377 14.861 13.909C15.263 13.439 15.514 13.205 15.614 13.205ZM12.701 20.84C13.9129 20.8388 15.1109 20.5822 16.217 20.087C17.2904 19.6504 18.2643 19.001 19.08 18.178C19.903 17.3623 20.5524 16.3884 20.989 15.315C21.457 14.277 21.692 13.105 21.692 11.799C21.692 10.527 21.457 9.371 20.989 8.333C20.519 7.195 19.884 6.223 19.079 5.42C18.343 4.683 17.389 4.047 16.217 3.511C15.011 3.043 13.839 2.808 12.701 2.808C11.562 2.808 10.391 3.043 9.185 3.511C8.013 4.047 7.059 4.683 6.322 5.421C5.518 6.224 4.882 7.195 4.413 8.333C3.944 9.371 3.71 10.527 3.71 11.799C3.71 13.775 4.28 15.533 5.418 17.073L4.263 20.438L7.728 19.333C9.302 20.338 10.96 20.84 12.701 20.84ZM12.7 1C14.106 1 15.513 1.285 16.92 1.854C18.1982 2.39371 19.3584 3.17847 20.335 4.164C21.305 5.102 22.075 6.257 22.645 7.63C23.215 8.87 23.499 10.259 23.499 11.8C23.499 13.34 23.214 14.746 22.645 16.018C22.075 17.358 21.305 18.513 20.335 19.484C19.431 20.388 18.292 21.158 16.919 21.794C15.513 22.364 14.106 22.648 12.699 22.648C10.8695 22.6597 9.06879 22.1922 7.476 21.292L1.5 23.201L3.409 17.374C2.404 15.734 1.902 13.875 1.902 11.8C1.902 10.26 2.186 8.87 2.756 7.631C3.325 6.258 4.096 5.103 5.066 4.165C6.04284 3.179 7.20336 2.39389 8.482 1.854C9.888 1.284 11.295 1 12.7 1Z", fill: "white" })), z_ = (e) => /* @__PURE__ */ C.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.1111 2.99978H5.88889V5.57121H18.1111V2.99978ZM3.25 6.85669H20.75C21.4375 6.85669 22 7.43527 22 8.14241V14.571C22 15.2781 21.4375 15.8567 20.75 15.8567H18.1111V20.9996H5.88889V15.8567H3.25C2.56242 15.8567 2 15.2781 2 14.571V8.14241C2 7.43527 2.5625 6.85669 3.25 6.85669ZM16.8609 19.7142H7.13867V13.2857H16.8609V19.7142ZM20.125 9.71766C20.6254 9.71766 21.0312 9.30033 21.0312 8.78552C21.0312 8.27071 20.6255 7.85337 20.125 7.85337C19.6246 7.85337 19.2188 8.27071 19.2188 8.78552C19.2188 9.30033 19.6246 9.71766 20.125 9.71766Z", fill: "white" })), G_ = /* @__PURE__ */ b("button", {
  target: "e1uptd6o1"
})({
  name: "pt3bba",
  styles: "position:relative;padding:0;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer"
}), Y_ = /* @__PURE__ */ b("div", {
  target: "e1uptd6o0"
})({
  name: "wrqbg1",
  styles: "position:relative;z-index:2"
}), H2 = ({
  children: e,
  className: t,
  onClick: r,
  url: n
}) => {
  const a = () => {
    window.open(`/print${n}`, "_blank"), r == null || r();
  };
  return /* @__PURE__ */ m.createElement(G_, {
    className: t,
    type: "button",
    onClick: a,
    "data-qa": "print-button"
  }, /* @__PURE__ */ m.createElement(Y_, null, e));
};
H2.displayName = "PrintButton";
const Ri = /* @__PURE__ */ b("span", {
  target: "e136m1kq1"
})("padding-block-start:11px;font-size:14px;font-family:", Q, ";line-height:16px;white-space:nowrap;"), W_ = /* @__PURE__ */ b("div", {
  ...Xi,
  target: "e136m1kq0"
})("display:flex;inline-size:", (e) => e.$size + e.$mobilePadding * 2, "px;block-size:", (e) => e.$size + e.$mobilePadding * 2, "px;padding:", (e) => e.$mobilePadding, "px;border-radius:200px;background-color:", (e) => e.$backgroundColor, ";", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:", (e) => e.$size + e.$padding * 2, "px;block-size:", (e) => e.$size + e.$padding * 2, "px;padding:", (e) => e.$padding, "px;}svg{inline-size:", (e) => e.$size, "px;block-size:", (e) => e.$size, "px;", (e) => e.$svgTransform && /* @__PURE__ */ Lt("transform:", e.$svgTransform, ";", ""), ";path{fill:", (e) => e.$iconFillColor, ";}}"), M2 = ({
  children: e,
  className: t,
  disableTrackMixpanel: r,
  extraProps: n,
  hideIcon: a = !1,
  onClick: i,
  position: o,
  relativeUrl: s,
  shortUrl: c,
  showLabel: l = !1,
  style: u,
  title: d,
  type: f,
  utm: h
}) => {
  var v, p, g, _;
  const {
    config: E,
    handleTrackGA4: y,
    handleTrackMixPanel: w,
    userCountry: T
  } = U(), S = new URL(c ?? s, E.siteUrl), A = () => {
    var N, B, H, K, X;
    if (a) return null;
    const $ = {
      "copy-link": M_,
      email: D_,
      email1: V_,
      facebook: X_,
      line: F_,
      messenger: $_,
      print: z_,
      telegram: q_,
      twitter: j_,
      whatsapp: K_,
      ...n == null ? void 0 : n.overrideIcons
    }[f];
    return /* @__PURE__ */ m.createElement(W_, {
      $backgroundColor: (N = u == null ? void 0 : u.backgroundColor) !== null && N !== void 0 ? N : "#001246",
      $iconFillColor: (B = u == null ? void 0 : u.color) !== null && B !== void 0 ? B : "white",
      $mobilePadding: (H = u == null ? void 0 : u.mobilePadding) !== null && H !== void 0 ? H : 12,
      $padding: (K = u == null ? void 0 : u.padding) !== null && K !== void 0 ? K : 5,
      $size: (X = u == null ? void 0 : u.size) !== null && X !== void 0 ? X : 24,
      $svgTransform: u == null ? void 0 : u.svgTransform,
      "data-qa": "render-icon"
    }, /* @__PURE__ */ m.createElement($, null));
  }, R = (N) => l && /* @__PURE__ */ m.createElement(Ri, null, N), I = () => {
    switch (f) {
      case "copy-link":
        return "copy_link";
      case "messenger":
        return "facebook_messenger";
      case "email1":
        return "email";
      default:
        return f;
    }
  }, L = () => {
    const N = I(), B = new URL(s, E.siteUrl).href;
    o && y({
      action: "click",
      category: "share",
      customized_parameters: {
        method: N,
        position: o,
        share_url: B
      },
      subcategory: ""
    });
  }, O = () => {
    if (r) return;
    w({
      name: "Article Share",
      property: {
        Location: "Share Button",
        "Share Channel": {
          "copy-link": "Copy Link",
          email: "Email",
          email1: "Email",
          facebook: "Facebook",
          line: "Line",
          messenger: "Facebook Messenger",
          print: "Print",
          telegram: "Telegram",
          twitter: "Twitter",
          whatsapp: "Whatsapp"
        }[f]
      }
    });
  }, P = () => {
    L(), O(), i == null || i();
  }, k = (() => {
    if (!(h != null && h.campaign)) return S.href;
    const N = new URL(S);
    return N.searchParams.set("utm_source", f), N.searchParams.set("utm_campaign", h.campaign), h.medium && N.searchParams.set("utm_medium", h.medium), h.content && N.searchParams.set("utm_content", h.content), N.href;
  })();
  switch (f) {
    case "copy-link":
      return /* @__PURE__ */ m.createElement(U2, {
        className: t,
        disablePortal: n == null || (v = n.copyLink) === null || v === void 0 ? void 0 : v.disablePortal,
        LabelComponent: Ri,
        showLabel: l,
        tooltipPlacement: n == null || (p = n.copyLink) === null || p === void 0 ? void 0 : p.tooltipPlacement,
        url: k,
        variant: (g = n == null || (_ = n.copyLink) === null || _ === void 0 ? void 0 : _.variant) !== null && g !== void 0 ? g : "responsive",
        onClick: P
      }, A(), e);
    case "email":
    case "email1":
      const N = `\r
`, B = `${d}${N}${k}${N}------------------------------${N}` + (T === "HK" ? "Join our Telegram to get the latest Hong Kong updates https://sc.mp/join-our-telegram" : "Download the SCMP app to explore our daily digest of Hong Kong news. https://scmp.onelink.me/3586748601/kdat6bde");
      return /* @__PURE__ */ m.createElement(g4, {
        beforeOnClick: P,
        body: B,
        className: t,
        separator: N,
        subject: "Shared from South China Morning Post",
        url: ""
      }, A(), R("Email"), e);
    case "facebook":
      return /* @__PURE__ */ m.createElement(v4, {
        className: t,
        url: k,
        onClick: P
      }, A(), R("Facebook"), e);
    case "line":
      return /* @__PURE__ */ m.createElement(m4, {
        className: t,
        title: d,
        url: k,
        onClick: P
      }, A(), R("Line"), e);
    case "messenger":
      return /* @__PURE__ */ m.createElement(f4, {
        appId: E.facebook.appId,
        className: t,
        title: d,
        url: k,
        onClick: P
      }, A(), R("Messenger"), e);
    case "print":
      return /* @__PURE__ */ m.createElement(H2, {
        className: t,
        url: s,
        onClick: P
      }, A(), R("Print"), e);
    case "telegram":
      return /* @__PURE__ */ m.createElement(p4, {
        className: t,
        title: `${d}

Join SCMP's Channel: t.me/scmp_news - Get Daily News Update`,
        url: k,
        onClick: P
      }, A(), R("Telegram"), e);
    case "twitter":
      return /* @__PURE__ */ m.createElement(d4, {
        className: t,
        title: d,
        url: k,
        via: E.twitter.accountName.toLowerCase(),
        onClick: P
      }, A(), R("X/Twitter"), e);
    case "whatsapp":
      return /* @__PURE__ */ m.createElement(u4, {
        className: t,
        separator: `

`,
        title: d,
        url: k,
        onClick: P
      }, A(), R("Whatsapp"), e);
    default:
      return null;
  }
};
M2.displayName = "ShareButton";
const Z_ = /* @__PURE__ */ b(X0, {
  target: "e109f9ks5"
})("z-index:", S1.Tooltip, ";"), Q_ = /* @__PURE__ */ b("div", {
  target: "e109f9ks4"
})({
  name: "12xxavj",
  styles: "display:flex;flex-flow:row nowrap;align-items:center;padding:20px"
}), J_ = /* @__PURE__ */ b(b2, {
  target: "e109f9ks3"
})({
  name: "hnshaw",
  styles: "inline-size:15px;block-size:19px;margin-inline-end:14px;padding:0;& path:last-of-type{fill:#001246;}"
}), eE = /* @__PURE__ */ b("button", {
  target: "e109f9ks2"
})("margin-inline-start:10px;padding:0;color:#4585ff;font-size:14px;font-family:", Q, ";line-height:16px;border:none;background:transparent;cursor:pointer;"), tE = /* @__PURE__ */ b(M2, {
  target: "e109f9ks1"
})({
  name: "ghntb1",
  styles: "display:flex;justify-content:center;align-items:center;inline-size:30px;block-size:30px"
}), Ii = /* @__PURE__ */ b("div", {
  target: "e109f9ks0"
})({
  name: "y1gwey",
  styles: "inline-size:1px;block-size:20px;margin-inline:5px;background:#bbbbbb"
});
function _1() {
  return _1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _1.apply(null, arguments);
}
const V2 = ({
  children: e
}) => {
  const {
    removeReadingHistory: t
  } = yn(), [r, n] = Me(), {
    bindBookmarkButton: a
  } = eC();
  return /* @__PURE__ */ m.createElement(s4, {
    popupId: "reading-history-item-popover",
    variant: "popover",
    "data-qa": "reading-history-action-menu"
  }, (i) => {
    const o = c4(i), s = (v) => {
      const p = {
        ...o
      };
      return p.onClick = (g) => {
        n(v), o.onClick(g);
      }, p;
    }, c = l4(i), l = () => {
      c.onClose(), setTimeout(() => {
        n(void 0);
      }, 500);
    }, u = () => {
      const v = {
        ...c
      };
      return v.onClose = l, v;
    }, d = (v) => i.isOpen && !!r && r.entityUuid === v.entityUuid && r.createdAt === v.createdAt, f = (v) => {
      const p = l1(E2, v.article);
      return ["facebook", "twitter", "copy-link", "email"].map((_) => /* @__PURE__ */ m.createElement(tE, {
        extraProps: {
          copyLink: {
            disablePortal: !1,
            tooltipPlacement: "top",
            variant: "tooltip"
          }
        },
        key: _,
        position: "history",
        relativeUrl: p.urlAlias,
        shortUrl: p.urlAlias,
        showLabel: !1,
        style: {
          /* stylelint-disable csstree/validator */
          /* stylelint-disable property-no-unknown */
          backgroundColor: "transparent",
          color: "#001246",
          svgTransform: "scale(0.75)"
        },
        title: I0(p.socialHeadline, p.headline),
        type: _,
        utm: {
          campaign: p.entityId,
          medium: "share_widget"
        },
        onClick: () => {
          l();
        }
      }));
    }, h = (v) => {
      const p = l1(_2, v.article);
      return /* @__PURE__ */ m.createElement(J_, _1({}, a({
        entityId: p.entityId,
        trackings: {
          ga4Events: {
            click: {
              action: "click",
              category: "bookmark",
              customized_parameters: {
                action_type: "add",
                article_id: p.entityId,
                trigger_point: "history"
              },
              subcategory: ""
            }
          }
        }
      }, () => {
        setTimeout(l, 500);
      }), {
        "data-qa": "render-bookmark-button"
      }));
    };
    return /* @__PURE__ */ m.createElement(m.Fragment, null, e({
      bindTrigger: s,
      isCurrentItem: d
    }), /* @__PURE__ */ m.createElement(Z_, _1({
      anchorOrigin: {
        horizontal: "left",
        vertical: "top"
      },
      elevation: 4,
      transformOrigin: {
        horizontal: "left",
        vertical: "bottom"
      }
    }, u()), r ? /* @__PURE__ */ m.createElement(Q_, null, h(r), /* @__PURE__ */ m.createElement(Ii, null), f(r), /* @__PURE__ */ m.createElement(Ii, null), /* @__PURE__ */ m.createElement(eE, {
      onClick: () => {
        l(), t(r.article, r.createdAt);
      }
    }, "Remove")) : null));
  });
};
V2.displayName = "ReadingHistoryActionMenu";
const rE = /* @__PURE__ */ b("div", {
  target: "e1h768hc11"
})({
  name: "1ehb0iy",
  styles: "display:flex;flex-flow:column nowrap;border:1px solid #a1a1a1;border-radius:4px;background:#f2f2f2;overflow:hidden"
}), nE = /* @__PURE__ */ b("div", {
  target: "e1h768hc10"
})({
  name: "6cm4s2",
  styles: "display:flex;flex-flow:column nowrap;gap:20px;padding:20px"
}), aE = /* @__PURE__ */ b("div", {
  target: "e1h768hc9"
})({
  name: "ege6rc",
  styles: 'display:grid;grid:"greeting link" min-content "message message" min-content/1fr max-content;grid-gap:12px;align-items:baseline;min-inline-size:90px'
}), iE = /* @__PURE__ */ b("span", {
  target: "e1h768hc8"
})("grid-area:greeting;color:#000000;font-weight:400;font-size:16px;font-family:", De, ";line-height:21px;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:16px;line-height:19px;}"), oE = /* @__PURE__ */ b("span", {
  target: "e1h768hc7"
})({
  name: "1666q6m",
  styles: "font-weight:700;word-break:break-all"
}), Pi = /* @__PURE__ */ b("a", {
  target: "e1h768hc6"
})("grid-area:link;justify-self:flex-end;color:#4585ff;font-weight:400;font-size:16px;font-family:", Q, ";line-height:19px;white-space:nowrap;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:14px;line-height:16px;}"), sE = /* @__PURE__ */ b("div", {
  target: "e1h768hc5"
})({
  name: "1k47rlg",
  styles: "grid-area:message"
}), cE = /* @__PURE__ */ b("div", {
  target: "e1h768hc4"
})({
  name: "1tc6xju",
  styles: "flex:1;overflow:auto"
}), lE = /* @__PURE__ */ b("div", {
  target: "e1h768hc0"
})({
  name: "w65oug",
  styles: "display:flex;justify-content:center;align-items:center;min-block-size:56px;background:#ededed"
}), uE = {
  name: "1qpdkzg",
  styles: "scrollbar-width:thin;scrollbar-gutter:stable;&::-webkit-scrollbar{inline-size:6px;background-color:#f5f5f5;}&::-webkit-scrollbar-track{background-color:#f5f5f5;}&::-webkit-scrollbar-thumb{border-radius:20px;background-color:#cccccc;}&::-webkit-scrollbar-thumb:hover{background:#bbbbbb;}"
}, dE = (e) => /* @__PURE__ */ C.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 180 203", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("circle", { cx: 90, cy: 90, r: 90, fill: "#F2F2F2" }), /* @__PURE__ */ C.createElement("circle", { cx: 90, cy: 90, r: 57.012, fill: "white" }), /* @__PURE__ */ C.createElement("path", { d: "M89.9731 63.1076C75.1285 63.1076 63.1076 75.1554 63.1076 90C63.1076 104.845 75.1285 116.892 89.9731 116.892C104.845 116.892 116.892 104.845 116.892 90C116.892 75.1554 104.845 63.1076 89.9731 63.1076ZM98.8476 102.666L87.3108 91.1026V76.5538H92.6892V88.8974L102.666 98.8745L98.8476 102.666Z", fill: "#7E8599" }), /* @__PURE__ */ C.createElement("circle", { cx: 90.3387, cy: 136.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ C.createElement("circle", { cx: 90.3387, cy: 166.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ C.createElement("circle", { cx: 90.3387, cy: 196.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.6517 89.6331C30.6872 84.8257 31.2607 80.0599 32.4238 75.4906C36.2166 60.5304 45.6985 47.4666 59.3946 39.2491C72.9853 31.1369 88.8938 28.8191 104.17 32.6118C119.552 36.4045 132.405 45.9917 140.517 59.5823C148.63 73.1728 151.053 89.0812 147.155 104.357C143.362 119.739 133.775 132.592 120.184 140.704C106.593 148.816 90.6848 151.24 75.4084 147.342C60.0267 143.549 47.1735 133.962 39.0612 120.371L42.6432 118.159C50.1234 130.801 62.1338 139.651 76.3566 143.233C90.5795 146.815 105.329 144.602 117.972 137.122C130.614 129.642 139.464 117.632 143.046 103.409C146.628 89.1865 144.416 74.4371 136.935 61.7947C129.455 49.1523 117.445 40.3026 103.222 36.7206C88.9992 33.1386 74.2495 35.351 61.607 42.8311C44.4532 53.0416 34.3254 71.5644 34.868 91.3985L41.4801 85.5759L44.4408 88.8678L32.8173 99.1825L22.9482 87.1121L26.3476 84.3689L30.6517 89.6331Z", fill: "#DAE3E9" }), /* @__PURE__ */ C.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ C.createElement("line", { x1: 102, y1: 132, x2: 139, y2: 132, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ C.createElement("line", { x1: 102, y1: 142, x2: 133, y2: 142, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ C.createElement("line", { x1: 102, y1: 137, x2: 121, y2: 137, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ C.createElement("line", { x1: 126, y1: 137, x2: 145, y2: 137, stroke: "#7E8599", strokeWidth: 2 })), /* @__PURE__ */ C.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ C.createElement("line", { x1: 102, y1: 162, x2: 139, y2: 162, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ C.createElement("line", { x1: 102, y1: 172, x2: 139, y2: 172, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ C.createElement("line", { x1: 102, y1: 167, x2: 126, y2: 167, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ C.createElement("line", { x1: 128, y1: 167, x2: 147, y2: 167, stroke: "#7E8599", strokeWidth: 2 })), /* @__PURE__ */ C.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ C.createElement("line", { x1: 102, y1: 192, x2: 115, y2: 192, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ C.createElement("line", { x1: 117, y1: 192, x2: 139, y2: 192, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ C.createElement("line", { x1: 102, y1: 202, x2: 149, y2: 202, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ C.createElement("line", { x1: 102, y1: 197, x2: 128, y2: 197, stroke: "#7E8599", strokeWidth: 2 }))), pE = /* @__PURE__ */ b("div", {
  target: "euvv2st11"
})("block-size:100%;padding:20px;background:#ffffff;overflow-y:auto;", uE, ";"), fE = /* @__PURE__ */ b("div", {
  target: "euvv2st10"
})("color:#000000;font-weight:700;font-size:16px;font-family:", Q, ";line-height:19px;"), mE = /* @__PURE__ */ b("div", {
  target: "euvv2st9"
})(""), vE = /* @__PURE__ */ b("div", {
  target: "euvv2st8"
})({
  name: "84lqid",
  styles: "display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;padding-block:20px"
}), gE = /* @__PURE__ */ b("div", {
  target: "euvv2st7"
})("color:#000000;font-size:14px;font-family:", De, ";line-height:18px;text-transform:uppercase;"), hE = /* @__PURE__ */ b("button", {
  target: "euvv2st6"
})("color:#4585ff;font-size:14px;font-family:", Q, ";line-height:16px;border:none;background:transparent;cursor:pointer;"), CE = /* @__PURE__ */ b("div", {
  target: "euvv2st5"
})({
  name: "1tzhvsk",
  styles: 'position:relative;padding-block-end:28px;padding-inline-start:20px;::before{position:absolute;inset-block-start:2px;inset-inline-start:0;content:"";z-index:2;display:block;inline-size:10px;block-size:10px;border-radius:50%;background:#ffca05;}::after{position:absolute;inset-block-start:2px;inset-inline-start:0;content:"";z-index:1;display:block;inline-size:10px;block-size:calc(100% + 8px);border-radius:5px 5px 0 0;background:#f2f2f2;}:last-child{::after{block-size:calc(100% - 2px);}}'
}), _E = /* @__PURE__ */ b("div", {
  target: "euvv2st4"
})("color:#666666;font-size:16px;font-family:", Q, ";line-height:22px;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:14px;line-height:18px;}:hover{color:#4585ff;}"), EE = /* @__PURE__ */ b(Kr, {
  ...Xi,
  target: "euvv2st3"
})("padding-block:4px;padding-inline:0;color:", (e) => e.$isActive ? "#000000" : "#cccccc", ";"), yE = /* @__PURE__ */ b("div", {
  target: "euvv2st2"
})("display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;margin-block-start:16px;color:#666666;font-size:14px;font-family:", Q, ";"), bE = /* @__PURE__ */ b(dE, {
  target: "euvv2st1"
})("min-inline-size:180px;max-inline-size:250px;margin-block-start:28px;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:180px;}"), Li = /* @__PURE__ */ b($0, {
  target: "euvv2st0"
})({
  name: "7rcus4",
  styles: "display:block;margin-block:30px;margin-inline:auto;color:#4585ff"
});
function Fr() {
  return Fr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fr.apply(null, arguments);
}
const D2 = ({
  state: e
}) => {
  const {
    currentPageType: t,
    handleRoutePush: r,
    handleTrackGA4: n,
    user: a
  } = U(), {
    clearReadingHistory: i
  } = yn(), o = Object.entries(Jh(e.result, (s) => at(s.createdAt)));
  return vt(() => {
    n({
      action: "imp",
      category: "readinghistory",
      subcategory: ""
    });
  }), /* @__PURE__ */ m.createElement(V2, {
    "data-qa": "reading-history-panel"
  }, ({
    bindTrigger: s,
    isCurrentItem: c
  }) => {
    const l = () => {
      const f = a ? "Your recently viewed stories will appear here. This allows us to give you a more personalised experience." : "By signing up as a registered user, your recently viewed stories will appear here. This allows us to give you a more personalised experience.";
      return /* @__PURE__ */ m.createElement(yE, {
        "data-qa": "render-empty-message"
      }, f, /* @__PURE__ */ m.createElement(bE, null));
    }, u = () => {
      const f = (v) => {
        const p = new Date(v);
        return Tc(p) ? "Today" : Ac(p) ? "Yesterday" : v;
      }, h = (v) => {
        var p;
        const g = l1(g2, v.article);
        return /* @__PURE__ */ m.createElement(CE, {
          key: v.entityUuid,
          "data-qa": "render-item"
        }, /* @__PURE__ */ m.createElement(_E, {
          onClick: () => {
            var _;
            n({
              action: "click",
              category: "readinghistory",
              customized_parameters: {
                action_type: "read",
                article_id: g.entityId
              },
              subcategory: ""
            }), r(g.urlAlias, {
              applicationId: (_ = g.application) === null || _ === void 0 ? void 0 : _.entityUuid,
              entityId: g.entityId,
              entityUuid: g.entityUuid,
              query: {
                campaign: "reading_history",
                module: "my_account_overlay",
                pgtype: t
              },
              type: _0(g.__typename)
            });
          }
        }, (p = g.socialHeadline) !== null && p !== void 0 ? p : g.headline), /* @__PURE__ */ m.createElement(EE, Fr({
          "aria-label": "more action",
          disableRipple: !0
        }, s(v), {
          $isActive: c(v)
        }), /* @__PURE__ */ m.createElement(C2, {
          color: "inherit"
        })));
      };
      return o.map(([v, p]) => /* @__PURE__ */ m.createElement(mE, {
        key: v
      }, /* @__PURE__ */ m.createElement(vE, null, /* @__PURE__ */ m.createElement(gE, null, f(v)), /* @__PURE__ */ m.createElement(hE, {
        onClick: () => void i(v)
      }, "Clear")), p.map((g) => h(g))));
    }, d = () => {
      const f = o.length === 0;
      switch (e.status) {
        case "not-executed":
          return /* @__PURE__ */ m.createElement(Li, {
            color: "inherit"
          });
        case "loading":
          return f ? /* @__PURE__ */ m.createElement(Li, {
            color: "inherit"
          }) : void 0;
        case "success":
        case "error":
          return f ? l() : u();
      }
    };
    return /* @__PURE__ */ m.createElement(pE, null, /* @__PURE__ */ m.createElement(fE, null, "Recently Viewed"), d());
  });
};
D2.displayName = "ReadingHistoryPanel";
const F2 = ({
  beforeHeaderSlot: e,
  className: t,
  messageRenders: r
}) => {
  var n;
  const {
    config: a,
    handleOpenLoginDialog: i,
    handleRoutePush: o,
    user: s
  } = U(), c = s != null && s.firstname && s !== null && s !== void 0 && s.lastname ? `${s.firstname} ${s.lastname}` : (n = s == null ? void 0 : s.username) !== null && n !== void 0 ? n : "Guest", l = () => s ? /* @__PURE__ */ m.createElement(Pi, {
    onClick: () => {
      const f = new URL(`${a.accounts.host}/settings`);
      f.searchParams.set("destination", window.location.href), o(f.toString());
    },
    "data-qa": "render-account-link"
  }, "My Account") : /* @__PURE__ */ m.createElement(Pi, {
    onClick: () => {
      i({
        destination: window.location.href,
        ga4CustomParameter: {
          trigger_point: "header"
        }
      });
    }
  }, "Sign In / Register"), {
    message: u
  } = xg(r), {
    state: d
  } = Lg();
  return /* @__PURE__ */ m.createElement(rE, {
    className: t,
    "data-qa": "dashboard-display"
  }, /* @__PURE__ */ m.createElement(nE, null, e, /* @__PURE__ */ m.createElement(aE, null, /* @__PURE__ */ m.createElement(iE, null, "Hi, ", /* @__PURE__ */ m.createElement(oE, null, c)), l(), /* @__PURE__ */ m.createElement(sE, null, u))), /* @__PURE__ */ m.createElement(cE, null, /* @__PURE__ */ m.createElement(D2, {
    state: d
  })), /* @__PURE__ */ m.createElement(lE, null, l()));
};
F2.displayName = "DashboardDisplay";
const wE = /* @__PURE__ */ b("div", {
  target: "eprlsh16"
})({
  name: "14l2p6l",
  styles: "inline-size:fit-content"
}), TE = /* @__PURE__ */ b(F2, {
  target: "eprlsh15"
})("block-size:100vh;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:300px;block-size:574px;}"), SE = /* @__PURE__ */ b(q0, {
  target: "eprlsh14"
})("z-index:", S1.Modal, ";"), AE = /* @__PURE__ */ b("div", {
  target: "eprlsh13"
})("display:flex;justify-content:space-between;align-items:center;", (e) => e.theme.breakpoints.up("tablet"), "{display:none;}"), RE = /* @__PURE__ */ b(j0, {
  target: "eprlsh12"
})("z-index:", S1.Modal, ";"), IE = /* @__PURE__ */ b("div", {
  target: "eprlsh11"
})(""), PE = (e) => /* @__PURE__ */ C.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.81257 8.03137L16 15.1874L15.2503 15.9999L8 8.78108L0.812571 15.9999L0 15.1874L7.18743 8.03137L0 0.81251L0.812571 -6.10352e-05L8 7.2188L15.2503 -6.10352e-05L16 0.81251L8.81257 8.03137Z", fill: "white" }));
function Xr() {
  return Xr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xr.apply(null, arguments);
}
const LE = /* @__PURE__ */ b(Kr, {
  target: "e15aj8c1"
})({
  name: "if9fso",
  styles: "flex:none;margin-inline-start:18px;padding:0"
}), OE = /* @__PURE__ */ b(({
  className: e,
  ...t
}) => /* @__PURE__ */ m.createElement(K0, Xr({}, t, {
  classes: {
    popper: e
  }
})), {
  target: "e15aj8c0"
})("& .", Fn.tooltip, "{display:flex;flex-flow:row nowrap;justify-content:end;align-items:flex-start;inline-size:max-content;max-inline-size:325px;padding:16px;color:#ffffff;font-weight:400;font-size:16px;font-family:", Q, ";line-height:22px;border-radius:0;background:rgba(0, 18, 70, 0.9);cursor:pointer;user-select:none;}& .", Fn.arrow, "{color:rgba(0, 18, 70, 0.9);font-size:25px;}"), X2 = ({
  children: e,
  isDashboardOpen: t,
  isTooltipVisible: r,
  tooltipRenders: n
}) => {
  var a;
  const [i, o] = Xt(async () => {
    if (!n) return null;
    const f = await Promise.allSettled(n.map((h) => h.current));
    for (const h of f)
      if (!(h.status === "rejected" || h.value === null))
        return h.value;
  }), [s, c] = Me(!1);
  Di(() => {
    s || o.execute();
  }, [n, s]);
  const l = r && !t && !s && i.status === "success" && !!((a = i.result) !== null && a !== void 0 && a.node), u = i.status === "success" ? i.result : void 0, {
    router: d
  } = U();
  return te(() => {
    const f = () => {
      var h;
      !l || !u || (c(!0), u == null || (h = u.onChangeUrl) === null || h === void 0 || h.call(u));
    };
    return d.events.on("routeChangeStart", f), () => {
      d.events.off("routeChangeStart", f);
    };
  }, [u, d, l]), te(() => {
    t && u && c(!0);
  }, [t, l, u]), /* @__PURE__ */ m.createElement(OE, {
    open: l,
    placement: "bottom-end",
    PopperProps: {
      disablePortal: !0,
      modifiers: [{
        name: "offset",
        options: {
          offset: [16, 0]
        }
      }]
    },
    title: /* @__PURE__ */ m.createElement(m.Fragment, null, u == null ? void 0 : u.node, /* @__PURE__ */ m.createElement(LE, {
      "aria-label": "close",
      disableRipple: !0,
      onClick: () => {
        var f;
        c(!0), u == null || (f = u.onClose) === null || f === void 0 || f.call(u);
      }
    }, /* @__PURE__ */ m.createElement(PE, null))),
    arrow: !0,
    "data-qa": "dashboard-tooltips"
  }, e);
};
X2.displayName = "DashboardTooltips";
function $r() {
  return $r = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $r.apply(null, arguments);
}
const xy = ({
  children: e,
  className: t,
  messageRenders: r,
  tooltipRenders: n
}) => {
  const {
    hasAcceptedGDPR: a
  } = U();
  Ig();
  const i = E1(null), [o, s] = N0(!0), [c, l] = Me(!1), u = x0(i), d = Bt(kt.breakpoints.only("mobile"), !1), f = Bt(kt.breakpoints.up("desktop"), !1), h = () => /* @__PURE__ */ m.createElement(TE, {
    beforeHeaderSlot: /* @__PURE__ */ m.createElement(AE, null, /* @__PURE__ */ m.createElement(Ng, null), /* @__PURE__ */ m.createElement(Kr, {
      "aria-label": "close",
      disableRipple: !0,
      onClick: () => l(!1)
    }, /* @__PURE__ */ m.createElement(Og, null))),
    messageRenders: r,
    "data-qa": "render-display"
  }), {
    setIsFirstTime: v
  } = v2();
  te(() => {
    !c || !a || v(!1);
  }, [a, c, v]), te(() => {
    s(u == null ? void 0 : u.isIntersecting);
  }, [u == null ? void 0 : u.isIntersecting, s]);
  const p = Ye(() => [{
    name: "offset",
    options: {
      // This is for handling tablet placement of the popper
      offset: [f ? 0 : 42, 10]
    }
  }], [f]), g = () => l(!1);
  return te(() => {
    if (c && f)
      window.addEventListener("scroll", g);
    else
      return () => {
        window.removeEventListener("scroll", g);
      };
    return () => {
      window.removeEventListener("scroll", g);
    };
  }, [f, c]), /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(hu, null, /* @__PURE__ */ m.createElement(X2, {
    isDashboardOpen: c,
    isTooltipVisible: o,
    tooltipRenders: n
  }, /* @__PURE__ */ m.createElement(wE, {
    className: t,
    ref: i,
    onClick: () => l(!0)
  }, e))), /* @__PURE__ */ m.createElement(SE, {
    anchor: "bottom",
    open: d && c,
    SlideProps: {
      easing: {
        enter: "ease"
      },
      timeout: {
        enter: 500,
        exit: 0
      }
    },
    hideBackdrop: !0,
    onClose: () => l(!1)
  }, h()), /* @__PURE__ */ m.createElement(RE, {
    anchorEl: i.current,
    modifiers: p,
    open: !d && c,
    placement: "bottom-end",
    transition: !0
  }, ({
    TransitionProps: _
  }) => /* @__PURE__ */ m.createElement(z0, {
    onClickAway: () => l(!1)
  }, /* @__PURE__ */ m.createElement(G0, $r({}, _, {
    timeout: {
      enter: 500,
      exit: 0
    }
  }), /* @__PURE__ */ m.createElement(IE, null, h())))));
}, NE = /* @__PURE__ */ b("div", {
  target: "e6yd7ba0"
})("display:flex;flex:none;justify-content:center;align-items:center;padding-block:1px;padding-inline:5px;color:#ffffff;font-weight:700;font-size:14px;font-family:", De, ";line-height:18px;text-transform:uppercase;border-radius:4px;background:#eb4254;"), ky = () => {
  const {
    hasAcceptedGDPR: e
  } = U(), {
    isFirstTime: t,
    setIsFirstTime: r
  } = v2(), {
    promise: n,
    reject: a,
    resolve: i
  } = y1();
  return te(() => e && t ? i.current({
    node: /* @__PURE__ */ m.createElement(m.Fragment, null, "Find your recently read stories and latest notifications here.", /* @__PURE__ */ m.createElement(NE, null, "New")),
    onChangeUrl: () => {
      r(!1);
    },
    onClose: () => {
      r(!1);
    }
  }) : a.current(), [i, a, t, n, r, e]), {
    hintTooltipRender: n
  };
}, xE = /* @__PURE__ */ b("div", {
  target: "e1nmhixk0"
})({
  name: "dpbic8",
  styles: "inline-size:240px;color:#ffffff;font-size:16px;line-height:18px;a{color:#ffffff;text-decoration:underline;}"
}), $2 = ({
  message: e
}) => /* @__PURE__ */ m.createElement(xE, {
  dangerouslySetInnerHTML: {
    __html: e
  },
  "data-qa": "piano-tooltip-display"
});
$2.displayName = "PianoTooltipDisplay";
const By = () => {
  var e;
  const {
    rosettaInstance: t
  } = U(), {
    set: r,
    value: n
  } = Oe("pianoTooltipHistory", {
    defaultValue: []
  }), {
    message: a,
    shortKey: i,
    version: o
  } = (e = t == null ? void 0 : t.rulesEngine.getOutcome("ui.tooltip.messageObject")) !== null && e !== void 0 ? e : {}, s = i && o && `${i}_${o.toString()}`, [c, l] = Me(), {
    promise: u,
    reject: d,
    resolve: f
  } = y1();
  return te(() => {
    if (t) {
      if (s && n) {
        l(!n.includes(s));
        return;
      }
    } else return;
    l(!1);
  }, [n, t, s, o]), te(() => {
    if (!(!t || c === void 0))
      return c && a && s ? f.current({
        node: /* @__PURE__ */ m.createElement($2, {
          message: a
        }),
        onChangeUrl: () => {
          r((h) => Dn(h ?? [], [s])), l(!1);
        },
        onClose: () => {
          r((h) => Dn(h ?? [], [s])), l(!1);
        }
      }) : d.current();
  }, [c, a, d, f, t, r, s]), {
    pianoTooltipRender: u
  };
}, kE = (e) => /* @__PURE__ */ C.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.414 19.6869L21.437 10.6639L19.141 8.36694L12.414 15.0389L8.914 11.4839L6.562 13.8349L12.414 19.6869ZM23.898 23.8979C21.164 26.6319 17.864 27.9999 14 27.9999C10.135 27.9999 6.836 26.6319 4.101 23.8979C1.367 21.1639 0 17.8649 0 13.9999C0 10.1349 1.367 6.83494 4.101 4.10094C6.836 1.36694 10.135 -6.10352e-05 14 -6.10352e-05C17.864 -6.10352e-05 21.164 1.36694 23.898 4.10094C26.633 6.83494 28 10.1349 28 13.9999C28 17.8649 26.633 21.1639 23.898 23.8979Z", fill: "white" })), BE = /* @__PURE__ */ b("div", {
  target: "e1yc3qie1"
})({
  name: "zjik7",
  styles: "display:flex"
}), UE = /* @__PURE__ */ b(kE, {
  target: "e1yc3qie0"
})({
  name: "dyx8jd",
  styles: "flex:none;inline-size:28px;block-size:28px;margin-inline-end:16px"
}), q2 = ({
  onImpression: e
}) => (vt(() => {
  e();
}), /* @__PURE__ */ m.createElement(BE, {
  "data-qa": "login-reminder-tooltip"
}, /* @__PURE__ */ m.createElement(UE, null), "Log in again for better content recommendations."));
q2.displayName = "LoginReminderTooltip";
const Uy = () => {
  const {
    hasAcceptedGDPR: e,
    user: t
  } = U(), [r] = h0("last_logout_timestamp"), {
    remove: n,
    set: a,
    value: i
  } = Oe("loginReminderData"), o = Fi(i);
  te(() => {
    t && n();
  }, [n, t]);
  const {
    promise: s,
    reject: c,
    resolve: l
  } = y1();
  return te(() => {
    var u;
    if (!e || r === null || t) return c.current();
    const d = (u = o.current) !== null && u !== void 0 ? u : [{
      // 30 minutes
      intervalTime: 1800,
      shown: !1
    }, {
      // 1 day
      intervalTime: 86400,
      shown: !1
    }, {
      // 30 days
      intervalTime: 172800,
      shown: !1
    }], f = pr(/* @__PURE__ */ new Date()), h = Number.parseInt(r ?? "0");
    for (const [v, p] of d.entries())
      if (f - h >= p.intervalTime && !p.shown)
        return a(() => (d[v].shown = !0, d)), l.current({
          node: /* @__PURE__ */ m.createElement(q2, {
            onImpression: () => {
            }
          }),
          onChangeUrl: () => {
          }
        });
    return c.current();
  }, [r, c, l, a, o, e, t]), {
    loginReminderTooltipRender: s
  };
}, j2 = /* @__PURE__ */ function() {
  var e = [{
    kind: "Literal",
    name: "filter",
    value: {
      entityId: "acquisition"
    }
  }], t = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "json",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: [],
      kind: "Fragment",
      metadata: null,
      name: "hooksUseGroupSubscriptionDataQuery",
      selections: [{
        alias: null,
        args: e,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [
          t
          /*: any*/
        ],
        storageKey: 'appConfig(filter:{"entityId":"acquisition"})'
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [],
      kind: "Operation",
      name: "hooksUseGroupSubscriptionDataQuery",
      selections: [{
        alias: null,
        args: e,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [t, {
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "id",
          storageKey: null
        }],
        storageKey: 'appConfig(filter:{"entityId":"acquisition"})'
      }]
    },
    params: {
      cacheID: "f8a59a268fef536b2b8a27cbc8bf3147",
      id: null,
      metadata: {},
      name: "hooksUseGroupSubscriptionDataQuery",
      operationKind: "query",
      text: `query hooksUseGroupSubscriptionDataQuery {
  appConfig(filter: {entityId: "acquisition"}) {
    json
    id
  }
}
`
    }
  };
}();
j2.hash = "10b91bd845ddc4c70e045441fbd4454d";
var HE = e2, ME = n2, VE = V1, DE = be, FE = Zr, XE = mn, $E = Js, qE = vn, jE = "[object Map]", KE = "[object Set]", zE = Object.prototype, GE = zE.hasOwnProperty;
function YE(e) {
  if (e == null)
    return !0;
  if (FE(e) && (DE(e) || typeof e == "string" || typeof e.splice == "function" || XE(e) || qE(e) || VE(e)))
    return !e.length;
  var t = ME(e);
  if (t == jE || t == KE)
    return !e.size;
  if ($E(e))
    return !HE(e).length;
  for (var r in e)
    if (GE.call(e, r))
      return !1;
  return !0;
}
var WE = YE;
const Oi = /* @__PURE__ */ T1(WE), ZE = async (e, t) => (await e.post("/tier", {
  email: t,
  withCredentials: !0
})).data || "", QE = /* @__PURE__ */ b("div", {
  target: "e1dy73d80"
})({
  name: "dpbic8",
  styles: "inline-size:240px;color:#ffffff;font-size:16px;line-height:18px;a{color:#ffffff;text-decoration:underline;}"
}), K2 = ({
  message: e,
  onImpression: t
}) => (vt(() => {
  t();
}), /* @__PURE__ */ m.createElement(QE, {
  dangerouslySetInnerHTML: {
    __html: e
  },
  "data-qa": "group-subscriber-tooltip"
}));
K2.displayName = "GroupSubscriberTooltip";
const Hy = () => {
  const {
    user: e
  } = U(), {
    remove: t,
    set: r,
    value: n
  } = Oe("groupSubscriberTooltipData"), a = JE(), i = ey(), o = Fi(n), {
    promise: s,
    reject: c,
    resolve: l
  } = y1();
  return te(() => {
    var u, d;
    if (Ni(a) || Ni(i)) return;
    if (!e || xi(a) || xi(i)) return c.current();
    const f = a.result, h = i.result;
    if (!f || !h) return c.current();
    (o == null || (u = o.current) === null || u === void 0 ? void 0 : u.version) !== f.tooltip.version && t();
    const v = (d = o.current) !== null && d !== void 0 ? d : {
      intervalData: [{
        intervalTime: 0,
        shown: !1
      }, {
        intervalTime: 604800,
        shown: !1
      }, {
        intervalTime: 1209600,
        shown: !1
      }, {
        intervalTime: 1814400,
        shown: !1
      }, {
        intervalTime: 2419200,
        shown: !1
      }],
      lastShownTimeStamp: pr(Date.now()),
      version: f.tooltip.version
    }, p = pr(Date.now()) - v.lastShownTimeStamp;
    if (!v.intervalData) return c.current();
    for (const [g] of v.intervalData.entries()) {
      const _ = v.intervalData;
      if (r(() => {
        var E;
        const y = [..._];
        return y[g] = {
          intervalTime: _[g].intervalTime,
          shown: !0
        }, {
          intervalData: y,
          lastShownTimeStamp: v.lastShownTimeStamp,
          version: (E = v.version) !== null && E !== void 0 ? E : ""
        };
      }), p >= v.intervalData[g].intervalTime && !v.intervalData[g].shown)
        return l.current({
          node: /* @__PURE__ */ m.createElement(K2, {
            message: `${f.tooltip.message}`,
            onImpression: () => {
            }
          }),
          onChangeUrl: () => {
          }
        });
    }
    return c.current();
  }, [a, i, c, t, l, r, o, e, s]), {
    groupSubscriberTooltipRender: s
  };
}, Ni = (e) => !e || e.status === "loading" || e.status === "not-executed", xi = (e) => e.status === "error", JE = () => {
  const e = Wi(), {
    config: t
  } = U(), [r, n] = Xt(async () => {
    var a, i;
    const o = await Zi(e, j2, {}).toPromise();
    if (o != null && (a = o.appConfig) !== null && a !== void 0 && a.json) return (o == null || (i = o.appConfig) === null || i === void 0 ? void 0 : i.json)[t.environment];
  });
  return vt(() => {
    n.execute();
  }), r;
}, ey = () => {
  const {
    config: e,
    user: t
  } = U(), {
    remove: r,
    set: n,
    value: a
  } = Oe("corp_subscriber_tier"), i = Ye(() => jr.create({
    baseURL: e.corporateSubscriber.host,
    headers: {
      apikey: e.graphql.apiKey
    }
  }), [e]), [o, s] = Xt(async () => {
    var c, l;
    const u = /* @__PURE__ */ new Set(["T2", "T3", "T4", "C-suite"]);
    if (!(t != null && t.useremail)) return !1;
    if (a && (a == null ? void 0 : a["Users Email Address"]) !== (t == null ? void 0 : t.useremail) && r(), !Oi(a)) return u.has((c = a == null ? void 0 : a.Tier) !== null && c !== void 0 ? c : "");
    const d = await ZE(i, t == null ? void 0 : t.useremail);
    return Oi(a) && d && n(d), u.has((l = d == null ? void 0 : d.Tier) !== null && l !== void 0 ? l : "");
  });
  return vt(() => void s.execute()), o;
};
function ty(e) {
  const {
    checked: t,
    defaultChecked: r,
    disabled: n,
    onBlur: a,
    onChange: i,
    onFocus: o,
    onFocusVisible: s,
    readOnly: c,
    required: l
  } = e, [u, d] = wo({
    controlled: t,
    default: !!r,
    name: "Switch",
    state: "checked"
  }), f = (R) => (I) => {
    var L;
    I.nativeEvent.defaultPrevented || (d(I.target.checked), i == null || i(I), (L = R.onChange) == null || L.call(R, I));
  }, {
    isFocusVisibleRef: h,
    onBlur: v,
    onFocus: p,
    ref: g
  } = To(), [_, E] = C.useState(!1);
  n && _ && E(!1), C.useEffect(() => {
    h.current = _;
  }, [_, h]);
  const y = C.useRef(null), w = (R) => (I) => {
    var L;
    y.current || (y.current = I.currentTarget), p(I), h.current === !0 && (E(!0), s == null || s(I)), o == null || o(I), (L = R.onFocus) == null || L.call(R, I);
  }, T = (R) => (I) => {
    var L;
    v(I), h.current === !1 && E(!1), a == null || a(I), (L = R.onBlur) == null || L.call(R, I);
  }, S = st(g, y);
  return {
    checked: u,
    disabled: !!n,
    focusVisible: _,
    getInputProps: (R = {}) => F({
      checked: t,
      defaultChecked: r,
      disabled: n,
      readOnly: c,
      ref: S,
      required: l,
      type: "checkbox",
      role: "switch",
      "aria-checked": t
    }, R, {
      onChange: f(R),
      onFocus: w(R),
      onBlur: T(R)
    }),
    inputRef: S,
    readOnly: !!c
  };
}
const z2 = "Switch";
function ry(e) {
  return Ln(z2, e);
}
const Le = x2(z2, ["root", "input", "track", "thumb", "checked", "disabled", "focusVisible", "readOnly"]), ny = ["checked", "defaultChecked", "disabled", "onBlur", "onChange", "onFocus", "onFocusVisible", "readOnly", "required", "slotProps", "slots"], ay = (e) => {
  const {
    checked: t,
    disabled: r,
    focusVisible: n,
    readOnly: a
  } = e;
  return rn({
    root: ["root", t && "checked", r && "disabled", n && "focusVisible", a && "readOnly"],
    thumb: ["thumb"],
    input: ["input"],
    track: ["track"]
  }, B2(ry));
}, iy = /* @__PURE__ */ C.forwardRef(function(t, r) {
  var n, a, i, o;
  const {
    slotProps: s = {},
    slots: c = {}
  } = t, l = mt(t, ny), {
    getInputProps: u,
    checked: d,
    disabled: f,
    focusVisible: h,
    readOnly: v
  } = ty(t), p = F({}, t, {
    checked: d,
    disabled: f,
    focusVisible: h,
    readOnly: v
  }), g = ay(p), _ = (n = c.root) != null ? n : "span", E = Pt({
    elementType: _,
    externalSlotProps: s.root,
    externalForwardedProps: l,
    additionalProps: {
      ref: r
    },
    ownerState: p,
    className: g.root
  }), y = (a = c.thumb) != null ? a : "span", w = Pt({
    elementType: y,
    externalSlotProps: s.thumb,
    ownerState: p,
    className: g.thumb
  }), T = (i = c.input) != null ? i : "input", S = Pt({
    elementType: T,
    getSlotProps: u,
    externalSlotProps: s.input,
    ownerState: p,
    className: g.input
  }), A = c.track === null ? () => null : (o = c.track) != null ? o : "span", R = Pt({
    elementType: A,
    externalSlotProps: s.track,
    ownerState: p,
    className: g.track
  });
  return /* @__PURE__ */ ie.jsxs(_, F({}, E, {
    children: [/* @__PURE__ */ ie.jsx(A, F({}, R)), /* @__PURE__ */ ie.jsx(y, F({}, w)), /* @__PURE__ */ ie.jsx(T, F({}, S))]
  }));
}), oy = /* @__PURE__ */ b("span", {
  target: "e167yolf1"
})({
  name: "1nb6kt7",
  styles: "display:flex;flex-flow:row;justify-content:flex-start;align-items:center"
}), ki = /* @__PURE__ */ b(iy, {
  target: "e167yolf0"
})("position:relative;display:inline-block;&.", Le.root, "{inline-size:37px;block-size:24px;}& .", Le.input, "{position:absolute;inset-block-start:0;inset-inline-start:0;z-index:1;inline-size:100%;block-size:100%;margin:0;cursor:pointer;opacity:0;}& .", Le.track, "{position:absolute;display:block;inline-size:100%;block-size:100%;border-radius:12px;background-color:#cccccc;}& .", Le.thumb, "{position:absolute;inset-block-start:2px;inset-inline-start:2px;display:block;inline-size:20px;block-size:20px;border-radius:10px;background-color:#ffffff;transition:all 0.2s ease;}&.", Le.checked, "{.", Le.track, "{background-color:#4585ff;}.", Le.thumb, "{inset-block-start:2px;inset-inline-start:15px;}}&.", Le.disabled, "{opacity:0.4;.", Le.input, "{cursor:not-allowed;}}"), sy = ({
  label: e,
  ...t
}) => e ? /* @__PURE__ */ m.createElement(oy, null, /* @__PURE__ */ m.createElement(ki, t), e) : /* @__PURE__ */ m.createElement(ki, t);
sy.displayName = "Switch";
export {
  E3 as A,
  qo as B,
  xy as D,
  du as F,
  Lo as G,
  qs as P,
  Oo as R,
  we as S,
  xo as U,
  R3 as a,
  n3 as b,
  g3 as c,
  f3 as d,
  mu as e,
  By as f,
  Uy as g,
  Hy as h,
  M2 as i,
  b2 as j,
  sy as k,
  Po as l,
  No as m,
  nn as n,
  e6 as o,
  ky as u
};
//# sourceMappingURL=index-csTVN17o.mjs.map
